import axiosInstance from "axios";
export const axios = axiosInstance;
// export const axios = require("axios");
export const AUTH_TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiMSIsImlhdCI6MTY0NjQ4NjUzNSwiZXhwIjoxNjQ2NTcyOTM1fQ.7gz3RSKX7yDWDlfd9pO9yzmLFlGaGvenivMChUImwGs";
// normal
// export const baseURL = "http://localhost:3331";
export const baseURL = "https://production.medisevas.com/erp";
export const ServiceURL = "https://production.medisevas.com/services";
export const imgurl ="https://production-medisevas-bucket.s3.ap-southeast-2.amazonaws.com/";

// aws
// axios.defaults.baseURL = 'https://nvk.nvkgenesys.com/';

export const config = {
  headers: {
    "Content-type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
};
export const set = "set";
export const LOGINAUTH = "LOGINAUTH";
export const GENERATECAPTCHA = "GENERATECAPTCHA";

export const LOGINULL = "LOGINULL";
export const SIGNUP = "SIGNUP";
export const GETHOSPITAL = "GETHOSPITAL";
export const CREATEHOSPITAL = "CREATEHOSPITAL";
export const UPDATEHOSPITAL = "UPDATEHOSPITAL";
export const CREATEUSER = "CREATEUSER";
export const GETUSER = "GETUSER";
export const GETUSERBYROLL = "GETUSERBYROLL";
export const GETUSERBYPARTY = "GETUSERBYPARTY";

export const UPDATEUSER = "UPDATEUSER";
export const UPDATEUSERBYMOBAIL = "UPDATEUSERBYMOBAIL";
export const DELETEUSER = "DELETEUSER";

export const GETHOSPITALBYID = "GETHOSPITALBYID";
export const CREATENOTIFICATION = "CREATENOTIFICATION";
export const GETNOTIFICATION = "GETNOTIFICATION";
export const UPDATENOTIFICATION = "UPDATENOTIFICATION";
export const DELETENOTIFICATION = "DELETENOTIFICATION";
export const CREATESMS1 = "CREATESMS1";
export const GETSMS1 = "GETSMS1";
export const UPDATESMS1 = "UPDATESMS1";
export const GETSMS2 = "GETSMS2";
export const UPDATESMS2 = "UPDATESMS2";
export const GETSMS3 = "GETSMS3";
export const UPDATESMS3 = "UPDATESMS3";
export const GETSMS4 = "GETSMS4";
export const UPDATESMS4 = "UPDATESMS4";
export const GETSMS5 = "GETSMS5";
export const UPDATESMS5 = "UPDATESMS5";
export const GETSMS6 = "GETSMS6";
export const UPDATESMS6 = "UPDATESMS6";
export const GETSMS7 = "GETSMS7";
export const UPDATESMS7 = "UPDATESMS7";
export const DELETESMS1 = "DELETESMS1";
export const DELETESMS2 = "DELETESMS2";
export const DELETESMS3 = "DELETESMS3";
export const DELETESMS4 = "DELETESMS4";
export const DELETESMS5 = "DELETESMS5";
export const DELETESMS6 = "DELETESMS6";
export const DELETESMS7 = "DELETESMS7";
export const CREATESMS2 = "CREATESMS2";
export const CREATESMS3 = "CREATESMS3";
export const CREATESMS4 = "CREATESMS4";
export const CREATESMS5 = "CREATESMS5";
export const CREATESMS6 = "CREATESMS6";
export const CREATESMS7 = "CREATESMS7";
export const CREATEEMAIL = "CREATEEMAIL";
export const GETEMAIL = "GETEMAIL";
export const DELETEEMAIL = "DELETEEMAIL";
export const UPDATEEMAIL = "UPDATEEMAIL";
export const UPDATEPAYMENT1 = "UPDATEPAYMENT1";
export const GETPAYMENT1 = "GETPAYMENT1";
export const UPDATEPAYMENT2 = "UPDATEPAYMENT2";
export const GETPAYMENT2 = "GETPAYMENT2";
export const UPDATEPAYMENT3 = "UPDATEPAYMENT3";
export const GETPAYMENT3 = "GETPAYMENT3";
export const UPDATEPAYMENT4 = "UPDATEPAYMENT4";
export const GETPAYMENT4 = "GETPAYMENT4";
export const UPDATEPAYMENT5 = "UPDATEPAYMENT5";
export const GETPAYMENT5 = "GETPAYMENT5";
export const UPDATEPAYMENT6 = "UPDATEPAYMENT6";
export const GETPAYMENT6 = "GETPAYMENT6";
export const UPDATEPAYMENT7 = "UPDATEPAYMENT7";
export const GETPAYMENT7 = "GETPAYMENT7";
export const UPDATEPAYMENT8 = "UPDATEPAYMENT8";
export const GETPAYMENT8 = "GETPAYMENT8";
export const UPDATEPAYMENT9 = "UPDATEPAYMENT9";
export const GETPAYMENT9 = "GETPAYMENT9";
export const UPDATEPAYMENT10 = "UPDATEPAYMENT10";
export const GETPAYMENT10 = "GETPAYMENT10";
export const UPDATEPAYMENT11 = "UPDATEPAYMENT11";
export const GETPAYMENT11 = "GETPAYMENT11";
export const UPDATEPAYMENT12 = "UPDATEPAYMENT12";
export const GETPAYMENT12 = "GETPAYMENT12";
export const UPDATEPAYMENT13 = "UPDATEPAYMENT13";
export const GETPAYMENT13 = "GETPAYMENT13";
export const UPDATEPAYMENT14 = "UPDATEPAYMENT14";
export const GETPAYMENT14 = "GETPAYMENT14";
export const UPDATEPAYMENT15 = "UPDATEPAYMENT15";
export const GETPAYMENT15 = "GETPAYMENT15";
export const UPDATEPAYMENT16 = "UPDATEPAYMENT16";
export const GETPAYMENT16 = "GETPAYMENT16";
export const DELETEPAYMENT1 = "DELETEPAYMENT1";
export const DELETEPAYMENT2 = "DELETEPAYMENT2";
export const DELETEPAYMENT3 = "DELETEPAYMENT3";
export const DELETEPAYMENT4 = "DELETEPAYMENT4";
export const DELETEPAYMENT5 = "DELETEPAYMENT5";
export const DELETEPAYMENT6 = "DELETEPAYMENT6";
export const DELETEPAYMENT7 = "DELETEPAYMENT7";
export const DELETEPAYMENT8 = "DELETEPAYMENT8";
export const DELETEPAYMENT9 = "DELETEPAYMENT9";
export const DELETEPAYMENT10 = "DELETEPAYMENT10";
export const DELETEPAYMENT11 = "DELETEPAYMENT11";
export const DELETEPAYMENT12 = "DELETEPAYMENT12";
export const DELETEPAYMENT13 = "DELETEPAYMENT13";
export const DELETEPAYMENT14 = "DELETEPAYMENT14";
export const DELETEPAYMENT15 = "DELETEPAYMENT15";
export const DELETEPAYMENT16 = "DELETEPAYMENT16";
export const CREATEPAYMENT1 = "CREATEPAYMENT1";
export const CREATEPAYMENT2 = "CREATEPAYMENT2";
export const CREATEPAYMENT3 = "CREATEPAYMENT3";
export const CREATEPAYMENT4 = "CREATEPAYMENT4";
export const CREATEPAYMENT5 = "CREATEPAYMENT5";
export const CREATEPAYMENT6 = "CREATEPAYMENT6";
export const CREATEPAYMENT7 = "CREATEPAYMENT7";
export const CREATEPAYMENT8 = "CREATEPAYMENT8";
export const CREATEPAYMENT9 = "CREATEPAYMENT9";
export const CREATEPAYMENT10 = "CREATEPAYMENT10";
export const CREATEPAYMENT11 = "CREATEPAYMENT11";
export const CREATEPAYMENT12 = "CREATEPAYMENT12";
export const CREATEPAYMENT13 = "CREATEPAYMENT13";
export const CREATEPAYMENT14 = "CREATEPAYMENT14";
export const CREATEPAYMENT15 = "CREATEPAYMENT15";
export const CREATEPAYMENT16 = "CREATEPAYMENT16";
export const CREATEPREFIX = "CREATEPREFIX";
export const GETPREFIX = "GETPREFIX";
export const DELETEPREFIX = "DELETEPREFIX";
export const UPDATEPREFIX = "UPDATEPREFIX";
export const CREATEROLE = "CREATEROLE";
export const GETROLE = "GETROLE";
export const DELETEROLE = "DELETEROLE";
export const UPDATEROLE = "UPDATEROLE";
export const CREATEBACKUP = "CREATEBACKUP";
export const GETBACKUP = "GETBACKUP";
export const DELETEBACKUP = "DELETEBACKUP";
export const UPDATEBACKUP = "UPDATEBACKUP";
export const CREATELANGUAGE = "CREATELANGUAGE";
export const GETLANGUAGE = "GETLANGUAGE";
export const DELETELANGUAGE = "DELETELANGUAGE";
export const UPDATELANGUAGE = "UPDATELANGUAGE";
export const CREATEPATIENT = "CREATEPATIENT";
export const GETPATIENT = "GETPATIENT";
export const DELETEPATIENT = "DELETEPATIENT";
export const UPDATEPATIENT = "UPDATEPATIENT";
export const CREATESTAFF = "CREATESTAFF";
export const GETSTAFF = "GETSTAFF";
export const DELETESTAFF = "DELETESTAFF";
export const UPDATESTAFF = "UPDATESTAFF";
export const CREATECAPTCHA = "CREATECAPTCHA";
export const GETCAPTCHA = "GETCAPTCHA";
export const DELETECAPTCHA = "DELETECAPTCHA";
export const UPDATECAPTCHA = "UPDATECAPTCHA";
export const CREATEMODULE = "CREATEMODULE";
export const GETMODULE = "GETMODULE";
export const GETMODULEVIASTATUS = "GETMODULEVIASTATUS";
export const GETMODULEADMIN = "GETMODULEADMIN";
export const DELETEMODULE = "DELETEMODULE";
export const UPDATEMODULE = "UPDATEMODULE";
export const CREATECHILDRENMODULE = "CREATECHILDRENMODULE";
export const GETCHILDRENMODULE = "GETCHILDRENMODULE";
export const GETCHILDRENMODULEADMIN = "GETCHILDRENMODULEADMIN";
export const DELETECHILDRENMODULE = "DELETECHILDRENMODULE";
export const UPDATECHILDRENMODULE = "UPDATECHILDRENMODULE";
export const GETALLCHILDRENMODULE = "GETALLCHILDRENMODULE";

export const CREATEUNIT = "CREATEUNIT";
export const GETUNIT = "GETUNIT";
export const DELETEUNIT = "DELETEUNIT";
export const UPDATEUNIT = "UPDATEUNIT";

export const CREATECHARGESTYPE = "CREATECHARGESTYPE";
export const GETCHARGESTYPE = "GETCHARGESTYPE";
export const DELETECHARGESTYPE = "DELETECHARGESTYPE";
export const UPDATECHARGESTYPE = "UPDATETECHARGEDTYPE";
export const CREATECHARGESCHATEGORY = "CREATECHARGESCHATEGORY";
export const GETCHARGESCHATEGORY = "GETCHARGESCHATEGORY";
export const DELETECHARGESCHATEGORY = "DELETECHARGESCHATEGORY";
export const UPDATECHARGESCHATEGORY = "UPDATETECHARGESCHATEGORY";
export const CREATECHARGE = "CREATECHARGE";
export const GETCHARGE = "GETCHARGE";
export const DELETECHARGE = "DELETECHARGE";
export const UPDATECHARGE = "UPDATETECHARGE";
export const CREATELEAVETYPE = "CREATELEAVETYPE";
export const GETLEAVETYPE = "GETLEAVETYPE";
export const DELETELEAVETYPE = "DELETELEAVETYPE";
export const UPDATELEAVETYPE = "UPDATELEAVETYPE";
export const CREATEDEPARTMENT = "CREATEDEPARTMENT";
export const GETDEPARTMENT = "GETDEPARTMENT";
export const DELETEDEPARTMENT = "DELETEDEPARTMENT";
export const UPDATEDEPARTMENT = "UPDATEDEPARTMENT";
export const CREATEDESIGNATION = "CREATEDESIGNATION";
export const GETDESIGNATION = "GETDESIGNATION";
export const DELETEDESIGNATION = "DELETEDESIGNATION";
export const UPDATEDESIGNATION = "UPDATEDESIGNATION";
export const CREATESPECIALITY = "CREATESPECIALITY";
export const GETSPECIALITY = "GETSPECIALITY";
export const GETAllSPECIALITY = "GETALLSPECIALITY";
export const DELETESPECIALITY = "DELETESPECIALITY";
export const UPDATESPECIALITY = "UPDATESPECIALITY";
export const CREATEPAYROLLTYPE = "CREATEPAYROLLTYPE";
export const GETPAYROLLTYPE = "GETPAYROLLTYPE";
export const DELETEPAYROLLTYPE = "DELETEPAYROLLTYPE";
export const UPDATEPAYROLLTYPE = "UPDATEPAYROLLTYPE";
export const CREATEPAYROLL = "CREATEPAYROLL";
export const GETPAYROLL = "GETPAYROLL";
export const DELETEPAYROLL = "DELETEPAYROLL";
export const UPDATEPAYROLL = "UPDATEPAYROLL";
export const CREATEFLOOR = "CREATEFLOOR";
export const GETFLOOR = "GETFLOOR";
export const DELETEFLOOR = "DELETEFLOOR";
export const UPDATEFLOOR = "UPDATEFLOOR";
export const CREATEBEDGROUP = "CREATEBEDGROUP";
export const GETBEDGROUP = "GETBEDGROUP";
export const DELETEBEDGROUP = "DELETEBEDGROUP";
export const UPDATEBEDGROUP = "UPDATEBEDGROUP";
export const CREATEBEDTYPE = "CREATEBEDTYPE";
export const GETBEDTYPE = "GETBEDTYPE";
export const DELETEBEDTYPE = "DELETEBEDTYPE";
export const UPDATEBEDTYPE = "UPDATEBEDTYPE";
export const CREATEBED = "CREATEBED";
export const GETBED = "GETBED";
export const DELETEBED = "DELETEBED";
export const UPDATEBED = "UPDATEBED";
export const CREATEPUPOSE = "CREATEPURPOSE";
export const GETPURPOSE = "GETPURPOSE";
export const DELETEPURPOSE = "DELETEPURPOSE";
export const UPDATEPURPOSE = "UPDATEPURPOSE";
export const CREATECOMPLAINT = "CREATECOMPLAINT";
export const GETCOMPLAINT = "GETCOMPLAINT";
export const DELETECOMPLAINT = "DELETECOMPLAINT";
export const UPDATECOMPLAINT = "UPDATECOMPLAINT";
export const CREATESOURCE = "CREATESOURCE";
export const GETSOURCE = "GETSOURCE";
export const DELETESOURCE = "DELETESOURCE";
export const UPDATESOURCE = "UPDATESOURCE";
export const CREATEAPPOINTMENTPRIORITY = "CREATEAPPOINTMENTPRIORITY";
export const GETAPPOINTMENTPRIORITY = "GETAPPOINTMENTPRIORITY";
export const DELETEAPPOINTMENTPRIORITY = "DELETEAPPOINTMENTPRIORITY";
export const UPDATEAPPOINTMENTPRIORITY = "UPDATEAPPOINTMENTPRIORITY";
export const CREATEOPERATION = "CREATEOPERATION";
export const GETOPERATION = "GETOPERATION";
export const DELETEOPERATION = "DELETEOPERATION";
export const UPDATEOPERATION = "UPDATEOPERATION";
export const CREATEOPERATIONCATEGORY = "CREATEOPERATIONCATEGORY";
export const GETOPERATIONCATEGORY = "GETOPERATIONCATEGORY";
export const DELETEOPERATIONCATEGORY = "DELETEOPERATIONCATEGORY";
export const UPDATEOPERATIONCATEGORY = "UPDATEOPERATIONCATEGORY";
export const CREATEFINDINGCATEGORY = "CREATEFINDINGCATEGORY";
export const GETFINDINGCATEGORY = "GETFINDINGCATEGORY";
export const DELETEFINDINGCATEGORY = "DELETEFINDINGCATEGORY";
export const UPDATEFINDINGCATEGORY = "UPDATEFINDINGCATEGORY";
export const CREATEFINDING = "CREATEFINDING";
export const GETFINDING = "GETFINDING";
export const DELETEFINDING = "DELETEFINDING";
export const UPDATEFINDING = "UPDATEFINDING";
export const CREATESYMPTOMSTYPE = "CREATESYMPTOMSTYPE";
export const GETSYMPTOMSTYPE = "GETSYMPTOMSTYPE";
export const DELETESYMPTOMSTYPE = "DELETESYMPTOMSTYPE";
export const UPDATESYMPTOMSTYPE = "UPDATESYMPTOMSTYPE";
export const CREATESYMPTOMSHEAD = "CREATESYMPTOMSHEAD";
export const GETSYMPTOMSHEAD = "GETSYMPTOMSHEAD";
export const DELETESYMPTOMSHEAD = "DELETESYMPTOMSHEAD";
export const UPDATESYMPTOMSHEAD = "UPDATESYMPTOMSHEAD";
export const CREATECOMORBIDITYTYPE = "CREATECOMORBIDITYTYPE";
export const GETCOMORBIDITYTYPE = "GETCOMORBIDITYTYPE";
export const DELETECOMORBIDITYTYPE = "DELETECOMORBIDITYTYPE";
export const UPDATECOMORBIDITYTYPE = "UPDATECOMORBIDITYTYPE";
export const CREATECOMORBIDITYHEAD = "CREATECOMORBIDITYHEAD";
export const GETCOMORBIDITYHEAD = "GETCOMORBIDITYHEAD";
export const DELETECOMORBIDITYHEAD = "DELETECOMORBIDITYHEAD";
export const UPDATECOMORBIDITYHEAD = "UPDATECOMORBIDITYHEAD";
export const CREATEINCOMEHEAD = "CREATEINCOMEHEAD";
export const GETINCOMEHEAD = "GETINCOMEHEAD";
export const DELETEINCOMEHEAD = "DELETEINCOMEHEAD";
export const UPDATEINCOMEHEAD = "UPDATEINCOMEHEAD";
export const CREATEEXPENSEHEAD = "CREATEEXPENSEHEAD";
export const GETEXPENSEHEAD = "GETEXPENSEHEAD";
export const DELETEEXPENSEHEAD = "DELETEEXPENSEHEAD";
export const UPDATEEXPENSEHEAD = "UPDATEEXPENSEHEAD";
export const CREATEZOOMSETTING = "CREATEZOOMSETTING";
export const GETZOOMSETTING = "GETZOOMSETTING";
export const DELETEZOOMSETTING = "DELETEZOOMSETTING";
export const UPDATEZOOMSETTING = "UPDATEZOOMSETTING";
export const CREATEMEDICINCECATEGORY = "CREATEMEDICINCECATEGORY";
export const GETMEDICINCECATEGORY = "GETMEDICINCECATEGORY";
export const DELETEMEDICINCECATEGORY = "DELETEMEDICINCECATEGORY";
export const UPDATEMEDICINECATEGORY = "UPDATEMEDICINECATEGORY";
export const CREATESUPPLIER = "CREATESUPPLIER";
export const GETSUPPLIER = "GETSUPPLIER";
export const DELETESUPPLIER = "DELETESUPPLIER";
export const UPDATESUPPLIER = "UPDATESUPPLIER";
export const CREATEDOSEUNIT = "CREATEDOSEUNIT";
export const GETDOSEUNIT = "GETDOSEUNIT";
export const DELETEDOSEUNIT = "DELETEDOSEUNIT";
export const UPDATEDOSEUNIT = "UPDATEDOSEUNIT";
export const CREATEMEDICINCEDOSAGE = "CREATEMEDICINCEDOSAGE";
export const GETMEDICINCEDOSAGE = "GETMEDICINCEDOSAGE";
export const DELETEMEDICINCEDOSAGE = "DELETEMEDICINCEDOSAGE";
export const UPDATEMEDICINCEDOSAGE = "UPDATEMEDICINCEDOSAGE";
export const CREATEDOSEINTERVAL = "CREATEDOSEINTERVAL";
export const GETDOSEINTERVAL = "GETDOSEINTERVAL";
export const DELETEDOSEINTERVAL = "DELETEDOSEINTERVAL";
export const UPDATEDOSEINTERVAL = "UPDATEDOSEINTERVAL";
export const CREATEDOSEDURATION = "CREATEDOSEDURATION";
export const GETDOSEDURATION = "GETDOSEDURATION";
export const DELETEDOSEDURATION = "DELETEDOSEDURATION";
export const UPDATEDOSEDURATION = "UPDATEDOSEDURATION";
export const UPDATEPATHOLOGYCATEGORY = "UPDATEPATHOLOGYCATEGORY";
export const CREATEPATHOLOGYCATEGORY = "CREATEPATHOLOGYCATEGORY";
export const GETPATHOLOGYCATEGORY = "GETPATHOLOGYCATEGORY";
export const DELETEPATHOLOGYCATEGORY = "DELETEPATHOLOGYCATEGORY";
export const UPDATEPATHOLOGYUNIT = "UPDATEPATHOLOGYUNIT";
export const CREATEPATHOLOGYUNIT = "CREATEPATHOLOGYUNIT";
export const GETPATHOLOGYUNIT = "GETPATHOLOGYUNIT";
export const DELETEPATHOLOGYUNIT = "DELETEPATHOLOGYUNIT";
export const UPDATEPATHOLOGYPARAMETER = "UPDATEPATHOLOGYPARAMETER";
export const CREATEPATHOLOGYPARAMETER = "CREATEPATHOLOGYPARAMETER";
export const GETPATHOLOGYPARAMETER = "GETPATHOLOGYPARAMETER";
export const DELETEPATHOLOGYPARAMETER = "DELETEPATHOLOGYPARAMETER";
export const UPDATEPATHOLOGIST = "UPDATEPATHOLOGIST";
export const CREATEPATHOLOGIST = "CREATEPATHOLOGIST";
export const GETPATHOLOGIST = "GETPATHOLOGIST";
export const DELETEPATHOLOGIST = "DELETEPATHOLOGIST";
export const UPDATERADIOLOGYCATEGORY = "UPDATERADIOLOGYCATEGORY";
export const CREATERADIOLOGYCATEGORY = "CREATERADIOLOGYCATEGORY";
export const GETRADIOLOGYCATEGORY = "GETRADIOLOGYCATEGORY";
export const DELETERADIOLOGYCATEGORY = "DELETERADIOLOGYCATEGORY";
export const UPDATERADIOLOGYUNIT = "UPDATERADIOLOGYUNIT";
export const CREATERADIOLOGYUNIT = "CREATERADIOLOGYUNIT";
export const GETRADIOLOGYUNIT = "GETRADIOLOGYUNIT";
export const DELETERADIOLOGYUNIT = "DELETERADIOLOGYUNIT";
export const UPDATERADIOLOGYPARAMETER = "UPDATERADIOLOGYPARAMETER";
export const CREATERADIOLOGYPARAMETER = "CREATERADIOLOGYPARAMETER";
export const GETRADIOLOGYPARAMETER = "GETRADIOLOGYPARAMETER";
export const DELETERADIOLOGYPARAMETER = "DELETERADIOLOGYPARAMETER";
export const UPDATERADIOLOGIST = "UPDATERADIOLOGIST";
export const CREATERADIOLOGIST = "CREATERADIOLOGIST";
export const GETRADIOLOGIST = "GETRADIOLOGIST";
export const DELETERADIOLOGIST = "DELETERADIOLOGIST";
export const UPDATERADIOLOGYCENTER = "UPDATERADIOLOGYCENTER";
export const CREATERADIOLOGYCENTER = "CREATERADIOLOGYCENTER";
export const GETRADIOLOGYCENTER = "GETRADIOLOGYCENTER";
export const DELETERADIOLOGYCENTER = "DELETERADIOLOGYCENTER";
export const UPDATEPATHOLOGYCENTER = "UPDATEPATHOLOGYCENTER";
export const CREATEPATHOLOGYCENTER = "CREATEPATHOLOGYCENTER";
export const GETPATHOLOGYCENTER = "GETPATHOLOGYCENTER";
export const DELETEPATHOLOGYCENTER = "DELETEPATHOLOGYCENTER";
export const UPDATEBLOODBANKPRODUCT = "UPDATEBLOODBANKPRODUCT";
export const CREATEBLOODBANKPRODUCT = "CREATEBLOODBANKPRODUCT";
export const GETBLOODBANKPRODUCT = "GETBLOODBANKPRODUCT";
export const DELETEBLOODBANKPRODUCT = "DELETEBLOODBANKPRODUCT";
export const UPDATEBLOODBANKTYPE = "UPDATEBLOODBANKTYPE";
export const CREATEBLOODBANKTYPE = "CREATEBLOODBANKTYPE";
export const GETBLOODBANKTYPE = "GETBLOODBANKTYPE";
export const DELETEBLOODBANKTYPE = "DELETEBLOODBANKTYPE";
export const UPDATEREFERRALCATEGORY = "UPDATEREFERRALCATEGORY";
export const CREATEREFERRALCATEGORY = "CREATEREFERRALCATEGORY";
export const GETREFERRALCATEGORY = "GETREFERRALCATEGORY";
export const DELETEREFERRALCATEGORY = "DELETEREFERRALCATEGORY";
export const UPDATEREFERRALCOMMITION = "UPDATEREFERRALCOMMITION";
export const CREATEREFERRALCOMMITION = "CREATEREFERRALCOMMITION";
export const GETREFERRALCOMMITION = "GETREFERRALCOMMITION";
export const DELETEREFERRALCOMMITION = "DELETEREFERRALCOMMITION";
export const UPDATEREFERRALMODULECOMMITION = "UPDATEREFERRALMODULECOMMITION";
export const CREATEREFERRALMODULECOMMITION = "CREATEREFERRALMODULECOMMITION";
export const GETREFERRALMODULECOMMITION = "GETREFERRALMODULECOMMITION";
export const DELETEREFERRALMODULECOMMITION = "DELETEREFERRALMODULECOMMITION";
export const UPDATEINVENTORYITEMCATEGORY = "UPDATEINVENTORYITEMCATEGORY";
export const CREATEINVENTORYITEMCATEGORY = "CREATEINVENTORYITEMCATEGORY";
export const GETINVENTORYITEMCATEGORY = "GETINVENTORYITEMCATEGORY";
export const DELETEINVENTORYITEMCATEGORY = "DELETEINVENTORYITEMCATEGORY";
export const UPDATEINVENTORYITEMSTORE = "UPDATEINVENTORYITEMSTORE";
export const CREATEINVENTORYITEMSTORE = "CREATEINVENTORYITEMSTORE";
export const GETINVENTORYITEMSTORE = "GETINVENTORYITEMSTORE";
export const DELETEINVENTORYITEMSTORE = "DELETEINVENTORYITEMSTORE";
export const UPDATEINVENTORYITEMSUPPLIER = "UPDATEINVENTORYITEMSUPPLIER";
export const CREATEINVENTORYITEMSUPPLIER = "CREATEINVENTORYITEMSUPPLIER";
export const GETINVENTORYITEMSUPPLIER = "GETINVENTORYITEMSUPPLIER";
export const DELETEINVENTORYITEMSUPPLIER = "DELETEINVENTORYITEMSUPPLIER";
export const UPDATEHRSTAFFBASICINFORMATION = "UPDATEHRSTAFFBASICINFORMATION";
export const UPDATEHRSTAFFBASICINFORMATIONFORALLTABLES = "UPDATEHRSTAFFBASICINFORMATIONFORALLTABLES";
export const UPDATEHRSTAFFBASICINFORMATION1 = "UPDATEHRSTAFFBASICINFORMATION1";
export const CREATEHRSTAFFBASICINFORMATION = "CREATEHRSTAFFBASICINFORMATION";
export const GETHRSTAFFBASICINFORMATION = "GETHRSTAFFBASICINFORMATION";
export const GETHRSTAFFBASICINFORMATIONBYID = "GETHRSTAFFBASICINFORMATIONBYID";
export const GETHRSTAFFBASICINFORMATIONBYROLL =
  "GETHRSTAFFBASICINFORMATIONBYROLL";

export const GETHRSTAFFPAYROLLINFORMATIONBYID =
  "GETHRSTAFFPAYROLLINFORMATIONBYID";
export const GETHRSTAFFLEAVEINFORMATIONBYID = "GETHRSTAFFLEAVEINFORMATIONBYID";
export const GETHRSTAFFBANKINFORMATIONBYID = "GETHRSTAFFBANKINFORMATIONBYID";
export const GETHRSTAFFMEDIAINFORMATIONBYID = "GETHRSTAFFMEDIAINFORMATIONBYID";
export const GETHRSTAFFDOCUMENTINFORMATIONBYID =
  "GETHRSTAFFDOCUMENTINFORMATIONBYID";

export const DELETEHRSTAFFBASICINFORMATION = "DELETEHRSTAFFBASICINFORMATION";
export const DELETEHRSTAFFBASICINFORMATIONEVERYTHING = "DELETEHRSTAFFBASICINFORMATIONEVERYTHING";
export const UPDATEHRSTAFFPAYROLLINFORMATION =
  "UPDATEHRSTAFFPAYROLLINFORMATION";
export const CREATEHRSTAFFPAYROLLINFORMATION =
  "CREATEHRSTAFFPAYROLLINFORMATION";
export const GETHRSTAFFPAYROLLINFORMATION = "GETHRSTAFFPAYROLLINFORMATION";
export const DELETEHRSTAFFPAYROLLINFORMATION =
  "DELETEHRSTAFFPAYROLLINFORMATION";
export const UPDATEHRSTAFFLEAVEINFORMATION = "UPDATEHRSTAFFLEAVEINFORMATION";
export const CREATEHRSTAFFLEAVEINFORMATION = "CREATEHRSTAFFLEAVEINFORMATION";
export const GETHRSTAFFLEAVEINFORMATION = "GETHRSTAFFLEAVEINFORMATION";
export const DELETEHRSTAFFLEAVEINFORMATION = "DELETEHRSTAFFLEAVEINFORMATION";
export const UPDATEHRSTAFFBANKINFORMATION = "UPDATEHRSTAFFBANKINFORMATION";
export const CREATEHRSTAFFBANKINFORMATION = "CREATEHRSTAFFBANKINFORMATION";
export const GETHRSTAFFBANKINFORMATION = "GETHRSTAFFBANKINFORMATION";
export const DELETEHRSTAFFBANKINFORMATION = "DELETEHRSTAFFBANKINFORMATION";
export const UPDATEHRSTAFFMEDIAINFORMATION = "UPDATEHRSTAFFMEDIAINFORMATION";
export const CREATEHRSTAFFMEDIAINFORMATION = "CREATEHRSTAFFMEDIAINFORMATION";
export const GETHRSTAFFMEDIAINFORMATION = "GETHRSTAFFMEDIAINFORMATION";
export const DELETEHRSTAFFMEDIAINFORMATION = "DELETEHRSTAFFMEDIAINFORMATION";
export const UPDATEHRSTAFFDOCUMENTINFORMATION =
  "UPDATEHRSTAFFDOCUMENTINFORMATION";
export const CREATEHRSTAFFDOCUMENTINFORMATION =
  "CREATEHRSTAFFDOCUMENTINFORMATION";
export const GETHRSTAFFDOCUMENTINFORMATION = "GETHRSTAFFDOCUMENTINFORMATION";
export const DELETEHRSTAFFDOCUMENTINFORMATION =
  "DELETEHRSTAFFDOCUMENTINFORMATION";

export const CREATEHOSPITALEAPPOINMENTSHIFT = "CREATEHOSPITALEAPPOINMENTSHIFT";
export const GETHOSPITALEAPPOINMENTSHIFT = "GETHOSPITALEAPPOINMENTSHIFT";
export const DELETEHOSPITALEAPPOINMENTSHIFT = "DELETEHOSPITALEAPPOINMENTSHIFT";
export const UPDATEHOSPITALAPPOINMENTSHIFT = "UPDATEHOSPITALAPPOINMENTSHIFT";
export const CREATEHOSPITALEAPPOINMENTSLOT = "CREATEHOSPITALEAPPOINMENTSLOT";
export const GETHOSPITALEAPPOINMENTSLOT = "GETHOSPITALEAPPOINMENTSLOT";
export const GETHOSPITALEAPPOINMENTSLOTBYDOCTOR =
  "GETHOSPITALEAPPOINMENTSLOTBYDOCTOR";

export const DELETEHOSPITALEAPPOINMENTSLOT = "DELETEHOSPITALEAPPOINMENTSLOT";
export const UPDATEHOSPITALAPPOINMENTSLOT = "UPDATEHOSPITALAPPOINMENTSLOT";

export const SERCHCHARG = "SERCHCHARG";

export const CREATEOPDPRESCRIPTION = "CREATEOPDPRESCRIPTION";
export const GETOPDPRESCRIPTION = "GETOPDPRESCRIPTION";
export const DELETEOPDPRESCRIPTION = "DELETEOPDPRESCRIPTION";
export const UPDATEOPDPRESCRIPTION = "UPDATEOPDPRESCRIPTION";
export const CREATEOPDBILL = "CREATEOPDBILL";
export const GETOPDBILL = "GETOPDBILL";
export const DELETEOPDBILL = "DELETEOPDBILL";
export const UPDATEOPDBILL = "UPDATEOPDBILL";
export const CREATEOPDIMANGING = "CREATEOPDIMANGING";
export const GETOPDIMANGING = "GETOPDIMANGING";
export const DELETEOPDIMANGING = "DELETEOPDIMANGING";
export const UPDATEOPDIMANGING = "UPDATEOPDIMANGING";
export const CREATEIPDPRESCRIPTION = "CREATEIPDPRESCRIPTION";
export const GETIPDPRESCRIPTION = "GETIPDPRESCRIPTION";
export const DELETEIPDPRESCRIPTION = "DELETEIPDPRESCRIPTION";
export const UPDATEIPDPRESCRIPTION = "UPDATEIPDPRESCRIPTION";
export const CREATEIPDBILL = "CREATEIPDBILL";
export const GETIPDBILL = "GETIPDBILL";
export const DELETEIPDBILL = "DELETEIPDBILL";
export const UPDATEIPDBILL = "UPDATEIPDBILL";
export const CREATEBILL = "CREATEIPDBILL";
export const GETBILL = "GETBILL";
export const DELETEBILL = "DELETEBILL";
export const UPDATEBILL = "UPDATEBILL";
export const CREATEPHARMACYBILLL = "CREATEPHARMACYBILLL";
export const GETPHARMACYBILLL = "GETPHARMACYBILLL";
export const DELETEPHARMACYBILLL = "DELETEPHARMACYBILLL";
export const UPDATEPHARMACYBILLL = "UPDATEPHARMACYBILLL";
export const CREATEPAYSLIP = "CREATEIPDPAYSLIP";
export const GETPAYSLIP = "GETPAYSLIP";
export const DELETEPAYSLIP = "DELETEPAYSLIP";
export const UPDATEPAYSLIP = "UPDATEPAYSLIP";
export const CREATEPAYMENTRECEIPT = "CREATEIPDPAYMENTRECEIPT";
export const GETPAYMENTRECEIPT = "GETPAYMENTRECEIPT";
export const DELETEPAYMENTRECEIPT = "DELETEPAYMENTRECEIPT";
export const UPDATEPAYMENTRECEIPT = "UPDATEPAYMENTRECEIPT";
export const CREATEBIRTHRECORD = "CREATEIPDBIRTHRECORD";
export const GETBIRTHRECORD = "GETBIRTHRECORD";
export const DELETEBIRTHRECORD = "DELETEBIRTHRECORD";
export const UPDATEBIRTHRECORD = "UPDATEBIRTHRECORD";
export const CREATEDEATHRECORD = "CREATEIPDDEATHRECORD";
export const GETDEATHRECORD = "GETDEATHRECORD";
export const DELETEDEATHRECORD = "DELETEDEATHRECORD";
export const UPDATEDEATHRECORD = "UPDATEDEATHRECORD";
export const CREATEPATHOLOGY = "CREATEIPDPATHOLOGY";
export const GETPATHOLOGY = "GETPATHOLOGY";
export const DELETEPATHOLOGY = "DELETEPATHOLOGY";
export const UPDATEPATHOLOGY = "UPDATEPATHOLOGY";
export const CREATERADIOLOGY = "CREATEIPDRADIOLOGY";
export const GETRADIOLOGY = "GETRADIOLOGY";
export const DELETERADIOLOGY = "DELETERADIOLOGY";
export const UPDATERADIOLOGY = "UPDATERADIOLOGY";
export const CREATEPRINTOPERATION = "CREATEIPDPRINTOPERATION";
export const GETPRINTOPERATION = "GETPRINTOPERATION";
export const DELETEPRINTOPERATION = "DELETEPRINTOPERATION";
export const UPDATEPRINTOPERATION = "UPDATEPRINTOPERATION";
export const CREATEPRINTBLOODBANK = "CREATEIPDPRINTBLOODBANK";
export const GETPRINTBLOODBANK = "GETPRINTBLOODBANK";
export const DELETEPRINTBLOODBANK = "DELETEPRINTBLOODBANK";
export const UPDATEPRINTBLOODBANK = "UPDATEPRINTBLOODBANK";
export const CREATEPRINTAMBULANCE = "CREATEIPDPRINTAMBULANCE";
export const GETPRINTAMBULANCE = "GETPRINTAMBULANCE";
export const DELETEPRINTAMBULANCE = "DELETEPRINTAMBULANCE";
export const UPDATEPRINTAMBULANCE = "UPDATEPRINTAMBULANCE";
export const CREATEPRINTDISCHARGE = "CREATEIPDPRINTDISCHARGE";
export const GETPRINTDISCHARGE = "GETPRINTDISCHARGE";
export const DELETEPRINTDISCHARGE = "DELETEPRINTDISCHARGE";
export const UPDATEPRINTDISCHARGE = "UPDATEPRINTDISCHARGE";
export const CREATEAPPOINTMENTPATIENT = "CREATEIPDAPPOINTMENTPATIENT";
export const GETALLAPPOINTMENT = "GETALLAPPOINTMENT";

export const GETAPPOINTMENTPATIENT = "GETAPPOINTMENTPATIENT";
export const GETAPPOINTMENTPATIENTLIKE = "GETAPPOINTMENTPATIENTLIKE";

export const GETAPPOINTMENTPATIENTBYID = "GETAPPOINTMENTPATIENTBYID";
export const DELETEAPPOINTMENTPATIENT = "DELETEAPPOINTMENTPATIENT";
export const UPDATEAPPOINTMENTPATIENT = "UPDATEAPPOINTMENTPATIENT";
export const UPDATEAPPOINTMENTPATIENTACTION = "UPDATEAPPOINTMENTPATIENTACTION";

export const CREATEAPPOINTMENTVISITER = "CREATEIPDAPPOINTMENTVISITER";
export const GETAPPOINTMENTVISITER = "GETAPPOINTMENTVISITER";
export const DELETEAPPOINTMENTVISITER = "DELETEAPPOINTMENTVISITER";
export const UPDATEAPPOINTMENTVISITER = "UPDATEAPPOINTMENTVISITER";

export const CREATEOPDVISITS = "CREATEIPDOPDVISITS";
export const GETOPDVISITS = "GETOPDVISITS";
export const GETALLOPDVISITS = "GETALLOPDVISITS";
export const DELETEOPDVISITS = "DELETEOPDVISITS";
export const UPDATEOPDVISITS = "UPDATEOPDVISITS";
export const DETAILSOPDVISITS = "DETAILSOPDVISITS";
export const DETAILSOPDPRESCRIPTION = "DETAILSOPDPRESCRIPTION";

export const CREATEOPDOUTBILL = "CREATEIPDOPDOUTBILL";
export const GETOPDOUTBILL = "GETOPDOUTBILL";
export const GETALLOPDOUTBILL = "GETALLOPDOUTBILL";
export const DELETEOPDOUTBILL = "DELETEOPDOUTBILL";
export const UPDATEOPDOUTBILL = "UPDATEOPDOUTBILL";
export const CREATEOPDOUTSYMPTOMS = "CREATEIPDOPDOUTSYMPTOMS";
export const GETOPDOUTSYMPTOMS = "GETOPDOUTSYMPTOMS";
export const GETALLOPDOUTSYMPTOMS = "GETALLOPDOUTSYMPTOMS";
export const DELETEOPDOUTSYMPTOMS = "DELETEOPDOUTSYMPTOMS";
export const UPDATEOPDOUTSYMPTOMS = "UPDATEOPDOUTSYMPTOMS";
export const CREATEOPDOUTCOBORBIDITY = "CREATEIPDOPDOUTCOBORBIDITY";
export const GETOPDOUTCOBORBIDITY = "GETOPDOUTCOBORBIDITY";
export const GETALLOPDOUTCOBORBIDITY = "GETALLOPDOUTCOBORBIDITY";
export const DELETEOPDOUTCOBORBIDITY = "DELETEOPDOUTCOBORBIDITY";
export const UPDATEOPDOUTCOBORBIDITY = "UPDATEOPDOUTCOBORBIDITY";
export const CREATEOPDOUTINVESTIGATION = "CREATEIPDOPDOUTINVESTIGATION";
export const GETOPDOUTINVESTIGATION = "GETOPDOUTINVESTIGATION";
export const GETALLOPDOUTINVESTIGATION = "GETALLOPDOUTINVESTIGATION";
export const DELETEOPDOUTINVESTIGATION = "DELETEOPDOUTINVESTIGATION";
export const UPDATEOPDOUTINVESTIGATION = "UPDATEOPDOUTINVESTIGATION";
export const CREATEPRESCRIPTION = "CREATEIPDPRESCRIPTION";
export const GETPRESCRIPTION = "GETPRESCRIPTION";
export const GETALLPRESCRIPTION = "GETALLPRESCRIPTION";
export const DELETEPRESCRIPTION = "DELETEPRESCRIPTION";
export const UPDATEPRESCRIPTION = "UPDATEPRESCRIPTION";
export const CREATEPRESCRIPTIONMEDICINE = "CREATEIPDPRESCRIPTIONMEDICINE";
export const GETPRESCRIPTIONMEDICINE = "GETPRESCRIPTIONMEDICINE";
export const GETALLPRESCRIPTIONMEDICINE = "GETALLPRESCRIPTIONMEDICINE";
export const DELETEPRESCRIPTIONMEDICINE = "DELETEPRESCRIPTIONMEDICINE";
export const UPDATEPRESCRIPTIONMEDICINE = "UPDATEPRESCRIPTIONMEDICINE";
export const CREATEPRESCRIPTIONROLL = "CREATEIPDPRESCRIPTIONROLL";
export const GETPRESCRIPTIONROLL = "GETPRESCRIPTIONROLL";
export const GETALLPRESCRIPTIONROLL = "GETALLPRESCRIPTIONROLL";
export const DELETEPRESCRIPTIONROLL = "DELETEPRESCRIPTIONROLL";
export const UPDATEPRESCRIPTIONROLL = "UPDATEPRESCRIPTIONROLL";

export const CREATETPA = "CREATEIPDTPA";
export const GETTPA = "GETTPA";
export const GETALLTPA = "GETALLTPA";
export const DELETETPA = "DELETETPA";
export const UPDATETPA = "UPDATETPA";
export const CREATETPACHARGE = "CREATEIPDTPACHARGE";
export const GETTPACHARGE = "GETTPACHARGE";
export const GETALLTPACHARGE = "GETALLTPACHARGE";
export const DELETETPACHARGE = "DELETETPACHARGE";
export const UPDATETPACHARGE = "UPDATETPACHARGE";

export const CREATEREFERALPERSON = "CREATEIPDREFERALPERSON";
export const GETREFERALPERSON = "GETREFERALPERSON";
export const GETALLREFERALPERSON = "GETALLREFERALPERSON";
export const DELETEREFERALPERSON = "DELETEREFERALPERSON";
export const UPDATEREFERALPERSON = "UPDATEREFERALPERSON";
export const CREATEREFERALDEPARTMENTCOMMISSION =
  "CREATEIPDREFERALDEPARTMENTCOMMISSION";
export const GETREFERALDEPARTMENTCOMMISSION = "GETREFERALDEPARTMENTCOMMISSION";
export const GETALLREFERALDEPARTMENTCOMMISSION =
  "GETALLREFERALDEPARTMENTCOMMISSION";
export const DELETEREFERALDEPARTMENTCOMMISSION =
  "DELETEREFERALDEPARTMENTCOMMISSION";
export const UPDATEREFERALDEPARTMENTCOMMISSION =
  "UPDATEREFERALDEPARTMENTCOMMISSION";
export const CREATEREFERALPAYMENT = "CREATEIPDREFERALPAYMENT";
export const GETREFERALPAYMENT = "GETREFERALPAYMENT";
export const GETALLREFERALPAYMENT = "GETALLREFERALPAYMENT";
export const DELETEREFERALPAYMENT = "DELETEREFERALPAYMENT";
export const UPDATEREFERALPAYMENT = "UPDATEREFERALPAYMENT";
export const CREATETIMELINE = "CREATEIPDTIMELINE";
export const GETTIMELINE = "GETTIMELINE";
export const GETALLTIMELINE = "GETALLTIMELINE";
export const DELETETIMELINE = "DELETETIMELINE";
export const UPDATETIMELINE = "UPDATETIMELINE";

export const GET_SERVICE = "GET_SERVICE";
export const CREATE_SERVICE = "CREATE_SERVICE";
export const UPDATE_SERVICE = "UPDATE_SERVICE";
export const DELETE_SERVICE = "DELETE_SERVICE";

export const CREATEPAYMENT = "CREATEIPDPAYMENT";
export const GETPAYMENT = "GETPAYMENT";
export const GETALLPAYMENT = "GETALLPAYMENT";
export const DELETEPAYMENT = "DELETEPAYMENT";
export const UPDATEPAYMENT = "UPDATEPAYMENT";
export const CREATEOPDCHARGE = "CREATEIPDOPDCHARGE";
export const GETOPDCHARGE = "GETOPDCHARGE";
export const GETALLOPDCHARGE = "GETALLOPDCHARGE";
export const DELETEOPDCHARGE = "DELETEOPDCHARGE";
export const UPDATEOPDCHARGE = "UPDATEOPDCHARGE";

export const CREATEOPDOPERATION = "CREATEIPDOPDOPERATION";
export const GETOPDOPERATION = "GETOPDOPERATION";
export const GETALLOPDOPERATION = "GETALLOPDOPERATION";
export const DELETEOPDOPERATION = "DELETEOPDOPERATION";
export const UPDATEOPDOPERATION = "UPDATEOPDOPERATION";

export const CREATEPHARMACYMEDICINE = "CREATEIPDPHARMACYMEDICINE";
export const GETPHARMACYMEDICINE = "GETPHARMACYMEDICINE";
export const GETALLPHARMACYMEDICINE = "GETALLPHARMACYMEDICINE";
export const DELETEPHARMACYMEDICINE = "DELETEPHARMACYMEDICINE";
export const UPDATEPHARMACYMEDICINE = "UPDATEPHARMACYMEDICINE";
export const GETALLPHARMACYMEDICINEQTY = "GETALLPHARMACYMEDICINEQTY";
export const CREATEPURCHESEMEDICINE = "CREATEIPDPURCHESEMEDICINE";
export const GETPURCHESEMEDICINE = "GETPURCHESEMEDICINE";
export const GETPURCHESEMEDICINEAVIQTY = "GETPURCHESEMEDICINEAVLQTY";

export const GETALLPURCHESEMEDICINE = "GETALLPURCHESEMEDICINE";
export const DELETEPURCHESEMEDICINE = "DELETEPURCHESEMEDICINE";
export const UPDATEPURCHESEMEDICINE = "UPDATEPURCHESEMEDICINE";
export const CREATEPURCHESEMEDICINESHOW = "CREATEIPDPURCHESEMEDICINESHOW";
export const GETPURCHESEMEDICINESHOW = "GETPURCHESEMEDICINESHOW";
export const GETALLPURCHESEMEDICINESHOW = "GETALLPURCHESEMEDICINESHOW";
export const DELETEPURCHESEMEDICINESHOW = "DELETEPURCHESEMEDICINESHOW";
export const UPDATEPURCHESEMEDICINESHOW = "UPDATEPURCHESEMEDICINESHOW";
export const UPDATEAVAILQTY = "UPDATEAVAILQTY";

export const RESERVE_STOCK_SUCCESS = "RESERVE_STOCK_SUCCESS";
export const RESERVE_STOCK_FAILURE = "RESERVE_STOCK_FAILURE";
export const RESTORE_RESERVED_STOCK_SUCCESS = "RESTORE_RESERVED_STOCK_SUCCESS";
export const RESTORE_RESERVED_STOCK_FAILURE = "RESTORE_RESERVED_STOCK_FAILURE";

export const CREATEPURCHESEMEDICINEBILL = "CREATEIPDPURCHESEMEDICINEBILL";
export const GETPURCHESEMEDICINEBILL = "GETPURCHESEMEDICINEBILL";
export const GETALLPURCHESEMEDICINEBILL = "GETALLPURCHESEMEDICINEBILL";
export const DELETEPURCHESEMEDICINEBILL = "DELETEPURCHESEMEDICINEBILL";
export const UPDATEPURCHESEMEDICINEBILL = "UPDATEPURCHESEMEDICINEBILL";
export const CREATEPURCHESEMEDICINEBILLTRANSACTION = "CREATEIPDPURCHESEMEDICINEBILLTRANSACTION";
export const GETPURCHESEMEDICINEBILLTRANSACTION = "GETPURCHESEMEDICINEBILLTRANSACTION";
export const GETALLPURCHESEMEDICINEBILLTRANSACTION = "GETALLPURCHESEMEDICINEBILLTRANSACTION";
export const DELETEPURCHESEMEDICINEBILLTRANSACTION = "DELETEPURCHESEMEDICINEBILLTRANSACTION";
export const UPDATEPURCHESEMEDICINEBILLTRANSACTION = "UPDATEPURCHESEMEDICINEBILLTRANSACTION";
export const CREATEPHARMACYBILL = "CREATEIPDPHARMACYBILL";
export const GETPHARMACYBILL = "GETPHARMACYBILL";
export const GETALLPHARMACYBILL = "GETALLPHARMACYBILL";
export const DELETEPHARMACYBILL = "DELETEPHARMACYBILL";
export const UPDATEPHARMACYBILL = "UPDATEPHARMACYBILL";
export const CREATEPHARMACYBILLMEDICINE = "CREATEIPDPHARMACYBILLMEDICINE";
export const GETPHARMACYBILLMEDICINE = "GETPHARMACYBILLMEDICINE";
export const GETALLPHARMACYBILLMEDICINE = "GETALLPHARMACYBILLMEDICINE";
export const DELETEPHARMACYBILLMEDICINE = "DELETEPHARMACYBILLMEDICINE";
export const UPDATEPHARMACYBILLMEDICINE = "UPDATEPHARMACYBILLMEDICINE";

export const CREATEPHARMACYBADSTOCK = "CREATEIPDPHARMACYBADSTOCK";
export const GETPHARMACYBADSTOCK = "GETPHARMACYBADSTOCK";
export const GETALLPHARMACYBADSTOCK = "GETALLPHARMACYBADSTOCK";
export const DELETEPHARMACYBADSTOCK = "DELETEPHARMACYBADSTOCK";
export const UPDATEPHARMACYBADSTOCK = "UPDATEPHARMACYBADSTOCK";

export const CREATEPATHOLOGYTEST = "CREATEIPDPATHOLOGYTEST";
export const GETPATHOLOGYTEST = "GETPATHOLOGYTEST";
export const GETALLPATHOLOGYTEST = "GETALLPATHOLOGYTEST";
export const DELETEPATHOLOGYTEST = "DELETEPATHOLOGYTEST";
export const UPDATEPATHOLOGYTEST = "UPDATEPATHOLOGYTEST";
export const CREATEPATHOLOGYTESTPARAMETER = "CREATEIPDPATHOLOGYTESTPARAMETER";
export const GETPATHOLOGYTESTPARAMETER = "GETPATHOLOGYTESTPARAMETER";
export const GETALLPATHOLOGYTESTPARAMETER = "GETALLPATHOLOGYTESTPARAMETER";
export const DELETEPATHOLOGYTESTPARAMETER = "DELETEPATHOLOGYTESTPARAMETER";
export const UPDATEPATHOLOGYTESTPARAMETER = "UPDATEPATHOLOGYTESTPARAMETER";

export const CREATEPATHOLOGYBILL = "CREATEIPDPATHOLOGYBILL";
export const GETPATHOLOGYBILL = "GETPATHOLOGYBILL";
export const GETALLPATHOLOGYBILL = "GETALLPATHOLOGYBILL";
export const DELETEPATHOLOGYBILL = "DELETEPATHOLOGYBILL";
export const UPDATEPATHOLOGYBILL = "UPDATEPATHOLOGYBILL";
export const CREATEPATHOLOGYBILLTEST = "CREATEIPDPATHOLOGYBILLTEST";
export const GETPATHOLOGYBILLTEST = "GETPATHOLOGYBILLTEST";
export const GETALLPATHOLOGYBILLTEST = "GETALLPATHOLOGYBILLTEST";
export const DELETEPATHOLOGYBILLTEST = "DELETEPATHOLOGYBILLTEST";
export const UPDATEPATHOLOGYBILLTEST = "UPDATEPATHOLOGYBILLTEST";
export const CREATEPATHOLOGYTESTCOLLECTER = "CREATEIPDPATHOLOGYTESTCOLLECTER";
export const GETPATHOLOGYTESTCOLLECTER = "GETPATHOLOGYTESTCOLLECTER";
export const GETALLPATHOLOGYTESTCOLLECTER = "GETALLPATHOLOGYTESTCOLLECTER";
export const DELETEPATHOLOGYTESTCOLLECTER = "DELETEPATHOLOGYTESTCOLLECTER";
export const UPDATEPATHOLOGYTESTCOLLECTER = "UPDATEPATHOLOGYTESTCOLLECTER";

export const CREATERADIOLOGYTEST = "CREATEIPDRADIOLOGYTEST";
export const GETRADIOLOGYTEST = "GETRADIOLOGYTEST";
export const GETALLRADIOLOGYTEST = "GETALLRADIOLOGYTEST";
export const DELETERADIOLOGYTEST = "DELETERADIOLOGYTEST";
export const UPDATERADIOLOGYTEST = "UPDATERADIOLOGYTEST";
export const CREATERADIOLOGYOPDTEST = "CREATEIPDRADIOLOGYOPDTEST";
export const GETRADIOLOGYOPDTEST = "GETRADIOLOGYOPDTEST";
export const GETALLRADIOLOGYOPDTEST = "GETALLRADIOLOGYOPDTEST";
export const DELETERADIOLOGYOPDTEST = "DELETERADIOLOGYOPDTEST";
export const UPDATERADIOLOGYOPDTEST = "UPDATERADIOLOGYOPDTEST";
export const CREATEPATHOLOGYOPDTEST = "CREATEIPDPATHOLOGYOPDTEST";
export const GETPATHOLOGYOPDTEST = "GETPATHOLOGYOPDTEST";
export const GETALLPATHOLOGYOPDTEST = "GETALLPATHOLOGYOPDTEST";
export const DELETEPATHOLOGYOPDTEST = "DELETEPATHOLOGYOPDTEST";
export const UPDATEPATHOLOGYOPDTEST = "UPDATEPATHOLOGYOPDTEST";
export const CREATERADIOLOGYTESTPARAMETER = "CREATEIPDRADIOLOGYTESTPARAMETER";
export const GETRADIOLOGYTESTPARAMETER = "GETRADIOLOGYTESTPARAMETER";
export const GETALLRADIOLOGYTESTPARAMETER = "GETALLRADIOLOGYTESTPARAMETER";
export const DELETERADIOLOGYTESTPARAMETER = "DELETERADIOLOGYTESTPARAMETER";
export const UPDATERADIOLOGYTESTPARAMETER = "UPDATERADIOLOGYTESTPARAMETER";
export const CREATERADIOLOGYTESTPARAMETERVALUE =
  "CREATEIPDRADIOLOGYTESTPARAMETERVALUE";
export const GETRADIOLOGYTESTPARAMETERVALUE = "GETRADIOLOGYTESTPARAMETERVALUE";
export const GETALLRADIOLOGYTESTPARAMETERVALUE =
  "GETALLRADIOLOGYTESTPARAMETERVALUE";
export const DELETERADIOLOGYTESTPARAMETERVALUE =
  "DELETERADIOLOGYTESTPARAMETERVALUE";
export const UPDATERADIOLOGYTESTPARAMETERVALUE =
  "UPDATERADIOLOGYTESTPARAMETERVALUE";
export const CREATEPATHOLOGYTESTPARAMETERVALUE =
  "CREATEIPDPATHOLOGYTESTPARAMETERVALUE";
export const GETPATHOLOGYTESTPARAMETERVALUE = "GETPATHOLOGYTESTPARAMETERVALUE";
export const GETALLPATHOLOGYTESTPARAMETERVALUE =
  "GETALLPATHOLOGYTESTPARAMETERVALUE";
export const DELETEPATHOLOGYTESTPARAMETERVALUE =
  "DELETEPATHOLOGYTESTPARAMETERVALUE";
export const UPDATEPATHOLOGYTESTPARAMETERVALUE =
  "UPDATEPATHOLOGYTESTPARAMETERVALUE";
export const CREATERADIOLOGYBILL = "CREATEIPDRADIOLOGYBILL";
export const GETRADIOLOGYBILL = "GETRADIOLOGYBILL";
export const GETALLRADIOLOGYBILL = "GETALLRADIOLOGYBILL";
export const DELETERADIOLOGYBILL = "DELETERADIOLOGYBILL";
export const UPDATERADIOLOGYBILL = "UPDATERADIOLOGYBILL";
export const CREATERADIOLOGYBILLTEST = "CREATEIPDRADIOLOGYBILLTEST";
export const GETRADIOLOGYBILLTEST = "GETRADIOLOGYBILLTEST";
export const GETALLRADIOLOGYBILLTEST = "GETALLRADIOLOGYBILLTEST";
export const DELETERADIOLOGYBILLTEST = "DELETERADIOLOGYBILLTEST";
export const UPDATERADIOLOGYBILLTEST = "UPDATERADIOLOGYBILLTEST";
export const CREATERADIOLOGYTESTCOLLECTER = "CREATEIPDRADIOLOGYTESTCOLLECTER";
export const GETRADIOLOGYTESTCOLLECTER = "GETRADIOLOGYTESTCOLLECTER";
export const GETALLRADIOLOGYTESTCOLLECTER = "GETALLRADIOLOGYTESTCOLLECTER";
export const DELETERADIOLOGYTESTCOLLECTER = "DELETERADIOLOGYTESTCOLLECTER";
export const UPDATERADIOLOGYTESTCOLLECTER = "UPDATERADIOLOGYTESTCOLLECTER";
export const CREATERADIOLOGYBILLTRANSACTION =
  "CREATEIPDRADIOLOGYBILLTRANSACTION";
export const GETRADIOLOGYBILLTRANSACTION = "GETRADIOLOGYBILLTRANSACTION";
export const GETALLRADIOLOGYBILLTRANSACTION = "GETALLRADIOLOGYBILLTRANSACTION";
export const DELETERADIOLOGYBILLTRANSACTION = "DELETERADIOLOGYBILLTRANSACTION";
export const UPDATERADIOLOGYBILLTRANSACTION = "UPDATERADIOLOGYBILLTRANSACTION";
export const CREATEPATHOLOGYBILLTRANSACTION =
  "CREATEIPDPATHOLOGYBILLTRANSACTION";
export const GETPATHOLOGYBILLTRANSACTION = "GETPATHOLOGYBILLTRANSACTION";

export const GETALLPATHOLOGYBILLTRANSACTION = "GETALLPATHOLOGYBILLTRANSACTION";
export const DELETEPATHOLOGYBILLTRANSACTION = "DELETEPATHOLOGYBILLTRANSACTION";
export const UPDATEPATHOLOGYBILLTRANSACTION = "UPDATEPATHOLOGYBILLTRANSACTION";
export const CREATEBLOODBANKDONAR = "CREATEIPDBLOODBANKDONAR";
export const GETBLOODBANKDONAR = "GETBLOODBANKDONAR";
export const GETALLBLOODBANKDONAR = "GETALLBLOODBANKDONAR";
export const DELETEBLOODBANKDONAR = "DELETEBLOODBANKDONAR";
export const UPDATEBLOODBANKDONAR = "UPDATEBLOODBANKDONAR";
export const CREATEBLOODBANKBAGRECEIVE = "CREATEIPDBLOODBANKBAGRECEIVE";
export const GETBLOODBANKBAGRECEIVE = "GETBLOODBANKBAGRECEIVE";
export const GETALLBLOODBANKBAGRECEIVE = "GETALLBLOODBANKBAGRECEIVE";
export const DELETEBLOODBANKBAGRECEIVE = "DELETEBLOODBANKBAGRECEIVE";
export const UPDATEBLOODBANKBAGRECEIVE = "UPDATEBLOODBANKBAGRECEIVE";
export const CREATEBLOODBANKBAGRECEIVETRANSACTION =
  "CREATEIPDBLOODBANKBAGRECEIVETRANSACTION";
export const GETBLOODBANKBAGRECEIVETRANSACTION =
  "GETBLOODBANKBAGRECEIVETRANSACTION";
export const GETALLBLOODBANKBAGRECEIVETRANSACTION =
  "GETALLBLOODBANKBAGRECEIVETRANSACTION";
export const DELETEBLOODBANKBAGRECEIVETRANSACTION =
  "DELETEBLOODBANKBAGRECEIVETRANSACTION";
export const UPDATEBLOODBANKBAGRECEIVETRANSACTION =
  "UPDATEBLOODBANKBAGRECEIVETRANSACTION";
export const CREATEBLOODBANKCOMPONENT = "CREATEIPDBLOODBANKCOMPONENT";
export const GETBLOODBANKCOMPONENT = "GETBLOODBANKCOMPONENT";
export const GETALLBLOODBANKCOMPONENT = "GETALLBLOODBANKCOMPONENT";
export const DELETEBLOODBANKCOMPONENT = "DELETEBLOODBANKCOMPONENT";
export const UPDATEBLOODBANKCOMPONENT = "UPDATEBLOODBANKCOMPONENT";
export const CREATEPHARMACYBILLTRANSACTION = "CREATEIPDPHARMACYBILLTRANSACTION";
export const GETPHARMACYBILLTRANSACTION = "GETPHARMACYBILLTRANSACTION";
export const GETALLPHARMACYBILLTRANSACTION = "GETALLPHARMACYBILLTRANSACTION";
export const DELETEPHARMACYBILLTRANSACTION = "DELETEPHARMACYBILLTRANSACTION";
export const UPDATEPHARMACYBILLTRANSACTION = "UPDATEPHARMACYBILLTRANSACTION";

export const CREATEBLOODBANKBAGISSUE = "CREATEIPDBLOODBANKBAGISSUE";
export const GETBLOODBANKBAGISSUE = "GETBLOODBANKBAGISSUE";
export const GETALLBLOODBANKBAGISSUE = "GETALLBLOODBANKBAGISSUE";
export const DELETEBLOODBANKBAGISSUE = "DELETEBLOODBANKBAGISSUE";
export const UPDATEBLOODBANKBAGISSUE = "UPDATEBLOODBANKBAGISSUE";
export const CREATEBLOODBANKBAGISSUETRANSACTION =
  "CREATEIPDBLOODBANKBAGISSUETRANSACTION";
export const GETBLOODBANKBAGISSUETRANSACTION =
  "GETBLOODBANKBAGISSUETRANSACTION";
export const GETALLBLOODBANKBAGISSUETRANSACTION =
  "GETALLBLOODBANKBAGISSUETRANSACTION";
export const DELETEBLOODBANKBAGISSUETRANSACTION =
  "DELETEBLOODBANKBAGISSUETRANSACTION";
export const UPDATEBLOODBANKBAGISSUETRANSACTION =
  "UPDATEBLOODBANKBAGISSUETRANSACTION";
export const CREATEBLOODBANKCOMPONENTISSUE = "CREATEIPDBLOODBANKCOMPONENTISSUE";
export const GETBLOODBANKCOMPONENTISSUE = "GETBLOODBANKCOMPONENTISSUE";
export const GETALLBLOODBANKCOMPONENTISSUE = "GETALLBLOODBANKCOMPONENTISSUE";
export const DELETEBLOODBANKCOMPONENTISSUE = "DELETEBLOODBANKCOMPONENTISSUE";
export const UPDATEBLOODBANKCOMPONENTISSUE = "UPDATEBLOODBANKCOMPONENTISSUE";
export const CREATEBLOODBANKCOMPONENTISSUETRANSACTION =
  "CREATEIPDBLOODBANKCOMPONENTISSUETRANSACTION";
export const GETBLOODBANKCOMPONENTISSUETRANSACTION =
  "GETBLOODBANKCOMPONENTISSUETRANSACTION";
export const GETALLBLOODBANKCOMPONENTISSUETRANSACTION =
  "GETALLBLOODBANKCOMPONENTISSUETRANSACTION";
export const DELETEBLOODBANKCOMPONENTISSUETRANSACTION =
  "DELETEBLOODBANKCOMPONENTISSUETRANSACTION";
export const UPDATEBLOODBANKCOMPONENTISSUETRANSACTION =
  "UPDATEBLOODBANKCOMPONENTISSUETRANSACTION";

export const CREATEAMBULANCE = "CREATEIPDAMBULANCE";
export const GETAMBULANCE = "GETAMBULANCE";
export const GETALLAMBULANCE = "GETALLAMBULANCE";
export const DELETEAMBULANCE = "DELETEAMBULANCE";
export const UPDATEAMBULANCE = "UPDATEAMBULANCE";
export const CREATEAMBULANCECALL = "CREATEIPDAMBULANCECALL";
export const GETAMBULANCECALL = "GETAMBULANCECALL";
export const GETALLAMBULANCECALL = "GETALLAMBULANCECALL";
export const DELETEAMBULANCECALL = "DELETEAMBULANCECALL";
export const UPDATEAMBULANCECALL = "UPDATEAMBULANCECALL";
export const CREATEAMBULANCECALLTRANSACTION =
  "CREATEIPDAMBULANCECALLTRANSACTION";
export const GETAMBULANCECALLTRANSACTION = "GETAMBULANCECALLTRANSACTION";
export const GETALLAMBULANCECALLTRANSACTION = "GETALLAMBULANCECALLTRANSACTION";
export const DELETEAMBULANCECALLTRANSACTION = "DELETEAMBULANCECALLTRANSACTION";
export const UPDATEAMBULANCECALLTRANSACTION = "UPDATEAMBULANCECALLTRANSACTION";

export const CREATEFRONTOFFICEPHONECALLLOG = "CREATEIPDFRONTOFFICEPHONECALLLOG";
export const GETFRONTOFFICEPHONECALLLOG = "GETFRONTOFFICEPHONECALLLOG";
export const GETALLFRONTOFFICEPHONECALLLOG = "GETALLFRONTOFFICEPHONECALLLOG";
export const GETBYIDFRONTOFFICEPHONECALLLOG = "GETBYIDFRONTOFFICEPHONECALLLOG"
export const DELETEFRONTOFFICEPHONECALLLOG = "DELETEFRONTOFFICEPHONECALLLOG";
export const UPDATEFRONTOFFICEPHONECALLLOG = "UPDATEFRONTOFFICEPHONECALLLOG";
export const CREATEFRONTOFFICEVISITOR = "CREATEIPDFRONTOFFICEVISITOR";
export const GETFRONTOFFICEVISITOR = "GETFRONTOFFICEVISITOR";
export const GETALLFRONTOFFICEVISITOR = "GETALLFRONTOFFICEVISITOR";
export const DELETEFRONTOFFICEVISITOR = "DELETEFRONTOFFICEVISITOR";
export const UPDATEFRONTOFFICEVISITOR = "UPDATEFRONTOFFICEVISITOR";
export const CREATEFRONTOFFICEPOSTAL = "CREATEIPDFRONTOFFICEPOSTAL";
export const GETFRONTOFFICEPOSTAL = "GETFRONTOFFICEPOSTAL";
export const GETALLFRONTOFFICEPOSTAL = "GETALLFRONTOFFICEPOSTAL";
export const DELETEFRONTOFFICEPOSTAL = "DELETEFRONTOFFICEPOSTAL";
export const UPDATEFRONTOFFICEPOSTAL = "UPDATEFRONTOFFICEPOSTAL";
export const CREATEFRONTOFFICEPOSTALDISPATCH =
  "CREATEIPDFRONTOFFICEPOSTALDISPATCH";
export const GETFRONTOFFICEPOSTALDISPATCH = "GETFRONTOFFICEPOSTALDISPATCH";
export const GETALLFRONTOFFICEPOSTALDISPATCH =
  "GETALLFRONTOFFICEPOSTALDISPATCH";
export const DELETEFRONTOFFICEPOSTALDISPATCH =
  "DELETEFRONTOFFICEPOSTALDISPATCH";
export const UPDATEFRONTOFFICEPOSTALDISPATCH =
  "UPDATEFRONTOFFICEPOSTALDISPATCH";
export const CREATEFRONTOFFICECOMPLAIN = "CREATEIPDFRONTOFFICECOMPLAIN";
export const GETFRONTOFFICECOMPLAIN = "GETFRONTOFFICECOMPLAIN";
export const GETALLFRONTOFFICECOMPLAIN = "GETALLFRONTOFFICECOMPLAIN";
export const DELETEFRONTOFFICECOMPLAIN = "DELETEFRONTOFFICECOMPLAIN";
export const UPDATEFRONTOFFICECOMPLAIN = "UPDATEFRONTOFFICECOMPLAIN";

export const CREATEIPDPATIENT = "CREATEIPDIPDPATIENT";
export const GETALLIPD = "GETALLIPD";

export const GETIPDPATIENT = "GETIPDPATIENT";
export const GETIPDPATIENTLIKE = "GETIPDPATIENTLIKE";


export const GETIPDPATIENTBYID = "GETIPDPATIENTBYID";
export const DELETEIPDPATIENT = "DELETEIPDPATIENT";
export const UPDATEIPDPATIENT = "UPDATEIPDPATIENT";
export const UPDATEIPDPATIENTACTION = "UPDATEIPDPATIENTACTION";
export const CREATEIPDVISITS = "CREATEIPDIPDVISITS";
export const GETIPDVISITS = "GETIPDVISITS";
export const GETALLIPDVISITS = "GETALLIPDVISITS";
export const DELETEIPDVISITS = "DELETEIPDVISITS";
export const UPDATEIPDVISITS = "UPDATEIPDVISITS";
export const CREATEIPDOUTBILL = "CREATEIPDIPDOUTBILL";
export const GETIPDOUTBILL = "GETIPDOUTBILL";
export const GETALLIPDOUTBILL = "GETALLIPDOUTBILL";
export const DELETEIPDOUTBILL = "DELETEIPDOUTBILL";
export const UPDATEIPDOUTBILL = "UPDATEIPDOUTBILL";
export const CREATEHOSPITALEBIRTHRECORD = "CREATEIPDHOSPITALEBIRTHRECORD";
export const GETHOSPITALEBIRTHRECORD = "GETHOSPITALEBIRTHRECORD";
export const GETALLHOSPITALEBIRTHRECORD = "GETALLHOSPITALEBIRTHRECORD";
export const DELETEHOSPITALEBIRTHRECORD = "DELETEHOSPITALEBIRTHRECORD";
export const UPDATEHOSPITALEBIRTHRECORD = "UPDATEHOSPITALEBIRTHRECORD";
export const CREATEHOSPITALEDEATHRECORD = "CREATEIPDHOSPITALEDEATHRECORD";
export const GETHOSPITALEDEATHRECORD = "GETHOSPITALEDEATHRECORD";
export const GETALLHOSPITALEDEATHRECORD = "GETALLHOSPITALEDEATHRECORD";
export const DELETEHOSPITALEDEATHRECORD = "DELETEHOSPITALEDEATHRECORD";
export const UPDATEHOSPITALEDEATHRECORD = "UPDATEHOSPITALEDEATHRECORD";
export const CREATEHOSPITALEINCOME = "CREATEIPDHOSPITALEINCOME";
export const GETHOSPITALEINCOME = "GETHOSPITALEINCOME";
export const GETALLHOSPITALEINCOME = "GETALLHOSPITALEINCOME";
export const DELETEHOSPITALEINCOME = "DELETEHOSPITALEINCOME";
export const UPDATEHOSPITALEINCOME = "UPDATEHOSPITALEINCOME";
export const CREATEHOSPITALEEXPENSE = "CREATEIPDHOSPITALEEXPENSE";
export const GETHOSPITALEEXPENSE = "GETHOSPITALEEXPENSE";
export const GETALLHOSPITALEEXPENSE = "GETALLHOSPITALEEXPENSE";
export const DELETEHOSPITALEEXPENSE = "DELETEHOSPITALEEXPENSE";
export const UPDATEHOSPITALEEXPENSE = "UPDATEHOSPITALEEXPENSE";
export const CREATEHOSPITALEINVENTORYITEM = "CREATEIPDHOSPITALEINVENTORYITEM";
export const GETHOSPITALEINVENTORYITEM = "GETHOSPITALEINVENTORYITEM";
export const GETALLHOSPITALEINVENTORYITEM = "GETALLHOSPITALEINVENTORYITEM";
export const DELETEHOSPITALEINVENTORYITEM = "DELETEHOSPITALEINVENTORYITEM";
export const UPDATEHOSPITALEINVENTORYITEM = "UPDATEHOSPITALEINVENTORYITEM";
export const CREATEHOSPITALEINVENTORYSTOCK = "CREATEIPDHOSPITALEINVENTORYSTOCK";
export const GETHOSPITALEINVENTORYSTOCK = "GETHOSPITALEINVENTORYSTOCK";
export const GETALLHOSPITALEINVENTORYSTOCK = "GETALLHOSPITALEINVENTORYSTOCK";
export const DELETEHOSPITALEINVENTORYSTOCK = "DELETEHOSPITALEINVENTORYSTOCK";
export const UPDATEHOSPITALEINVENTORYSTOCK = "UPDATEHOSPITALEINVENTORYSTOCK";
export const CREATEHOSPITALEINVENTORYITEMISSUE =
  "CREATEIPDHOSPITALEINVENTORYITEMISSUE";
export const GETHOSPITALEINVENTORYITEMISSUE = "GETHOSPITALEINVENTORYITEMISSUE";
export const GETALLHOSPITALEINVENTORYITEMISSUE =
  "GETALLHOSPITALEINVENTORYITEMISSUE";
export const DELETEHOSPITALEINVENTORYITEMISSUE =
  "DELETEHOSPITALEINVENTORYITEMISSUE";
export const UPDATEHOSPITALEINVENTORYITEMISSUE =
  "UPDATEHOSPITALEINVENTORYITEMISSUE";
export const CREATEHOSPITALEDOWNLOAD = "CREATEIPDHOSPITALEDOWNLOAD";
export const GETHOSPITALEDOWNLOAD = "GETHOSPITALEDOWNLOAD";
export const GETALLHOSPITALEDOWNLOAD = "GETALLHOSPITALEDOWNLOAD";
export const DELETEHOSPITALEDOWNLOAD = "DELETEHOSPITALEDOWNLOAD";
export const UPDATEHOSPITALEDOWNLOAD = "UPDATEHOSPITALEDOWNLOAD";
export const CREATEHOSPITALEMESSAGE = "CREATEIPDHOSPITALEMESSAGE";
export const GETHOSPITALEMESSAGE = "GETHOSPITALEMESSAGE";
export const GETALLHOSPITALEMESSAGE = "GETALLHOSPITALEMESSAGE";
export const DELETEHOSPITALEMESSAGE = "DELETEHOSPITALEMESSAGE";
export const UPDATEHOSPITALEMESSAGE = "UPDATEHOSPITALEMESSAGE";
export const CREATEHOSPITALESENDMESSAGE = "CREATEIPDHOSPITALESENDMESSAGE";
export const GETHOSPITALESENDMESSAGE = "GETHOSPITALESENDMESSAGE";
export const GETALLHOSPITALESENDMESSAGE = "GETALLHOSPITALESENDMESSAGE";
export const DELETEHOSPITALESENDMESSAGE = "DELETEHOSPITALESENDMESSAGE";
export const UPDATEHOSPITALESENDMESSAGE = "UPDATEHOSPITALESENDMESSAGE";
export const CREATEHOSPITALESENDEMAIL = "CREATEIPDHOSPITALESENDEMAIL";
export const GETHOSPITALESENDEMAIL = "GETHOSPITALESENDEMAIL";
export const GETALLHOSPITALESENDEMAIL = "GETALLHOSPITALESENDEMAIL";
export const DELETEHOSPITALESENDEMAIL = "DELETEHOSPITALESENDEMAIL";
export const UPDATEHOSPITALESENDEMAIL = "UPDATEHOSPITALESENDEMAIL";
export const CREATEHRSTAFFATTENDANCE = "CREATEIPDHRSTAFFATTENDANCE";
export const GETHRSTAFFATTENDANCE = "GETHRSTAFFATTENDANCE";
export const GETALLHRSTAFFATTENDANCE = "GETALLHRSTAFFATTENDANCE";
export const DELETEHRSTAFFATTENDANCE = "DELETEHRSTAFFATTENDANCE";
export const UPDATEHRSTAFFATTENDANCE = "UPDATEHRSTAFFATTENDANCE";
export const CREATEHRSTAFFPAYROLLDEDUCTION = "CREATEIPDHRSTAFFPAYROLLDEDUCTION";
export const GETHRSTAFFPAYROLLDEDUCTION = "GETHRSTAFFPAYROLLDEDUCTION";
export const GETALLHRSTAFFPAYROLLDEDUCTION = "GETALLHRSTAFFPAYROLLDEDUCTION";
export const DELETEHRSTAFFPAYROLLDEDUCTION = "DELETEHRSTAFFPAYROLLDEDUCTION";
export const UPDATEHRSTAFFPAYROLLDEDUCTION = "UPDATEHRSTAFFPAYROLLDEDUCTION";
export const CREATEHRSTAFFPAYROLLINFO = "CREATEIPDHRSTAFFPAYROLLINFO";
export const GETHRSTAFFPAYROLLINFO = "GETHRSTAFFPAYROLLINFO";
export const GETALLHRSTAFFPAYROLLINFO = "GETALLHRSTAFFPAYROLLINFO";
export const DELETEHRSTAFFPAYROLLINFO = "DELETEHRSTAFFPAYROLLINFO";
export const UPDATEHRSTAFFPAYROLLINFO = "UPDATEHRSTAFFPAYROLLINFO";
export const CREATEHRSTAFFPAYROLLPAYMENT = "CREATEIPDHRSTAFFPAYROLLPAYMENT";
export const GETHRSTAFFPAYROLLPAYMENT = "GETHRSTAFFPAYROLLPAYMENT";
export const GETALLHRSTAFFPAYROLLPAYMENT = "GETALLHRSTAFFPAYROLLPAYMENT";
export const DELETEHRSTAFFPAYROLLPAYMENT = "DELETEHRSTAFFPAYROLLPAYMENT";
export const UPDATEHRSTAFFPAYROLLPAYMENT = "UPDATEHRSTAFFPAYROLLPAYMENT";
export const CREATEHRSTAFFLEAVE = "CREATEIPDHRSTAFFLEAVE";
export const GETHRSTAFFLEAVE = "GETHRSTAFFLEAVE";
export const GETALLHRSTAFFLEAVE = "GETALLHRSTAFFLEAVE";
export const DELETEHRSTAFFLEAVE = "DELETEHRSTAFFLEAVE";
export const UPDATEHRSTAFFLEAVE = "UPDATEHRSTAFFLEAVE";
export const CREATEHRSTAFFLEAVEAPPROVE = "CREATEIPDHRSTAFFLEAVEAPPROVE";
export const GETHRSTAFFLEAVEAPPROVE = "GETHRSTAFFLEAVEAPPROVE";
export const GETALLHRSTAFFLEAVEAPPROVE = "GETALLHRSTAFFLEAVEAPPROVE";
export const DELETEHRSTAFFLEAVEAPPROVE = "DELETEHRSTAFFLEAVEAPPROVE";
export const UPDATEHRSTAFFLEAVEAPPROVE = "UPDATEHRSTAFFLEAVEAPPROVE";
export const COPYPROJECT = "COPYPROJECT";
export const CREATEPROJECT = "CREATEPROJECT";
export const GETPROJECT = "GETPROJECT";
export const DELETEPROJECT = "DELETEPROJECT";
export const UPDATEPROJECT = "UPDATEPROJECT";
export const GETALLMODULE = "GETALLMODULE";
export const CREATEPROJECTMODULE = "CREATEPROJECTMODULE";
export const GETPROJECTMODULE = "GETPROJECTMODULE";
export const DELETEPROJECTMODULE = "DELETEPROJECTMODULE";
export const UPDATEPROJECTMODULE = "UPDATEPROJECTMODULE";
export const CREATEPROJECTGROUP = "CREATEPROJECTGROUP";
export const GETPROJECTGROUP = "GETPROJECTGROUP";
export const DELETEPROJECTGROUP = "DELETEPROJECTGROUP";
export const UPDATEPROJECTGROUP = "UPDATEPROJECTGROUP";
export const CREATEPROJECTTASK = "CREATEPROJECTTASK";
export const GETPROJECTTASK = "GETPROJECTTASK";
export const GETALLPROJECTTASK = "GETALLPROJECTTASK";
export const DELETEPROJECTTASK = "DELETEPROJECTTASK";
export const UPDATEPROJECTTASK = "UPDATEPROJECTTASK";
export const CREATEPROJECTISSUE = "CREATEPROJECTISSUE";
export const GETPROJECTISSUE = "GETPROJECTISSUE";
export const GETALLPROJECTISSUE = "GETALLPROJECTISSUE";
export const DELETEPROJECTISSUE = "DELETEPROJECTISSUE";
export const UPDATEPROJECTISSUE = "UPDATEPROJECTISSUE";
export const CREATECONSALTATION = "CREATECONSALTATION";
export const GETCONSALTATION = "GETCONSALTATION";
export const UPDATECONSALTATION = "UPDATECONSALTATION";
export const DELETECONSALTATION = "DELETECONSALTATION";

export const CREATEMEETING = "CREATEMEETING";
export const GETMEETING = "GETMEETING";
export const GETALLMEETING = "GETALLMEETING";
export const UPDATEMEETING = "UPDATEMEETING";
export const DELETEMEETING = "DELETEMEETING";

export const CREATEMEETINGSTAFF = "CREATEMEETINGSTAFF";
export const GETMEETINGSTAFF = "GETMEETINGSTAFF";
export const UPDATEMEETINGSTAFF = "UPDATEMEETINGSTAFF";
export const DELETEMEETINGSTAFF = "DELETEMEETINGSTAFF";

export const CREATEPRODUCTGROUP = "CREATEPRODUCTGROUP";
export const GETPRODUCTGROUP = "GETPRODUCTGROUP";
export const DELETEPRODUCTGROUP = "DELETEPRODUCTGROUP";
export const UPDATEPRODUCTGROUP = "UPDATEPRODUCTGROUP";
export const CREATEPRODUCT = "CREATEPRODUCT";
export const GETPRODUCT = "GETPRODUCT";
export const DELETEPRODUCT = "DELETEPRODUCT";
export const UPDATEPRODUCT = "UPDATEPRODUCT";


export const CREATECHANELPARTNER = "CREATECHANELPARTNER";
export const GETCHANELPARTNER = "GETCHANELPARTNER";
export const UPDATECHANELPARTNER = "UPDATECHANELPARTNER";
export const DELETECHANELPARTNER = "DELETECHANELPARTNER";
export const CREATECONTACT = "CREATECONTACT";
export const GETCONTACT = "GETCONTACT";
export const DELETECONTACT = "DELETECONTACT";
export const UPDATECONTACT = "UPDATECONTACT";
export const CREATEACCOUNTPERSONAL = "CREATEACCOUNTPERSONAL";
export const GETACCOUNTPERSONAL = "GETACCOUNTPERSONAL";
export const DELETEACCOUNTPERSONAL = "DELETEACCOUNTPERSONAL";
export const UPDATEACCOUNTPERSONAL = "UPDATEACCOUNTPERSONAL";
export const CREATECUSTOMPRODUCTFORACCOUNT = "CREATECUSTOMPRODUCTFORACCOUNT";
export const GETCUSTOMPRODUCTACCOUNT = "GETCUSTOMPRODUCTACCOUNT";
export const UPDATECUSTOMPRODUCTACCOUNT = "UPDATECUSTOMPRODUCTACCOUNT";

export const CREATELEAD = "CREATELEAD";
export const GETLEAD = "GETLEAD";
export const DELETELEAD = "DELETELEAD";
export const UPDATELEAD = "UPDATELEAD";

export const CREATELEADTASK = "CREATELEADTASK";
export const GETLEADTASK = "GETLEADTASK";
export const DELETELEADTASK = "DELETELEADTASK";
export const UPDATELEADTASK = "UPDATELEADTASK";

export const CREATELEADCASE = "CREATELEADCASE";
export const GETLEADCASE = "GETLEADCASE";
export const DELETELEADCASE = "DELETELEADCASE";
export const UPDATELEADCASE = "UPDATELEADCASE";

export const CREATEBANK = "CREATEBANK";
export const GETBANK = "GETBANK";
export const DELETEBANK = "DELETEBANK";
export const UPDATEBANK = "UPDATEBANK";

export const CREATECARD = "CREATECARD";
export const GETCARD = "GETCARD";
export const DELETECARD = "DELETECARD";
export const UPDATECARD = "UPDATECARD";

export const CREATEORDERS = "CREATEORDERS";
export const GETORDERS = "GETORDERS";
export const DELETEORDERS = "DELETEORDERS";
export const UPDATEORDERS = "UPDATEORDERS";

export const CREATEPRODUCTORDERS = "CREATEPRODUCTORDERS";
export const GETPRODUCTORDERS = "GETPRODUCTORDERS";
export const DELETEPRODUCTORDERS = "DELETEPRODUCTORDERS";
export const UPDATEPRODUCTORDERS = "UPDATEPRODUCTORDERS";

export const CREATEQUOTES = "CREATEQUOTES";
export const GETQUOTES = "GETQUOTES";
export const DELETEQUOTES = "DELETEQUOTES";
export const UPDATEQUOTES = "UPDATEQUOTES";

export const CREATESALESORDERS = "CREATESALESORDERS";
export const GETSALESORDERS = "GETSALESORDERS";
export const GETSALESORDERSDETAILS = "GETSALESORDERSDETAILS";
export const DELETESALESORDERS = "DELETESALESORDERS";
export const UPDATESALESORDERS = "UPDATESALESORDERS";
export const CREATESALESORDERSITEM = "CREATESALESORDERSITEM";
export const CREATESALESORDERSREFRENCE = "CREATESALESORDERSREFRENCE";
export const CREATEREVERSESALESORDERS = "CREATEREVERSESALESORDERS";
export const GETALLSALESORDERSDATA = "GETALLSALESORDERSDATA";
export const UPDATESALESORDERSITEM = "UPDATESALESORDERSITEM";
export const GETALLLOGESALESORDERSDATA = "GETALLLOGESALESORDERSDATA";
export const GETPRODUCTPACKAGERELATION = "GETPRODUCTPACKAGERELATION";
export const UPDATESALESITEM = "UPDATESALESITEM";
export const CREATESALESORDERRECIPT = "CREATESALESORDERRECIPT";
export const DELETELOGESALESITEM = "DELETELOGESALESITEM";
export const DELETELOGESALESITEMBYID = "DELETELOGESALESITEMBYID";
export const UPDATELOGESALESITEM = "UPDATELOGESALESITEM";
export const CREATETEAM = "CREATETEAM";
export const GETTEAM = "GETTEAM";
export const DELETETEAM = "DELETETEAM";
export const UPDATETEAM = "UPDATETEAM";

export const CREATETEAMMEMBER = "CREATETEAMMEMBER";
export const GETTEAMMEMBER = "GETTEAMMEMBER";
export const DELETETEAMMEMBER = "DELETETEAMMEMBER";
export const UPDATETEAMMEMBER = "UPDATETEAMMEMBER";

export const CREATEFORECAST = "CREATEFORECAST";
export const GETFORECAST = "GETFORECAST";
export const DELETEFORECAST = "DELETEFORECAST";
export const UPDATEFORECAST = "UPDATEFORECAST";

export const CREATEQUOTATION = "CREATEQUOTATION";
export const GETQUOTATION = "GETQUOTATION";
export const DELETEQUOTATION = "DELETEQUOTATION";
export const UPDATEQUOTATION = "UPDATEQUOTATION";

export const CREATEINVOICE = "CREATEINVOICE";
export const GETINVOICE = "GETINVOICE";
export const DELETEINVOICE = "DELETEINVOICE";
export const UPDATEINVOICE = "UPDATEINVOICE";
export const CREATETIMELINETYPE = "CREATETIMELINETYPE";
export const GETTIMELINETYPE = "GETTIMELINETYPE";
export const DELETETIMELINETYPE = "DELETETIMELINETYPE";
export const UPDATETIMELINETYPE = "UPDATETIMELINETYPE";

export const CREATEIPDINSYMPTOMS = "CREATEIPDIPDINSYMPTOMS";
export const GETIPDINSYMPTOMS = "GETIPDINSYMPTOMS";
export const GETALLIPDINSYMPTOMS = "GETALLIPDINSYMPTOMS";
export const DELETEIPDINSYMPTOMS = "DELETEIPDINSYMPTOMS";
export const UPDATEIPDINSYMPTOMS = "UPDATEIPDINSYMPTOMS";
export const CREATEIPDINCOBORBIDITY = "CREATEIPDIPDINCOBORBIDITY";
export const GETIPDINCOBORBIDITY = "GETIPDINCOBORBIDITY";
export const GETALLIPDINCOBORBIDITY = "GETALLIPDINCOBORBIDITY";
export const DELETEIPDINCOBORBIDITY = "DELETEIPDINCOBORBIDITY";
export const UPDATEIPDINCOBORBIDITY = "UPDATEIPDINCOBORBIDITY";
export const CREATEIPDININVESTIGATION = "CREATEIPDIPDININVESTIGATION";
export const GETIPDININVESTIGATION = "GETIPDININVESTIGATION";
export const GETALLIPDININVESTIGATION = "GETALLIPDININVESTIGATION";
export const DELETEIPDININVESTIGATION = "DELETEIPDININVESTIGATION";
export const UPDATEIPDININVESTIGATION = "UPDATEIPDININVESTIGATION";

export const CREATEPATIENTCARDTEMPLATE = "CREATEPATIENTCARDTEMPLATE";
export const GETPATIENTCARDTEMPLATE = "GETPATIENTCARDTEMPLATE";
export const DELETEPATIENTCARDTEMPLATE = "DELETEPATIENTCARDTEMPLATE";
export const UPDATEPATIENTCARDTEMPLATE = "UPDATEPATIENTCARDTEMPLATE";
export const CREATEIPDNURSENOTE = "CREATEIPDIPDNURSENOTE";
export const GETIPDNURSENOTE = "GETIPDNURSENOTE";
export const GETALLIPDNURSENOTE = "GETALLIPDNURSENOTE";
export const DELETEIPDNURSENOTE = "DELETEIPDNURSENOTE";
export const UPDATEIPDNURSENOTE = "UPDATEIPDNURSENOTE";
export const CREATEIPDMEDICATION = "CREATEIPDIPDMEDICATION";
export const GETIPDMEDICATION = "GETIPDMEDICATION";
export const GETALLIPDMEDICATION = "GETALLIPDMEDICATION";
export const DELETEIPDMEDICATION = "DELETEIPDMEDICATION";
export const UPDATEIPDMEDICATION = "UPDATEIPDMEDICATION";
export const CREATEIPDDISCHARGE = "CREATEIPDIPDDISCHARGE";
export const GETIPDDISCHARGE = "GETIPDDISCHARGE";
export const GETALLIPDDISCHARGE = "GETALLIPDDISCHARGE";
export const DELETEIPDDISCHARGE = "DELETEIPDDISCHARGE";
export const UPDATEIPDDISCHARGE = "UPDATEIPDDISCHARGE";
export const CREATEIPDPAYMENT = "CREATEIPDIPDPAYMENT";
export const GETIPDPAYMENT = "GETIPDPAYMENT";
export const GETALLIPDPAYMENT = "GETALLIPDPAYMENT";
export const DELETEIPDPAYMENT = "DELETEIPDPAYMENT";
export const UPDATEIPDPAYMENT = "UPDATEIPDPAYMENT";
export const CREATEIPDBEDHISTORY = "CREATEIPDIPDBEDHISTORY";
export const GETIPDBEDHISTORY = "GETIPDBEDHISTORY";
export const GETALLIPDBEDHISTORY = "GETALLIPDBEDHISTORY";
export const DELETEIPDBEDHISTORY = "DELETEIPDBEDHISTORY";
export const UPDATEIPDBEDHISTORY = "UPDATEIPDBEDHISTORY";
export const CREATEIPDCONSULTANTREGISTER = "CREATEIPDIPDCONSULTANTREGISTER";
export const GETIPDCONSULTANTREGISTER = "GETIPDCONSULTANTREGISTER";
export const GETALLIPDCONSULTANTREGISTER = "GETALLIPDCONSULTANTREGISTER";
export const DELETEIPDCONSULTANTREGISTER = "DELETEIPDCONSULTANTREGISTER";
export const UPDATEIPDCONSULTANTREGISTER = "UPDATEIPDCONSULTANTREGISTER";
export const CREATESTAFFCARDTEMPLATE = "CREATESTAFFCARDTEMPLATE";
export const GETSTAFFCARDTEMPLATE = "GETSTAFFCARDTEMPLATE";
export const DELETESTAFFCARDTEMPLATE = "DELETESTAFFCARDTEMPLATE";
export const UPDATESTAFFCARDTEMPLATE = "UPDATESTAFFCARDTEMPLATE";
export const CREATEIPDOPERATION = "CREATEIPDIPDOPERATION";
export const GETIPDOPERATION = "GETIPDOPERATION";
export const GETALLIPDOPERATION = "GETALLIPDOPERATION";
export const DELETEIPDOPERATION = "DELETEIPDOPERATION";
export const UPDATEIPDOPERATION = "UPDATEIPDOPERATION";
export const CREATECERTIFICATETEMPLATE = "CREATECERTIFICATETEMPLATE";
export const GETCERTIFICATETEMPLATE = "GETCERTIFICATETEMPLATE";
export const DELETECERTIFICATETEMPLATE = "DELETECERTIFICATETEMPLATE";
export const UPDATECERTIFICATETEMPLATE = "UPDATECERTIFICATETEMPLATE";
export const CREATEIPDPRESCRIPTIONDATA = "CREATEIPDIPDPRESCRIPTION";
export const GETIPDPRESCRIPTIONDATA = "GETIPDPRESCRIPTIONDATA";
export const GETALLIPDPRESCRIPTIONDATA = "GETALLIPDPRESCRIPTIONDATA";
export const DELETEIPDPRESCRIPTIONDATA = "DELETEIPDPRESCRIPTIONDATA";
export const UPDATEIPDPRESCRIPTIONDATA = "UPDATEIPDPRESCRIPTIONDATA";
export const CREATEIPDPRESCRIPTIONMEDICINE = "CREATEIPDIPDPRESCRIPTIONMEDICINE";
export const GETIPDPRESCRIPTIONMEDICINE = "GETIPDPRESCRIPTIONMEDICINE";
export const GETALLIPDPRESCRIPTIONMEDICINE = "GETALLIPDPRESCRIPTIONMEDICINE";
export const DELETEIPDPRESCRIPTIONMEDICINE = "DELETEIPDPRESCRIPTIONMEDICINE";
export const UPDATEIPDPRESCRIPTIONMEDICINE = "UPDATEIPDPRESCRIPTIONMEDICINE";

export const CREATEHOLIDAYDATE = "CREATEHOLIDAYDATE";
export const GETHOLIDAYDATE = "GETHOLIDAYDATE";
export const DELETEHOLIDAYDATE = "DELETEHOLIDAYDATE";
export const UPDATEHOLIDAYDATE = "UPDATEHOLIDAYDATE";

export const CREATEACTIVITY = "CREATEACTIVITY";
export const GETACTIVITY = "GETACTIVITY";
export const DELETEACTIVITY = "DELETEACTIVITY";
export const UPDATEACTIVITY = "UPDATEACTIVITY";

export const CREATEVACATION = "CREATEVACATION";
export const GETVACATION = "GETVACATION";
export const DELETEVACATION = "DELETEVACATION";
export const UPDATEVACATION = "UPDATEVACATION";
export const CREATEIPDOBSTETRIC = "CREATEIPDIPDOBSTETRIC";
export const GETIPDOBSTETRIC = "GETIPDOBSTETRIC";
export const GETALLIPDOBSTETRIC = "GETALLIPDOBSTETRIC";
export const DELETEIPDOBSTETRIC = "DELETEIPDOBSTETRIC";
export const UPDATEIPDOBSTETRIC = "UPDATEIPDOBSTETRIC";

export const CREATETASK = "CREATETASK";
export const GETTASK = "GETTASK";
export const DELETETASK = "DELETETASK";
export const UPDATETASK = "UPDATETASK";

export const CREATENOTE = "CREATENOTE";
export const GETNOTE = "GETNOTE";
export const DELETENOTE = "DELETENOTE";
export const UPDATENOTE = "UPDATENOTE";

export const CREATEIPDPOSTNATAL = "CREATEIPDIPDPOSTNATAL";
export const GETIPDPOSTNATAL = "GETIPDPOSTNATAL";
export const GETALLIPDPOSTNATAL = "GETALLIPDPOSTNATAL";
export const DELETEIPDPOSTNATAL = "DELETEIPDPOSTNATAL";
export const UPDATEIPDPOSTNATAL = "UPDATEIPDPOSTNATAL";
export const CREATEIPDANTENATAL = "CREATEIPDIPDANTENATAL";
export const GETIPDANTENATAL = "GETIPDANTENATAL";
export const GETALLIPDANTENATAL = "GETALLIPDANTENATAL";
export const DELETEIPDANTENATAL = "DELETEIPDANTENATAL";
export const UPDATEIPDANTENATAL = "UPDATEIPDANTENATAL";
export const CREATEIPDVITAL = "CREATEIPDIPDVITAL";
export const GETIPDVITAL = "GETIPDVITAL";
export const GETALLIPDVITAL = "GETALLIPDVITAL";
export const DELETEIPDVITAL = "DELETEIPDVITAL";
export const UPDATEIPDVITAL = "UPDATEIPDVITAL";
export const CREATECONSULTANTSYMPTOMS = "CREATEIPDCONSULTANTSYMPTOMS";
export const GETCONSULTANTSYMPTOMS = "GETCONSULTANTSYMPTOMS";
export const GETALLCONSULTANTSYMPTOMS = "GETALLCONSULTANTSYMPTOMS";
export const DELETECONSULTANTSYMPTOMS = "DELETECONSULTANTSYMPTOMS";
export const UPDATECONSULTANTSYMPTOMS = "UPDATECONSULTANTSYMPTOMS";
export const CREATEIPDTIMELINEHISTORY = "CREATEIPDIPDTIMELINEHISTORY";
export const GETIPDTIMELINEHISTORY = "GETIPDTIMELINEHISTORY";
export const GETALLIPDTIMELINEHISTORY = "GETALLIPDTIMELINEHISTORY";
export const DELETEIPDTIMELINEHISTORY = "DELETEIPDTIMELINEHISTORY";
export const UPDATEIPDTIMELINEHISTORY = "UPDATEIPDTIMELINEHISTORY";
export const CREATEAYURVEDICTYPE = "CREATEAYURVEDICTYPE";
export const GETAYURVEDICTYPE = "GETAYURVEDICTYPE";
export const DELETEAYURVEDICTYPE = "DELETEAYURVEDICTYPE";
export const UPDATEAYURVEDICTYPE = "UPDATEAYURVEDICTYPE";
export const CREATEAYURVEDICHEAD = "CREATEAYURVEDICHEAD";
export const GETAYURVEDICHEAD = "GETAYURVEDICHEAD";
export const DELETEAYURVEDICHEAD = "DELETEAYURVEDICHEAD";
export const UPDATEAYURVEDICHEAD = "UPDATEAYURVEDICHEAD";
export const CREATEEXERCISECHARTTYPE = "CREATEEXERCISECHARTTYPE";
export const GETEXERCISECHARTTYPE = "GETEXERCISECHARTTYPE";
export const DELETEEXERCISECHARTTYPE = "DELETEEXERCISECHARTTYPE";
export const UPDATEEXERCISECHARTTYPE = "UPDATEEXERCISECHARTTYPE";
export const CREATEEXERCISECHARTHEAD = "CREATEEXERCISECHARTHEAD";
export const GETEXERCISECHARTHEAD = "GETEXERCISECHARTHEAD";
export const DELETEEXERCISECHARTHEAD = "DELETEEXERCISECHARTHEAD";
export const UPDATEEXERCISECHARTHEAD = "UPDATEEXERCISECHARTHEAD";
export const CREATEIMMUNIZATIONNAME = "CREATEIMMUNIZATIONNAME";
export const GETIMMUNIZATIONNAME = "GETIMMUNIZATIONNAME";
export const DELETEIMMUNIZATIONNAME = "DELETEIMMUNIZATIONNAME";
export const UPDATEIMMUNIZATIONNAME = "UPDATEIMMUNIZATIONNAME";
export const CREATEIMMUNIZATIONAGEGROUP = "CREATEIMMUNIZATIONAGEGROUP";
export const GETIMMUNIZATIONAGEGROUP = "GETIMMUNIZATIONAGEGROUP";
export const DELETEIMMUNIZATIONAGEGROUP = "DELETEIMMUNIZATIONAGEGROUP";
export const UPDATEIMMUNIZATIONAGEGROUP = "UPDATEIMMUNIZATIONAGEGROUP";
export const CREATEDUTYROSTERSHIFT = "CREATEDUTYROSTERSHIFT";
export const GETDUTYROSTERSHIFT = "GETDUTYROSTERSHIFT";
export const DELETEDUTYROSTERSHIFT = "DELETEDUTYROSTERSHIFT";
export const UPDATEDUTYROSTERSHIFT = "UPDATEDUTYROSTERSHIFT";
export const CREATEDUTYROSTER = "CREATEDUTYROSTER";
export const GETDUTYROSTER = "GETDUTYROSTER";
export const DELETEDUTYROSTER = "DELETEDUTYROSTER";
export const UPDATEDUTYROSTER = "UPDATEDUTYROSTER";
export const CREATEDUTYROSTERASSIGN = "CREATEDUTYROSTERASSIGN";
export const GETDUTYROSTERASSIGN = "GETDUTYROSTERASSIGN";
export const DELETEDUTYROSTERASSIGN = "DELETEDUTYROSTERASSIGN";
export const UPDATEDUTYROSTERASSIGN = "UPDATEDUTYROSTERASSIGN";
export const CREATEOPDVACCINE = "CREATEOPDVACCINE";
export const GETOPDVACCINE = "GETOPDVACCINE";
export const DELETEOPDVACCINE = "DELETEOPDVACCINE";
export const UPDATEOPDVACCINE = "UPDATEOPDVACCINE";
export const CREATEGENERALPAINASSESSMENTSTATUS = "CREATEGENERALPAINASSESSMENTSTATUS";
export const GETGENERALPAINASSESSMENTSTATUS = "GETGENERALPAINASSESSMENTSTATUS";
export const DELETEGENERALPAINASSESSMENTSTATUS = "DELETEGENERALPAINASSESSMENTSTATUS";
export const UPDATEGENERALPAINASSESSMENTSTATUS = "UPDATEGENERALPAINASSESSMENTSTATUS";
export const CREATEGENERALPAINASSESSMENTSEVERITY = "CREATEGENERALPAINASSESSMENTSEVERITY";
export const GETGENERALPAINASSESSMENTSEVERITY = "GETGENERALPAINASSESSMENTSEVERITY";
export const DELETEGENERALPAINASSESSMENTSEVERITY = "DELETEGENERALPAINASSESSMENTSEVERITY";
export const UPDATEGENERALPAINASSESSMENTSEVERITY = "UPDATEGENERALPAINASSESSMENTSEVERITY";
export const CREATEGENERALPAINASSESSMENTPAINNATURE = "CREATEGENERALPAINASSESSMENTPAINNATURE";
export const GETGENERALPAINASSESSMENTPAINNATURE = "GETGENERALPAINASSESSMENTPAINNATURE";
export const DELETEGENERALPAINASSESSMENTPAINNATURE = "DELETEGENERALPAINASSESSMENTPAINNATURE";
export const UPDATEGENERALPAINASSESSMENTPAINNATURE = "UPDATEGENERALPAINASSESSMENTPAINNATURE";
export const CREATEGENERALPAINASSESSMENTPAINONSET = "CREATEGENERALPAINASSESSMENTPAINONSET";
export const GETGENERALPAINASSESSMENTPAINONSET = "GETGENERALPAINASSESSMENTPAINONSET";
export const DELETEGENERALPAINASSESSMENTPAINONSET = "DELETEGENERALPAINASSESSMENTPAINONSET";
export const UPDATEGENERALPAINASSESSMENTPAINONSET = "UPDATEGENERALPAINASSESSMENTPAINONSET";
export const CREATEGENERALPAINASSESSMENTPAINVARIATION = "CREATEGENERALPAINASSESSMENTPAINVARIATION";
export const GETGENERALPAINASSESSMENTPAINVARIATION = "GETGENERALPAINASSESSMENTPAINVARIATION";
export const DELETEGENERALPAINASSESSMENTPAINVARIATION = "DELETEGENERALPAINASSESSMENTPAINVARIATION";
export const UPDATEGENERALPAINASSESSMENTPAINVARIATION = "UPDATEGENERALPAINASSESSMENTPAINVARIATION";

export const GETGENERALCOMPLAINTCHILDILLNESS = "GETGENERALCOMPLAINTCHILDILLNESS";
export const CREATEGENERALCOMPLAINTCHILDILLNESS = "CREATEGENERALCOMPLAINTCHILDILLNESS";
export const DELETEGENERALCOMPLAINTCHILDILLNESS = "DELETEGENERALCOMPLAINTCHILDILLNESS";
export const UPDATEGENERALCOMPLAINTCHILDILLNESS = "UPDATEGENERALCOMPLAINTCHILDILLNESS";
export const GETGENERALCOMPLAINTADULTILLNESS = "GETGENERALCOMPLAINTADULTILLNESS";
export const CREATEGENERALCOMPLAINTADULTILLNESS = "CREATEGENERALCOMPLAINTADULTILLNESS";
export const DELETEGENERALCOMPLAINTADULTILLNESS = "DELETEGENERALCOMPLAINTADULTILLNESS";
export const UPDATEGENERALCOMPLAINTADULTILLNESS = "UPDATEGENERALCOMPLAINTADULTILLNESS";
export const GETGENERALCOMPLAINTHEALTHMAINT = "GETGENERALCOMPLAINTHEALTHMAINT";
export const CREATEGENERALCOMPLAINTHEALTHMAINT = "CREATEGENERALCOMPLAINTHEALTHMAINT";
export const DELETEGENERALCOMPLAINTHEALTHMAINT = "DELETEGENERALCOMPLAINTHEALTHMAINT";
export const UPDATEGENERALCOMPLAINTHEALTHMAINT = "UPDATEGENERALCOMPLAINTHEALTHMAINT";
export const GETGENERALCOMPLAINTRELATION = "GETGENERALCOMPLAINTRELATION";
export const CREATEGENERALCOMPLAINTRELATION = "CREATEGENERALCOMPLAINTRELATION";
export const DELETEGENERALCOMPLAINTRELATION = "DELETEGENERALCOMPLAINTRELATION";
export const UPDATEGENERALCOMPLAINTRELATION = "UPDATEGENERALCOMPLAINTRELATION";
export const GETGENERALCOMPLAINTAPPETITE = "GETGENERALCOMPLAINTAPPETITE";
export const CREATEGENERALCOMPLAINTAPPETITE = "CREATEGENERALCOMPLAINTAPPETITE";
export const UPDATEGENERALCOMPLAINTAPPETITE = "UPDATEGENERALCOMPLAINTAPPETITE";
export const DELETEGENERALCOMPLAINTAPPETITE = "DELETEGENERALCOMPLAINTAPPETITE";
export const GETGENERALCOMPLAINTDIGESTIVETRACT = "GETGENERALCOMPLAINTDIGESTIVETRACT";
export const CREATEGENERALCOMPLAINTDIGESTIVETRACT = "CREATEGENERALCOMPLAINTDIGESTIVETRACT";
export const UPDATEGENERALCOMPLAINTDIGESTIVETRACT = "UPDATEGENERALCOMPLAINTDIGESTIVETRACT";
export const DELETEGENERALCOMPLAINTDIGESTIVETRACT = "DELETEGENERALCOMPLAINTDIGESTIVETRACT";
export const GETGENERALCOMPLAINTBOWEL = "GETGENERALCOMPLAINTBOWEL";
export const CREATEGENERALCOMPLAINTBOWEL = "CREATEGENERALCOMPLAINTBOWEL";
export const UPDATEGENERALCOMPLAINTBOWEL = "UPDATEGENERALCOMPLAINTBOWEL";
export const DELETEGENERALCOMPLAINTBOWEL = "DELETEGENERALCOMPLAINTBOWEL";
export const GETGENERALCOMPLAINTSLEEP = "GETGENERALCOMPLAINTSLEEP";
export const CREATEGENERALCOMPLAINTSLEEP = "CREATEGENERALCOMPLAINTSLEEP";
export const UPDATEGENERALCOMPLAINTSLEEP = "UPDATEGENERALCOMPLAINTSLEEP";
export const DELETEGENERALCOMPLAINTSLEEP = "DELETEGENERALCOMPLAINTSLEEP";
export const GETGENERALCOMPLAINTADDICTIONS = "GETGENERALCOMPLAINTADDICTIONS";
export const CREATEGENERALCOMPLAINTADDICTIONS = "CREATEGENERALCOMPLAINTADDICTIONS";
export const UPDATEGENERALCOMPLAINTADDICTIONS = "UPDATEGENERALCOMPLAINTADDICTIONS";
export const DELETEGENERALCOMPLAINTADDICTIONS = "DELETEGENERALCOMPLAINTADDICTIONS";
export const GETGENERALCOMPLAINTHIGHRISK = "GETGENERALCOMPLAINTHIGHRISK";
export const CREATEGENERALCOMPLAINTHIGHRISK = "CREATEGENERALCOMPLAINTHIGHRISK";
export const UPDATEGENERALCOMPLAINTHIGHRISK = "UPDATEGENERALCOMPLAINTHIGHRISK";
export const DELETEGENERALCOMPLAINTHIGHRISK = "DELETEGENERALCOMPLAINTHIGHRISK";
export const GETGENERALCOMPLAINTWORKPOSITION = "GETGENERALCOMPLAINTWORKPOSITION";
export const CREATEGENERALCOMPLAINTWORKPOSITION = "CREATEGENERALCOMPLAINTWORKPOSITION";
export const UPDATEGENERALCOMPLAINTWORKPOSITION = "UPDATEGENERALCOMPLAINTWORKPOSITION";
export const DELETEGENERALCOMPLAINTWORKPOSITION = "DELETEGENERALCOMPLAINTWORKPOSITION";
export const GETGENERALCOMPLAINTWORKNATURE = "GETGENERALCOMPLAINTWORKNATURE";
export const CREATEGENERALCOMPLAINTWORKNATURE = "CREATEGENERALCOMPLAINTWORKNATURE";
export const UPDATEGENERALCOMPLAINTWORKNATURE = "UPDATEGENERALCOMPLAINTWORKNATURE";
export const DELETEGENERALCOMPLAINTWORKNATURE = "DELETEGENERALCOMPLAINTWORKNATURE";
export const GETGENERALCOMPLAINTALLOPATHICMEDI = "GETGENERALCOMPLAINTALLOPATHICMEDI";
export const CREATEGENERALCOMPLAINTALLOPATHICMEDI = "CREATEGENERALCOMPLAINTALLOPATHICMEDI";
export const UPDATEGENERALCOMPLAINTALLOPATHICMEDI = "UPDATEGENERALCOMPLAINTALLOPATHICMEDI";
export const DELETEGENERALCOMPLAINTALLOPATHICMEDI = "DELETEGENERALCOMPLAINTALLOPATHICMEDI";
export const GETGENERALCOMPLAINTAYURVEDAMEDI = "GETGENERALCOMPLAINTAYURVEDAMEDI";
export const CREATEGENERALCOMPLAINTAYURVEDAMEDI = "CREATEGENERALCOMPLAINTAYURVEDAMEDI";
export const UPDATEGENERALCOMPLAINTAYURVEDAMEDI = "UPDATEGENERALCOMPLAINTAYURVEDAMEDI";
export const DELETEGENERALCOMPLAINTAYURVEDAMEDI = "DELETEGENERALCOMPLAINTAYURVEDAMEDI";
export const GETGENERALCOMPLAINTHOMEOPATHICMEDI = "GETGENERALCOMPLAINTHOMEOPATHICMEDI";
export const CREATEGENERALCOMPLAINTHOMEOPATHICMEDI = "CREATEGENERALCOMPLAINTHOMEOPATHICMEDI";
export const UPDATEGENERALCOMPLAINTHOMEOPATHICMEDI = "UPDATEGENERALCOMPLAINTHOMEOPATHICMEDI";
export const DELETEGENERALCOMPLAINTHOMEOPATHICMEDI = "DELETEGENERALCOMPLAINTHOMEOPATHICMEDI";
export const GETGENERALCOMPLAINTOTHERMEDI = "GETGENERALCOMPLAINTOTHERMEDI";
export const CREATEGENERALCOMPLAINTOTHERMEDI = "CREATEGENERALCOMPLAINTOTHERMEDI";
export const UPDATEGENERALCOMPLAINTOTHERMEDI = "UPDATEGENERALCOMPLAINTOTHERMEDI";
export const DELETEGENERALCOMPLAINTOTHERMEDI = "DELETEGENERALCOMPLAINTOTHERMEDI";

export const GETGENERALCOMPLAINTANXIETY = "GETGENERALCOMPLAINTANXIETY";
export const CREATEGENERALCOMPLAINTANXIETY = "CREATEGENERALCOMPLAINTANXIETY";
export const UPDATEGENERALCOMPLAINTANXIETY = "UPDATEGENERALCOMPLAINTANXIETY";
export const DELETEGENERALCOMPLAINTANXIETY = "DELETEGENERALCOMPLAINTANXIETY";
export const GETGENERALCOMPLAINTDEPRESSION = "GETGENERALCOMPLAINTDEPRESSION";
export const CREATEGENERALCOMPLAINTDEPRESSION = "CREATEGENERALCOMPLAINTDEPRESSION";
export const UPDATEGENERALCOMPLAINTDEPRESSION = "UPDATEGENERALCOMPLAINTDEPRESSION";
export const DELETEGENERALCOMPLAINTDEPRESSION = "DELETEGENERALCOMPLAINTDEPRESSION";
export const GETGENERALCOMPLAINTIRRITABILITY = "GETGENERALCOMPLAINTIRRITABILITY";
export const CREATEGENERALCOMPLAINTIRRITABILITY = "CREATEGENERALCOMPLAINTIRRITABILITY";
export const UPDATEGENERALCOMPLAINTIRRITABILITY = "UPDATEGENERALCOMPLAINTIRRITABILITY";
export const DELETEGENERALCOMPLAINTIRRITABILITY = "DELETEGENERALCOMPLAINTIRRITABILITY";
export const GETGENERALCOMPLAINTEUPHORIA = "GETGENERALCOMPLAINTEUPHORIA";
export const CREATEGENERALCOMPLAINTEUPHORIA = "CREATEGENERALCOMPLAINTEUPHORIA";
export const UPDATEGENERALCOMPLAINTEUPHORIA = "UPDATEGENERALCOMPLAINTEUPHORIA";
export const DELETEGENERALCOMPLAINTEUPHORIA = "DELETEGENERALCOMPLAINTEUPHORIA";
export const GETGENERALCOMPLAINTOBSESSION = "GETGENERALCOMPLAINTOBSESSION";
export const CREATEGENERALCOMPLAINTOBSESSION = "CREATEGENERALCOMPLAINTOBSESSION";
export const UPDATEGENERALCOMPLAINTOBSESSION = "UPDATEGENERALCOMPLAINTOBSESSION";
export const DELETEGENERALCOMPLAINTOBSESSION = "DELETEGENERALCOMPLAINTOBSESSION";
export const GETGENERALCOMPLAINTNEUROSIS = "GETGENERALCOMPLAINTNEUROSIS";
export const CREATEGENERALCOMPLAINTNEUROSIS = "CREATEGENERALCOMPLAINTNEUROSIS";
export const UPDATEGENERALCOMPLAINTNEUROSIS = "UPDATEGENERALCOMPLAINTNEUROSIS";
export const DELETEGENERALCOMPLAINTNEUROSIS = "DELETEGENERALCOMPLAINTNEUROSIS";
export const GETGENERALCOMPLAINTDEPERSONALIZATION = "GETGENERALCOMPLAINTDEPERSONALIZATION";
export const CREATEGENERALCOMPLAINTDEPERSONALIZATION = "CREATEGENERALCOMPLAINTDEPERSONALIZATION";
export const UPDATEGENERALCOMPLAINTDEPERSONALIZATION = "UPDATEGENERALCOMPLAINTDEPERSONALIZATION";
export const DELETEGENERALCOMPLAINTDEPERSONALIZATION = "DELETEGENERALCOMPLAINTDEPERSONALIZATION";
export const GETGENERALCOMPLAINTMENSTRUALCYCLE = "GETGENERALCOMPLAINTMENSTRUALCYCLE";
export const CREATEGENERALCOMPLAINTMENSTRUALCYCLE = "CREATEGENERALCOMPLAINTMENSTRUALCYCLE";
export const UPDATEGENERALCOMPLAINTMENSTRUALCYCLE = "UPDATEGENERALCOMPLAINTMENSTRUALCYCLE";
export const DELETEGENERALCOMPLAINTMENSTRUALCYCLE = "DELETEGENERALCOMPLAINTMENSTRUALCYCLE";
export const GETGENERALCOMPLAINTNATUREOFDELIVERY = "GETGENERALCOMPLAINTNATUREOFDELIVERY";
export const CREATEGENERALCOMPLAINTNATUREOFDELIVERY = "CREATEGENERALCOMPLAINTNATUREOFDELIVERY";
export const UPDATEGENERALCOMPLAINTNATUREOFDELIVERY = "UPDATEGENERALCOMPLAINTNATUREOFDELIVERY";
export const DELETEGENERALCOMPLAINTNATUREOFDELIVERY = "DELETEGENERALCOMPLAINTNATUREOFDELIVERY";

export const GETGENERALEXAMGENERALLOOK = "GETGENERALEXAMGENERALLOOK";
export const CREATEGENERALEXAMGENERALLOOK = "CREATEGENERALEXAMGENERALLOOK";
export const UPDATEGENERALEXAMGENERALLOOK = "UPDATEGENERALEXAMGENERALLOOK";
export const DELETEGENERALEXAMGENERALLOOK = "DELETEGENERALEXAMGENERALLOOK";
export const GETGENERALEXAMNUTRITION = "GETGENERALEXAMNUTRITION";
export const CREATEGENERALEXAMNUTRITION = "CREATEGENERALEXAMNUTRITION";
export const UPDATEGENERALEXAMNUTRITION = "UPDATEGENERALEXAMNUTRITION";
export const DELETEGENERALEXAMNUTRITION = "DELETEGENERALEXAMNUTRITION";
export const GETGENERALEXAMANEAMIA = "GETGENERALEXAMANEAMIA";
export const CREATEGENERALEXAMANEAMIA = "CREATEGENERALEXAMANEAMIA";
export const UPDATEGENERALEXAMANEAMIA = "UPDATEGENERALEXAMANEAMIA";
export const DELETEGENERALEXAMANEAMIA = "DELETEGENERALEXAMANEAMIA";
export const GETGENERALEXAMNECKANDVEIN = "GETGENERALEXAMNECKANDVEIN";
export const CREATEGENERALEXAMNECKANDVEIN = "CREATEGENERALEXAMNECKANDVEIN";
export const UPDATEGENERALEXAMNECKANDVEIN = "UPDATEGENERALEXAMNECKANDVEIN";
export const DELETEGENERALEXAMNECKANDVEIN = "DELETEGENERALEXAMNECKANDVEIN";
export const GETGENERALEXAMLYMPHNODE = "GETGENERALEXAMLYMPHNODE";
export const CREATEGENERALEXAMLYMPHNODE = "CREATEGENERALEXAMLYMPHNODE";
export const UPDATEGENERALEXAMLYMPHNODE = "UPDATEGENERALEXAMLYMPHNODE";
export const DELETEGENERALEXAMLYMPHNODE = "DELETEGENERALEXAMLYMPHNODE";

export const GETGENERALOPDBODYCHART = "GETGENERALOPDBODYCHART";
export const CREATEGENERALOPDBODYCHART = "CREATEGENERALOPDBODYCHART";
export const UPDATEGENERALOPDBODYCHART = "UPDATEGENERALOPDBODYCHART";
export const DELETEGENERALOPDBODYCHART = "DELETEGENERALOPDBODYCHART";
export const GETGENERALOPDPAINASSESSMENT = "GETGENERALOPDPAINASSESSMENT";
export const CREATEGENERALOPDPAINASSESSMENT = "CREATEGENERALOPDPAINASSESSMENT";
export const UPDATEGENERALOPDPAINASSESSMENT = "UPDATEGENERALOPDPAINASSESSMENT";
export const DELETEGENERALOPDPAINASSESSMENT = "DELETEGENERALOPDPAINASSESSMENT";
export const GETGENERALOPDCHIEFCOMPLAINT = "GETGENERALOPDCHIEFCOMPLAINT";
export const CREATEGENERALOPDCHIEFCOMPLAINT = "CREATEGENERALOPDCHIEFCOMPLAINT";
export const UPDATEGENERALOPDCHIEFCOMPLAINT = "UPDATEGENERALOPDCHIEFCOMPLAINT";
export const DELETEGENERALOPDCHIEFCOMPLAINT = "DELETEGENERALOPDCHIEFCOMPLAINT";
export const GETGENERALOPDASSOCIATEDCOMPLAINT = "GETGENERALOPDASSOCIATEDCOMPLAINT";
export const CREATEGENERALOPDASSOCIATEDCOMPLAINT = "CREATEGENERALOPDASSOCIATEDCOMPLAINT";
export const UPDATEGENERALOPDASSOCIATEDCOMPLAINT = "UPDATEGENERALOPDASSOCIATEDCOMPLAINT";
export const DELETEGENERALOPDASSOCIATEDCOMPLAINT = "DELETEGENERALOPDASSOCIATEDCOMPLAINT";
export const GETGENERALOPDPRESENTILLNESSHIST = "GETGENERALOPDPRESENTILLNESSHIST";
export const CREATEGENERALOPDPRESENTILLNESSHIST = "CREATEGENERALOPDPRESENTILLNESSHIST";
export const UPDATEGENERALOPDPRESENTILLNESSHIST = "UPDATEGENERALOPDPRESENTILLNESSHIST";
export const DELETEGENERALOPDPRESENTILLNESSHIST = "DELETEGENERALOPDPRESENTILLNESSHIST";
export const GETGENERALOPDCHIDLILLNESSHIST = "GETGENERALOPDCHIDLILLNESSHIST";
export const CREATEGENERALOPDCHIDLILLNESSHIST = "CREATEGENERALOPDCHIDLILLNESSHIST";
export const UPDATEGENERALOPDCHIDLILLNESSHIST = "UPDATEGENERALOPDCHIDLILLNESSHIST";
export const DELETEGENERALOPDCHIDLILLNESSHIST = "DELETEGENERALOPDCHIDLILLNESSHIST";
export const GETGENERALOPDADULTILLNESSHIST = "GETGENERALOPDADULTILLNESSHIST";
export const CREATEGENERALOPDADULTILLNESSHIST = "CREATEGENERALOPDADULTILLNESSHIST";
export const UPDATEGENERALOPDADULTILLNESSHIST = "UPDATEGENERALOPDADULTILLNESSHIST";
export const DELETEGENERALOPDADULTILLNESSHIST = "DELETEGENERALOPDADULTILLNESSHIST";
export const GETGENERALOPDHEALTHMAINHIST = "GETGENERALOPDHEALTHMAINHIST";
export const CREATEGENERALOPDHEALTHMAINHIST = "CREATEGENERALOPDHEALTHMAINHIST";
export const UPDATEGENERALOPDHEALTHMAINHIST = "UPDATEGENERALOPDHEALTHMAINHIST";
export const DELETEGENERALOPDHEALTHMAINHIST = "DELETEGENERALOPDHEALTHMAINHIST";
export const GETGENERALOPDPASTILLNESSNOTE = "GETGENERALOPDPASTILLNESSNOTE";
export const CREATEGENERALOPDPASTILLNESSNOTE = "CREATEGENERALOPDPASTILLNESSNOTE";
export const UPDATEGENERALOPDPASTILLNESSNOTE = "UPDATEGENERALOPDPASTILLNESSNOTE";
export const DELETEGENERALOPDPASTILLNESSNOTE = "DELETEGENERALOPDPASTILLNESSNOTE";
export const GETGENERALOPDRELATIONHIST = "GETGENERALOPDRELATIONHIST";
export const CREATEGENERALOPDRELATIONHIST = "CREATEGENERALOPDRELATIONHIST";
export const UPDATEGENERALOPDRELATIONHIST = "UPDATEGENERALOPDRELATIONHIST";
export const DELETEGENERALOPDRELATIONHIST = "DELETEGENERALOPDRELATIONHIST";
export const GETGENERALOPDFAMILYSYMPTOMHIST = "GETGENERALOPDFAMILYSYMPTOMHIST";
export const CREATEGENERALOPDFAMILYSYMPTOMHIST = "CREATEGENERALOPDFAMILYSYMPTOMHIST";
export const UPDATEGENERALOPDFAMILYSYMPTOMHIST = "UPDATEGENERALOPDFAMILYSYMPTOMHIST";
export const DELETEGENERALOPDFAMILYSYMPTOMHIST = "DELETEGENERALOPDFAMILYSYMPTOMHIST";
export const GETGENERALOPDFAMILYCOMORBIDITYHIST = "GETGENERALOPDFAMILYCOMORBIDITYHIST";
export const CREATEGENERALOPDFAMILYCOMORBIDITYHIST = "CREATEGENERALOPDFAMILYCOMORBIDITYHIST";
export const UPDATEGENERALOPDFAMILYCOMORBIDITYHIST = "UPDATEGENERALOPDFAMILYCOMORBIDITYHIST";
export const DELETEGENERALOPDFAMILYCOMORBIDITYHIST = "DELETEGENERALOPDFAMILYCOMORBIDITYHIST";
export const GETGENERALOPDFAMILYHISTNOTE = "GETGENERALOPDFAMILYHISTNOTE";
export const CREATEGENERALOPDFAMILYHISTNOTE = "CREATEGENERALOPDFAMILYHISTNOTE";
export const UPDATEGENERALOPDFAMILYHISTNOTE = "UPDATEGENERALOPDFAMILYHISTNOTE";
export const DELETEGENERALOPDFAMILYHISTNOTE = "DELETEGENERALOPDFAMILYHISTNOTE";
export const GETGENERALOPDPERSONALDIETHIST = "GETGENERALOPDPERSONALDIETHIST";
export const CREATEGENERALOPDPERSONALDIETHIST = "CREATEGENERALOPDPERSONALDIETHIST";
export const UPDATEGENERALOPDPERSONALDIETHIST = "UPDATEGENERALOPDPERSONALDIETHIST";
export const DELETEGENERALOPDPERSONALDIETHIST = "DELETEGENERALOPDPERSONALDIETHIST";
export const GETGENERALOPDAPPETITEHIST = "GETGENERALOPDAPPETITEHIST";
export const CREATEGENERALOPDAPPETITEHIST = "CREATEGENERALOPDAPPETITEHIST";
export const UPDATEGENERALOPDAPPETITEHIST = "UPDATEGENERALOPDAPPETITEHIST";
export const DELETEGENERALOPDAPPETITEHIST = "DELETEGENERALOPDAPPETITEHIST";
export const GETGENERALOPDDIGESTIVETRACTHIST = "GETGENERALOPDDIGESTIVETRACTHIST";
export const CREATEGENERALOPDDIGESTIVETRACTHIST = "CREATEGENERALOPDDIGESTIVETRACTHIST";
export const UPDATEGENERALOPDDIGESTIVETRACTHIST = "UPDATEGENERALOPDDIGESTIVETRACTHIST";
export const DELETEGENERALOPDDIGESTIVETRACTHIST = "DELETEGENERALOPDDIGESTIVETRACTHIST";
export const GETGENERALOPDBOWELHIST = "GETGENERALOPDBOWELHIST";
export const CREATEGENERALOPDBOWELHIST = "CREATEGENERALOPDBOWELHIST";
export const UPDATEGENERALOPDBOWELHIST = "UPDATEGENERALOPDBOWELHIST";
export const DELETEGENERALOPDBOWELHIST = "DELETEGENERALOPDBOWELHIST";
export const GETGENERALOPDSLEEPHIST = "GETGENERALOPDSLEEPHIST";
export const CREATEGENERALOPDSLEEPHIST = "CREATEGENERALOPDSLEEPHIST";
export const UPDATEGENERALOPDSLEEPHIST = "UPDATEGENERALOPDSLEEPHIST";
export const DELETEGENERALOPDSLEEPHIST = "DELETEGENERALOPDSLEEPHIST";
export const GETGENERALOPDADDICTIONHIST = "GETGENERALOPDADDICTIONHIST";
export const CREATEGENERALOPDADDICTIONHIST = "CREATEGENERALOPDADDICTIONHIST";
export const UPDATEGENERALOPDADDICTIONHIST = "UPDATEGENERALOPDADDICTIONHIST";
export const DELETEGENERALOPDADDICTIONHIST = "DELETEGENERALOPDADDICTIONHIST";
export const GETGENERALOPDHIGHRISKHIST = "GETGENERALOPDHIGHRISKHIST";
export const CREATEGENERALOPDHIGHRISKHIST = "CREATEGENERALOPDHIGHRISKHIST";
export const UPDATEGENERALOPDHIGHRISKHIST = "UPDATEGENERALOPDHIGHRISKHIST";
export const DELETEGENERALOPDHIGHRISKHIST = "DELETEGENERALOPDHIGHRISKHIST";
export const GETGENERALOPDPOSITIONODWORK = "GETGENERALOPDPOSITIONODWORK";
export const CREATEGENERALOPDPOSITIONODWORK = "CREATEGENERALOPDPOSITIONODWORK";
export const UPDATEGENERALOPDPOSITIONODWORK = "UPDATEGENERALOPDPOSITIONODWORK";
export const DELETEGENERALOPDPOSITIONODWORK = "DELETEGENERALOPDPOSITIONODWORK";
export const GETGENERALOPDNATUREOFWORK = "GETGENERALOPDNATUREOFWORK";
export const CREATEGENERALOPDNATUREOFWORK = "CREATEGENERALOPDNATUREOFWORK";
export const UPDATEGENERALOPDNATUREOFWORK = "UPDATEGENERALOPDNATUREOFWORK";
export const DELETEGENERALOPDNATUREOFWORK = "DELETEGENERALOPDNATUREOFWORK";
export const GETGENERALOPDOCCUPATIONALHIST = "GETGENERALOPDOCCUPATIONALHIST";
export const CREATEGENERALOPDOCCUPATIONALHIST = "CREATEGENERALOPDOCCUPATIONALHIST";
export const UPDATEGENERALOPDOCCUPATIONALHIST = "UPDATEGENERALOPDOCCUPATIONALHIST";
export const DELETEGENERALOPDOCCUPATIONALHIST = "DELETEGENERALOPDOCCUPATIONALHIST";
export const GETGENERALOPDALLOPTHYMEDIHIST = "GETGENERALOPDALLOPTHYMEDIHIST";
export const CREATEGENERALOPDALLOPTHYMEDIHIST = "CREATEGENERALOPDALLOPTHYMEDIHIST";
export const UPDATEGENERALOPDALLOPTHYMEDIHIST = "UPDATEGENERALOPDALLOPTHYMEDIHIST";
export const DELETEGENERALOPDALLOPTHYMEDIHIST = "DELETEGENERALOPDALLOPTHYMEDIHIST";
export const GETGENERALOPDAYURVEDAMEDIHIST = "GETGENERALOPDAYURVEDAMEDIHIST";
export const CREATEGENERALOPDAYURVEDAMEDIHIST = "CREATEGENERALOPDAYURVEDAMEDIHIST";
export const UPDATEGENERALOPDAYURVEDAMEDIHIST = "UPDATEGENERALOPDAYURVEDAMEDIHIST";
export const DELETEGENERALOPDAYURVEDAMEDIHIST = "DELETEGENERALOPDAYURVEDAMEDIHIST";
export const GETGENERALOPDHOMEOPATHYMEDIHIST = "GETGENERALOPDHOMEOPATHYMEDIHIST";
export const CREATEGENERALOPDHOMEOPATHYMEDIHIST = "CREATEGENERALOPDHOMEOPATHYMEDIHIST";
export const UPDATEGENERALOPDHOMEOPATHYMEDIHIST = "UPDATEGENERALOPDHOMEOPATHYMEDIHIST";
export const DELETEGENERALOPDHOMEOPATHYMEDIHIST = "DELETEGENERALOPDHOMEOPATHYMEDIHIST";
export const GETGENERALOPDOTHERMEDIHIST = "GETGENERALOPDOTHERMEDIHIST";
export const CREATEGENERALOPDOTHERMEDIHIST = "CREATEGENERALOPDOTHERMEDIHIST";
export const UPDATEGENERALOPDOTHERMEDIHIST = "UPDATEGENERALOPDOTHERMEDIHIST";
export const DELETEGENERALOPDOTHERMEDIHIST = "DELETEGENERALOPDOTHERMEDIHIST";
export const GETGENERALOPDANXIETYHIST = "GETGENERALOPDANXIETYHIST";
export const CREATEGENERALOPDANXIETYHIST = "CREATEGENERALOPDANXIETYHIST";
export const UPDATEGENERALOPDANXIETYHIST = "UPDATEGENERALOPDANXIETYHIST";
export const DELETEGENERALOPDANXIETYHIST = "DELETEGENERALOPDANXIETYHIST";
export const GETGENERALOPDDEPRESSIONHIST = "GETGENERALOPDDEPRESSIONHIST";
export const CREATEGENERALOPDDEPRESSIONHIST = "CREATEGENERALOPDDEPRESSIONHIST";
export const UPDATEGENERALOPDDEPRESSIONHIST = "UPDATEGENERALOPDDEPRESSIONHIST";
export const DELETEGENERALOPDDEPRESSIONHIST = "DELETEGENERALOPDDEPRESSIONHIST";
export const GETGENERALOPDIRRITABILITYHIST = "GETGENERALOPDIRRITABILITYHIST";
export const CREATEGENERALOPDIRRITABILITYHIST = "CREATEGENERALOPDIRRITABILITYHIST";
export const UPDATEGENERALOPDIRRITABILITYHIST = "UPDATEGENERALOPDIRRITABILITYHIST";
export const DELETEGENERALOPDIRRITABILITYHIST = "DELETEGENERALOPDIRRITABILITYHIST";
export const GETGENERALOPDEUPHORIAHIST = "GETGENERALOPDEUPHORIAHIST";
export const CREATEGENERALOPDEUPHORIAHIST = "CREATEGENERALOPDEUPHORIAHIST";
export const UPDATEGENERALOPDEUPHORIAHIST = "UPDATEGENERALOPDEUPHORIAHIST";
export const DELETEGENERALOPDEUPHORIAHIST = "DELETEGENERALOPDEUPHORIAHIST";
export const GETGENERALOPDOBSESSION = "GETGENERALOPDOBSESSION";
export const CREATEGENERALOPDOBSESSION = "CREATEGENERALOPDOBSESSION";
export const UPDATEGENERALOPDOBSESSION = "UPDATEGENERALOPDOBSESSION";
export const DELETEGENERALOPDOBSESSION = "DELETEGENERALOPDOBSESSION";
export const GETGENERALOPDNEUROSISHIST = "GETGENERALOPDNEUROSISHIST";
export const CREATEGENERALOPDNEUROSISHIST = "CREATEGENERALOPDNEUROSISHIST";
export const UPDATEGENERALOPDNEUROSISHIST = "UPDATEGENERALOPDNEUROSISHIST";
export const DELETEGENERALOPDNEUROSISHIST = "DELETEGENERALOPDNEUROSISHIST";
export const GETGENERALOPDDEPERSONALIZATION = "GETGENERALOPDDEPERSONALIZATION";
export const CREATEGENERALOPDDEPERSONALIZATION = "CREATEGENERALOPDDEPERSONALIZATION";
export const UPDATEGENERALOPDDEPERSONALIZATION = "UPDATEGENERALOPDDEPERSONALIZATION";
export const DELETEGENERALOPDDEPERSONALIZATION = "DELETEGENERALOPDDEPERSONALIZATION";
export const GETGENERALOPDGYNECOLOGICALHIST = "GETGENERALOPDGYNECOLOGICALHIST";
export const CREATEGENERALOPDGYNECOLOGICALHIST = "CREATEGENERALOPDGYNECOLOGICALHIST";
export const UPDATEGENERALOPDGYNECOLOGICALHIST = "UPDATEGENERALOPDGYNECOLOGICALHIST";
export const DELETEGENERALOPDGYNECOLOGICALHIST = "DELETEGENERALOPDGYNECOLOGICALHIST";
export const GETGENERALOPDMENSTRUALCYCLEHIST = "GETGENERALOPDMENSTRUALCYCLEHIST";
export const CREATEGENERALOPDMENSTRUALCYCLEHIST = "CREATEGENERALOPDMENSTRUALCYCLEHIST";
export const UPDATEGENERALOPDMENSTRUALCYCLEHIST = "UPDATEGENERALOPDMENSTRUALCYCLEHIST";
export const DELETEGENERALOPDMENSTRUALCYCLEHIST = "DELETEGENERALOPDMENSTRUALCYCLEHIST";
export const GETGENERALOPDOBSTETRICALHIST = "GETGENERALOPDOBSTETRICALHIST";
export const CREATEGENERALOPDOBSTETRICALHIST = "CREATEGENERALOPDOBSTETRICALHIST";
export const UPDATEGENERALOPDOBSTETRICALHIST = "UPDATEGENERALOPDOBSTETRICALHIST";
export const DELETEGENERALOPDOBSTETRICALHIST = "DELETEGENERALOPDOBSTETRICALHIST";
export const GETGENERALOPDNATUREOFDELIVERY = "GETGENERALOPDNATUREOFDELIVERY";
export const CREATEGENERALOPDNATUREOFDELIVERY = "CREATEGENERALOPDNATUREOFDELIVERY";
export const UPDATEGENERALOPDNATUREOFDELIVERY = "UPDATEGENERALOPDNATUREOFDELIVERY";
export const DELETEGENERALOPDNATUREOFDELIVERY = "DELETEGENERALOPDNATUREOFDELIVERY";

export const GETGENERALOPDEXAMGENERALLOOK = "GETGENERALOPDEXAMGENERALLOOK";
export const CREATEGENERALOPDEXAMGENERALLOOK = "CREATEGENERALOPDEXAMGENERALLOOK";
export const UPDATEGENERALOPDEXAMGENERALLOOK = "UPDATEGENERALOPDEXAMGENERALLOOK";
export const DELETEGENERALOPDEXAMGENERALLOOK = "DELETEGENERALOPDEXAMGENERALLOOK";
export const GETGENERALOPDEXAMNUTRITION = "GETGENERALOPDEXAMNUTRITION";
export const CREATEGENERALOPDEXAMNUTRITION = "CREATEGENERALOPDEXAMNUTRITION";
export const UPDATEGENERALOPDEXAMNUTRITION = "UPDATEGENERALOPDEXAMNUTRITION";
export const DELETEGENERALOPDEXAMNUTRITION = "DELETEGENERALOPDEXAMNUTRITION";
export const GETGENERALOPDEXAMANAEMIA = "GETGENERALOPDEXAMANAEMIA";
export const CREATEGENERALOPDEXAMANAEMIA = "CREATEGENERALOPDEXAMANAEMIA";
export const UPDATEGENERALOPDEXAMANAEMIA = "UPDATEGENERALOPDEXAMANAEMIA";
export const DELETEGENERALOPDEXAMANAEMIA = "DELETEGENERALOPDEXAMANAEMIA";
export const GETGENERALOPDEXAMNECKVEIN = "GETGENERALOPDEXAMNECKVEIN";
export const CREATEGENERALOPDEXAMNECKVEIN = "CREATEGENERALOPDEXAMNECKVEIN";
export const UPDATEGENERALOPDEXAMNECKVEIN = "UPDATEGENERALOPDEXAMNECKVEIN";
export const DELETEGENERALOPDEXAMNECKVEIN = "DELETEGENERALOPDEXAMNECKVEIN";
export const GETGENERALOPDEXAMLYMPHNODES = "GETGENERALOPDEXAMLYMPHNODES";
export const CREATEGENERALOPDEXAMLYMPHNODES = "CREATEGENERALOPDEXAMLYMPHNODES";
export const UPDATEGENERALOPDEXAMLYMPHNODES = "UPDATEGENERALOPDEXAMLYMPHNODES";
export const DELETEGENERALOPDEXAMLYMPHNODES = "DELETEGENERALOPDEXAMLYMPHNODES";
export const GETGENERALOPDEXAMGENERALOTHERFIELDS = "GETGENERALOPDEXAMGENERALOTHERFIELDS";
export const CREATEGENERALOPDEXAMGENERALOTHERFIELDS = "CREATEGENERALOPDEXAMGENERALOTHERFIELDS";
export const UPDATEGENERALOPDEXAMGENERALOTHERFIELDS = "UPDATEGENERALOPDEXAMGENERALOTHERFIELDS";
export const DELETEGENERALOPDEXAMGENERALOTHERFIELDS = "DELETEGENERALOPDEXAMGENERALOTHERFIELDS";
export const GETGENERALOPDEXAMVITALS = "GETGENERALOPDEXAMVITALS";
export const CREATEGENERALOPDEXAMVITALS = "CREATEGENERALOPDEXAMVITALS";
export const UPDATEGENERALOPDEXAMVITALS = "UPDATEGENERALOPDEXAMVITALS";
export const DELETEGENERALOPDEXAMVITALS = "DELETEGENERALOPDEXAMVITALS";
export const GETGENERALOPDEXAMGENDER = "GETGENERALOPDEXAMGENDER";
export const CREATEGENERALOPDEXAMGENDER = "CREATEGENERALOPDEXAMGENDER";
export const UPDATEGENERALOPDEXAMGENDER = "UPDATEGENERALOPDEXAMGENDER";
export const DELETEGENERALOPDEXAMGENDER = "DELETEGENERALOPDEXAMGENDER";
export const GETGENERALOPDEXAMSIGNOFDISTRESS = "GETGENERALOPDEXAMSIGNOFDISTRESS";
export const CREATEGENERALOPDEXAMSIGNOFDISTRESS = "CREATEGENERALOPDEXAMSIGNOFDISTRESS";
export const UPDATEGENERALOPDEXAMSIGNOFDISTRESS = "UPDATEGENERALOPDEXAMSIGNOFDISTRESS";
export const DELETEGENERALOPDEXAMSIGNOFDISTRESS = "DELETEGENERALOPDEXAMSIGNOFDISTRESS";
export const GETGENERALOPDEXAMBODYTYPE = "GETGENERALOPDEXAMBODYTYPE";
export const CREATEGENERALOPDEXAMBODYTYPE = "CREATEGENERALOPDEXAMBODYTYPE";
export const UPDATEGENERALOPDEXAMBODYTYPE = "UPDATEGENERALOPDEXAMBODYTYPE";
export const DELETEGENERALOPDEXAMBODYTYPE = "DELETEGENERALOPDEXAMBODYTYPE";
export const GETGENERALOPDEXAMPOSTURE = "GETGENERALOPDEXAMPOSTURE";
export const CREATEGENERALOPDEXAMPOSTURE = "CREATEGENERALOPDEXAMPOSTURE";
export const UPDATEGENERALOPDEXAMPOSTURE = "UPDATEGENERALOPDEXAMPOSTURE";
export const DELETEGENERALOPDEXAMPOSTURE = "DELETEGENERALOPDEXAMPOSTURE";
export const GETGENERALOPDEXAMGAIT = "GETGENERALOPDEXAMGAIT";
export const CREATEGENERALOPDEXAMGAIT = "CREATEGENERALOPDEXAMGAIT";
export const UPDATEGENERALOPDEXAMGAIT = "UPDATEGENERALOPDEXAMGAIT";
export const DELETEGENERALOPDEXAMGAIT = "DELETEGENERALOPDEXAMGAIT";
export const GETGENERALOPDEXAMBODYMOVEMENT = "GETGENERALOPDEXAMBODYMOVEMENT";
export const CREATEGENERALOPDEXAMBODYMOVEMENT = "CREATEGENERALOPDEXAMBODYMOVEMENT";
export const UPDATEGENERALOPDEXAMBODYMOVEMENT = "UPDATEGENERALOPDEXAMBODYMOVEMENT";
export const DELETEGENERALOPDEXAMBODYMOVEMENT = "DELETEGENERALOPDEXAMBODYMOVEMENT";
export const GETGENERALOPDEXAMBODY = "GETGENERALOPDEXAMBODY";
export const CREATEGENERALOPDEXAMBODY = "CREATEGENERALOPDEXAMBODY";
export const UPDATEGENERALOPDEXAMBODY = "UPDATEGENERALOPDEXAMBODY";
export const DELETEGENERALOPDEXAMBODY = "DELETEGENERALOPDEXAMBODY";
export const GETGENERALOPDEXAMAFFECTANDMOOD = "GETGENERALOPDEXAMAFFECTANDMOOD";
export const CREATEGENERALOPDEXAMAFFECTANDMOOD = "CREATEGENERALOPDEXAMAFFECTANDMOOD";
export const UPDATEGENERALOPDEXAMAFFECTANDMOOD = "UPDATEGENERALOPDEXAMAFFECTANDMOOD";
export const DELETEGENERALOPDEXAMAFFECTANDMOOD = "DELETEGENERALOPDEXAMAFFECTANDMOOD";
export const GETGENERALOPDEXAMSPEECH = "GETGENERALOPDEXAMSPEECH";
export const CREATEGENERALOPDEXAMSPEECH = "CREATEGENERALOPDEXAMSPEECH";
export const UPDATEGENERALOPDEXAMSPEECH = "UPDATEGENERALOPDEXAMSPEECH";
export const DELETEGENERALOPDEXAMSPEECH = "DELETEGENERALOPDEXAMSPEECH";
export const GETGENERALOPDEXAMSUBSTANCEABUSE = "GETGENERALOPDEXAMSUBSTANCEABUSE";
export const CREATEGENERALOPDEXAMSUBSTANCEABUSE = "CREATEGENERALOPDEXAMSUBSTANCEABUSE";
export const UPDATEGENERALOPDEXAMSUBSTANCEABUSE = "UPDATEGENERALOPDEXAMSUBSTANCEABUSE";
export const DELETEGENERALOPDEXAMSUBSTANCEABUSE = "DELETEGENERALOPDEXAMSUBSTANCEABUSE";
export const GETGENERALOPDEXAMHAIRCOLOR = "GETGENERALOPDEXAMHAIRCOLOR";
export const CREATEGENERALOPDEXAMHAIRCOLOR = "CREATEGENERALOPDEXAMHAIRCOLOR";
export const UPDATEGENERALOPDEXAMHAIRCOLOR = "UPDATEGENERALOPDEXAMHAIRCOLOR";
export const DELETEGENERALOPDEXAMHAIRCOLOR = "DELETEGENERALOPDEXAMHAIRCOLOR";
export const GETGENERALOPDEXAMHAIRDUSTRIBUTION = "GETGENERALOPDEXAMHAIRDUSTRIBUTION";
export const CREATEGENERALOPDEXAMHAIRDUSTRIBUTION = "CREATEGENERALOPDEXAMHAIRDUSTRIBUTION";
export const UPDATEGENERALOPDEXAMHAIRDUSTRIBUTION = "UPDATEGENERALOPDEXAMHAIRDUSTRIBUTION";
export const DELETEGENERALOPDEXAMHAIRDUSTRIBUTION = "DELETEGENERALOPDEXAMHAIRDUSTRIBUTION";
export const GETGENERALOPDEXAMHAIRTEXTURE = "GETGENERALOPDEXAMHAIRTEXTURE";
export const CREATEGENERALOPDEXAMHAIRTEXTURE = "CREATEGENERALOPDEXAMHAIRTEXTURE";
export const UPDATEGENERALOPDEXAMHAIRTEXTURE = "UPDATEGENERALOPDEXAMHAIRTEXTURE";
export const DELETEGENERALOPDEXAMHAIRTEXTURE = "DELETEGENERALOPDEXAMHAIRTEXTURE";
export const GETGENERALOPDEXAMHAIRLUBRICATON = "GETGENERALOPDEXAMHAIRLUBRICATON";
export const CREATEGENERALOPDEXAMHAIRLUBRICATON = "CREATEGENERALOPDEXAMHAIRLUBRICATON";
export const UPDATEGENERALOPDEXAMHAIRLUBRICATON = "UPDATEGENERALOPDEXAMHAIRLUBRICATON";
export const DELETEGENERALOPDEXAMHAIRLUBRICATON = "DELETEGENERALOPDEXAMHAIRLUBRICATON";
export const GETGENERALOPDEXAMHAIRSCALP = "GETGENERALOPDEXAMHAIRSCALP";
export const CREATEGENERALOPDEXAMHAIRSCALP = "CREATEGENERALOPDEXAMHAIRSCALP";
export const UPDATEGENERALOPDEXAMHAIRSCALP = "UPDATEGENERALOPDEXAMHAIRSCALP";
export const DELETEGENERALOPDEXAMHAIRSCALP = "DELETEGENERALOPDEXAMHAIRSCALP";
export const GETGENERALOPDEXAMHEADPOSITION = "GETGENERALOPDEXAMHEADPOSITION";
export const CREATEGENERALOPDEXAMHEADPOSITION = "CREATEGENERALOPDEXAMHEADPOSITION";
export const UPDATEGENERALOPDEXAMHEADPOSITION = "UPDATEGENERALOPDEXAMHEADPOSITION";
export const DELETEGENERALOPDEXAMHEADPOSITION = "DELETEGENERALOPDEXAMHEADPOSITION";
export const GETGENERALOPDEXAMHEADSHAPE = "GETGENERALOPDEXAMHEADSHAPE";
export const CREATEGENERALOPDEXAMHEADSHAPE = "CREATEGENERALOPDEXAMHEADSHAPE";
export const UPDATEGENERALOPDEXAMHEADSHAPE = "UPDATEGENERALOPDEXAMHEADSHAPE";
export const DELETEGENERALOPDEXAMHEADSHAPE = "DELETEGENERALOPDEXAMHEADSHAPE";
export const GETGENERALOPDEXAMFACIALFEATURES = "GETGENERALOPDEXAMFACIALFEATURES";
export const CREATEGENERALOPDEXAMFACIALFEATURES = "CREATEGENERALOPDEXAMFACIALFEATURES";
export const UPDATEGENERALOPDEXAMFACIALFEATURES = "UPDATEGENERALOPDEXAMFACIALFEATURES";
export const DELETEGENERALOPDEXAMFACIALFEATURES = "DELETEGENERALOPDEXAMFACIALFEATURES";
export const GETGENERALOPDEXAMEXTERNALEYEPOSTION = "GETGENERALOPDEXAMEXTERNALEYEPOSTION";
export const CREATEGENERALOPDEXAMEXTERNALEYEPOSTION = "CREATEGENERALOPDEXAMEXTERNALEYEPOSTION";
export const UPDATEGENERALOPDEXAMEXTERNALEYEPOSTION = "UPDATEGENERALOPDEXAMEXTERNALEYEPOSTION";
export const DELETEGENERALOPDEXAMEXTERNALEYEPOSTION = "DELETEGENERALOPDEXAMEXTERNALEYEPOSTION";
export const GETGENERALOPDEXAMHEADEYENECK = "GETGENERALOPDEXAMHEADEYENECK";
export const CREATEGENERALOPDEXAMHEADEYENECK = "CREATEGENERALOPDEXAMHEADEYENECK";
export const UPDATEGENERALOPDEXAMHEADEYENECK = "UPDATEGENERALOPDEXAMHEADEYENECK";
export const DELETEGENERALOPDEXAMHEADEYENECK = "DELETEGENERALOPDEXAMHEADEYENECK";
export const GETGENERALOPDEXAMLACRIMALAAPPARATUS = "GETGENERALOPDEXAMLACRIMALAAPPARATUS";
export const CREATEGENERALOPDEXAMLACRIMALAAPPARATUS = "CREATEGENERALOPDEXAMLACRIMALAAPPARATUS";
export const UPDATEGENERALOPDEXAMLACRIMALAAPPARATUS = "UPDATEGENERALOPDEXAMLACRIMALAAPPARATUS";
export const DELETEGENERALOPDEXAMLACRIMALAAPPARATUS = "DELETEGENERALOPDEXAMLACRIMALAAPPARATUS";
export const GETGENERALOPDEXAMCONJUCTIVASCLERACOLOR = "GETGENERALOPDEXAMCONJUCTIVASCLERACOLOR";
export const CREATEGENERALOPDEXAMCONJUCTIVASCLERACOLOR = "CREATEGENERALOPDEXAMCONJUCTIVASCLERACOLOR";
export const UPDATEGENERALOPDEXAMCONJUCTIVASCLERACOLOR = "UPDATEGENERALOPDEXAMCONJUCTIVASCLERACOLOR";
export const DELETEGENERALOPDEXAMCONJUCTIVASCLERACOLOR = "DELETEGENERALOPDEXAMCONJUCTIVASCLERACOLOR";
export const GETGENERALOPDEXAMEXTRACOCULARMOVEMENT = "GETGENERALOPDEXAMEXTRACOCULARMOVEMENT";
export const CREATEGENERALOPDEXAMEXTRACOCULARMOVEMENT = "CREATEGENERALOPDEXAMEXTRACOCULARMOVEMENT";
export const UPDATEGENERALOPDEXAMEXTRACOCULARMOVEMENT = "UPDATEGENERALOPDEXAMEXTRACOCULARMOVEMENT";
export const DELETEGENERALOPDEXAMEXTRACOCULARMOVEMENT = "DELETEGENERALOPDEXAMEXTRACOCULARMOVEMENT";
export const GETGENERALOPDEXAMNECKLYMPHNODE = "GETGENERALOPDEXAMNECKLYMPHNODE";
export const CREATEGENERALOPDEXAMNECKLYMPHNODE = "CREATEGENERALOPDEXAMNECKLYMPHNODE";
export const UPDATEGENERALOPDEXAMNECKLYMPHNODE = "UPDATEGENERALOPDEXAMNECKLYMPHNODE";
export const DELETEGENERALOPDEXAMNECKLYMPHNODE = "DELETEGENERALOPDEXAMNECKLYMPHNODE";
export const GETGENERALOPDEXAMEARNOSEMOUTH = "GETGENERALOPDEXAMEARNOSEMOUTH";
export const CREATEGENERALOPDEXAMEARNOSEMOUTH = "CREATEGENERALOPDEXAMEARNOSEMOUTH";
export const UPDATEGENERALOPDEXAMEARNOSEMOUTH = "UPDATEGENERALOPDEXAMEARNOSEMOUTH";
export const DELETEGENERALOPDEXAMEARNOSEMOUTH = "DELETEGENERALOPDEXAMEARNOSEMOUTH";
export const GETGENERALOPDEXAMCHESTAXILLATHORAX = "GETGENERALOPDEXAMCHESTAXILLATHORAX";
export const CREATEGENERALOPDEXAMCHESTAXILLATHORAX = "CREATEGENERALOPDEXAMCHESTAXILLATHORAX";
export const UPDATEGENERALOPDEXAMCHESTAXILLATHORAX = "UPDATEGENERALOPDEXAMCHESTAXILLATHORAX";
export const DELETEGENERALOPDEXAMCHESTAXILLATHORAX = "DELETEGENERALOPDEXAMCHESTAXILLATHORAX";
export const GETGENERALOPDEXAMABDOMEN = "GETGENERALOPDEXAMABDOMEN";
export const CREATEGENERALOPDEXAMABDOMEN = "CREATEGENERALOPDEXAMABDOMEN";
export const UPDATEGENERALOPDEXAMABDOMEN = "UPDATEGENERALOPDEXAMABDOMEN";
export const DELETEGENERALOPDEXAMABDOMEN = "DELETEGENERALOPDEXAMABDOMEN";
export const GETGENERALOPDEXAMEXTERNLGENITALORGAN = "GETGENERALOPDEXAMEXTERNLGENITALORGAN";
export const CREATEGENERALOPDEXAMEXTERNLGENITALORGAN = "CREATEGENERALOPDEXAMEXTERNLGENITALORGAN";
export const UPDATEGENERALOPDEXAMEXTERNLGENITALORGAN = "UPDATEGENERALOPDEXAMEXTERNLGENITALORGAN";
export const DELETEGENERALOPDEXAMEXTERNLGENITALORGAN = "DELETEGENERALOPDEXAMEXTERNLGENITALORGAN";
export const GETGENERALOPDEXAMMUSCULOSKELETAL = "GETGENERALOPDEXAMMUSCULOSKELETAL";
export const CREATEGENERALOPDEXAMMUSCULOSKELETAL = "CREATEGENERALOPDEXAMMUSCULOSKELETAL";
export const UPDATEGENERALOPDEXAMMUSCULOSKELETAL = "UPDATEGENERALOPDEXAMMUSCULOSKELETAL";
export const DELETEGENERALOPDEXAMMUSCULOSKELETAL = "DELETEGENERALOPDEXAMMUSCULOSKELETAL";
export const GETGENERALOPDEXAMNEURO = "GETGENERALOPDEXAMNEURO";
export const CREATEGENERALOPDEXAMNEURO = "CREATEGENERALOPDEXAMNEURO";
export const UPDATEGENERALOPDEXAMNEURO = "UPDATEGENERALOPDEXAMNEURO";
export const DELETEGENERALOPDEXAMNEURO = "DELETEGENERALOPDEXAMNEURO";

export const GETGENERALEXAMSIGNOFDISTRESS = "GETGENERALEXAMSIGNOFDISTRESS";
export const CREATEGENERALEXAMSIGNOFDISTRESS = "CREATEGENERALEXAMSIGNOFDISTRESS";
export const UPDATEGENERALEXAMSIGNOFDISTRESS = "UPDATEGENERALEXAMSIGNOFDISTRESS";
export const DELETEGENERALEXAMSIGNOFDISTRESS = "DELETEGENERALEXAMSIGNOFDISTRESS";
export const GETGENERALEXAMBODYTYPE = "GETGENERALEXAMBODYTYPE";
export const CREATEGENERALEXAMBODYTYPE = "CREATEGENERALEXAMBODYTYPE";
export const UPDATEGENERALEXAMBODYTYPE = "UPDATEGENERALEXAMBODYTYPE";
export const DELETEGENERALEXAMBODYTYPE = "DELETEGENERALEXAMBODYTYPE";
export const GETGENERALEXAMPOSTURE = "GETGENERALEXAMPOSTURE";
export const CREATEGENERALEXAMPOSTURE = "CREATEGENERALEXAMPOSTURE";
export const UPDATEGENERALEXAMPOSTURE = "UPDATEGENERALEXAMPOSTURE";
export const DELETEGENERALEXAMPOSTURE = "DELETEGENERALEXAMPOSTURE";
export const GETGENERALEXAMGAIT = "GETGENERALEXAMGAIT";
export const CREATEGENERALEXAMGAIT = "CREATEGENERALEXAMGAIT";
export const UPDATEGENERALEXAMGAIT = "UPDATEGENERALEXAMGAIT";
export const DELETEGENERALEXAMGAIT = "DELETEGENERALEXAMGAIT";
export const GETGENERALEXAMBODYMOVEMENTS = "GETGENERALEXAMBODYMOVEMENTS";
export const CREATEGENERALEXAMBODYMOVEMENTS = "CREATEGENERALEXAMBODYMOVEMENTS";
export const UPDATEGENERALEXAMBODYMOVEMENTS = "UPDATEGENERALEXAMBODYMOVEMENTS";
export const DELETEGENERALEXAMBODYMOVEMENTS = "DELETEGENERALEXAMBODYMOVEMENTS";
export const GETGENERALEXAMBODY = "GETGENERALEXAMBODY";
export const CREATEGENERALEXAMBODY = "CREATEGENERALEXAMBODY";
export const UPDATEGENERALEXAMBODY = "UPDATEGENERALEXAMBODY";
export const DELETEGENERALEXAMBODY = "DELETEGENERALEXAMBODY";
export const GETGENERALEXAMAFFECTANDMOOD = "GETGENERALEXAMAFFECTANDMOOD";
export const CREATEGENERALEXAMAFFECTANDMOOD = "CREATEGENERALEXAMAFFECTANDMOOD";
export const UPDATEGENERALEXAMAFFECTANDMOOD = "UPDATEGENERALEXAMAFFECTANDMOOD";
export const DELETEGENERALEXAMAFFECTANDMOOD = "DELETEGENERALEXAMAFFECTANDMOOD";
export const GETGENERALEXAMSPEECH = "GETGENERALEXAMSPEECH";
export const CREATEGENERALEXAMSPEECH = "CREATEGENERALEXAMSPEECH";
export const UPDATEGENERALEXAMSPEECH = "UPDATEGENERALEXAMSPEECH";
export const DELETEGENERALEXAMSPEECH = "DELETEGENERALEXAMSPEECH";
export const GETGENERALEXAMHAIRCOLOR = "GETGENERALEXAMHAIRCOLOR";
export const CREATEGENERALEXAMHAIRCOLOR = "CREATEGENERALEXAMHAIRCOLOR";
export const UPDATEGENERALEXAMHAIRCOLOR = "UPDATEGENERALEXAMHAIRCOLOR";
export const DELETEGENERALEXAMHAIRCOLOR = "DELETEGENERALEXAMHAIRCOLOR";
export const GETGENERALEXAMHAIRDISTRIBUTION = "GETGENERALEXAMHAIRDISTRIBUTION";
export const CREATEGENERALEXAMHAIRDISTRIBUTION = "CREATEGENERALEXAMHAIRDISTRIBUTION";
export const UPDATEGENERALEXAMHAIRDISTRIBUTION = "UPDATEGENERALEXAMHAIRDISTRIBUTION";
export const DELETEGENERALEXAMHAIRDISTRIBUTION = "DELETEGENERALEXAMHAIRDISTRIBUTION";
export const GETGENERALEXAMHAIRTEXTURE = "GETGENERALEXAMHAIRTEXTURE";
export const CREATEGENERALEXAMHAIRTEXTURE = "CREATEGENERALEXAMHAIRTEXTURE";
export const UPDATEGENERALEXAMHAIRTEXTURE = "UPDATEGENERALEXAMHAIRTEXTURE";
export const DELETEGENERALEXAMHAIRTEXTURE = "DELETEGENERALEXAMHAIRTEXTURE";
export const GETGENERALEXAMLUBRICATION = "GETGENERALEXAMLUBRICATION";
export const CREATEGENERALEXAMLUBRICATION = "CREATEGENERALEXAMLUBRICATION";
export const UPDATEGENERALEXAMLUBRICATION = "UPDATEGENERALEXAMLUBRICATION";
export const DELETEGENERALEXAMLUBRICATION = "DELETEGENERALEXAMLUBRICATION";
export const GETGENERALEXAMSCALP = "GETGENERALEXAMSCALP";
export const CREATEGENERALEXAMSCALP = "CREATEGENERALEXAMSCALP";
export const UPDATEGENERALEXAMSCALP = "UPDATEGENERALEXAMSCALP";
export const DELETEGENERALEXAMSCALP = "DELETEGENERALEXAMSCALP";
export const GETGENERALEXAMHEADPOSITION = "GETGENERALEXAMHEADPOSITION";
export const CREATEGENERALEXAMHEADPOSITION = "CREATEGENERALEXAMHEADPOSITION";
export const UPDATEGENERALEXAMHEADPOSITION = "UPDATEGENERALEXAMHEADPOSITION";
export const DELETEGENERALEXAMHEADPOSITION = "DELETEGENERALEXAMHEADPOSITION";
export const GETGENERALEXAMHEADSHAPE = "GETGENERALEXAMHEADSHAPE";
export const CREATEGENERALEXAMHEADSHAPE = "CREATEGENERALEXAMHEADSHAPE";
export const UPDATEGENERALEXAMHEADSHAPE = "UPDATEGENERALEXAMHEADSHAPE";
export const DELETEGENERALEXAMHEADSHAPE = "DELETEGENERALEXAMHEADSHAPE";
export const GETGENERALEXAMFACIALFEATURES = "GETGENERALEXAMFACIALFEATURES";
export const CREATEGENERALEXAMFACIALFEATURES = "CREATEGENERALEXAMFACIALFEATURES";
export const UPDATEGENERALEXAMFACIALFEATURES = "UPDATEGENERALEXAMFACIALFEATURES";
export const DELETEGENERALEXAMFACIALFEATURES = "DELETEGENERALEXAMFACIALFEATURES";
export const GETGENERALEXAMEXTERNALEYEPOSITION = "GETGENERALEXAMEXTERNALEYEPOSITION";
export const CREATEGENERALEXAMEXTERNALEYEPOSITION = "CREATEGENERALEXAMEXTERNALEYEPOSITION";
export const UPDATEGENERALEXAMEXTERNALEYEPOSITION = "UPDATEGENERALEXAMEXTERNALEYEPOSITION";
export const DELETEGENERALEXAMEXTERNALEYEPOSITION = "DELETEGENERALEXAMEXTERNALEYEPOSITION";
export const GETGENERALEXAMLACRIMALAPPARATUS = "GETGENERALEXAMLACRIMALAPPARATUS";
export const CREATEGENERALEXAMLACRIMALAPPARATUS = "CREATEGENERALEXAMLACRIMALAPPARATUS";
export const UPDATEGENERALEXAMLACRIMALAPPARATUS = "UPDATEGENERALEXAMLACRIMALAPPARATUS";
export const DELETEGENERALEXAMLACRIMALAPPARATUS = "DELETEGENERALEXAMLACRIMALAPPARATUS";
export const GETGENERALEXAMCONJUCTIVASCLEARCOLOR = "GETGENERALEXAMCONJUCTIVASCLEARCOLOR";
export const CREATEGENERALEXAMCONJUCTIVASCLEARCOLOR = "CREATEGENERALEXAMCONJUCTIVASCLEARCOLOR";
export const UPDATEGENERALEXAMCONJUCTIVASCLEARCOLOR = "UPDATEGENERALEXAMCONJUCTIVASCLEARCOLOR";
export const DELETEGENERALEXAMCONJUCTIVASCLEARCOLOR = "DELETEGENERALEXAMCONJUCTIVASCLEARCOLOR";
export const GETGENERALEXAMEXTRAOCULARMOVEMENTS = "GETGENERALEXAMEXTRAOCULARMOVEMENTS";
export const CREATEGENERALEXAMEXTRAOCULARMOVEMENTS = "CREATEGENERALEXAMEXTRAOCULARMOVEMENTS";
export const UPDATEGENERALEXAMEXTRAOCULARMOVEMENTS = "UPDATEGENERALEXAMEXTRAOCULARMOVEMENTS";
export const DELETEGENERALEXAMEXTRAOCULARMOVEMENTS = "DELETEGENERALEXAMEXTRAOCULARMOVEMENTS";
export const GETGENERALEXAMNECKLYMPHNODE = "GETGENERALEXAMNECKLYMPHNODE";
export const CREATEGENERALEXAMNECKLYMPHNODE = "CREATEGENERALEXAMNECKLYMPHNODE";
export const UPDATEGENERALEXAMNECKLYMPHNODE = "UPDATEGENERALEXAMNECKLYMPHNODE";
export const DELETEGENERALEXAMNECKLYMPHNODE = "DELETEGENERALEXAMNECKLYMPHNODE";

export const CREATEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS = "CREATEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS";

export const CREATEAYURVEDICPAINASSESSMENTSEVERITY = "CREATEAYURVEDICPAINASSESSMENTSEVERITY";
export const GETAYURVEDICPAINASSESSMENTSEVERITY = "GETAYURVEDICPAINASSESSMENTSEVERITY";
export const DELETEAYURVEDICPAINASSESSMENTSEVERITY = "DELETEAYURVEDICPAINASSESSMENTSEVERITY";
export const UPDATEAYURVEDICPAINASSESSMENTSEVERITY = "UPDATEAYURVEDICPAINASSESSMENTSEVERITY";
export const CREATEAYURVEDICPAINASSESSMENTPAINNATURE = "CREATEAYURVEDICPAINASSESSMENTPAINNATURE";
export const GETAYURVEDICPAINASSESSMENTPAINNATURE = "GETAYURVEDICPAINASSESSMENTPAINNATURE";
export const DELETEAYURVEDICPAINASSESSMENTPAINNATURE = "DELETEAYURVEDICPAINASSESSMENTPAINNATURE";
export const UPDATEAYURVEDICPAINASSESSMENTPAINNATURE = "UPDATEAYURVEDICPAINASSESSMENTPAINNATURE";
export const CREATEAYURVEDICPAINASSESSMENTPAINONSET = "CREATEAYURVEDICPAINASSESSMENTPAINONSET";
export const GETAYURVEDICPAINASSESSMENTPAINONSET = "GETAYURVEDICPAINASSESSMENTPAINONSET";
export const DELETEAYURVEDICPAINASSESSMENTPAINONSET = "DELETEAYURVEDICPAINASSESSMENTPAINONSET";
export const UPDATEAYURVEDICPAINASSESSMENTPAINONSET = "UPDATEAYURVEDICPAINASSESSMENTPAINONSET";
export const CREATEAYURVEDICPAINASSESSMENTPAINVARIATION = "CREATEAYURVEDICPAINASSESSMENTPAINVARIATION";
export const GETAYURVEDICPAINASSESSMENTPAINVARIATION = "GETAYURVEDICPAINASSESSMENTPAINVARIATION";
export const DELETEAYURVEDICPAINASSESSMENTPAINVARIATION = "DELETEAYURVEDICPAINASSESSMENTPAINVARIATION";
export const UPDATEAYURVEDICPAINASSESSMENTPAINVARIATION = "UPDATEAYURVEDICPAINASSESSMENTPAINVARIATION";

export const GETSETUPAYURVEDICHEALTHMAINT = "GETSETUPAYURVEDICHEALTHMAINT";
export const CREATESETUPAYURVEDICHEALTHMAINT = "CREATESETUPAYURVEDICHEALTHMAINT";
export const UPDATESETUPAYURVEDICHEALTHMAINT = "UPDATESETUPAYURVEDICHEALTHMAINT";
export const DELETESETUPAYURVEDICHEALTHMAINT = "DELETESETUPAYURVEDICHEALTHMAINT";


export const GETSETUPAYURVEDICRELATIONLST = "GETSETUPAYURVEDICRELATIONLST";
export const CREATESETUPAYURVEDICRELATIONLST = "CREATESETUPAYURVEDICRELATIONLST";
export const UPDATESETUPAYURVEDICRELATIONLST = "UPDATESETUPAYURVEDICRELATIONLST";
export const DELETESETUPAYURVEDICRELATIONLST = "DELETESETUPAYURVEDICRELATIONLST";

export const GETSETUPAYURVEDICPERSONALHISTORY = "GETSETUPAYURVEDICPERSONALHISTORY";
export const CREATESETUPAYURVEDICPERSONALHISTORY = "CREATESETUPAYURVEDICPERSONALHISTORY";
export const UPDATESETUPAYURVEDICPERSONALHISTORY = "UPDATESETUPAYURVEDICPERSONALHISTORY";
export const DELETESETUPAYURVEDICPERSONALHISTORY = "DELETESETUPAYURVEDICPERSONALHISTORY";


export const GETSETUPAYURVEDICDIGESTIVETRACT = "GETSETUPAYURVEDICDIGESTIVETRACT";
export const CREATESETUPAYURVEDICDIGESTIVETRACT = "CREATESETUPAYURVEDICDIGESTIVETRACT";
export const UPDATESETUPAYURVEDICDIGESTIVETRACT = "UPDATESETUPAYURVEDICDIGESTIVETRACT";
export const DELETESETUPAYURVEDICDIGESTIVETRACT = "DELETESETUPAYURVEDICDIGESTIVETRACT";

export const GETSETUPAYURVEDICBOWEL = "GETSETUPAYURVEDICBOWEL";
export const CREATESETUPAYURVEDICBOWEL = "CREATESETUPAYURVEDICBOWEL";
export const UPDATESETUPAYURVEDICBOWEL = "UPDATESETUPAYURVEDICBOWEL";
export const DELETESETUPAYURVEDICBOWEL = "DELETESETUPAYURVEDICBOWEL";

export const GETSETUPAYURVEDICSLEEP = "GETSETUPAYURVEDICSLEEP";
export const CREATESETUPAYURVEDICSLEEP = "CREATESETUPAYURVEDICSLEEP";
export const UPDATESETUPAYURVEDICSLEEP = "UPDATESETUPAYURVEDICSLEEP";
export const DELETESETUPAYURVEDICSLEEP = "DELETESETUPAYURVEDICSLEEP";

export const GETSETUPAYURVEDICADDICTIONS = "GETSETUPAYURVEDICADDICTIONS";
export const CREATESETUPAYURVEDICADDICTIONS = "CREATESETUPAYURVEDICADDICTIONS";
export const UPDATESETUPAYURVEDICADDICTIONS = "UPDATESETUPAYURVEDICADDICTIONS";
export const DELETESETUPAYURVEDICADDICTIONS = "DELETESETUPAYURVEDICADDICTIONS";

export const GETSETUPAYURVEDICHIGHRISK = "GETSETUPAYURVEDICHIGHRISK";
export const CREATESETUPAYURVEDICHIGHRISK = "CREATESETUPAYURVEDICHIGHRISK";
export const UPDATESETUPAYURVEDICHIGHRISK = "UPDATESETUPAYURVEDICHIGHRISK";
export const DELETESETUPAYURVEDICHIGHRISK = "DELETESETUPAYURVEDICHIGHRISK";

export const GETSETUPAYURVEDICPOSITIONOFWORK = "GETSETUPAYURVEDICPOSITIONOFWORK";
export const CREATESETUPAYURVEDICPOSITIONOFWORK = "CREATESETUPAYURVEDICPOSITIONOFWORK";
export const UPDATESETUPAYURVEDICPOSITIONOFWORK = "UPDATESETUPAYURVEDICPOSITIONOFWORK";
export const DELETESETUPAYURVEDICPOSITIONOFWORK = "DELETESETUPAYURVEDICPOSITIONOFWORK";

export const GETSETUPAYURVEDICNATUREOFWORK = "GETSETUPAYURVEDICNATUREOFWORK";
export const CREATESETUPAYURVEDICNATUREOFWORK = "CREATESETUPAYURVEDICNATUREOFWORK";
export const UPDATESETUPAYURVEDICNATUREOFWORK = "UPDATESETUPAYURVEDICNATUREOFWORK";
export const DELETESETUPAYURVEDICNATUREOFWORK = "DELETESETUPAYURVEDICNATUREOFWORK";

export const GETSETUPAYURVEDICDEPRESSION = "GETSETUPAYURVEDICDEPRESSION";
export const CREATESETUPAYURVEDICDEPRESSION = "CREATESETUPAYURVEDICDEPRESSION";
export const UPDATESETUPAYURVEDICDEPRESSION = "UPDATESETUPAYURVEDICDEPRESSION";
export const DELETESETUPAYURVEDICDEPRESSION = "DELETESETUPAYURVEDICDEPRESSION";

export const GETSETUPAYURVEDICIRRITABILITY = "GETSETUPAYURVEDICIRRITABILITY";
export const CREATESETUPAYURVEDICIRRITABILITY = "CREATESETUPAYURVEDICIRRITABILITY";
export const UPDATESETUPAYURVEDICIRRITABILITY = "UPDATESETUPAYURVEDICIRRITABILITY";
export const DELETESETUPAYURVEDICIRRITABILITY = "DELETESETUPAYURVEDICIRRITABILITY";

export const GETSETUPAYURVEDICEUPHORIA = "GETSETUPAYURVEDICEUPHORIA";
export const CREATESETUPAYURVEDICEUPHORIA = "CREATESETUPAYURVEDICEUPHORIA";
export const UPDATESETUPAYURVEDICEUPHORIA = "UPDATESETUPAYURVEDICEUPHORIA";
export const DELETESETUPAYURVEDICEUPHORIA = "DELETESETUPAYURVEDICEUPHORIA";

export const GETSETUPAYURVEDICOBSESSION = "GETSETUPAYURVEDICOBSESSION";
export const CREATESETUPAYURVEDICOBSESSION = "CREATESETUPAYURVEDICOBSESSION";
export const UPDATESETUPAYURVEDICOBSESSION = "UPDATESETUPAYURVEDICOBSESSION";
export const DELETESETUPAYURVEDICOBSESSION = "DELETESETUPAYURVEDICOBSESSION";

export const GETSETUPAYURVEDICNEUROSIS = "GETSETUPAYURVEDICNEUROSIS";
export const CREATESETUPAYURVEDICNEUROSIS = "CREATESETUPAYURVEDICNEUROSIS";
export const UPDATESETUPAYURVEDICNEUROSIS = "UPDATESETUPAYURVEDICNEUROSIS";
export const DELETESETUPAYURVEDICNEUROSIS = "DELETESETUPAYURVEDICNEUROSIS";

export const GETSETUPAYURVEDICDEPERSONALIZATION = "GETSETUPAYURVEDICDEPERSONALIZATION";
export const CREATESETUPAYURVEDICDEPERSONALIZATION = "CREATESETUPAYURVEDICDEPERSONALIZATION";
export const UPDATESETUPAYURVEDICDEPERSONALIZATION = "UPDATESETUPAYURVEDICDEPERSONALIZATION";
export const DELETESETUPAYURVEDICDEPERSONALIZATION = "DELETESETUPAYURVEDICDEPERSONALIZATION";

export const GETSETUPAYURVEDICALLOPATHICMEDI = "GETSETUPAYURVEDICALLOPATHICMEDI";
export const CREATESETUPAYURVEDICALLOPATHICMEDI = "CREATESETUPAYURVEDICALLOPATHICMEDI";
export const UPDATESETUPAYURVEDICALLOPATHICMEDI = "UPDATESETUPAYURVEDICALLOPATHICMEDI";
export const DELETESETUPAYURVEDICALLOPATHICMEDI = "DELETESETUPAYURVEDICALLOPATHICMEDI";

export const GETSETUPAYURVEDICAYURVEDAMEDI = "GETSETUPAYURVEDICAYURVEDAMEDI";
export const CREATESETUPAYURVEDICAYURVEDAMEDI = "CREATESETUPAYURVEDICAYURVEDAMEDI";
export const UPDATESETUPAYURVEDICAYURVEDAMEDI = "UPDATESETUPAYURVEDICAYURVEDAMEDI";
export const DELETESETUPAYURVEDICAYURVEDAMEDI = "DELETESETUPAYURVEDICAYURVEDAMEDI";

export const GETSETUPAYURVEDICHOMEOPATHYMEDI = "GETSETUPAYURVEDICHOMEOPATHYMEDI";
export const CREATESETUPAYURVEDICHOMEOPATHYMEDI = "CREATESETUPAYURVEDICHOMEOPATHYMEDI";
export const UPDATESETUPAYURVEDICHOMEOPATHYMEDI = "UPDATESETUPAYURVEDICHOMEOPATHYMEDI";
export const DELETESETUPAYURVEDICHOMEOPATHYMEDI = "DELETESETUPAYURVEDICHOMEOPATHYMEDI";

export const GETSETUPAYURVEDICOTHERMEDI = "GETSETUPAYURVEDICOTHERMEDI";
export const CREATESETUPAYURVEDICOTHERMEDI = "CREATESETUPAYURVEDICOTHERMEDI";
export const UPDATESETUPAYURVEDICOTHERMEDI = "UPDATESETUPAYURVEDICOTHERMEDI";
export const DELETESETUPAYURVEDICOTHERMEDI = "DELETESETUPAYURVEDICOTHERMEDI";

export const GETSETUPAYURVEDICPSYCOLOGICALHIST = "GETSETUPAYURVEDICPSYCOLOGICALHIST";
export const CREATESETUPAYURVEDICPSYCOLOGICALHIST = "CREATESETUPAYURVEDICPSYCOLOGICALHIST";
export const UPDATESETUPAYURVEDICPSYCOLOGICALHIST = "UPDATESETUPAYURVEDICPSYCOLOGICALHIST";
export const DELETESETUPAYURVEDICPSYCOLOGICALHIST = "DELETESETUPAYURVEDICPSYCOLOGICALHIST";

export const GETSETUPAYURVEDICGYNECOLOGICAL = "GETSETUPAYURVEDICGYNECOLOGICAL";
export const CREATESETUPAYURVEDICGYNECOLOGICAL = "CREATESETUPAYURVEDICGYNECOLOGICAL";
export const UPDATESETUPAYURVEDICGYNECOLOGICAL = "UPDATESETUPAYURVEDICGYNECOLOGICAL";
export const DELETESETUPAYURVEDICGYNECOLOGICAL = "DELETESETUPAYURVEDICGYNECOLOGICAL";

export const GETSETUPAYURVEDICOBSTETRICALHIST = "GETSETUPAYURVEDICOBSTETRICALHIST";
export const CREATESETUPAYURVEDICOBSTETRICALHIST = "CREATESETUPAYURVEDICOBSTETRICALHIST";
export const UPDATESETUPAYURVEDICOBSTETRICALHIST = "UPDATESETUPAYURVEDICOBSTETRICALHIST";
export const DELETESETUPAYURVEDICOBSTETRICALHIST = "DELETESETUPAYURVEDICOBSTETRICALHIST";

export const GETSETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE = "GETSETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE";
export const CREATESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE = "CREATESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE";
export const UPDATESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE = "UPDATESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE";
export const DELETESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE = "DELETESETUPAYURVEDICEXAMINATIONGENERALAPPEARANCE";

export const GETSETUPAYURVEDICEXAMINATIONNUTRITION = "GETSETUPAYURVEDICEXAMINATIONNUTRITION";
export const CREATESETUPAYURVEDICEXAMINATIONNUTRITION = "CREATESETUPAYURVEDICEXAMINATIONNUTRITION";
export const UPDATESETUPAYURVEDICEXAMINATIONNUTRITION = "UPDATESETUPAYURVEDICEXAMINATIONNUTRITION";
export const DELETESETUPAYURVEDICEXAMINATIONNUTRITION = "DELETESETUPAYURVEDICEXAMINATIONNUTRITION";

export const GETSETUPAYURVEDICEXAMINATIONANAEMIA = "GETSETUPAYURVEDICEXAMINATIONANAEMIA";
export const CREATESETUPAYURVEDICEXAMINATIONANAEMIA = "CREATESETUPAYURVEDICEXAMINATIONANAEMIA";
export const UPDATESETUPAYURVEDICEXAMINATIONANAEMIA = "UPDATESETUPAYURVEDICEXAMINATIONANAEMIA";
export const DELETESETUPAYURVEDICEXAMINATIONANAEMIA = "DELETESETUPAYURVEDICEXAMINATIONANAEMIA";

export const GETSETUPAYURVEDICEXAMINATIONNECKVEIN = "GETSETUPAYURVEDICEXAMINATIONNECKVEIN";
export const CREATESETUPAYURVEDICEXAMINATIONNECKVEIN = "CREATESETUPAYURVEDICEXAMINATIONNECKVEIN";
export const UPDATESETUPAYURVEDICEXAMINATIONNECKVEIN = "UPDATESETUPAYURVEDICEXAMINATIONNECKVEIN";
export const DELETESETUPAYURVEDICEXAMINATIONNECKVEIN = "DELETESETUPAYURVEDICEXAMINATIONNECKVEIN";

export const GETSETUPAYURVEDICEXAMINATIONLYMPHNODES = "GETSETUPAYURVEDICEXAMINATIONLYMPHNODES";
export const CREATESETUPAYURVEDICEXAMINATIONLYMPHNODES = "CREATESETUPAYURVEDICEXAMINATIONLYMPHNODES";
export const UPDATESETUPAYURVEDICEXAMINATIONLYMPHNODES = "UPDATESETUPAYURVEDICEXAMINATIONLYMPHNODES";
export const DELETESETUPAYURVEDICEXAMINATIONLYMPHNODES = "DELETESETUPAYURVEDICEXAMINATIONLYMPHNODES";

export const GETSETUPAYURVEDICEXAMINATIONBUILD = "GETSETUPAYURVEDICEXAMINATIONBUILD";
export const CREATESETUPAYURVEDICEXAMINATIONBUILD = "CREATESETUPAYURVEDICEXAMINATIONBUILD";
export const UPDATESETUPAYURVEDICEXAMINATIONBUILD = "UPDATESETUPAYURVEDICEXAMINATIONBUILD";
export const DELETESETUPAYURVEDICEXAMINATIONBUILD = "DELETESETUPAYURVEDICEXAMINATIONBUILD";

export const GETSETUPAYURVEDICEXAMINATIONPULSE = "GETSETUPAYURVEDICEXAMINATIONPULSE";
export const CREATESETUPAYURVEDICEXAMINATIONPULSE = "CREATESETUPAYURVEDICEXAMINATIONPULSE";
export const UPDATESETUPAYURVEDICEXAMINATIONPULSE = "UPDATESETUPAYURVEDICEXAMINATIONPULSE";
export const DELETESETUPAYURVEDICEXAMINATIONPULSE = "DELETESETUPAYURVEDICEXAMINATIONPULSE";

export const GETSETUPAYURVEDICEXAMINATIONTONGUE = "GETSETUPAYURVEDICEXAMINATIONTONGUE";
export const CREATESETUPAYURVEDICEXAMINATIONTONGUE = "CREATESETUPAYURVEDICEXAMINATIONTONGUE";
export const UPDATESETUPAYURVEDICEXAMINATIONTONGUE = "UPDATESETUPAYURVEDICEXAMINATIONTONGUE";
export const DELETESETUPAYURVEDICEXAMINATIONTONGUE = "DELETESETUPAYURVEDICEXAMINATIONTONGUE";

export const GETSETUPAYURVEDICEXAMINATIONPOOP = "GETSETUPAYURVEDICEXAMINATIONPOOP";
export const CREATESETUPAYURVEDICEXAMINATIONPOOP = "CREATESETUPAYURVEDICEXAMINATIONPOOP";
export const UPDATESETUPAYURVEDICEXAMINATIONPOOP = "UPDATESETUPAYURVEDICEXAMINATIONPOOP";
export const DELETESETUPAYURVEDICEXAMINATIONPOOP = "DELETESETUPAYURVEDICEXAMINATIONPOOP";

export const GETSETUPAYURVEDICEXAMINATIONURINE = "GETSETUPAYURVEDICEXAMINATIONURINE";
export const CREATESETUPAYURVEDICEXAMINATIONURINE = "CREATESETUPAYURVEDICEXAMINATIONURINE";
export const UPDATESETUPAYURVEDICEXAMINATIONURINE = "UPDATESETUPAYURVEDICEXAMINATIONURINE";
export const DELETESETUPAYURVEDICEXAMINATIONURINE = "DELETESETUPAYURVEDICEXAMINATIONURINE";

export const GETSETUPAYURVEDICEXAMINATIONWORD = "GETSETUPAYURVEDICEXAMINATIONWORD";
export const CREATESETUPAYURVEDICEXAMINATIONWORD = "CREATESETUPAYURVEDICEXAMINATIONWORD";
export const UPDATESETUPAYURVEDICEXAMINATIONWORD = "UPDATESETUPAYURVEDICEXAMINATIONWORD";
export const DELETESETUPAYURVEDICEXAMINATIONWORD = "DELETESETUPAYURVEDICEXAMINATIONWORD";

export const GETSETUPAYURVEDICEXAMINATIONTOUCH = "GETSETUPAYURVEDICEXAMINATIONTOUCH";
export const CREATESETUPAYURVEDICEXAMINATIONTOUCH = "CREATESETUPAYURVEDICEXAMINATIONTOUCH";
export const UPDATESETUPAYURVEDICEXAMINATIONTOUCH = "UPDATESETUPAYURVEDICEXAMINATIONTOUCH";
export const DELETESETUPAYURVEDICEXAMINATIONTOUCH = "DELETESETUPAYURVEDICEXAMINATIONTOUCH";

export const GETSETUPAYURVEDICEXAMINATIONEYE = "GETSETUPAYURVEDICEXAMINATIONEYE";
export const CREATESETUPAYURVEDICEXAMINATIONEYE = "CREATESETUPAYURVEDICEXAMINATIONEYE";
export const UPDATESETUPAYURVEDICEXAMINATIONEYE = "UPDATESETUPAYURVEDICEXAMINATIONEYE";
export const DELETESETUPAYURVEDICEXAMINATIONEYE = "DELETESETUPAYURVEDICEXAMINATIONEYE";

export const GETSETUPAYURVEDICEXAMINATIONAKRITA = "GETSETUPAYURVEDICEXAMINATIONAKRITA";
export const CREATESETUPAYURVEDICEXAMINATIONAKRITA = "CREATESETUPAYURVEDICEXAMINATIONAKRITA";
export const UPDATESETUPAYURVEDICEXAMINATIONAKRITA = "UPDATESETUPAYURVEDICEXAMINATIONAKRITA";
export const DELETESETUPAYURVEDICEXAMINATIONAKRITA = "DELETESETUPAYURVEDICEXAMINATIONAKRITA";


export const GETSETUPAYURVEDICEXAMINATIONNATUREPHYSICAL = "GETSETUPAYURVEDICEXAMINATIONNATUREPHYSICAL";
export const CREATESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL = "CREATESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL";
export const UPDATESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL = "UPDATESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL";
export const DELETESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL = "DELETESETUPAYURVEDICEXAMINATIONNATUREPHYSICAL";


export const GETSETUPAYURVEDICEXAMINATIONNATUREMENTAL = "GETSETUPAYURVEDICEXAMINATIONNATUREMENTAL";
export const CREATESETUPAYURVEDICEXAMINATIONNATUREMENTAL = "CREATESETUPAYURVEDICEXAMINATIONNATUREMENTAL";
export const UPDATESETUPAYURVEDICEXAMINATIONNATUREMENTAL = "UPDATESETUPAYURVEDICEXAMINATIONNATUREMENTAL";
export const DELETESETUPAYURVEDICEXAMINATIONNATUREMENTAL = "DELETESETUPAYURVEDICEXAMINATIONNATUREMENTAL";


export const GETSETUPAYURVEDICEXAMINATIONSUBSTANCE = "GETSETUPAYURVEDICEXAMINATIONSUBSTANCE";
export const CREATESETUPAYURVEDICEXAMINATIONSUBSTANCE = "CREATESETUPAYURVEDICEXAMINATIONSUBSTANCE";
export const UPDATESETUPAYURVEDICEXAMINATIONSUBSTANCE = "UPDATESETUPAYURVEDICEXAMINATIONSUBSTANCE";
export const DELETESETUPAYURVEDICEXAMINATIONSUBSTANCE = "DELETESETUPAYURVEDICEXAMINATIONSUBSTANCE";


export const GETSETUPAYURVEDICEXAMINATIONCOMPACTION = "GETSETUPAYURVEDICEXAMINATIONCOMPACTION";
export const CREATESETUPAYURVEDICEXAMINATIONCOMPACTION = "CREATESETUPAYURVEDICEXAMINATIONCOMPACTION";
export const UPDATESETUPAYURVEDICEXAMINATIONCOMPACTION = "UPDATESETUPAYURVEDICEXAMINATIONCOMPACTION";
export const DELETESETUPAYURVEDICEXAMINATIONCOMPACTION = "DELETESETUPAYURVEDICEXAMINATIONCOMPACTION";


export const GETSETUPAYURVEDICEXAMINATIONPERCEPTION = "GETSETUPAYURVEDICEXAMINATIONPERCEPTION";
export const CREATESETUPAYURVEDICEXAMINATIONPERCEPTION = "CREATESETUPAYURVEDICEXAMINATIONPERCEPTION";
export const UPDATESETUPAYURVEDICEXAMINATIONPERCEPTION = "UPDATESETUPAYURVEDICEXAMINATIONPERCEPTION";
export const DELETESETUPAYURVEDICEXAMINATIONPERCEPTION = "DELETESETUPAYURVEDICEXAMINATIONPERCEPTION";


export const GETSETUPAYURVEDICEXAMINATIONSUITABILITY = "GETSETUPAYURVEDICEXAMINATIONSUITABILITY";
export const CREATESETUPAYURVEDICEXAMINATIONSUITABILITY = "CREATESETUPAYURVEDICEXAMINATIONSUITABILITY";
export const UPDATESETUPAYURVEDICEXAMINATIONSUITABILITY = "UPDATESETUPAYURVEDICEXAMINATIONSUITABILITY";
export const DELETESETUPAYURVEDICEXAMINATIONSUITABILITY = "DELETESETUPAYURVEDICEXAMINATIONSUITABILITY";


export const GETSETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM = "GETSETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM";
export const CREATESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM = "CREATESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM";
export const UPDATESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM = "UPDATESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM";
export const DELETESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM = "DELETESETUPAYURVEDICEXAMINATIONSUBSTANCESVATVAM";


export const GETSETUPAYURVEDICEXAMINATIONDIETCARRYPOWER = "GETSETUPAYURVEDICEXAMINATIONDIETCARRYPOWER";
export const CREATESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER = "CREATESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER";
export const UPDATESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER = "UPDATESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER";
export const DELETESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER = "DELETESETUPAYURVEDICEXAMINATIONDIETCARRYPOWER";


export const GETSETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER = "GETSETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER";
export const CREATESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER = "CREATESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER";
export const UPDATESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER = "UPDATESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER";
export const DELETESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER = "DELETESETUPAYURVEDICEXAMINATIONDIETBURNINGPOWER";


export const GETSETUPAYURVEDICEXAMINATIONEXERCIZEPOWER = "GETSETUPAYURVEDICEXAMINATIONEXERCIZEPOWER";
export const CREATESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER = "CREATESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER";
export const UPDATESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER = "UPDATESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER";
export const DELETESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER = "DELETESETUPAYURVEDICEXAMINATIONEXERCIZEPOWER";


export const GETSETUPAYURVEDICEXAMINATIONAGE = "GETSETUPAYURVEDICEXAMINATIONAGE";
export const CREATESETUPAYURVEDICEXAMINATIONAGE = "CREATESETUPAYURVEDICEXAMINATIONAGE";
export const UPDATESETUPAYURVEDICEXAMINATIONAGE = "UPDATESETUPAYURVEDICEXAMINATIONAGE";
export const DELETESETUPAYURVEDICEXAMINATIONAGE = "DELETESETUPAYURVEDICEXAMINATIONAGE";


export const GETSETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS = "GETSETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS = "CREATESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS = "UPDATESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS = "DELETESETUPAYURVEDICEXAMINATIONPRANAVAHSROTAS";


export const GETSETUPAYURVEDICEXAMINATIONANNAVAHSROTAS = "GETSETUPAYURVEDICEXAMINATIONANNAVAHSROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS = "CREATESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS = "UPDATESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS = "DELETESETUPAYURVEDICEXAMINATIONANNAVAHSROTAS";


export const GETSETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS = "GETSETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS = "CREATESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS = "UPDATESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS = "DELETESETUPAYURVEDICEXAMINATIONUDAKAVAHASROTAS";


export const GETSETUPAYURVEDICEXAMINATIONRASAVAHASROTAS = "GETSETUPAYURVEDICEXAMINATIONRASAVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS = "CREATESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS = "UPDATESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS = "DELETESETUPAYURVEDICEXAMINATIONRASAVAHASROTAS";


export const GETSETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS = "GETSETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS = "CREATESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS = "UPDATESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS = "DELETESETUPAYURVEDICEXAMINATIONRAKTAVAHASROTAS";


export const GETSETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS = "GETSETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS = "CREATESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS = "UPDATESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS = "DELETESETUPAYURVEDICEXAMINATIONMAMSAVAHASROTAS";


export const GETSETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS = "GETSETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS = "CREATESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS = "UPDATESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS = "DELETESETUPAYURVEDICEXAMINATIONMEDOVAHASROTAS";


export const GETSETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS = "GETSETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS = "CREATESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS = "UPDATESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS = "DELETESETUPAYURVEDICEXAMINATIONASTHIVAHASROTAS";


export const GETSETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS = "GETSETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS = "CREATESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS = "UPDATESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS = "DELETESETUPAYURVEDICEXAMINATIONMAJJAVHASROTAS";


export const GETSETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS = "GETSETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS = "CREATESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS = "UPDATESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS = "DELETESETUPAYURVEDICEXAMINATIONSUKRAVAHASROTAS";


export const GETSETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS = "GETSETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS = "CREATESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS = "UPDATESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS = "DELETESETUPAYURVEDICEXAMINATIONMOOTRAVAHASROTAS";


export const GETSETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS = "GETSETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS = "CREATESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS = "UPDATESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS = "DELETESETUPAYURVEDICEXAMINATIONPUREESHVAHASROTAS";


export const GETSETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS = "GETSETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS";
export const CREATESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS = "CREATESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS";
export const UPDATESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS = "UPDATESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS";
export const DELETESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS = "DELETESETUPAYURVEDICEXAMINATIONSWEDAVAHASROTAS";


export const GETSETUPAYURVEDICEXAMINATIONTHEFAULT = "GETSETUPAYURVEDICEXAMINATIONTHEFAULT";
export const CREATESETUPAYURVEDICEXAMINATIONTHEFAULT = "CREATESETUPAYURVEDICEXAMINATIONTHEFAULT";
export const UPDATESETUPAYURVEDICEXAMINATIONTHEFAULT = "UPDATESETUPAYURVEDICEXAMINATIONTHEFAULT";
export const DELETESETUPAYURVEDICEXAMINATIONTHEFAULT = "DELETESETUPAYURVEDICEXAMINATIONTHEFAULT";


export const GETSETUPAYURVEDICEXAMINATIONDUSHYA = "GETSETUPAYURVEDICEXAMINATIONDUSHYA";
export const CREATESETUPAYURVEDICEXAMINATIONDUSHYA = "CREATESETUPAYURVEDICEXAMINATIONDUSHYA";
export const UPDATESETUPAYURVEDICEXAMINATIONDUSHYA = "UPDATESETUPAYURVEDICEXAMINATIONDUSHYA";
export const DELETESETUPAYURVEDICEXAMINATIONDUSHYA = "DELETESETUPAYURVEDICEXAMINATIONDUSHYA";


export const GETSETUPAYURVEDICEXAMINATIONFIRE = "GETSETUPAYURVEDICEXAMINATIONFIRE";
export const CREATESETUPAYURVEDICEXAMINATIONFIRE = "CREATESETUPAYURVEDICEXAMINATIONFIRE";
export const UPDATESETUPAYURVEDICEXAMINATIONFIRE = "UPDATESETUPAYURVEDICEXAMINATIONFIRE";
export const DELETESETUPAYURVEDICEXAMINATIONFIRE = "DELETESETUPAYURVEDICEXAMINATIONFIRE";


export const GETSETUPAYURVEDICEXAMINATIONAMA = "GETSETUPAYURVEDICEXAMINATIONAMA";
export const CREATESETUPAYURVEDICEXAMINATIONAMA = "CREATESETUPAYURVEDICEXAMINATIONAMA";
export const UPDATESETUPAYURVEDICEXAMINATIONAMA = "UPDATESETUPAYURVEDICEXAMINATIONAMA";
export const DELETESETUPAYURVEDICEXAMINATIONAMA = "DELETESETUPAYURVEDICEXAMINATIONAMA";


export const GETSETUPAYURVEDICEXAMINATIONSOURCES = "GETSETUPAYURVEDICEXAMINATIONSOURCES";
export const CREATESETUPAYURVEDICEXAMINATIONSOURCES = "CREATESETUPAYURVEDICEXAMINATIONSOURCES";
export const UPDATESETUPAYURVEDICEXAMINATIONSOURCES = "UPDATESETUPAYURVEDICEXAMINATIONSOURCES";
export const DELETESETUPAYURVEDICEXAMINATIONSOURCES = "DELETESETUPAYURVEDICEXAMINATIONSOURCES";


export const GETSETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE = "GETSETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE";
export const CREATESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE = "CREATESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE";
export const UPDATESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE = "UPDATESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE";
export const DELETESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE = "DELETESETUPAYURVEDICEXAMINATIONFACULTYSOURCESTYPE";


export const GETSETUPAYURVEDICEXAMINATIONPLACEOFORIGIN = "GETSETUPAYURVEDICEXAMINATIONPLACEOFORIGIN";
export const CREATESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN = "CREATESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN";
export const UPDATESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN = "UPDATESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN";
export const DELETESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN = "DELETESETUPAYURVEDICEXAMINATIONPLACEOFORIGIN";

export const GETSETUPAYURVEDICOPDBODYCHART = "GETSETUPAYURVEDICOPDBODYCHART";
export const CREATESETUPAYURVEDICOPDBODYCHART = "CREATESETUPAYURVEDICOPDBODYCHART";
export const UPDATESETUPAYURVEDICOPDBODYCHART = "UPDATESETUPAYURVEDICOPDBODYCHART";
export const DELETESETUPAYURVEDICOPDBODYCHART = "DELETESETUPAYURVEDICOPDBODYCHART";

export const GETAYURVEDICOPDPAINASSESSMENT = "GETAYURVEDICOPDPAINASSESSMENT";
export const CREATEAYURVVEDICOPDPAINASSESSMENT = "CREATEAYURVVEDICOPDPAINASSESSMENT";
export const UPDATEAYURVEDICOPDPAINASSESSMENT = "UPDATEAYURVEDICOPDPAINASSESSMENT";
export const DELETEAYURVEDICOPDPAINASSESSMENT = "DELETEAYURVEDICOPDPAINASSESSMENT";

export const CREATEAYURVVEDICOPDCHIEFSYMTOMPS = "CREATEAYURVVEDICOPDCHIEFSYMTOMPS";
export const GETAYURVEDICOPDCHIEFSYMTOMPS = "GETAYURVEDICOPDCHIEFSYMTOMPS";
export const UPDATEAYURVEDICOPDCHIEFSYMTOMPS = "UPDATEAYURVEDICOPDCHIEFSYMTOMPS";
export const DELETEAYURVEDICOPDCHIEFSYMTOMPS = "DELETEAYURVEDICOPDCHIEFSYMTOMPS";

export const GETAYURVEDICOPDASSOCIATEDSYMTOMPS = "GETAYURVEDICOPDASSOCIATEDSYMTOMPS";
export const CREATEAYURVVEDICOPDASSOCIATEDSYMTOMPS = "CREATEAYURVVEDICOPDASSOCIATEDSYMTOMPS";
export const UPDATEAYURVEDICOPDASSOCIATEDSYMTOMPS = "UPDATEAYURVEDICOPDASSOCIATEDSYMTOMPS";
export const DELETEAYURVEDICOPDASSOCIATEDSYMTOMPS = "DELETEAYURVEDICOPDASSOCIATEDSYMTOMPS";

export const GETAYURVEDICOPDPRESENTILLCOMORBIDITY = "GETAYURVEDICOPDPRESENTILLCOMORBIDITY";
export const CREATEAYURVVEDICOPDPRESENTILLCOMORBIDITY = "CREATEAYURVVEDICOPDPRESENTILLCOMORBIDITY";
export const UPDATEAYURVEDICOPDPRESENTILLCOMORBIDITY = "UPDATEAYURVEDICOPDPRESENTILLCOMORBIDITY";
export const DELETEAYURVEDICOPDPRESENTILLCOMORBIDITY = "DELETEAYURVEDICOPDPRESENTILLCOMORBIDITY";

export const GETAYURVEDICOPDFAMILYSYMTOMPS = "GETAYURVEDICOPDFAMILYSYMTOMPS";
export const CREATEAYURVVEDICOPDFAMILYSYMTOMPS = "CREATEAYURVVEDICOPDFAMILYSYMTOMPS";
export const UPDATEAYURVEDICOPDFAMILYSYMTOMPS = "UPDATEAYURVEDICOPDFAMILYSYMTOMPS";
export const DELETEAYURVEDICOPDFAMILYSYMTOMPS = "DELETEAYURVEDICOPDFAMILYSYMTOMPS";

export const GETAYURVEDICOPDFAMILYCOMORBIDITY = "GETAYURVEDICOPDFAMILYCOMORBIDITY";
export const CREATEAYURVVEDICOPDFAMILYCOMORBIDITY = "CREATEAYURVVEDICOPDFAMILYCOMORBIDITY";
export const UPDATEAYURVEDICOPDFAMILYCOMORBIDITY = "UPDATEAYURVEDICOPDFAMILYCOMORBIDITY";
export const DELETEAYURVEDICOPDFAMILYCOMORBIDITY = "DELETEAYURVEDICOPDFAMILYCOMORBIDITY";

export const GETAYURVEDICOPDCHILDHOODILLNESS = "GETAYURVEDICOPDCHILDHOODILLNESS";
export const CREATEAYURVVEDICOPDCHILDHOODILLNESS = "CREATEAYURVVEDICOPDCHILDHOODILLNESS";
export const UPDATEAYURVEDICOPDCHILDHOODILLNESS = "UPDATEAYURVEDICOPDCHILDHOODILLNESS";
export const DELETEAYURVEDICOPDCHILDHOODILLNESS = "DELETEAYURVEDICOPDCHILDHOODILLNESS";

export const GETAYURVEDICOPDADULTILLNESS = "GETAYURVEDICOPDADULTILLNESS";
export const CREATEAYURVVEDICOPDADULTILLNESS = "CREATEAYURVVEDICOPDADULTILLNESS";
export const UPDATEAYURVEDICOPDADULTILLNESS = "UPDATEAYURVEDICOPDADULTILLNESS";
export const DELETEAYURVEDICOPDADULTILLNESS = "DELETEAYURVEDICOPDADULTILLNESS";

export const GETAYURVEDICOPDPRESENTCOMORILLNESS = "GETAYURVEDICOPDPRESENTCOMORILLNESS";
export const CREATEAYURVVEDICOPDPRESENTCOMORILLNESS = "CREATEAYURVVEDICOPDPRESENTCOMORILLNESS";
export const UPDATEAYURVEDICOPDPRESENTCOMORILLNESS = "UPDATEAYURVEDICOPDPRESENTCOMORILLNESS";
export const DELETEAYURVEDICOPDPRESENTCOMORILLNESS = "DELETEAYURVEDICOPDPRESENTCOMORILLNESS";

export const GETAYURVEDICOPDPASTILLNESS = "GETAYURVEDICOPDPASTILLNESS";
export const CREATEAYURVVEDICOPDPASTILLNESS = "CREATEAYURVVEDICOPDPASTILLNESS";
export const UPDATEAYURVEDICOPDPASTILLNESS = "UPDATEAYURVEDICOPDPASTILLNESS";
export const DELETEAYURVEDICOPDPASTILLNESS = "DELETEAYURVEDICOPDPASTILLNESS";

export const GETAYURVEDICOPDFAMILYILLNESS = "GETAYURVEDICOPDFAMILYILLNESS";
export const CREATEAYURVVEDICOPDFAMILYILLNESS = "CREATEAYURVVEDICOPDFAMILYILLNESS";
export const UPDATEAYURVEDICOPDFAMILYILLNESS = "UPDATEAYURVEDICOPDFAMILYILLNESS";
export const DELETEAYURVEDICOPDFAMILYILLNESS = "DELETEAYURVEDICOPDFAMILYILLNESS";

export const GETAYURVEDICOPDCOMPLAINTAPPETITE = "GETAYURVEDICOPDCOMPLAINTAPPETITE";
export const CREATEAYURVVEDICOPDCOMPLAINTAPPETITE = "CREATEAYURVVEDICOPDCOMPLAINTAPPETITE";
export const UPDATEAYURVEDICOPDCOMPLAINTAPPETITE = "UPDATEAYURVEDICOPDCOMPLAINTAPPETITE";
export const DELETEAYURVEDICOPDCOMPLAINTAPPETITE = "DELETEAYURVEDICOPDCOMPLAINTAPPETITE";
export const GETAYURVEDICOPDCOMPLAINTDIGESTIVETRACT = "GETAYURVEDICOPDCOMPLAINTDIGESTIVETRACT";
export const CREATEAYURVVEDICOPDCOMPLAINTDIGESTIVETRACT = "CREATEAYURVVEDICOPDCOMPLAINTDIGESTIVETRACT";
export const UPDATEAYURVEDICOPDCOMPLAINTDIGESTIVETRACT = "UPDATEAYURVEDICOPDCOMPLAINTDIGESTIVETRACT";
export const DELETEAYURVEDICOPDCOMPLAINTDIGESTIVETRACT = "DELETEAYURVEDICOPDCOMPLAINTDIGESTIVETRACT";
export const GETAYURVEDICOPDCOMPLAINTBOWEL = "GETAYURVEDICOPDCOMPLAINTBOWEL";
export const CREATEAYURVVEDICOPDCOMPLAINTBOWEL = "CREATEAYURVVEDICOPDCOMPLAINTBOWEL";
export const UPDATEAYURVEDICOPDCOMPLAINTBOWEL = "UPDATEAYURVEDICOPDCOMPLAINTBOWEL";
export const DELETEAYURVEDICOPDCOMPLAINTBOWEL = "DELETEAYURVEDICOPDCOMPLAINTBOWEL";
export const GETAYURVEDICOPDCOMPLAINTSLEEP = "GETAYURVEDICOPDCOMPLAINTSLEEP";
export const CREATEAYURVVEDICOPDCOMPLAINTSLEEP = "CREATEAYURVVEDICOPDCOMPLAINTSLEEP";
export const UPDATEAYURVEDICOPDCOMPLAINTSLEEP = "UPDATEAYURVEDICOPDCOMPLAINTSLEEP";
export const DELETEAYURVEDICOPDCOMPLAINTSLEEP = "DELETEAYURVEDICOPDCOMPLAINTSLEEP";
export const GETAYURVEDICOPDCOMPLAINTADDICTIONS = "GETAYURVEDICOPDCOMPLAINTADDICTIONS";
export const CREATEAYURVVEDICOPDCOMPLAINTADDICTIONS = "CREATEAYURVVEDICOPDCOMPLAINTADDICTIONS";
export const UPDATEAYURVEDICOPDCOMPLAINTADDICTIONS = "UPDATEAYURVEDICOPDCOMPLAINTADDICTIONS";
export const DELETEAYURVEDICOPDCOMPLAINTADDICTIONS = "DELETEAYURVEDICOPDCOMPLAINTADDICTIONS";
export const GETAYURVEDICOPDCOMPLAINTHIGHRISK = "GETAYURVEDICOPDCOMPLAINTHIGHRISK";
export const CREATEAYURVVEDICOPDCOMPLAINTHIGHRISK = "CREATEAYURVVEDICOPDCOMPLAINTHIGHRISK";
export const UPDATEAYURVEDICOPDCOMPLAINTHIGHRISK = "UPDATEAYURVEDICOPDCOMPLAINTHIGHRISK";
export const DELETEAYURVEDICOPDCOMPLAINTHIGHRISK = "DELETEAYURVEDICOPDCOMPLAINTHIGHRISK";
export const GETAYURVEDICOPDCOMPLAINTPOSITIONOFWORK = "GETAYURVEDICOPDCOMPLAINTPOSITIONOFWORK";
export const CREATEAYURVVEDICOPDCOMPLAINTPOSITIONOFWORK = "CREATEAYURVVEDICOPDCOMPLAINTPOSITIONOFWORK";
export const UPDATEAYURVEDICOPDCOMPLAINTPOSITIONOFWORK = "UPDATEAYURVEDICOPDCOMPLAINTPOSITIONOFWORK";
export const DELETEAYURVEDICOPDCOMPLAINTPOSITIONOFWORK = "DELETEAYURVEDICOPDCOMPLAINTPOSITIONOFWORK";
export const GETAYURVEDICOPDCOMPLAINTNATUREOFWORK = "GETAYURVEDICOPDCOMPLAINTNATUREOFWORK";
export const CREATEAYURVVEDICOPDCOMPLAINTNATUREOFWORK = "CREATEAYURVVEDICOPDCOMPLAINTNATUREOFWORK";
export const UPDATEAYURVEDICOPDCOMPLAINTNATUREOFWORK = "UPDATEAYURVEDICOPDCOMPLAINTNATUREOFWORK";
export const DELETEAYURVEDICOPDCOMPLAINTNATUREOFWORK = "DELETEAYURVEDICOPDCOMPLAINTNATUREOFWORK";
export const GETAYURVEDICOPDCOMPLAINTALLOPATHICMEDI = "GETAYURVEDICOPDCOMPLAINTALLOPATHICMEDI";
export const CREATEAYURVVEDICOPDCOMPLAINTALLOPATHICMEDI = "CREATEAYURVVEDICOPDCOMPLAINTALLOPATHICMEDI";
export const UPDATEAYURVEDICOPDCOMPLAINTALLOPATHICMEDI = "UPDATEAYURVEDICOPDCOMPLAINTALLOPATHICMEDI";
export const DELETEAYURVEDICOPDCOMPLAINTALLOPATHICMEDI = "DELETEAYURVEDICOPDCOMPLAINTALLOPATHICMEDI";
export const GETAYURVEDICOPDCOMPLAINTAYURVDAMEDI = "GETAYURVEDICOPDCOMPLAINTAYURVDAMEDI";
export const CREATEAYURVVEDICOPDCOMPLAINTAYURVDAMEDI = "CREATEAYURVVEDICOPDCOMPLAINTAYURVDAMEDI";
export const UPDATEAYURVEDICOPDCOMPLAINTAYURVDAMEDI = "UPDATEAYURVEDICOPDCOMPLAINTAYURVDAMEDI";
export const DELETEAYURVEDICOPDCOMPLAINTAYURVDAMEDI = "DELETEAYURVEDICOPDCOMPLAINTAYURVDAMEDI";
export const GETAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI = "GETAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI";
export const CREATEAYURVVEDICOPDCOMPLAINTHOMEOATHYMEDI = "CREATEAYURVVEDICOPDCOMPLAINTHOMEOATHYMEDI";
export const UPDATEAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI = "UPDATEAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI";
export const DELETEAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI = "DELETEAYURVEDICOPDCOMPLAINTHOMEOATHYMEDI";
export const GETAYURVEDICOPDCOMPLAINTOTHERMEDI = "GETAYURVEDICOPDCOMPLAINTOTHERMEDI";
export const CREATEAYURVVEDICOPDCOMPLAINTOTHERMEDI = "CREATEAYURVVEDICOPDCOMPLAINTOTHERMEDI";
export const UPDATEAYURVEDICOPDCOMPLAINTOTHERMEDI = "UPDATEAYURVEDICOPDCOMPLAINTOTHERMEDI";
export const DELETEAYURVEDICOPDCOMPLAINTOTHERMEDI = "DELETEAYURVEDICOPDCOMPLAINTOTHERMEDI";
export const GETAYURVEDICOPDCOMPLAINTANXIETY = "GETAYURVEDICOPDCOMPLAINTANXIETY";
export const CREATEAYURVVEDICOPDCOMPLAINTANXIETY = "CREATEAYURVVEDICOPDCOMPLAINTANXIETY";
export const UPDATEAYURVEDICOPDCOMPLAINTANXIETY = "UPDATEAYURVEDICOPDCOMPLAINTANXIETY";
export const DELETEAYURVEDICOPDCOMPLAINTANXIETY = "DELETEAYURVEDICOPDCOMPLAINTANXIETY";
export const GETAYURVEDICOPDCOMPLAINTDEPRESSION = "GETAYURVEDICOPDCOMPLAINTDEPRESSION";
export const CREATEAYURVVEDICOPDCOMPLAINTDEPRESSION = "CREATEAYURVVEDICOPDCOMPLAINTDEPRESSION";
export const UPDATEAYURVEDICOPDCOMPLAINTDEPRESSION = "UPDATEAYURVEDICOPDCOMPLAINTDEPRESSION";
export const DELETEAYURVEDICOPDCOMPLAINTDEPRESSION = "DELETEAYURVEDICOPDCOMPLAINTDEPRESSION";
export const GETAYURVEDICOPDCOMPLAINTIRRITABIILTY = "GETAYURVEDICOPDCOMPLAINTIRRITABIILTY";
export const CREATEAYURVVEDICOPDCOMPLAINTIRRITABIILTY = "CREATEAYURVVEDICOPDCOMPLAINTIRRITABIILTY";
export const UPDATEAYURVEDICOPDCOMPLAINTIRRITABIILTY = "UPDATEAYURVEDICOPDCOMPLAINTIRRITABIILTY";
export const DELETEAYURVEDICOPDCOMPLAINTIRRITABIILTY = "DELETEAYURVEDICOPDCOMPLAINTIRRITABIILTY";
export const GETAYURVEDICOPDCOMPLAINTEUPHORIA = "GETAYURVEDICOPDCOMPLAINTEUPHORIA";
export const CREATEAYURVVEDICOPDCOMPLAINTEUPHORIA = "CREATEAYURVVEDICOPDCOMPLAINTEUPHORIA";
export const UPDATEAYURVEDICOPDCOMPLAINTEUPHORIA = "UPDATEAYURVEDICOPDCOMPLAINTEUPHORIA";
export const DELETEAYURVEDICOPDCOMPLAINTEUPHORIA = "DELETEAYURVEDICOPDCOMPLAINTEUPHORIA";
export const GETAYURVEDICOPDCOMPLAINTOBSESSION = "GETAYURVEDICOPDCOMPLAINTOBSESSION";
export const CREATEAYURVVEDICOPDCOMPLAINTOBSESSION = "CREATEAYURVVEDICOPDCOMPLAINTOBSESSION";
export const UPDATEAYURVEDICOPDCOMPLAINTOBSESSION = "UPDATEAYURVEDICOPDCOMPLAINTOBSESSION";
export const DELETEAYURVEDICOPDCOMPLAINTOBSESSION = "DELETEAYURVEDICOPDCOMPLAINTOBSESSION";
export const GETAYURVEDICOPDCOMPLAINTNEUROSIS = "GETAYURVEDICOPDCOMPLAINTNEUROSIS";
export const CREATEAYURVVEDICOPDCOMPLAINTNEUROSIS = "CREATEAYURVVEDICOPDCOMPLAINTNEUROSIS";
export const UPDATEAYURVEDICOPDCOMPLAINTNEUROSIS = "UPDATEAYURVEDICOPDCOMPLAINTNEUROSIS";
export const DELETEAYURVEDICOPDCOMPLAINTNEUROSIS = "DELETEAYURVEDICOPDCOMPLAINTNEUROSIS";
export const GETAYURVEDICOPDCOMPLAINTDEPERSONALIZATION = "GETAYURVEDICOPDCOMPLAINTDEPERSONALIZATION";
export const CREATEAYURVVEDICOPDCOMPLAINTDEPERSONALIZATION = "CREATEAYURVVEDICOPDCOMPLAINTDEPERSONALIZATION";
export const UPDATEAYURVEDICOPDCOMPLAINTDEPERSONALIZATION = "UPDATEAYURVEDICOPDCOMPLAINTDEPERSONALIZATION";
export const DELETEAYURVEDICOPDCOMPLAINTDEPERSONALIZATION = "DELETEAYURVEDICOPDCOMPLAINTDEPERSONALIZATION";
export const GETAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE = "GETAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE";
export const CREATEAYURVVEDICOPDCOMPLAINTMENSTRUALCYCLE = "CREATEAYURVVEDICOPDCOMPLAINTMENSTRUALCYCLE";
export const UPDATEAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE = "UPDATEAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE";
export const DELETEAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE = "DELETEAYURVEDICOPDCOMPLAINTMENSTRUALCYCLE";
export const GETAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY = "GETAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY";
export const CREATEAYURVVEDICOPDCOMPLAINTNATUREOFDELIVERY = "CREATEAYURVVEDICOPDCOMPLAINTNATUREOFDELIVERY";
export const UPDATEAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY = "UPDATEAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY";
export const DELETEAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY = "DELETEAYURVEDICOPDCOMPLAINTNATUREOFDELIVERY";

export const GETAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST = "GETAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST";
export const CREATEAYURVVEDICOPDCOMPLAINTOCCUPATIONALHIST = "CREATEAYURVVEDICOPDCOMPLAINTOCCUPATIONALHIST";
export const UPDATEAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST = "UPDATEAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST";
export const DELETEAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST = "DELETEAYURVEDICOPDCOMPLAINTOCCUPATIONALHIST";

export const GETAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST = "GETAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST";
export const CREATEAYURVVEDICOPDCOMPLAINTGYNECOLOGICHIST = "CREATEAYURVVEDICOPDCOMPLAINTGYNECOLOGICHIST";
export const UPDATEAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST = "UPDATEAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST";
export const DELETEAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST = "DELETEAYURVEDICOPDCOMPLAINTGYNECOLOGICHIST";

export const GETAYURVEDICOPDCOMPLAINTOBSTETRICALHIST = "GETAYURVEDICOPDCOMPLAINTOBSTETRICALHIST";
export const CREATEAYURVVEDICOPDCOMPLAINTOBSTETRICALHIST = "CREATEAYURVVEDICOPDCOMPLAINTOBSTETRICALHIST";
export const UPDATEAYURVEDICOPDCOMPLAINTOBSTETRICALHIST = "UPDATEAYURVEDICOPDCOMPLAINTOBSTETRICALHIST";
export const DELETEAYURVEDICOPDCOMPLAINTOBSTETRICALHIST = "DELETEAYURVEDICOPDCOMPLAINTOBSTETRICALHIST";

export const GETAYURVEDICOPDEXAMGENERALLOOKHIST = "GETAYURVEDICOPDEXAMGENERALLOOKHIST";
export const CREATEAYURVVEDICOPDEXAMGENERALLOOKHIST = "CREATEAYURVVEDICOPDEXAMGENERALLOOKHIST";
export const UPDATEAYURVEDICOPDEXAMGENERALLOOKHIST = "UPDATEAYURVEDICOPDEXAMGENERALLOOKHIST";
export const DELETEAYURVEDICOPDEXAMGENERALLOOKHIST = "DELETEAYURVEDICOPDEXAMGENERALLOOKHIST";
export const GETAYURVEDICOPDEXAMGENERALBUILD = "GETAYURVEDICOPDEXAMGENERALBUILD";
export const CREATEAYURVVEDICOPDEXAMGENERALBUILD = "CREATEAYURVVEDICOPDEXAMGENERALBUILD";
export const UPDATEAYURVEDICOPDEXAMGENERALBUILD = "UPDATEAYURVEDICOPDEXAMGENERALBUILD";
export const DELETEAYURVEDICOPDEXAMGENERALBUILD = "DELETEAYURVEDICOPDEXAMGENERALBUILD";
export const GETAYURVEDICOPDEXAMGENERALNUTRITION = "GETAYURVEDICOPDEXAMGENERALNUTRITION";
export const CREATEAYURVVEDICOPDEXAMGENERALNUTRITION = "CREATEAYURVVEDICOPDEXAMGENERALNUTRITION";
export const UPDATEAYURVEDICOPDEXAMGENERALNUTRITION = "UPDATEAYURVEDICOPDEXAMGENERALNUTRITION";
export const DELETEAYURVEDICOPDEXAMGENERALNUTRITION = "DELETEAYURVEDICOPDEXAMGENERALNUTRITION";
export const GETAYURVEDICOPDEXAMGENERALANAEMIA = "GETAYURVEDICOPDEXAMGENERALANAEMIA";
export const CREATEAYURVVEDICOPDEXAMGENERALANAEMIA = "CREATEAYURVVEDICOPDEXAMGENERALANAEMIA";
export const UPDATEAYURVEDICOPDEXAMGENERALANAEMIA = "UPDATEAYURVEDICOPDEXAMGENERALANAEMIA";
export const DELETEAYURVEDICOPDEXAMGENERALANAEMIA = "DELETEAYURVEDICOPDEXAMGENERALANAEMIA";
export const GETAYURVEDICOPDEXAMGENERALNECKVEIN = "GETAYURVEDICOPDEXAMGENERALNECKVEIN";
export const CREATEAYURVVEDICOPDEXAMGENERALNECKVEIN = "CREATEAYURVVEDICOPDEXAMGENERALNECKVEIN";
export const UPDATEAYURVEDICOPDEXAMGENERALNECKVEIN = "UPDATEAYURVEDICOPDEXAMGENERALNECKVEIN";
export const DELETEAYURVEDICOPDEXAMGENERALNECKVEIN = "DELETEAYURVEDICOPDEXAMGENERALNECKVEIN";
export const GETAYURVEDICOPDEXAMGENERALLYMPHNODE = "GETAYURVEDICOPDEXAMGENERALLYMPHNODE";
export const CREATEAYURVVEDICOPDEXAMGENERALLYMPHNODE = "CREATEAYURVVEDICOPDEXAMGENERALLYMPHNODE";
export const UPDATEAYURVEDICOPDEXAMGENERALLYMPHNODE = "UPDATEAYURVEDICOPDEXAMGENERALLYMPHNODE";
export const DELETEAYURVEDICOPDEXAMGENERALLYMPHNODE = "DELETEAYURVEDICOPDEXAMGENERALLYMPHNODE";
export const GETAYURVEDICOPDEXAMGENERALOTHERFIELDS = "GETAYURVEDICOPDEXAMGENERALOTHERFIELDS";
export const CREATEAYURVVEDICOPDEXAMGENERALOTHERFIELDS = "CREATEAYURVVEDICOPDEXAMGENERALOTHERFIELDS";
export const UPDATEAYURVEDICOPDEXAMGENERALOTHERFIELDS = "UPDATEAYURVEDICOPDEXAMGENERALOTHERFIELDS";
export const DELETEAYURVEDICOPDEXAMGENERALOTHERFIELDS = "DELETEAYURVEDICOPDEXAMGENERALOTHERFIELDS";
export const GETAYURVEDICOPDEXAMASHTAVIDAPULSE = "GETAYURVEDICOPDEXAMASHTAVIDAPULSE";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDAPULSE = "CREATEAYURVVEDICOPDEXAMASHTAVIDAPULSE";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDAPULSE = "UPDATEAYURVEDICOPDEXAMASHTAVIDAPULSE";
export const DELETEAYURVEDICOPDEXAMASHTAVIDAPULSE = "DELETEAYURVEDICOPDEXAMASHTAVIDAPULSE";
export const GETAYURVEDICOPDEXAMASHTAVIDATONGUE = "GETAYURVEDICOPDEXAMASHTAVIDATONGUE";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDATONGUE = "CREATEAYURVVEDICOPDEXAMASHTAVIDATONGUE";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDATONGUE = "UPDATEAYURVEDICOPDEXAMASHTAVIDATONGUE";
export const DELETEAYURVEDICOPDEXAMASHTAVIDATONGUE = "DELETEAYURVEDICOPDEXAMASHTAVIDATONGUE";
export const GETAYURVEDICOPDEXAMASHTAVIDAPOOP = "GETAYURVEDICOPDEXAMASHTAVIDAPOOP";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDAPOOP = "CREATEAYURVVEDICOPDEXAMASHTAVIDAPOOP";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDAPOOP = "UPDATEAYURVEDICOPDEXAMASHTAVIDAPOOP";
export const DELETEAYURVEDICOPDEXAMASHTAVIDAPOOP = "DELETEAYURVEDICOPDEXAMASHTAVIDAPOOP";
export const GETAYURVEDICOPDEXAMASHTAVIDAURINE = "GETAYURVEDICOPDEXAMASHTAVIDAURINE";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDAURINE = "CREATEAYURVVEDICOPDEXAMASHTAVIDAURINE";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDAURINE = "UPDATEAYURVEDICOPDEXAMASHTAVIDAURINE";
export const DELETEAYURVEDICOPDEXAMASHTAVIDAURINE = "DELETEAYURVEDICOPDEXAMASHTAVIDAURINE";
export const GETAYURVEDICOPDEXAMASHTAVIDAWORD = "GETAYURVEDICOPDEXAMASHTAVIDAWORD";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDAWORD = "CREATEAYURVVEDICOPDEXAMASHTAVIDAWORD";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDAWORD = "UPDATEAYURVEDICOPDEXAMASHTAVIDAWORD";
export const DELETEAYURVEDICOPDEXAMASHTAVIDAWORD = "DELETEAYURVEDICOPDEXAMASHTAVIDAWORD";
export const GETAYURVEDICOPDEXAMASHTAVIDATOUCH = "GETAYURVEDICOPDEXAMASHTAVIDATOUCH";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDATOUCH = "CREATEAYURVVEDICOPDEXAMASHTAVIDATOUCH";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDATOUCH = "UPDATEAYURVEDICOPDEXAMASHTAVIDATOUCH";
export const DELETEAYURVEDICOPDEXAMASHTAVIDATOUCH = "DELETEAYURVEDICOPDEXAMASHTAVIDATOUCH";
export const GETAYURVEDICOPDEXAMASHTAVIDAEYE = "GETAYURVEDICOPDEXAMASHTAVIDAEYE";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDAEYE = "CREATEAYURVVEDICOPDEXAMASHTAVIDAEYE";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDAEYE = "UPDATEAYURVEDICOPDEXAMASHTAVIDAEYE";
export const DELETEAYURVEDICOPDEXAMASHTAVIDAEYE = "DELETEAYURVEDICOPDEXAMASHTAVIDAEYE";
export const GETAYURVEDICOPDEXAMASHTAVIDAAKRITA = "GETAYURVEDICOPDEXAMASHTAVIDAAKRITA";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDAAKRITA = "CREATEAYURVVEDICOPDEXAMASHTAVIDAAKRITA";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDAAKRITA = "UPDATEAYURVEDICOPDEXAMASHTAVIDAAKRITA";
export const DELETEAYURVEDICOPDEXAMASHTAVIDAAKRITA = "DELETEAYURVEDICOPDEXAMASHTAVIDAAKRITA";
export const GETAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA = "GETAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA";
export const CREATEAYURVVEDICOPDEXAMASHTAVIDAOTHHERFILEDA = "CREATEAYURVVEDICOPDEXAMASHTAVIDAOTHHERFILEDA";
export const UPDATEAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA = "UPDATEAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA";
export const DELETEAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA = "DELETEAYURVEDICOPDEXAMASHTAVIDAOTHHERFILEDA";
export const GETAYURVEDICOPDEXAMDASHVIDAPHYSICAL = "GETAYURVEDICOPDEXAMDASHVIDAPHYSICAL";
export const CREATEAYURVVEDICOPDEXAMDASHVIDAPHYSICAL = "CREATEAYURVVEDICOPDEXAMDASHVIDAPHYSICAL";
export const UPDATEAYURVEDICOPDEXAMDASHVIDAPHYSICAL = "UPDATEAYURVEDICOPDEXAMDASHVIDAPHYSICAL";
export const DELETEAYURVEDICOPDEXAMDASHVIDAPHYSICAL = "DELETEAYURVEDICOPDEXAMDASHVIDAPHYSICAL";
export const GETAYURVEDICOPDEXAMDASHVIDAMENTAL = "GETAYURVEDICOPDEXAMDASHVIDAMENTAL";
export const CREATEAYURVVEDICOPDEXAMDASHVIDAMENTAL = "CREATEAYURVVEDICOPDEXAMDASHVIDAMENTAL";
export const UPDATEAYURVEDICOPDEXAMDASHVIDAMENTAL = "UPDATEAYURVEDICOPDEXAMDASHVIDAMENTAL";
export const DELETEAYURVEDICOPDEXAMDASHVIDAMENTAL = "DELETEAYURVEDICOPDEXAMDASHVIDAMENTAL";
export const GETAYURVEDICOPDEXAMDASHVIDASUBSTANCE = "GETAYURVEDICOPDEXAMDASHVIDASUBSTANCE";
export const CREATEAYURVVEDICOPDEXAMDASHVIDASUBSTANCE = "CREATEAYURVVEDICOPDEXAMDASHVIDASUBSTANCE";
export const UPDATEAYURVEDICOPDEXAMDASHVIDASUBSTANCE = "UPDATEAYURVEDICOPDEXAMDASHVIDASUBSTANCE";
export const DELETEAYURVEDICOPDEXAMDASHVIDASUBSTANCE = "DELETEAYURVEDICOPDEXAMDASHVIDASUBSTANCE";
export const GETAYURVEDICOPDEXAMDASHVIDACOMPACTION = "GETAYURVEDICOPDEXAMDASHVIDACOMPACTION";
export const CREATEAYURVVEDICOPDEXAMDASHVIDACOMPACTION = "CREATEAYURVVEDICOPDEXAMDASHVIDACOMPACTION";
export const UPDATEAYURVEDICOPDEXAMDASHVIDACOMPACTION = "UPDATEAYURVEDICOPDEXAMDASHVIDACOMPACTION";
export const DELETEAYURVEDICOPDEXAMDASHVIDACOMPACTION = "DELETEAYURVEDICOPDEXAMDASHVIDACOMPACTION";
export const GETAYURVEDICOPDEXAMDASHVIDAPERCEPTION = "GETAYURVEDICOPDEXAMDASHVIDAPERCEPTION";
export const CREATEAYURVVEDICOPDEXAMDASHVIDAPERCEPTION = "CREATEAYURVVEDICOPDEXAMDASHVIDAPERCEPTION";
export const UPDATEAYURVEDICOPDEXAMDASHVIDAPERCEPTION = "UPDATEAYURVEDICOPDEXAMDASHVIDAPERCEPTION";
export const DELETEAYURVEDICOPDEXAMDASHVIDAPERCEPTION = "DELETEAYURVEDICOPDEXAMDASHVIDAPERCEPTION";
export const GETAYURVEDICOPDEXAMDASHVIDASUITABILITY = "GETAYURVEDICOPDEXAMDASHVIDASUITABILITY";
export const CREATEAYURVVEDICOPDEXAMDASHVIDASUITABILITY = "CREATEAYURVVEDICOPDEXAMDASHVIDASUITABILITY";
export const UPDATEAYURVEDICOPDEXAMDASHVIDASUITABILITY = "UPDATEAYURVEDICOPDEXAMDASHVIDASUITABILITY";
export const DELETEAYURVEDICOPDEXAMDASHVIDASUITABILITY = "DELETEAYURVEDICOPDEXAMDASHVIDASUITABILITY";
export const GETAYURVEDICOPDEXAMDASHVIDASUBSTANCEE = "GETAYURVEDICOPDEXAMDASHVIDASUBSTANCEE";
export const CREATEAYURVVEDICOPDEXAMDASHVIDASUBSTANCEE = "CREATEAYURVVEDICOPDEXAMDASHVIDASUBSTANCEE";
export const UPDATEAYURVEDICOPDEXAMDASHVIDASUBSTANCEE = "UPDATEAYURVEDICOPDEXAMDASHVIDASUBSTANCEE";
export const DELETEAYURVEDICOPDEXAMDASHVIDASUBSTANCEE = "DELETEAYURVEDICOPDEXAMDASHVIDASUBSTANCEE";
export const GETAYURVEDICOPDEXAMDASHVIDADIETCARRY = "GETAYURVEDICOPDEXAMDASHVIDADIETCARRY";
export const CREATEAYURVVEDICOPDEXAMDASHVIDADIETCARRY = "CREATEAYURVVEDICOPDEXAMDASHVIDADIETCARRY";
export const UPDATEAYURVEDICOPDEXAMDASHVIDADIETCARRY = "UPDATEAYURVEDICOPDEXAMDASHVIDADIETCARRY";
export const DELETEAYURVEDICOPDEXAMDASHVIDADIETCARRY = "DELETEAYURVEDICOPDEXAMDASHVIDADIETCARRY";
export const GETAYURVEDICOPDEXAMDASHVIDADIETBURNING = "GETAYURVEDICOPDEXAMDASHVIDADIETBURNING";
export const CREATEAYURVVEDICOPDEXAMDASHVIDADIETBURNING = "CREATEAYURVVEDICOPDEXAMDASHVIDADIETBURNING";
export const UPDATEAYURVEDICOPDEXAMDASHVIDADIETBURNING = "UPDATEAYURVEDICOPDEXAMDASHVIDADIETBURNING";
export const DELETEAYURVEDICOPDEXAMDASHVIDADIETBURNING = "DELETEAYURVEDICOPDEXAMDASHVIDADIETBURNING";
export const GETAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER = "GETAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER";
export const CREATEAYURVVEDICOPDEXAMDASHVIDAEXERCISEPOWER = "CREATEAYURVVEDICOPDEXAMDASHVIDAEXERCISEPOWER";
export const UPDATEAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER = "UPDATEAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER";
export const DELETEAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER = "DELETEAYURVEDICOPDEXAMDASHVIDAEXERCISEPOWER";
export const GETAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE = "GETAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE";
export const CREATEAYURVVEDICOPDEXAMDASHVIDAEXERCISEAGEE = "CREATEAYURVVEDICOPDEXAMDASHVIDAEXERCISEAGEE";
export const UPDATEAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE = "UPDATEAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE";
export const DELETEAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE = "DELETEAYURVEDICOPDEXAMDASHVIDAEXERCISEAGEE";
export const GETAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS = "GETAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS";
export const CREATEAYURVVEDICOPDEXAMDASHVIDAOTHERFIELDS = "CREATEAYURVVEDICOPDEXAMDASHVIDAOTHERFIELDS";
export const UPDATEAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS = "UPDATEAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS";
export const DELETEAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS = "DELETEAYURVEDICOPDEXAMDASHVIDAOTHERFIELDS";
export const GETAYURVEDICOPDEXAMSROTASPRANAVAHA = "GETAYURVEDICOPDEXAMSROTASPRANAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASPRANAVAHA = "CREATEAYURVVEDICOPDEXAMSROTASPRANAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASPRANAVAHA = "UPDATEAYURVEDICOPDEXAMSROTASPRANAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASPRANAVAHA = "DELETEAYURVEDICOPDEXAMSROTASPRANAVAHA";
export const GETAYURVEDICOPDEXAMSROTASANNAVAHA = "GETAYURVEDICOPDEXAMSROTASANNAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASANNAVAHA = "CREATEAYURVVEDICOPDEXAMSROTASANNAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASANNAVAHA = "UPDATEAYURVEDICOPDEXAMSROTASANNAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASANNAVAHA = "DELETEAYURVEDICOPDEXAMSROTASANNAVAHA";
export const GETAYURVEDICOPDEXAMSROTASUDAKVAHA = "GETAYURVEDICOPDEXAMSROTASUDAKVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASUDAKVAHA = "CREATEAYURVVEDICOPDEXAMSROTASUDAKVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASUDAKVAHA = "UPDATEAYURVEDICOPDEXAMSROTASUDAKVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASUDAKVAHA = "DELETEAYURVEDICOPDEXAMSROTASUDAKVAHA";
export const GETAYURVEDICOPDEXAMSROTASRASAVAHA = "GETAYURVEDICOPDEXAMSROTASRASAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASRASAVAHA = "CREATEAYURVVEDICOPDEXAMSROTASRASAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASRASAVAHA = "UPDATEAYURVEDICOPDEXAMSROTASRASAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASRASAVAHA = "DELETEAYURVEDICOPDEXAMSROTASRASAVAHA";
export const GETAYURVEDICOPDEXAMSROTASRAKTAVAHA = "GETAYURVEDICOPDEXAMSROTASRAKTAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASRAKTAVAHA = "CREATEAYURVVEDICOPDEXAMSROTASRAKTAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASRAKTAVAHA = "UPDATEAYURVEDICOPDEXAMSROTASRAKTAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASRAKTAVAHA = "DELETEAYURVEDICOPDEXAMSROTASRAKTAVAHA";
export const GETAYURVEDICOPDEXAMSROTASMAMSAVAHA = "GETAYURVEDICOPDEXAMSROTASMAMSAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASMAMSAVAHA = "CREATEAYURVVEDICOPDEXAMSROTASMAMSAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASMAMSAVAHA = "UPDATEAYURVEDICOPDEXAMSROTASMAMSAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASMAMSAVAHA = "DELETEAYURVEDICOPDEXAMSROTASMAMSAVAHA";
export const GETAYURVEDICOPDEXAMSROTASMEDOVAHA = "GETAYURVEDICOPDEXAMSROTASMEDOVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASMEDOVAHA = "CREATEAYURVVEDICOPDEXAMSROTASMEDOVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASMEDOVAHA = "UPDATEAYURVEDICOPDEXAMSROTASMEDOVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASMEDOVAHA = "DELETEAYURVEDICOPDEXAMSROTASMEDOVAHA";
export const GETAYURVEDICOPDEXAMSROTASASTHIVAHA = "GETAYURVEDICOPDEXAMSROTASASTHIVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASASTHIVAHA = "CREATEAYURVVEDICOPDEXAMSROTASASTHIVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASASTHIVAHA = "UPDATEAYURVEDICOPDEXAMSROTASASTHIVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASASTHIVAHA = "DELETEAYURVEDICOPDEXAMSROTASASTHIVAHA";
export const GETAYURVEDICOPDEXAMSROTASMAJJAVAHA = "GETAYURVEDICOPDEXAMSROTASMAJJAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASMAJJAVAHA = "CREATEAYURVVEDICOPDEXAMSROTASMAJJAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASMAJJAVAHA = "UPDATEAYURVEDICOPDEXAMSROTASMAJJAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASMAJJAVAHA = "DELETEAYURVEDICOPDEXAMSROTASMAJJAVAHA";
export const GETAYURVEDICOPDEXAMSROTASSUKRAVAHA = "GETAYURVEDICOPDEXAMSROTASSUKRAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASSUKRAVAHA = "CREATEAYURVVEDICOPDEXAMSROTASSUKRAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASSUKRAVAHA = "UPDATEAYURVEDICOPDEXAMSROTASSUKRAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASSUKRAVAHA = "DELETEAYURVEDICOPDEXAMSROTASSUKRAVAHA";
export const GETAYURVEDICOPDEXAMSROTASMOOTRAVAHA = "GETAYURVEDICOPDEXAMSROTASMOOTRAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASMOOTRAVAHA = "CREATEAYURVVEDICOPDEXAMSROTASMOOTRAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASMOOTRAVAHA = "UPDATEAYURVEDICOPDEXAMSROTASMOOTRAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASMOOTRAVAHA = "DELETEAYURVEDICOPDEXAMSROTASMOOTRAVAHA";
export const GETAYURVEDICOPDEXAMSROTASPURESHVAHA = "GETAYURVEDICOPDEXAMSROTASPURESHVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASPURESHVAHA = "CREATEAYURVVEDICOPDEXAMSROTASPURESHVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASPURESHVAHA = "UPDATEAYURVEDICOPDEXAMSROTASPURESHVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASPURESHVAHA = "DELETEAYURVEDICOPDEXAMSROTASPURESHVAHA";
export const GETAYURVEDICOPDEXAMSROTASSWEDAVAHA = "GETAYURVEDICOPDEXAMSROTASSWEDAVAHA";
export const CREATEAYURVVEDICOPDEXAMSROTASSWEDAVAHA = "CREATEAYURVVEDICOPDEXAMSROTASSWEDAVAHA";
export const UPDATEAYURVEDICOPDEXAMSROTASSWEDAVAHA = "UPDATEAYURVEDICOPDEXAMSROTASSWEDAVAHA";
export const DELETEAYURVEDICOPDEXAMSROTASSWEDAVAHA = "DELETEAYURVEDICOPDEXAMSROTASSWEDAVAHA";
export const GETAYURVEDICOPDEXAMVIKRUTHIFIELDS = "GETAYURVEDICOPDEXAMVIKRUTHIFIELDS";
export const CREATEAYURVVEDICOPDEXAMVIKRUTHIFIELDS = "CREATEAYURVVEDICOPDEXAMVIKRUTHIFIELDS";
export const UPDATEAYURVEDICOPDEXAMVIKRUTHIFIELDS = "UPDATEAYURVEDICOPDEXAMVIKRUTHIFIELDS";
export const DELETEAYURVEDICOPDEXAMVIKRUTHIFIELDS = "DELETEAYURVEDICOPDEXAMVIKRUTHIFIELDS";
export const GETAYURVEDICOPDEXAMWEALTHFAULT = "GETAYURVEDICOPDEXAMWEALTHFAULT";
export const CREATEAYURVVEDICOPDEXAMWEALTHFAULT = "CREATEAYURVVEDICOPDEXAMWEALTHFAULT";
export const UPDATEAYURVEDICOPDEXAMWEALTHFAULT = "UPDATEAYURVEDICOPDEXAMWEALTHFAULT";
export const DELETEAYURVEDICOPDEXAMWEALTHFAULT = "DELETEAYURVEDICOPDEXAMWEALTHFAULT";
export const GETAYURVEDICOPDEXAMWEALTHDUSHYA = "GETAYURVEDICOPDEXAMWEALTHDUSHYA";
export const CREATEAYURVVEDICOPDEXAMWEALTHDUSHYA = "CREATEAYURVVEDICOPDEXAMWEALTHDUSHYA";
export const UPDATEAYURVEDICOPDEXAMWEALTHDUSHYA = "UPDATEAYURVEDICOPDEXAMWEALTHDUSHYA";
export const DELETEAYURVEDICOPDEXAMWEALTHDUSHYA = "DELETEAYURVEDICOPDEXAMWEALTHDUSHYA";
export const GETAYURVEDICOPDEXAMWEALTHFIRE = "GETAYURVEDICOPDEXAMWEALTHFIRE";
export const CREATEAYURVVEDICOPDEXAMWEALTHFIRE = "CREATEAYURVVEDICOPDEXAMWEALTHFIRE";
export const UPDATEAYURVEDICOPDEXAMWEALTHFIRE = "UPDATEAYURVEDICOPDEXAMWEALTHFIRE";
export const DELETEAYURVEDICOPDEXAMWEALTHFIRE = "DELETEAYURVEDICOPDEXAMWEALTHFIRE";
export const GETAYURVEDICOPDEXAMWEALTHAMA = "GETAYURVEDICOPDEXAMWEALTHAMA";
export const CREATEAYURVVEDICOPDEXAMWEALTHAMA = "CREATEAYURVVEDICOPDEXAMWEALTHAMA";
export const UPDATEAYURVEDICOPDEXAMWEALTHAMA = "UPDATEAYURVEDICOPDEXAMWEALTHAMA";
export const DELETEAYURVEDICOPDEXAMWEALTHAMA = "DELETEAYURVEDICOPDEXAMWEALTHAMA";
export const GETAYURVEDICOPDEXAMWEALTHSOURCES = "GETAYURVEDICOPDEXAMWEALTHSOURCES";
export const CREATEAYURVVEDICOPDEXAMWEALTHSOURCES = "CREATEAYURVVEDICOPDEXAMWEALTHSOURCES";
export const UPDATEAYURVEDICOPDEXAMWEALTHSOURCES = "UPDATEAYURVEDICOPDEXAMWEALTHSOURCES";
export const DELETEAYURVEDICOPDEXAMWEALTHSOURCES = "DELETEAYURVEDICOPDEXAMWEALTHSOURCES";
export const GETAYURVEDICOPDEXAMWEALTHFAULTYSOURCES = "GETAYURVEDICOPDEXAMWEALTHFAULTYSOURCES";
export const CREATEAYURVVEDICOPDEXAMWEALTHFAULTYSOURCES = "CREATEAYURVVEDICOPDEXAMWEALTHFAULTYSOURCES";
export const UPDATEAYURVEDICOPDEXAMWEALTHFAULTYSOURCES = "UPDATEAYURVEDICOPDEXAMWEALTHFAULTYSOURCES";
export const DELETEAYURVEDICOPDEXAMWEALTHFAULTYSOURCES = "DELETEAYURVEDICOPDEXAMWEALTHFAULTYSOURCES";
export const GETAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN = "GETAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN";
export const CREATEAYURVVEDICOPDEXAMWEALTHPLACEOFORIGIN = "CREATEAYURVVEDICOPDEXAMWEALTHPLACEOFORIGIN";
export const UPDATEAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN = "UPDATEAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN";
export const DELETEAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN = "DELETEAYURVEDICOPDEXAMWEALTHPLACEOFORIGIN";
export const GETAYURVEDICOPDEXAMWEALTHFACTOR = "GETAYURVEDICOPDEXAMWEALTHFACTOR";
export const CREATEAYURVVEDICOPDEXAMWEALTHFACTOR = "CREATEAYURVVEDICOPDEXAMWEALTHFACTOR";
export const UPDATEAYURVEDICOPDEXAMWEALTHFACTOR = "UPDATEAYURVEDICOPDEXAMWEALTHFACTOR";
export const DELETEAYURVEDICOPDEXAMWEALTHFACTOR = "DELETEAYURVEDICOPDEXAMWEALTHFACTOR";

export const GETAYURVEDICOPDPANCHAKRMA = "GETAYURVEDICOPDPANCHAKRMA";
export const CREATEAYURVVEDICOPDPANCHAKRMA = "CREATEAYURVVEDICOPDPANCHAKRMA";
export const UPDATEAYURVEDICOPDPANCHAKRMA = "UPDATEAYURVEDICOPDPANCHAKRMA";
export const DELETEAYURVEDICOPDPANCHAKRMA = "DELETEAYURVEDICOPDPANCHAKRMA";

export const GETPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS = "GETPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS";
export const DELETEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS = "DELETEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS";
export const UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS = "UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTSTATUS";
export const CREATEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY = "CREATEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY";
export const GETPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY = "GETPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY";
export const DELETEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY = "DELETEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY";
export const UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY = "UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTSEVERITY";
export const CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE = "CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE";
export const GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE = "GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE";
export const DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE = "DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE";
export const UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE = "UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINNATURE";
export const CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET = "CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET";
export const GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET = "GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET";
export const DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET = "DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET";
export const UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET = "UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINONSET";
export const CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION = "CREATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION";
export const GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION = "GETPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION";
export const DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION = "DELETEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION";
export const UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION = "UPDATEPEDIATRICOPDSETTINGPAINASSESSMENTPAINVARIATION";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY = "CREATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY";
export const GETPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY = "GETPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY = "DELETEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRY";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE = "CREATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE";
export const GETPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE = "GETPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE = "DELETEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTSSYSTEMICENQUIRYTYPE";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY = "CREATEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY";
export const GETPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY = "GETPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY = "DELETEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTSILLNESSDURINGPEGNANCY";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY = "CREATEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY";
export const GETPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY = "GETPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY = "DELETEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTSINFECTIONDURINGPEGNANCY";
export const CREATEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE = "CREATEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE";
export const GETPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE = "GETPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE";
export const DELETEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE = "DELETEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE";
export const UPDATEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE = "UPDATEPEDIATRICOPDSETTINGEXAMINATIONGENERALAPPEARANCE";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE = "CREATEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE";
export const GETPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE = "GETPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE = "DELETEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTDELIVERYTYPE";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY = "CREATEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY";
export const GETPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY = "GETPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY = "DELETEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTFIRSTCRY";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM = "CREATEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM";
export const GETPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM = "GETPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM = "DELETEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTBASICPROBLEM";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES = "CREATEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES";
export const GETPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES = "GETPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES = "DELETEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTPROCEDURES";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT = "CREATEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT";
export const GETPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT = "GETPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT = "DELETEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTFEEDINGSUPPLEMENT";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP = "CREATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP";
export const GETPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP = "GETPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP = "DELETEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONEAGEGROUP";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE = "CREATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE";
export const GETPEDIATRICOPDSETTINGCOMPLAINTMILESTONE = "GETPEDIATRICOPDSETTINGCOMPLAINTMILESTONE";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE = "DELETEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTMILESTONE";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES = "CREATEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES";
export const GETPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES = "GETPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES = "DELETEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTPASTILLNESSES";
export const CREATEPEDIATRICCOMPLAINTPASTSYMPTOMS = "CREATEPEDIATRICCOMPLAINTPASTSYMPTOMS";
export const GETPEDIATRICCOMPLAINTPASTSYMPTOMS = "GETPEDIATRICCOMPLAINTPASTSYMPTOMS";
export const DELETEPEDIATRICCOMPLAINTPASTSYMPTOMS = "DELETEPEDIATRICCOMPLAINTPASTSYMPTOMS";
export const UPDATEPEDIATRICCOMPLAINTPASTSYMPTOMS = "UPDATEPEDIATRICCOMPLAINTPASTSYMPTOMS";
export const CREATEPEDIATRICCOMPLAINTPASTCOMORBIDITY = "CREATEPEDIATRICCOMPLAINTPASTCOMORBIDITY";
export const GETPEDIATRICCOMPLAINTPASTCOMORBIDITY = "GETPEDIATRICCOMPLAINTPASTCOMORBIDITY";
export const DELETEPEDIATRICCOMPLAINTPASTCOMORBIDITY = "DELETEPEDIATRICCOMPLAINTPASTCOMORBIDITY";
export const UPDATEPEDIATRICCOMPLAINTPASTCOMORBIDITY = "UPDATEPEDIATRICCOMPLAINTPASTCOMORBIDITY";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTDIET = "CREATEPEDIATRICOPDSETTINGCOMPLAINTDIET";
export const GETPEDIATRICOPDSETTINGCOMPLAINTDIET = "GETPEDIATRICOPDSETTINGCOMPLAINTDIET";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTDIET = "DELETEPEDIATRICOPDSETTINGCOMPLAINTDIET";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTDIET = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTDIET";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE = "CREATEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE";
export const GETPEDIATRICOPDSETTINGCOMPLAINTAPPETITE = "GETPEDIATRICOPDSETTINGCOMPLAINTAPPETITE";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE = "DELETEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTAPPETITE";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT = "CREATEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT";
export const GETPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT = "GETPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT = "DELETEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTDIGESTIVETRACT";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTBOWEL = "CREATEPEDIATRICOPDSETTINGCOMPLAINTBOWEL";
export const GETPEDIATRICOPDSETTINGCOMPLAINTBOWEL = "GETPEDIATRICOPDSETTINGCOMPLAINTBOWEL";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTBOWEL = "DELETEPEDIATRICOPDSETTINGCOMPLAINTBOWEL";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTBOWEL = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTBOWEL";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTSLIP = "CREATEPEDIATRICOPDSETTINGCOMPLAINTSLIP";
export const GETPEDIATRICOPDSETTINGCOMPLAINTSLIP = "GETPEDIATRICOPDSETTINGCOMPLAINTSLIP";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTSLIP = "DELETEPEDIATRICOPDSETTINGCOMPLAINTSLIP";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTSLIP = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTSLIP";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK = "CREATEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK";
export const GETPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK = "GETPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK = "DELETEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTPOSITIONDURINGWORK";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTNATURE = "CREATEPEDIATRICOPDSETTINGCOMPLAINTNATURE";
export const GETPEDIATRICOPDSETTINGCOMPLAINTNATURE = "GETPEDIATRICOPDSETTINGCOMPLAINTNATURE";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTNATURE = "DELETEPEDIATRICOPDSETTINGCOMPLAINTNATURE";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTNATURE = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTNATURE";
export const CREATEPEDIATRICOPDSETTINGCOMPLAINTRELETION = "CREATEPEDIATRICOPDSETTINGCOMPLAINTRELETION";
export const GETPEDIATRICOPDSETTINGCOMPLAINTRELETION = "GETPEDIATRICOPDSETTINGCOMPLAINTRELETION";
export const DELETEPEDIATRICOPDSETTINGCOMPLAINTRELETION = "DELETEPEDIATRICOPDSETTINGCOMPLAINTRELETION";
export const UPDATEPEDIATRICOPDSETTINGCOMPLAINTRELETION = "UPDATEPEDIATRICOPDSETTINGCOMPLAINTRELETION";
export const GETPEDIATRICOPDSETTINGPAINASSESSMENT = "GETPEDIATRICOPDSETTINGPAINASSESSMENT";
export const GETALLPEDIATRICOPDSETTINGCOMPLAINT = "GETALLPEDIATRICOPDSETTINGCOMPLAINT";
export const GETALLPEDIATRICOPDSETTINGINVESTIGATION = "GETALLPEDIATRICOPDSETTINGINVESTIGATION";
export const CREATEPEDIATRICPAINASSESSMENTOPD = "CREATEPEDIATRICPAINASSESSMENTOPD";
export const GETPEDIATRICPAINASSESSMENTOPD = "GETPEDIATRICPAINASSESSMENTOPD";
export const DELETEPEDIATRICPAINASSESSMENTOPD = "DELETEPEDIATRICPAINASSESSMENTOPD";
export const UPDATEPEDIATRICPAINASSESSMENTOPD = "UPDATEPEDIATRICPAINASSESSMENTOPD";
export const CREATEPEDIATRICPAINASSESSMENTBODYCHARTOPD = "CREATEPEDIATRICPAINASSESSMENTBODYCHARTOPD";
export const GETPEDIATRICPAINASSESSMENTBODYCHARTOPD = "GETPEDIATRICPAINASSESSMENTBODYCHARTOPD";
export const DELETEPEDIATRICPAINASSESSMENTBODYCHARTOPD = "DELETEPEDIATRICPAINASSESSMENTBODYCHARTOPD";
export const UPDATEPEDIATRICPAINASSESSMENTBODYCHARTOPD = "UPDATEPEDIATRICPAINASSESSMENTBODYCHARTOPD";
export const CREATEPRESENTCOPLAINTSSYMTOMS = "CREATEPRESENTCOPLAINTSSYMTOMS";
export const GETPRESENTCOPLAINTSSYMTOMS = "GETPRESENTCOPLAINTSSYMTOMS";
export const DELETEPRESENTCOPLAINTSSYMTOMS = "DELETEPRESENTCOPLAINTSSYMTOMS";
export const UPDATEPRESENTCOPLAINTSSYMTOMS = "UPDATEPRESENTCOPLAINTSSYMTOMS";
export const CREATEPRESENTCOPLAINTSCOMORBIDITY = "CREATEPRESENTCOPLAINTSCOMORBIDITY";
export const GETPRESENTCOPLAINTSCOMORBIDITY = "GETPRESENTCOPLAINTSCOMORBIDITY";
export const DELETEPRESENTCOPLAINTSCOMORBIDITY = "DELETEPRESENTCOPLAINTSCOMORBIDITY";
export const UPDATEPRESENTCOPLAINTSCOMORBIDITY = "UPDATEPRESENTCOPLAINTSCOMORBIDITY";
export const CREATEPEDIATRICCOMPLAINTGENERALENQUIRY = "CREATEPEDIATRICCOMPLAINTGENERALENQUIRY";
export const GETPEDIATRICCOMPLAINTGENERALENQUIRY = "GETPEDIATRICCOMPLAINTGENERALENQUIRY";
export const DELETEPEDIATRICCOMPLAINTGENERALENQUIRY = "DELETEPEDIATRICCOMPLAINTGENERALENQUIRY";
export const UPDATEPEDIATRICCOMPLAINTGENERALENQUIRY = "UPDATEPEDIATRICCOMPLAINTGENERALENQUIRY";
export const CREATEPEDIATRICCOMPLAINTSYSTEMICENQUIRY = "CREATEPEDIATRICCOMPLAINTSYSTEMICENQUIRY";
export const GETPEDIATRICCOMPLAINTSYSTEMICENQUIRY = "GETPEDIATRICCOMPLAINTSYSTEMICENQUIRY";
export const DELETEPEDIATRICCOMPLAINTSYSTEMICENQUIRY = "DELETEPEDIATRICCOMPLAINTSYSTEMICENQUIRY";
export const UPDATEPEDIATRICCOMPLAINTSYSTEMICENQUIRY = "UPDATEPEDIATRICCOMPLAINTSYSTEMICENQUIRY";
export const CREATEPEDIATRICCOMPLAINTANTENATALILLNESS = "CREATEPEDIATRICCOMPLAINTANTENATALILLNESS";
export const GETPEDIATRICCOMPLAINTANTENATALILLNESS = "GETPEDIATRICCOMPLAINTANTENATALILLNESS";
export const DELETEPEDIATRICCOMPLAINTANTENATALILLNESS = "DELETEPEDIATRICCOMPLAINTANTENATALILLNESS";
export const UPDATEPEDIATRICCOMPLAINTANTENATALILLNESS = "UPDATEPEDIATRICCOMPLAINTANTENATALILLNESS";
export const CREATEPEDIATRICCOMPLAINTANTENATALINFECTIONS = "CREATEPEDIATRICCOMPLAINTANTENATALINFECTIONS";
export const GETPEDIATRICCOMPLAINTANTENATALINFECTIONS = "GETPEDIATRICCOMPLAINTANTENATALINFECTIONS";
export const DELETEPEDIATRICCOMPLAINTANTENATALINFECTIONS = "DELETEPEDIATRICCOMPLAINTANTENATALINFECTIONS";
export const UPDATEPEDIATRICCOMPLAINTANTENATALINFECTIONS = "UPDATEPEDIATRICCOMPLAINTANTENATALINFECTIONS";
export const CREATEPEDIATRICCOMPLAINTANTENATALPREGANANCY = "CREATEPEDIATRICCOMPLAINTANTENATALPREGANANCY";
export const GETPEDIATRICCOMPLAINTANTENATALPREGANANCY = "GETPEDIATRICCOMPLAINTANTENATALPREGANANCY";
export const DELETEPEDIATRICCOMPLAINTANTENATALPREGANANCY = "DELETEPEDIATRICCOMPLAINTANTENATALPREGANANCY";
export const UPDATEPEDIATRICCOMPLAINTANTENATALPREGANANCY = "UPDATEPEDIATRICCOMPLAINTANTENATALPREGANANCY";
export const CREATEPEDIATRICCOMPLAINTNATALDELIVERYTYPE = "CREATEPEDIATRICCOMPLAINTNATALDELIVERYTYPE";
export const GETPEDIATRICCOMPLAINTNATALDELIVERYTYPE = "GETPEDIATRICCOMPLAINTNATALDELIVERYTYPE";
export const DELETEPEDIATRICCOMPLAINTNATALDELIVERYTYPE = "DELETEPEDIATRICCOMPLAINTNATALDELIVERYTYPE";
export const UPDATEPEDIATRICCOMPLAINTNATALDELIVERYTYPE = "UPDATEPEDIATRICCOMPLAINTNATALDELIVERYTYPE";
export const CREATEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY = "CREATEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY";
export const GETPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY = "GETPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY";
export const DELETEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY = "DELETEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY";
export const UPDATEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY = "UPDATEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY";
export const CREATEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM = "CREATEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM";
export const GETPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM = "GETPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM";
export const DELETEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM = "DELETEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM";
export const UPDATEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM = "UPDATEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM";
export const CREATEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES = "CREATEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES";
export const GETPEDIATRICCOMPLAINTPOSTNATALPROCEDURES = "GETPEDIATRICCOMPLAINTPOSTNATALPROCEDURES";
export const DELETEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES = "DELETEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES";
export const UPDATEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES = "UPDATEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES";
export const CREATEPEDIATRICCOMPLAINTPOSTNATAL = "CREATEPEDIATRICCOMPLAINTPOSTNATAL";
export const GETPEDIATRICCOMPLAINTPOSTNATAL = "GETPEDIATRICCOMPLAINTPOSTNATAL";
export const DELETEPEDIATRICCOMPLAINTPOSTNATAL = "DELETEPEDIATRICCOMPLAINTPOSTNATAL";
export const UPDATEPEDIATRICCOMPLAINTPOSTNATAL = "UPDATEPEDIATRICCOMPLAINTPOSTNATAL";
export const CREATEPEDIATRICCOMPLAINTNATALHISTORY = "CREATEPEDIATRICCOMPLAINTNATALHISTORY";
export const GETPEDIATRICCOMPLAINTNATALHISTORY = "GETPEDIATRICCOMPLAINTNATALHISTORY";
export const DELETEPEDIATRICCOMPLAINTNATALHISTORY = "DELETEPEDIATRICCOMPLAINTNATALHISTORY";
export const UPDATEPEDIATRICCOMPLAINTNATALHISTORY = "UPDATEPEDIATRICCOMPLAINTNATALHISTORY";
export const CREATECOMPLAINTSYMPTOMSASSOCIATED = "CREATECOMPLAINTSYMPTOMSASSOCIATED";
export const GETCOMPLAINTSYMPTOMSASSOCIATED = "GETCOMPLAINTSYMPTOMSASSOCIATED";
export const DELETECOMPLAINTSYMPTOMSASSOCIATED = "DELETECOMPLAINTSYMPTOMSASSOCIATED";
export const UPDATECOMPLAINTSYMPTOMSASSOCIATED = "UPDATECOMPLAINTSYMPTOMSASSOCIATED";
export const CREATEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT = "CREATEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT";
export const GETPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT = "GETPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT";
export const DELETEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT = "DELETEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT";
export const UPDATEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT = "UPDATEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT";
export const CREATEPEDIATRICCOMPLAINTFEEDINGHISTORY = "CREATEPEDIATRICCOMPLAINTFEEDINGHISTORY";
export const GETPEDIATRICCOMPLAINTFEEDINGHISTORY = "GETPEDIATRICCOMPLAINTFEEDINGHISTORY";
export const DELETEPEDIATRICCOMPLAINTFEEDINGHISTORY = "DELETEPEDIATRICCOMPLAINTFEEDINGHISTORY";
export const UPDATEPEDIATRICCOMPLAINTFEEDINGHISTORY = "UPDATEPEDIATRICCOMPLAINTFEEDINGHISTORY";
export const CREATEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY = "CREATEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY";
export const GETPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY = "GETPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY";
export const DELETEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY = "DELETEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY";
export const UPDATEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY = "UPDATEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY";
export const CREATEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY = "CREATEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY";
export const GETPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY = "GETPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY";
export const DELETEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY = "DELETEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY";
export const UPDATEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY = "UPDATEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY";
export const CREATEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES = "CREATEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES";
export const GETPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES = "GETPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES";
export const DELETEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES = "DELETEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES";
export const UPDATEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES = "UPDATEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES";
export const CREATEPEDIATRICCOMPLAINTPASTILLNESS = "CREATEPEDIATRICCOMPLAINTPASTILLNESS";
export const GETPEDIATRICCOMPLAINTPASTILLNESS = "GETPEDIATRICCOMPLAINTPASTILLNESS";
export const DELETEPEDIATRICCOMPLAINTPASTILLNESS = "DELETEPEDIATRICCOMPLAINTPASTILLNESS";
export const UPDATEPEDIATRICCOMPLAINTPASTILLNESS = "UPDATEPEDIATRICCOMPLAINTPASTILLNESS";
export const GETPHYSIOTHERAPY = "GETPHYSIOTHERAPY";
export const CREATEPHYSIOTHERAPY = "CREATEPHYSIOTHERAPY"
export const UPDATEPHYSIOTHERAPYBYID = "UPDATEPHYSIOTHERAPYBYID"
export const DELETEPHYSIOTHERAPY = "DELETEPHYSIOTHERAPY"
export const GETPHYSIOTHERAPYSEVERITY = " GETPHYSIOTHERAPYSEVERITY"
export const CREATEPHYSIOTHERAPYSEVERITY = "CREATEPHYSIOTHERAPYSEVERITY"
export const UPDATEPHYSIOTHERAPYSEVERITYBYID = "UPDATEPHYSIOTHERAPYSEVERITYBYID"
export const DELETEPHYSIOTHERAPYSEVERITY = "DELETEPHYSIOTHERAPYSEVERITY"
export const GETPAINNATURE = "GETPAINNATURE";
export const CREATEPAINNATURE = "CREATEPAINNATURE";
export const UPDATEPHYSIOTHERAPYPAINNATUREBYID = "UPDATEPHYSIOTHERAPYPAINNATUREBYID"
export const DELETEPAINNATURE = "DELETEPAINNATURE";
export const GETPHYSIOTHERAPYPAINONSET = "GETPHYSIOTHERAPYPAINONSET";
export const CREATEPAINONSET = "CREATEPAINONSET";
export const UPDATEPHYSIOTHERAPPAINONSETBYID = "UPDATEPHYSIOTHERAPPAINONSETBYID"
export const DELETEPAINONSET = "DELETEPAINONSET";
export const GETPHYSIOTHERAPYDIURNAL = "GETPHYSIOTHERAPYDIURNAL";
export const CREATEPHYSIOTHERAPYDIURNAL = "CREATEPHYSIOTHERAPYDIURNAL";
export const UPDATEPHYSIOTHERAPYDIURNALBYID = "UPDATEPHYSIOTHERAPYDIURNALBYID"
export const DELETEPHYSIOTHERAPYDIURNAL = "DELETEPHYSIOTHERAPYDIURNAL";
export const GETPHYSIOTHERAPYTESTTYPE = "GETPHYSIOTHERAPYTESTTYPE";
export const CREATEPHYSIOTHERAPYTESTTYPE = "CREATEPHYSIOTHERAPYTESTTYPE";
export const UPDATEPHYSIOTHERAPYTESTTYPEBYID = "UPDATEPHYSIOTHERAPYTESTTYPEBYID";
export const DELETEPHYSIOTHERAPYTESTTYPE = "DELETEPHYSIOTHERAPYTESTTYPE";
export const GETPHYSIOTHERAPYTEST = "GETPHYSIOTHERAPYTEST";
export const CREATEPHYSIOTHERAPYTEST = "CREATEPHYSIOTHERAPYTEST";
export const UPDATEPHYSIOTHERAPYTESTBYID = "UPDATEPHYSIOTHERAPYTESTBYID";
export const DELETEPHYSIOTHERAPYTYPE = "DELETEPHYSIOTHERAPYTYPE";
export const GETPHYSIOTHERAPYTESTINVESTIGATION = "GETPHYSIOTHERAPYTESTINVESTIGATION";
export const CREATEPHYSIOTHERAPYTESTINVESTIGATION = "CREATEPHYSIOTHERAPYTESTINVESTIGATION";
export const UPDATEPHYSIOTHERAPYTESTTINVESTIGATIONBYID = "UPDATEPHYSIOTHERAPYTESTTINVESTIGATIONBYID";
export const DELETEPHYSIOTHERAPYTYPETINVESTIGATION = "DELETEPHYSIOTHERAPYTYPETINVESTIGATION ";
export const GETPHYSIOTHERAPYTDIAGNOSIS = "GETPHYSIOTHERAPYTDIAGNOSIS";
export const CREATEPHYSIOTHERAPYDIAGNOSIS = "CREATEPHYSIOTHERAPYDIAGNOSIS";
export const UPDATEPHYSIOTHERAPYDIAGNOSISBYID = "UPDATEPHYSIOTHERAPYDIAGNOSISBYID";
export const DELETEPHYSIOTHERAPYDIAGNOSIS = "DELETEPHYSIOTHERAPYDIAGNOSIS ";
export const GETPHYSIOTHERAPYTPROGNOSIS = "GETPHYSIOTHERAPYTPROGNOSIS";
export const CREATEPHYSIOTHERAPYPROGNOSIS = "CREATEPHYSIOTHERAPYPROGNOSIS";
export const UPDATEPHYSIOTHERAPYPROGNOSISBYID = "UPDATEPHYSIOTHERAPYPROGNOSISBYID";
export const DELETEPHYSIOTHERAPYPROGNOSIS = "DELETEPHYSIOTHERAPYPROGNOSIS ";
export const GETPHYSIOTHERAPYFREQUENCY = "GETPHYSIOTHERAPYFREQUENCY";
export const CREATEPHYSIOTHERAPYFREQUENCY = "CREATEPHYSIOTHERAPYFREQUENCY";
export const UPDATEPHYSIOTHERAPYFREQUENCYBYID = "UPDATEPHYSIOTHERAPYFREQUENCYBYID";
export const DELETEPHYSIOTHERAPYFREQUENCY = "DELETEPHYSIOTHERAPYFREQUENCY ";
export const GETPHYSIOTHERAPYDUTYCYCLE = "GETPHYSIOTHERAPYDUTYCYCLE";
export const CREATEPHYSIOTHERAPYDUTYCYCLE = "CREATEPHYSIOTHERAPYDUTYCYCLE";
export const UPDATEPHYSIOTHERAPYDUTYCYCLEBYID = "UPDATEPHYSIOTHERAPYDUTYCYCLEBYID";
export const DELETEPHYSIOTHERAPYDUTYCYCLE = "DELETEPHYSIOTHERAPYDUTYCYCLE ";
export const GETPHYSIOTHERAPYWARMING = "GETPHYSIOTHERAPYWARMING";
export const CREATEPHYSIOTHERAPYWARMING = "CREATEPHYSIOTHERAPYWARMING";
export const UPDATEPHYSIOTHERAPYWARMINGBYID = "UPDATEPHYSIOTHERAPYWARMINGBYID";
export const DELETEPHYSIOTHERAPYWARMING = "DELETEPHYSIOTHERAPYWARMING ";
export const GETPHYSIOTHERAPYINTENSITY = "GETPHYSIOTHERAPYINTENSITY";
export const CREATEPHYSIOTHERAPYINTENSITY = "CREATEPHYSIOTHERAPYINTENSITY";
export const UPDATEPHYSIOTHERAPYINTENSITYBYID = "UPDATEPHYSIOTHERAPYINTENSITYBYID";
export const DELETEPHYSIOTHERAPYINTENSITY = "DELETEPHYSIOTHERAPYINTENSITY ";
export const GETPHYSIOTHERAPYOPDOUT = "GETPHYSIOTHERAPYOPDOUT"
export const CREATEPHYSIOTHERAPYOPDOUT = "CREATEPHYSIOTHERAPYOPDOUT";
export const GETPHYSIOTHERAPYOPDOUTBODYCHARTTYPE = "GETPHYSIOTHERAPYOPDOUTBODYCHARTTYPE"
export const CREATEPHYSIOTHERAPYOPDOUTBODYCHARTTYPE = "CREATEPHYSIOTHERAPYOPDOUTBODYCHARTTYPE";
export const UPDATEPHYSIOTHERAPYPAINASSESSMENTBODYCHARTOPD = "UPDATEPHYSIOTHERAPYPAINASSESSMENTBODYCHARTOPD";
export const DELETEPHYSIOTHERAPYPAINASSESSMENTBODYCHARTOPD = "DELETEPHYSIOTHERAPYPAINASSESSMENTBODYCHARTOPD";
export const UPDATEPHYSIOTHERAPYPAINASSESSMENTOPDOUT = "UPDATEPHYSIOTHERAPYPAINASSESSMENTOPDOUT";
export const DELETEPHYSIOTHERAPYPAINASSESSMENTOPD = "DELETEPHYSIOTHERAPYPAINASSESSMENTOPD";
export const GETPHYSIOTHERAPYOPDOUTEXAMINATION = "GETPHYSIOTHERAPYOPDOUTEXAMINATION"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATION = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATION";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATION = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATION";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATION = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATION";
export const GETPHYSIOTHERAPYOPDEXAMINATIONCERVICALSPINE = "GETPHYSIOTHERAPYOPDEXAMINATIONCERVICALSPINE"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCERVICALSPINE";
export const GETPHYSIOTHERAPYOPDEXAMINATIONTEMROMANDIBULARJOINT = "GETPHYSIOTHERAPYOPDEXAMINATIONTEMROMANDIBULARJOINT"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTEMROMANDIBULARJOINT";
export const GETPHYSIOTHERAPYOPDEXAMINATIONSHOLDER = "GETPHYSIOTHERAPYOPDEXAMINATIONSHOLDER"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSHOLDER";
export const GETPHYSIOTHERAPYOPDEXAMINATIONELBOW = "GETPHYSIOTHERAPYOPDEXAMINATIONELBOW"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONELBOW";
export const GETPHYSIOTHERAPYOPDEXAMINATIONWRISTANDFINGERS = "GETPHYSIOTHERAPYOPDEXAMINATIONWRISTANDFINGERS"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONWRISTANDFINGERS";
export const GETPHYSIOTHERAPYOPDEXAMINATIONTHORACICSPINE = "GETPHYSIOTHERAPYOPDEXAMINATIONTHORACICSPINE"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTHORACICSPINE";
export const GETPHYSIOTHERAPYOPDEXAMINATIONHIP = "GETPHYSIOTHERAPYOPDEXAMINATIONHIP"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONHIP";
export const GETPHYSIOTHERAPYOPDEXAMINATIONKNEE = "GETPHYSIOTHERAPYOPDEXAMINATIONKNEE"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONKNEE";
export const GETPHYSIOTHERAPYOPDEXAMINATIONLEANDFOOT = "GETPHYSIOTHERAPYOPDEXAMINATIONLEANDFOOT"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONLEANDFOOT";
export const GETPHYSIOTHERAPYOPDEXAMINATIONDEEPTENDENREFLEXES = "GETPHYSIOTHERAPYOPDEXAMINATIONDEEPTENDENREFLEXES"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONDEEPTENDENREFLEXES";
export const GETPHYSIOTHERAPYOPDEXAMINATIONSUPERFICIALREFLEXES = "GETPHYSIOTHERAPYOPDEXAMINATIONSUPERFICIALREFLEXES"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSUPERFICIALREFLEXES";
export const GETPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE = "GETPHYSIOTHERAPYOPDEXAMINATIONLUMBERSPINE"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONLUMBERSPINE";
export const GETPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY = "GETPHYSIOTHERAPYOPDEXAMINATIONSENSORY"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONSENSORY";
export const GETPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION = "GETPHYSIOTHERAPYOPDEXAMINATIONHIGHERFUNCTION"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONHIGHERFUNCTION";
export const GETPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE = "GETPHYSIOTHERAPYOPDEXAMINATIONCARNIALNERVE"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCARNIALNERVE";
export const GETPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION = "GETPHYSIOTHERAPYOPDEXAMINATIONCOORDINATION"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONCOORDINATION";
export const GETPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE = "GETPHYSIOTHERAPYOPDEXAMINATIONTESTCERVICLESPINE"
export const CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE = "CREATEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE";
export const UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE = "UPDATEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE";
export const DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE = "DELETEPHYSIOTHERAPYOPDOUTEXAMINATIONTESTCERVICLESPINE";
export const GETPHYSIOTHERAPYOPDOUTDIAGNOSIS = "GETPHYSIOTHERAPYOPDOUTDIAGNOSIS"
export const CREATEPHYSIOTHERAPYOPDOUTDIAGNOSIS = "CREATEPHYSIOTHERAPYOPDOUTDIAGNOSIS";
export const UPDATEPHYSIOTHERAPYOPDOUTDIAGNOSIS = "UPDATEPHYSIOTHERAPYOPDOUTDIAGNOSIS";
export const DELETEPHYSIOTHERAPYOPDOUTDIAGNOSIS = "DELETEPHYSIOTHERAPYOPDOUTDIAGNOSIS";
export const GETPHYSIOTHERAPYOPDOUTPROGNOSIS = "GETPHYSIOTHERAPYOPDOUTPROGNOSIS"
export const CREATEPHYSIOTHERAPYOPDOUTPROGNOSIS = "CREATEPHYSIOTHERAPYOPDOUTPROGNOSIS";
export const UPDATEPHYSIOTHERAPYOPDOUTPROGNOSIS = "UPDATEPHYSIOTHERAPYOPDOUTPROGNOSIS";
export const DELETEPHYSIOTHERAPYOPDOUTPROGNOSIS = "DELETEPHYSIOTHERAPYOPDOUTPROGNOSIS";
export const GETPHYSIOTHERAPYOPDOUTTREATMENT = "GETPHYSIOTHERAPYOPDOUTTREATMENT"
export const CREATEPHYSIOTHERAPYOPDOUTTREATMENT = "CREATEPHYSIOTHERAPYOPDOUTTREATMENT";
export const UPDATEPHYSIOTHERAPYOPDOUTTREATMENT = "UPDATEPHYSIOTHERAPYOPDOUTTREATMENT";
export const DELETEPHYSIOTHERAPYOPDOUTTREATMENT = "DELETEPHYSIOTHERAPYOPDOUTTREATMENT";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORY = "CREATEPEDIATRICCOMPLAINTPERSONALHISTORY";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORY = "GETPEDIATRICCOMPLAINTPERSONALHISTORY";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORY = "DELETEPEDIATRICCOMPLAINTPERSONALHISTORY";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORY = "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORY";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE = "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE = "GETPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE = "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE = "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT = "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT = "GETPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT = "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT = "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL = "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL = "GETPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL = "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL = "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP = "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYSLIP = "GETPEDIATRICCOMPLAINTPERSONALHISTORYSLIP";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP = "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP = "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK = "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK = "GETPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK = "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK = "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK = "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK = "GETPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK = "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK = "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE = "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYNATURE = "GETPEDIATRICCOMPLAINTPERSONALHISTORYNATURE";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE = "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE = "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE";
export const CREATEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY = "CREATEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY";
export const GETPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY = "GETPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY";
export const DELETEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY = "DELETEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY";
export const UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY = "UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY";
export const CREATEPEDIATRICCOMPLAINTFAMILYHISTORY = "CREATEPEDIATRICCOMPLAINTFAMILYHISTORY";
export const GETPEDIATRICCOMPLAINTFAMILYHISTORY = "GETPEDIATRICCOMPLAINTFAMILYHISTORY";
export const DELETEPEDIATRICCOMPLAINTFAMILYHISTORY = "DELETEPEDIATRICCOMPLAINTFAMILYHISTORY";
export const UPDATEPEDIATRICCOMPLAINTFAMILYHISTORY = "UPDATEPEDIATRICCOMPLAINTFAMILYHISTORY";
export const CREATEPEDIATRICCOMPLAINTSYMPTOMSHISTORY = "CREATEPEDIATRICCOMPLAINTSYMPTOMSHISTORY";
export const GETPEDIATRICCOMPLAINTSYMPTOMSHISTORY = "GETPEDIATRICCOMPLAINTSYMPTOMSHISTORY";
export const DELETEPEDIATRICCOMPLAINTSYMPTOMSHISTORY = "DELETEPEDIATRICCOMPLAINTSYMPTOMSHISTORY";
export const UPDATEPEDIATRICCOMPLAINTSYMPTOMSHISTORY = "UPDATEPEDIATRICCOMPLAINTSYMPTOMSHISTORY";
export const CREATEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY = "CREATEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY";
export const GETPEDIATRICCOMPLAINTCOMORBIDITYHISTORY = "GETPEDIATRICCOMPLAINTCOMORBIDITYHISTORY";
export const DELETEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY = "DELETEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY";
export const UPDATEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY = "UPDATEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY";
export const CREATEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY = "CREATEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY";
export const GETPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY = "GETPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY";
export const DELETEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY = "DELETEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY";
export const UPDATEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY = "UPDATEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY";


export const CREATEPEDIATRICEXAMINATION = "CREATEPEDIATRICEXAMINATION";
export const GETPEDIATRICEXAMINATION = "GETPEDIATRICEXAMINATION";
export const DELETEPEDIATRICEXAMINATION = "DELETEPEDIATRICEXAMINATION";
export const UPDATEPEDIATRICEXAMINATION = "UPDATEPEDIATRICEXAMINATION";

export const CREATEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE = "CREATEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE";
export const GETPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE = "GETPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE";
export const DELETEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE = "DELETEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE";
export const UPDATEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE = "UPDATEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE";

export const CREATEPEDIATRICEXAMINATIONNUTRITION = "CREATEPEDIATRICEXAMINATIONNUTRITION";
export const GETPEDIATRICEXAMINATIONNUTRITION = "GETPEDIATRICEXAMINATIONNUTRITION";
export const DELETEPEDIATRICEXAMINATIONNUTRITION = "DELETEPEDIATRICEXAMINATIONNUTRITION";
export const UPDATEPEDIATRICEXAMINATIONNUTRITION = "UPDATEPEDIATRICEXAMINATIONNUTRITION";
export const CREATEPEDIATRICEXAMINATIONANAEMIA = "CREATEPEDIATRICEXAMINATIONANAEMIA";
export const GETPEDIATRICEXAMINATIONANAEMIA = "GETPEDIATRICEXAMINATIONANAEMIA";
export const DELETEPEDIATRICEXAMINATIONANAEMIA = "DELETEPEDIATRICEXAMINATIONANAEMIA";
export const UPDATEPEDIATRICEXAMINATIONANAEMIA = "UPDATEPEDIATRICEXAMINATIONANAEMIA";
export const CREATEPEDIATRICEXAMINATIONNECKVEIN = "CREATEPEDIATRICEXAMINATIONNECKVEIN";
export const GETPEDIATRICEXAMINATIONNECKVEIN = "GETPEDIATRICEXAMINATIONNECKVEIN";
export const DELETEPEDIATRICEXAMINATIONNECKVEIN = "DELETEPEDIATRICEXAMINATIONNECKVEIN";
export const UPDATEPEDIATRICEXAMINATIONNECKVEIN = "UPDATEPEDIATRICEXAMINATIONNECKVEIN";
export const CREATEPEDIATRICEXAMINATIONLYMPHNODES = "CREATEPEDIATRICEXAMINATIONLYMPHNODES";
export const GETPEDIATRICEXAMINATIONLYMPHNODES = "GETPEDIATRICEXAMINATIONLYMPHNODES";
export const DELETEPEDIATRICEXAMINATIONLYMPHNODES = "DELETEPEDIATRICEXAMINATIONLYMPHNODES";
export const UPDATEPEDIATRICEXAMINATIONLYMPHNODES = "UPDATEPEDIATRICEXAMINATIONLYMPHNODES";
export const CREATEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION = "CREATEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION";
export const GETPEDIATRICOPDSETTINGEXAMINATIONNUTRITION = "GETPEDIATRICOPDSETTINGEXAMINATIONNUTRITION";
export const DELETEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION = "DELETEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION";
export const UPDATEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION = "UPDATEPEDIATRICOPDSETTINGEXAMINATIONNUTRITION";
export const CREATEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA = "CREATEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA";
export const GETPEDIATRICOPDSETTINGEXAMINATIONANAEMIA = "GETPEDIATRICOPDSETTINGEXAMINATIONANAEMIA";
export const DELETEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA = "DELETEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA";
export const UPDATEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA = "UPDATEPEDIATRICOPDSETTINGEXAMINATIONANAEMIA";
export const CREATEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN = "CREATEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN";
export const GETPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN = "GETPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN";
export const DELETEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN = "DELETEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN";
export const UPDATEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN = "UPDATEPEDIATRICOPDSETTINGEXAMINATIONNECKVAIN";
export const CREATEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES = "CREATEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES";
export const GETPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES = "GETPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES";
export const DELETEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES = "DELETEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES";
export const UPDATEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES = "UPDATEPEDIATRICOPDSETTINGEXAMINATIONLYMPHNODES";
export const CREATEPEDIATRICEXAMINATIONVITALS = "CREATEPEDIATRICEXAMINATIONVITALS";
export const GETPEDIATRICEXAMINATIONVITALS = "GETPEDIATRICEXAMINATIONVITALS";
export const DELETEPEDIATRICEXAMINATIONVITALS = "DELETEPEDIATRICEXAMINATIONVITALS";
export const UPDATEPEDIATRICEXAMINATIONVITALS = "UPDATEPEDIATRICEXAMINATIONVITALS";

export const CREATEPEDIATRICEXAMINATIONGENERALAPPEARANCE = "CREATEPEDIATRICEXAMINATIONGENERALAPPEARANCE";
export const GETPEDIATRICEXAMINATIONGENERALAPPEARANCE = "GETPEDIATRICEXAMINATIONGENERALAPPEARANCE";
export const DELETEPEDIATRICEXAMINATIONGENERALAPPEARANCE = "DELETEPEDIATRICEXAMINATIONGENERALAPPEARANCE";
export const UPDATEPEDIATRICEXAMINATIONGENERALAPPEARANCE = "UPDATEPEDIATRICEXAMINATIONGENERALAPPEARANCE";
export const CREATEPEDIATRICEXAMINATIONSKIN = "CREATEPEDIATRICEXAMINATIONSKIN";
export const GETPEDIATRICEXAMINATIONSKIN = "GETPEDIATRICEXAMINATIONSKIN";
export const DELETEPEDIATRICEXAMINATIONSKIN = "DELETEPEDIATRICEXAMINATIONSKIN";
export const UPDATEPEDIATRICEXAMINATIONSKIN = "UPDATEPEDIATRICEXAMINATIONSKIN";
export const CREATEPEDIATRICEXAMINATIONHEENT = "CREATEPEDIATRICEXAMINATIONHEENT";
export const GETPEDIATRICEXAMINATIONHEENT = "GETPEDIATRICEXAMINATIONHEENT";
export const DELETEPEDIATRICEXAMINATIONHEENT = "DELETEPEDIATRICEXAMINATIONHEENT";
export const UPDATEPEDIATRICEXAMINATIONHEENT = "UPDATEPEDIATRICEXAMINATIONHEENT";
export const CREATEPEDIATRICEXAMINATIONCHEST = "CREATEPEDIATRICEXAMINATIONCHEST";
export const GETPEDIATRICEXAMINATIONCHEST = "GETPEDIATRICEXAMINATIONCHEST";
export const DELETEPEDIATRICEXAMINATIONCHEST = "DELETEPEDIATRICEXAMINATIONCHEST";
export const UPDATEPEDIATRICEXAMINATIONCHEST = "UPDATEPEDIATRICEXAMINATIONCHEST";
export const CREATEPEDIATRICEXAMINATIONABDOMEN = "CREATEPEDIATRICEXAMINATIONABDOMEN";
export const GETPEDIATRICEXAMINATIONABDOMEN = "GETPEDIATRICEXAMINATIONABDOMEN";
export const DELETEPEDIATRICEXAMINATIONABDOMEN = "DELETEPEDIATRICEXAMINATIONABDOMEN";
export const UPDATEPEDIATRICEXAMINATIONABDOMEN = "UPDATEPEDIATRICEXAMINATIONABDOMEN";
export const CREATEPEDIATRICEXAMINATIONMSK = "CREATEPEDIATRICEXAMINATIONMSK";
export const GETPEDIATRICEXAMINATIONMSK = "GETPEDIATRICEXAMINATIONMSK";
export const DELETEPEDIATRICEXAMINATIONMSK = "DELETEPEDIATRICEXAMINATIONMSK";
export const UPDATEPEDIATRICEXAMINATIONMSK = "UPDATEPEDIATRICEXAMINATIONMSK";
export const CREATEPEDIATRICEXAMINATIONNEURO = "CREATEPEDIATRICEXAMINATIONNEURO";
export const GETPEDIATRICEXAMINATIONNEURO = "GETPEDIATRICEXAMINATIONNEURO";
export const DELETEPEDIATRICEXAMINATIONNEURO = "DELETEPEDIATRICEXAMINATIONNEURO";
export const UPDATEPEDIATRICEXAMINATIONNEURO = "UPDATEPEDIATRICEXAMINATIONNEURO";
export const CREATEOPDOUTPEDIATRICVACCINE = "CREATEOPDOUTPEDIATRICVACCINE";
export const GETOPDOUTPEDIATRICVACCINE = "GETOPDOUTPEDIATRICVACCINE";
export const UPDATEOPDOUTPEDIATRICVACCINE = "UPDATEOPDOUTPEDIATRICVACCINE";
export const DELETEOPDOUTPEDIATRICVACCINE = "DELETEOPDOUTPEDIATRICVACCINE";
export const CREATEOPDOUTPEDIATRICDIETCHART = "CREATEOPDOUTPEDIATRICDIETCHART";
export const GETOPDOUTPEDIATRICDIETCHART = "GETOPDOUTPEDIATRICDIETCHART";
export const UPDATEOPDOUTPEDIATRICDIETCHART = "UPDATEOPDOUTPEDIATRICDIETCHART";
export const DELETEOPDOUTPEDIATRICDIETCHART = "DELETEOPDOUTPEDIATRICDIETCHART";
export const CREATEOPDOUTPEDIATRICDIETCHARTSELECTION = "CREATEOPDOUTPEDIATRICDIETCHARTSELECTION";
export const GETOPDOUTPEDIATRICDIETCHARTSELECTION = "GETOPDOUTPEDIATRICDIETCHARTSELECTION";
export const UPDATEOPDOUTPEDIATRICDIETCHARTSELECTION = "UPDATEOPDOUTPEDIATRICDIETCHARTSELECTION";
export const DELETEOPDOUTPEDIATRICDIETCHARTSELECTION = "DELETEOPDOUTPEDIATRICDIETCHARTSELECTION";
export const CREATEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT = "CREATEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT";
export const GETOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT = "GETOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT";
export const UPDATEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT = "UPDATEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT";
export const DELETEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT = "DELETEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT";
export const CREATEOPDOUTPEDIATRICDIETCHARTDAILYDIET = "CREATEOPDOUTPEDIATRICDIETCHARTDAILYDIET";
export const GETOPDOUTPEDIATRICDIETCHARTDAILYDIET = "GETOPDOUTPEDIATRICDIETCHARTDAILYDIET";
export const UPDATEOPDOUTPEDIATRICDIETCHARTDAILYDIET = "UPDATEOPDOUTPEDIATRICDIETCHARTDAILYDIET";
export const DELETEOPDOUTPEDIATRICDIETCHARTDAILYDIET = "DELETEOPDOUTPEDIATRICDIETCHARTDAILYDIET";
export const CREATEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE = "CREATEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE";
export const GETOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE = "GETOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE";
export const UPDATEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE = "UPDATEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE";
export const DELETEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE = "DELETEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE";
export const CREATEOPDOUTDIETCHARTPRINT = "CREATEOPDOUTDIETCHARTPRINT";
export const GETOPDOUTDIETCHARTPRINT = "GETOPDOUTDIETCHARTPRINT";
export const UPDATEOPDOUTDIETCHARTPRINT = "UPDATEOPDOUTDIETCHARTPRINT";
export const DELETEOPDOUTDIETCHARTPRINT = "DELETEOPDOUTDIETCHARTPRINT";
export const CREATEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE = "CREATEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE";
export const GETOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE = "GETOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE";
export const UPDATEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE = "UPDATEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE";
export const DELETEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE = "DELETEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE";
export const CREATEOPDOUTEXERCISEPRINT = "CREATEOPDOUTEXERCISEPRINT";
export const GETOPDOUTEXERCISEPRINT = "GETOPDOUTEXERCISEPRINT";
export const UPDATEOPDOUTEXERCISEPRINT = "UPDATEOPDOUTEXERCISEPRINT";
export const DELETEOPDOUTEXERCISEPRINT = "DELETEOPDOUTEXERCISEPRINT";
export const CREATEOPDOUTEXERCISE = "CREATEOPDOUTEXERCISE";
export const GETOPDOUTEXERCISE = "GETOPDOUTEXERCISE";
export const UPDATEOPDOUTEXERCISE = "UPDATEOPDOUTEXERCISE";
export const DELETEOPDOUTEXERCISE = "DELETEOPDOUTEXERCISE";
export const CREATEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM = "CREATEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM";
export const GETOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM = "GETOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM";
export const UPDATEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM = "UPDATEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM";
export const DELETEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM = "DELETEOPDOUTDENTALCHIEFCOMPLAINTSSYMPTOM";
export const CREATEOPDOUTDENTALASSOCIATEDSYMPTOM = "CREATEOPDOUTDENTALASSOCIATEDSYMPTOM";
export const GETOPDOUTDENTALASSOCIATEDSYMPTOM = "GETOPDOUTDENTALASSOCIATEDSYMPTOM";
export const UPDATEOPDOUTDENTALASSOCIATEDSYMPTOM = "UPDATEOPDOUTDENTALASSOCIATEDSYMPTOM";
export const DELETEOPDOUTDENTALASSOCIATEDSYMPTOM = "DELETEOPDOUTDENTALASSOCIATEDSYMPTOM";
export const CREATEOPDOUTDENTALPRESENTILLNESSHISTORY = "CREATEOPDOUTDENTALPRESENTILLNESSHISTORY";
export const GETOPDOUTDENTALPRESENTILLNESSHISTORY = "GETOPDOUTDENTALPRESENTILLNESSHISTORY";
export const UPDATEOPDOUTDENTALPRESENTILLNESSHISTORY = "UPDATEOPDOUTDENTALPRESENTILLNESSHISTORY";
export const DELETEOPDOUTDENTALPRESENTILLNESSHISTORY = "DELETEOPDOUTDENTALPRESENTILLNESSHISTORY";
export const GETDENTALCOMPLAINTCHILDILLNESS = "GETDENTALCOMPLAINTCHILDILLNESS";
export const CREATEDENTALCOMPLAINTCHILDILLNESS = "CREATEDENTALCOMPLAINTCHILDILLNESS";
export const DELETEDENTALCOMPLAINTCHILDILLNESS = "DELETEDENTALCOMPLAINTCHILDILLNESS";
export const UPDATEDENTALCOMPLAINTCHILDILLNESS = "UPDATEDENTALCOMPLAINTCHILDILLNESS";
export const GETDENTALCOMPLAINTADULTILLNESS = "GETDENTALCOMPLAINTADULTILLNESS";
export const CREATEDENTALCOMPLAINTADULTILLNESS = "CREATEDENTALCOMPLAINTADULTILLNESS";
export const DELETEDENTALCOMPLAINTADULTILLNESS = "DELETEDENTALCOMPLAINTADULTILLNESS";
export const UPDATEDENTALCOMPLAINTADULTILLNESS = "UPDATEDENTALCOMPLAINTADULTILLNESS";
export const GETDENTALCOMPLAINTHEALTHMAINT = "GETDENTALCOMPLAINTHEALTHMAINT";
export const CREATEDENTALCOMPLAINTHEALTHMAINT = "CREATEDENTALCOMPLAINTHEALTHMAINT";
export const DELETEDENTALCOMPLAINTHEALTHMAINT = "DELETEDENTALCOMPLAINTHEALTHMAINT";
export const UPDATEDENTALCOMPLAINTHEALTHMAINT = "UPDATEDENTALCOMPLAINTHEALTHMAINT";
export const GETDENTALCOMPLAINTRELATION = "GETDENTALCOMPLAINTRELATION";
export const CREATEDENTALCOMPLAINTRELATION = "CREATEDENTALCOMPLAINTRELATION";
export const DELETEDENTALCOMPLAINTRELATION = "DELETEDENTALCOMPLAINTRELATION";
export const UPDATEDENTALCOMPLAINTRELATION = "UPDATEDENTALCOMPLAINTRELATION";
export const GETDENTALAPPITITLE = "GETDENTALAPPITITLE";
export const CREATEDENTALAPPITITLE = "CREATEDENTALAPPITITLE";
export const DELETEDENTALAPPITITLE = "DELETEDENTALAPPITITLE";
export const UPDATEDENTALAPPITITLE = "UPDATEDENTALAPPITITLE";
export const GETDENTALDIGESTIVETRACT = "GETDENTALDIGESTIVETRACT";
export const CREATEDENTALDIGESTIVETRACT = "CREATEDENTALDIGESTIVETRACT";
export const DELETEDENTALDIGESTIVETRACT = "DELETEDENTALDIGESTIVETRACT";
export const UPDATEDENTALDIGESTIVETRACT = "UPDATEDENTALDIGESTIVETRACT";
export const GETDENTALBOWEL = "GETDENTALBOWEL";
export const CREATEDENTALBOWEL = "CREATEDENTALBOWEL";
export const DELETEDENTALBOWEL = "DELETEDENTALBOWEL";
export const UPDATEDENTALBOWEL = "UPDATEDENTALBOWEL";
export const GETDENTALSLIP = "GETDENTALSLIP";
export const CREATEDENTALSLIP = "CREATEDENTALSLIP";
export const DELETEDENTALSLIP = "DELETEDENTALSLIP";
export const UPDATEDENTALSLIP = "UPDATEDENTALSLIP";
export const GETDENTALADDICTIONS = "GETDENTALADDICTIONS";
export const CREATEDENTALADDICTIONS = "CREATEDENTALADDICTIONS";
export const DELETEDENTALADDICTIONS = "DELETEDENTALADDICTIONS";
export const UPDATEDENTALADDICTIONS = "UPDATEDENTALADDICTIONS";
export const GETDENTALHIGHRISKANDBEHAVIOR = "GETDENTALHIGHRISKANDBEHAVIOR";
export const CREATEDENTALHIGHRISKANDBEHAVIOR = "CREATEDENTALHIGHRISKANDBEHAVIOR";
export const DELETEDENTALHIGHRISKANDBEHAVIOR = "DELETEDENTALHIGHRISKANDBEHAVIOR";
export const UPDATEDENTALHIGHRISKANDBEHAVIOR = "UPDATEDENTALHIGHRISKANDBEHAVIOR";
export const GETDENTALPOSITIONDURINGWORK = "GETDENTALPOSITIONDURINGWORK";
export const CREATEDENTALPOSITIONDURINGWORK = "CREATEDENTALPOSITIONDURINGWORK";
export const DELETEDENTALPOSITIONDURINGWORK = "DELETEDENTALPOSITIONDURINGWORK";
export const UPDATEDENTALPOSITIONDURINGWORK = "UPDATEDENTALPOSITIONDURINGWORK";
export const GETDENTALNATUREOFWORK = "GETDENTALNATUREOFWORK";
export const CREATEDENTALNATUREOFWORK = "CREATEDENTALNATUREOFWORK";
export const DELETEDENTALNATUREOFWORK = "DELETEDENTALNATUREOFWORK";
export const UPDATEDENTALNATUREOFWORK = "UPDATEDENTALNATUREOFWORK";
export const GETDENTALALLOPATHIC = "GETDENTALALLOPATHIC";
export const CREATEDENTALALLOPATHIC = "CREATEDENTALALLOPATHIC";
export const DELETEDENTALALLOPATHIC = "DELETEDENTALALLOPATHIC";
export const UPDATEDENTALALLOPATHIC = "UPDATEDENTALALLOPATHIC";
export const GETDENTALAYURVEDA = "GETDENTALAYURVEDA";
export const CREATEDENTALAYURVEDA = "CREATEDENTALAYURVEDA";
export const DELETEDENTALAYURVEDA = "DELETEDENTALAYURVEDA";
export const UPDATEDENTALAYURVEDA = "UPDATEDENTALAYURVEDA";
export const GETDENTALHOMEOPATHIC = "GETDENTALHOMEOPATHIC";
export const CREATEDENTALHOMEOPATHIC = "CREATEDENTALHOMEOPATHIC";
export const DELETEDENTALHOMEOPATHIC = "DELETEDENTALHOMEOPATHIC";
export const UPDATEDENTALHOMEOPATHIC = "UPDATEDENTALHOMEOPATHIC";
export const GETDENTALOTHERMEDICINE = "GETDENTALOTHERMEDICINE";
export const CREATEDENTALOTHERMEDICINE = "CREATEDENTALOTHERMEDICINE";
export const DELETEDENTALOTHERMEDICINE = "DELETEDENTALOTHERMEDICINE";
export const UPDATEDENTALOTHERMEDICINE = "UPDATEDENTALOTHERMEDICINE";
export const GETDENTALANXIETY = "GETDENTALANXIETY";
export const CREATEDENTALANXIETY = "CREATEDENTALANXIETY";
export const DELETEDENTALANXIETY = "DELETEDENTALANXIETY";
export const UPDATEDENTALANXIETY = "UPDATEDENTALANXIETY";
export const GETDENTALDEPRESSION = "GETDENTALDEPRESSION";
export const CREATEDENTALDEPRESSION = "CREATEDENTALDEPRESSION";
export const DELETEDENTALDEPRESSION = "DELETEDENTALDEPRESSION";
export const UPDATEDENTALDEPRESSION = "UPDATEDENTALDEPRESSION";
export const GETDENTALIRRITABILITY = "GETDENTALIRRITABILITY";
export const CREATEDENTALIRRITABILITY = "CREATEDENTALIRRITABILITY";
export const DELETEDENTALIRRITABILITY = "DELETEDENTALIRRITABILITY";
export const UPDATEDENTALIRRITABILITY = "UPDATEDENTALIRRITABILITY";
export const GETDENTALEUPHORIA = "GETDENTALEUPHORIA";
export const CREATEDENTALEUPHORIA = "CREATEDENTALEUPHORIA";
export const DELETEDENTALEUPHORIA = "DELETEDENTALEUPHORIA";
export const UPDATEDENTALEUPHORIA = "UPDATEDENTALEUPHORIA";
export const GETDENTALOBSESSION = "GETDENTALOBSESSION";
export const CREATEDENTALOBSESSION = "CREATEDENTALOBSESSION";
export const DELETEDENTALOBSESSION = "DELETEDENTALOBSESSION";
export const UPDATEDENTALOBSESSION = "UPDATEDENTALOBSESSION";
export const GETDENTALNEUROSIS = "GETDENTALNEUROSIS";
export const CREATEDENTALNEUROSIS = "CREATEDENTALNEUROSIS";
export const DELETEDENTALNEUROSIS = "DELETEDENTALNEUROSIS";
export const UPDATEDENTALNEUROSIS = "UPDATEDENTALNEUROSIS";
export const GETDENTALDEPERSONALIZATION = "GETDENTALDEPERSONALIZATION";
export const CREATEDENTALDEPERSONALIZATION = "CREATEDENTALDEPERSONALIZATION";
export const DELETEDENTALDEPERSONALIZATION = "DELETEDENTALDEPERSONALIZATION";
export const UPDATEDENTALDEPERSONALIZATION = "UPDATEDENTALDEPERSONALIZATION";
export const GETDENTALMENSTRUALCYCLE = "GETDENTALMENSTRUALCYCLE";
export const CREATEDENTALMENSTRUALCYCLE = "CREATEDENTALMENSTRUALCYCLE";
export const DELETEDENTALMENSTRUALCYCLE = "DELETEDENTALMENSTRUALCYCLE";
export const UPDATEDENTALMENSTRUALCYCLE = "UPDATEDENTALMENSTRUALCYCLE";
export const GETDENTALFILLINGMATERIAL = "GETDENTALFILLINGMATERIAL";
export const CREATEDENTALFILLINGMATERIAL = "CREATEDENTALFILLINGMATERIAL";
export const DELETEDENTALFILLINGMATERIAL = "DELETEDENTALFILLINGMATERIAL";
export const UPDATEDENTALFILLINGMATERIAL = "UPDATEDENTALFILLINGMATERIAL";
export const GETDENTALFILLINGMATERIALUNIT = "GETDENTALFILLINGMATERIALUNIT";
export const CREATEDENTALFILLINGMATERIALUNIT = "CREATEDENTALFILLINGMATERIALUNIT";
export const DELETEDENTALFILLINGMATERIALUNIT = "DELETEDENTALFILLINGMATERIALUNIT";
export const UPDATEDENTALFILLINGMATERIALUNIT = "UPDATEDENTALFILLINGMATERIALUNIT";
export const GETDENTALCOVERINGMATERIAL = "GETDENTALCOVERINGMATERIAL";
export const CREATEDENTALCOVERINGMATERIAL = "CREATEDENTALCOVERINGMATERIAL";
export const DELETEDENTALCOVERINGMATERIAL = "DELETEDENTALCOVERINGMATERIAL";
export const UPDATEDENTALCOVERINGMATERIAL = "UPDATEDENTALCOVERINGMATERIAL";
export const GETDENTALCOVERINGMATERIALUNIT = "GETDENTALCOVERINGMATERIALUNIT";
export const CREATEDENTALCOVERINGMATERIALUNIT = "CREATEDENTALCOVERINGMATERIALUNIT";
export const DELETEDENTALCOVERINGMATERIALUNIT = "DELETEDENTALCOVERINGMATERIALUNIT";
export const UPDATEDENTALCOVERINGMATERIALUNIT = "UPDATEDENTALCOVERINGMATERIALUNIT";
export const GETDENTALSTATUS = "GETDENTALSTATUS";
export const CREATEDENTALSTATUS = "CREATEDENTALSTATUS";
export const DELETEDENTALSTATUS = "DELETEDENTALSTATUS";
export const UPDATEDENTALSTATUS = "UPDATEDENTALSTATUS";
export const GETDENTALCHILDHOODILLNESSES = "GETDENTALCHILDHOODILLNESSES";
export const CREATEDENTALCHILDHOODILLNESSES = "CREATEDENTALCHILDHOODILLNESSES";
export const DELETEDENTALCHILDHOODILLNESSES = "DELETEDENTALCHILDHOODILLNESSES";
export const UPDATEDENTALCHILDHOODILLNESSES = "UPDATEDENTALCHILDHOODILLNESSES";
export const GETDENTALADULTILLNESSES = "GETDENTALADULTILLNESSES";
export const CREATEDENTALADULTILLNESSES = "CREATEDENTALADULTILLNESSES";
export const DELETEDENTALADULTILLNESSES = "DELETEDENTALADULTILLNESSES";
export const UPDATEDENTALADULTILLNESSES = "UPDATEDENTALADULTILLNESSES";
export const GETDENTALHEALTHMAINTENANCE = "GETDENTALHEALTHMAINTENANCE";
export const CREATEDENTALHEALTHMAINTENANCE = "CREATEDENTALHEALTHMAINTENANCE";
export const DELETEDENTALHEALTHMAINTENANCE = "DELETEDENTALHEALTHMAINTENANCE";
export const UPDATEDENTALHEALTHMAINTENANCE = "UPDATEDENTALHEALTHMAINTENANCE";

export const GETDENTALSYMPTOMS = "GETDENTALSYMPTOMS";
export const CREATEDENTALSYMPTOMS = "CREATEDENTALSYMPTOMS";
export const DELETEDENTALSYMPTOMS = "DELETEDENTALSYMPTOMS";
export const UPDATEDENTALSYMPTOMS = "UPDATEDENTALSYMPTOMS";

export const GETDENTALCOMORBIDITY = "GETDENTALCOMORBIDITY";
export const CREATEDENTALCOMORBIDITY = "CREATEDENTALCOMORBIDITY";
export const DELETEDENTALCOMORBIDITY = "DELETEDENTALCOMORBIDITY";
export const UPDATEDENTALCOMORBIDITY = "UPDATEDENTALCOMORBIDITY";

export const GETDENTALPERSONALHISTORY = "GETDENTALPERSONALHISTORY";
export const CREATEDENTALPERSONALHISTORY = "CREATEDENTALPERSONALHISTORY";
export const DELETEDENTALPERSONALHISTORY = "DELETEDENTALPERSONALHISTORY";
export const UPDATEDENTALPERSONALHISTORY = "UPDATEDENTALPERSONALHISTORY";

export const GETDENTALOCCUPATIONALHISTORY = "GETDENTALOCCUPATIONALHISTORY";
export const CREATEDENTALOCCUPATIONALHISTORY = "CREATEDENTALOCCUPATIONALHISTORY";
export const DELETEDENTALOCCUPATIONALHISTORY = "DELETEDENTALOCCUPATIONALHISTORY";
export const UPDATEDENTALOCCUPATIONALHISTORY = "UPDATEDENTALOCCUPATIONALHISTORY";

export const GETDENTALPRETREATMENT = "GETDENTALPRETREATMENT";
export const GETDENTALPSYCHOLOGICAL = "GETDENTALPSYCHOLOGICAL";
export const CREATEDENTALPSYCHOLOGICAL = "CREATEDENTALPSYCHOLOGICAL";
export const DELETEDENTALPSYCHOLOGICAL = "DELETEDENTALPSYCHOLOGICAL";
export const UPDATEDENTALPSYCHOLOGICAL = "UPDATEDENTALPSYCHOLOGICAL";
export const GETDENTALGYNECOLOGICAL = "GETDENTALGYNECOLOGICAL";
export const CREATEDENTALGYNECOLOGICAL = "CREATEDENTALGYNECOLOGICAL";
export const DELETEDENTALGYNECOLOGICAL = "DELETEDENTALGYNECOLOGICAL";
export const UPDATEDENTALGYNECOLOGICAL = "UPDATEDENTALGYNECOLOGICAL";
export const GETDENTALOBSTETRICAL = "GETDENTALOBSTETRICAL";
export const CREATEDENTALOBSTETRICAL = "CREATEDENTALOBSTETRICAL";
export const DELETEDENTALOBSTETRICAL = "DELETEDENTALOBSTETRICAL";
export const UPDATEDENTALOBSTETRICAL = "UPDATEDENTALOBSTETRICAL";
export const GETDENTALDIET = "GETDENTALDIET";
export const CREATEDENTALDIET = "CREATEDENTALDIET";
export const UPDATEDENTALDIET = "UPDATEDENTALDIET";
export const DELETEDENTALDIET = "DELETEDENTALDIET";
export const GETDENTALNATUREOFDELIVERYHIST = "GETDENTALNATUREOFDELIVERYHIST";
export const CREATEDENTALNATUREOFDELIVERYHIST = "CREATEDENTALNATUREOFDELIVERYHIST";
export const UPDATEDENTALNATUREOFDELIVERYHIST = "UPDATEDENTALNATUREOFDELIVERYHIST";
export const DELETEDENTALNATUREOFDELIVERYHIST = "DELETEDENTALNATUREOFDELIVERYHIST";
export const GETGENERALOPDOBSTETRICALHISTORY = "GETGENERALOPDOBSTETRICALHISTORY";
export const CREATEGENERALOPDOBSTETRICALHISTORY = "CREATEGENERALOPDOBSTETRICALHISTORY";
export const UPDATEGENERALOPDOBSTETRICALHISTORY = "UPDATEGENERALOPDOBSTETRICALHISTORY";
export const DELETEGENERALOPDOBSTETRICALHISTORY = "DELETEGENERALOPDOBSTETRICALHISTORY";
export const GETGENERALCOMPLAINTPASTILLNESSNOTE = "GETGENERALCOMPLAINTPASTILLNESSNOTE";
export const CREATEGENERALCOMPLAINTPASTILLNESSNOTE = "CREATEGENERALCOMPLAINTPASTILLNESSNOTE";
export const DELETEGENERALCOMPLAINTPASTILLNESSNOTE = "DELETEGENERALCOMPLAINTPASTILLNESSNOTE";
export const UPDATEGENERALCOMPLAINTPASTILLNESSNOTE = "UPDATEGENERALCOMPLAINTPASTILLNESSNOTE";
export const GETDENTALCOMPLAINTFAMILYRELATION = "GETDENTALCOMPLAINTFAMILYRELATION";
export const CREATEDENTALCOMPLAINTFAMILYRELATION = "CREATEDENTALCOMPLAINTFAMILYRELATION";
export const UPDATEDENTALCOMPLAINTFAMILYRELATION = "UPDATEDENTALCOMPLAINTFAMILYRELATION";
export const DELETEDENTALCOMPLAINTFAMILYRELATION = "DELETEDENTALCOMPLAINTFAMILYRELATION";


export const GETDENTALOPDOUTPERSONALDIETHIST = "GETDENTALOPDOUTPERSONALDIETHIST";
export const CREATEDENTALOPDOUTPERSONALDIETHIST = "CREATEDENTALOPDOUTPERSONALDIETHIST";
export const UPDATEDENTALOPDOUTPERSONALDIETHIST = "UPDATEDENTALOPDOUTPERSONALDIETHIST";
export const DELETEDENTALOPDOUTPERSONALDIETHIST = "DELETEDENTALOPDOUTPERSONALDIETHIST";

export const GETDENTALOPDOUTPERSONALAPPETITEHIST = "GETDENTALOPDOUTPERSONALAPPETITEHIST";
export const CREATEDENTALOPDOUTPERSONALAPPETITEHIST = "CREATEDENTALOPDOUTPERSONALAPPETITEHIST";
export const UPDATEDENTALOPDOUTPERSONALAPPETITEHIST = "UPDATEDENTALOPDOUTPERSONALAPPETITEHIST";
export const DELETEDENTALOPDOUTPERSONALAPPETITEHIST = "DELETEDENTALOPDOUTPERSONALAPPETITEHIST";

export const GETDENTALOPDOUTPERSONALDIGESTIVETRACTHIST = "GETDENTALOPDOUTPERSONALDIGESTIVETRACTHIST";
export const CREATEDENTALOPDOUTPERSONALDIGESTIVETRACTHIST = "CREATEDENTALOPDOUTPERSONALDIGESTIVETRACTHIST";
export const UPDATEDENTALOPDOUTPERSONALDIGESTIVETRACTHIST = "UPDATEDENTALOPDOUTPERSONALDIGESTIVETRACTHIST";
export const DELETEDENTALOPDOUTPERSONALDIGESTIVETRACTHIST = "DELETEDENTALOPDOUTPERSONALDIGESTIVETRACTHIST";

export const GETDENTALOPDOUTPERSONALBOWELHIST = "GETDENTALOPDOUTPERSONALBOWELHIST";
export const CREATEDENTALOPDOUTPERSONALBOWELHIST = "CREATEDENTALOPDOUTPERSONALBOWELHIST";
export const UPDATEDENTALOPDOUTPERSONALBOWELHIST = "UPDATEDENTALOPDOUTPERSONALBOWELHIST";
export const DELETEDENTALOPDOUTPERSONALBOWELHIST = "DELETEDENTALOPDOUTPERSONALBOWELHIST";

export const GETDENTALOPDOUTPERSONALSLEEPHIST = "GETDENTALOPDOUTPERSONALSLEEPHIST";
export const CREATEDENTALOPDOUTPERSONALSLEEPHIST = "CREATEDENTALOPDOUTPERSONALSLEEPHIST";
export const UPDATEDENTALOPDOUTPERSONALSLEEPHIST = "UPDATEDENTALOPDOUTPERSONALSLEEPHIST";
export const DELETEDENTALOPDOUTPERSONALSLEEPHIST = "DELETEDENTALOPDOUTPERSONALSLEEPHIST";

export const GETDENTALOPDOUTPERSONALADDICTIONS = "GETDENTALOPDOUTPERSONALADDICTIONS";
export const CREATEDENTALOPDOUTPERSONALADDICTIONS = "CREATEDENTALOPDOUTPERSONALADDICTIONS";
export const UPDATEDENTALOPDOUTPERSONALADDICTIONS = "UPDATEDENTALOPDOUTPERSONALADDICTIONS";
export const DELETEDENTALOPDOUTPERSONALADDICTIONS = "DELETEDENTALOPDOUTPERSONALADDICTIONS";

export const GETDENTALOPDOUTPERSONALHIGHRISK = "GETDENTALOPDOUTPERSONALHIGHRISK";
export const CREATEDENTALOPDOUTPERSONALHIGHRISK = "CREATEDENTALOPDOUTPERSONALHIGHRISK";
export const UPDATEDENTALOPDOUTPERSONALHIGHRISK = "UPDATEDENTALOPDOUTPERSONALHIGHRISK";
export const DELETEDENTALOPDOUTPERSONALHIGHRISK = "DELETEDENTALOPDOUTPERSONALHIGHRISK";

export const GETDENTALOPDOUTPERSONALPOSITIONDURINGWORK = "GETDENTALOPDOUTPERSONALPOSITIONDURINGWORK";
export const CREATEDENTALOPDOUTPERSONALPOSITIONDURINGWORK = "CREATEDENTALOPDOUTPERSONALPOSITIONDURINGWORK";
export const UPDATEDENTALOPDOUTPERSONALPOSITIONDURINGWORK = "UPDATEDENTALOPDOUTPERSONALPOSITIONDURINGWORK";
export const DELETEDENTALOPDOUTPERSONALPOSITIONDURINGWORK = "DELETEDENTALOPDOUTPERSONALPOSITIONDURINGWORK";

export const GETDENTALOPDOUTPERSONALNATUREOFWORK = "GETDENTALOPDOUTPERSONALNATUREOFWORK";
export const CREATEDENTALOPDOUTPERSONALNATUREOFWORK = "CREATEDENTALOPDOUTPERSONALNATUREOFWORK";
export const UPDATEDENTALOPDOUTPERSONALNATUREOFWORK = "UPDATEDENTALOPDOUTPERSONALNATUREOFWORK";
export const DELETEDENTALOPDOUTPERSONALNATUREOFWORK = "DELETEDENTALOPDOUTPERSONALNATUREOFWORK";
export const GETDENTALOPDOUTALLOPATHYMEDIHIST = "GETDENTALOPDOUTALLOPATHYMEDIHIST";
export const CREATEDENTALOPDOUTALLOPATHYMEDIHIST = "CREATEDENTALOPDOUTALLOPATHYMEDIHIST";
export const UPDATEDENTALOPDOUTALLOPATHYMEDIHIST = "UPDATEDENTALOPDOUTALLOPATHYMEDIHIST";
export const DELETEDENTALOPDOUTALLOPATHYMEDIHIST = "DELETEDENTALOPDOUTALLOPATHYMEDIHIST";

export const GETDENTALOPDOUTAYURVEDAMEDIHIST = "GETDENTALOPDOUTAYURVEDAMEDIHIST";
export const CREATEDENTALOPDOUTAYURVEDAMEDIHIST = "CREATEDENTALOPDOUTAYURVEDAMEDIHIST";
export const UPDATEDENTALOPDOUTAYURVEDAMEDIHIST = "UPDATEDENTALOPDOUTAYURVEDAMEDIHIST";
export const DELETEDENTALOPDOUTAYURVEDAMEDIHIST = "DELETEDENTALOPDOUTAYURVEDAMEDIHIST";

export const GETDENTALOPDOUTHOMEOPATHYMEDIHIST = "GETDENTALOPDOUTHOMEOPATHYMEDIHIST";
export const CREATEDENTALOPDOUTHOMEOPATHYMEDIHIST = "CREATEDENTALOPDOUTHOMEOPATHYMEDIHIST";
export const UPDATEDENTALOPDOUTHOMEOPATHYMEDIHIST = "UPDATEDENTALOPDOUTHOMEOPATHYMEDIHIST";
export const DELETEDENTALOPDOUTHOMEOPATHYMEDIHIST = "DELETEDENTALOPDOUTHOMEOPATHYMEDIHIST";

export const GETDENTALOPDOUTOTHERMEDIHIST = "GETDENTALOPDOUTOTHERMEDIHIST";
export const CREATEDENTALOPDOUTOTHERMEDIHIST = "CREATEDENTALOPDOUTOTHERMEDIHIST";
export const UPDATEDENTALOPDOUTOTHERMEDIHIST = "UPDATEDENTALOPDOUTOTHERMEDIHIST";
export const DELETEDENTALOPDOUTOTHERMEDIHIST = "DELETEDENTALOPDOUTOTHERMEDIHIST";

export const GETDENTALOPDOUTANXIETYHIST = "GETDENTALOPDOUTANXIETYHIST";
export const CREATEDENTALOPDOUTANXIETYHIST = "CREATEDENTALOPDOUTANXIETYHIST";
export const UPDATEDENTALOPDOUTANXIETYHIST = "UPDATEDENTALOPDOUTANXIETYHIST";
export const DELETEDENTALOPDOUTANXIETYHIST = "DELETEDENTALOPDOUTANXIETYHIST";

export const GETDENTALOPDOUTDEPRESSIONHIST = "GETDENTALOPDOUTDEPRESSIONHIST";
export const CREATEDENTALOPDOUTDEPRESSIONHIST = "CREATEDENTALOPDOUTDEPRESSIONHIST";
export const UPDATEDENTALOPDOUTDEPRESSIONHIST = "UPDATEDENTALOPDOUTDEPRESSIONHIST";
export const DELETEDENTALOPDOUTDEPRESSIONHIST = "DELETEDENTALOPDOUTDEPRESSIONHIST";

export const GETDENTALOPDOUTIRRITABILITYHIST = "GETDENTALOPDOUTIRRITABILITYHIST";
export const CREATEDENTALOPDOUTIRRITABILITYHIST = "CREATEDENTALOPDOUTIRRITABILITYHIST";
export const UPDATEDENTALOPDOUTIRRITABILITYHIST = "UPDATEDENTALOPDOUTIRRITABILITYHIST";
export const DELETEDENTALOPDOUTIRRITABILITYHIST = "DELETEDENTALOPDOUTIRRITABILITYHIST";

export const GETDENTALOPDOUTEUPHORIAHIST = "GETDENTALOPDOUTEUPHORIAHIST";
export const CREATEDENTALOPDOUTEUPHORIAHIST = "CREATEDENTALOPDOUTEUPHORIAHIST";
export const UPDATEDENTALOPDOUTEUPHORIAHIST = "UPDATEDENTALOPDOUTEUPHORIAHIST";
export const DELETEDENTALOPDOUTEUPHORIAHIST = "DELETEDENTALOPDOUTEUPHORIAHIST";

export const GETDENTALOPDOUTOBSESSIONHIST = "GETDENTALOPDOUTOBSESSIONHIST";
export const CREATEDENTALOPDOUTOBSESSIONHIST = "CREATEDENTALOPDOUTOBSESSIONHIST";
export const UPDATEDENTALOPDOUTOBSESSIONHIST = "UPDATEDENTALOPDOUTOBSESSIONHIST";
export const DELETEDENTALOPDOUTOBSESSIONHIST = "DELETEDENTALOPDOUTOBSESSIONHIST";

export const GETDENTALOPDOUTNEUROSISHIST = "GETDENTALOPDOUTNEUROSISHIST";
export const CREATEDENTALOPDOUTNEUROSISHIST = "CREATEDENTALOPDOUTNEUROSISHIST";
export const UPDATEDENTALOPDOUTNEUROSISHIST = "UPDATEDENTALOPDOUTNEUROSISHIST";
export const DELETEDENTALOPDOUTNEUROSISHIST = "DELETEDENTALOPDOUTNEUROSISHIST";

export const GETDENTALOPDOUTDEPERSONALIZATIONHIST = "GETDENTALOPDOUTDEPERSONALIZATIONHIST";
export const CREATEDENTALOPDOUTDEPERSONALIZATIONHIST = "CREATEDENTALOPDOUTDEPERSONALIZATIONHIST";
export const UPDATEDENTALOPDOUTDEPERSONALIZATIONHIST = "UPDATEDENTALOPDOUTDEPERSONALIZATIONHIST";
export const DELETEDENTALOPDOUTDEPERSONALIZATIONHIST = "DELETEDENTALOPDOUTDEPERSONALIZATIONHIST";

export const GETDENTALOPDOUTGYNECOLOGICHIST = "GETDENTALOPDOUTGYNECOLOGICHIST";
export const CREATEDENTALOPDOUTGYNECOLOGICHIST = "CREATEDENTALOPDOUTGYNECOLOGICHIST";
export const UPDATEDENTALOPDOUTGYNECOLOGICHIST = "UPDATEDENTALOPDOUTGYNECOLOGICHIST";
export const DELETEDENTALOPDOUTGYNECOLOGICHIST = "DELETEDENTALOPDOUTGYNECOLOGICHIST";

export const GETDENTALOPDOUTMENSTRUALCYCLE = "GETDENTALOPDOUTMENSTRUALCYCLE";
export const CREATEDENTALOPDOUTMENSTRUALCYCLE = "CREATEDENTALOPDOUTMENSTRUALCYCLE";
export const UPDATEDENTALOPDOUTMENSTRUALCYCLE = "UPDATEDENTALOPDOUTMENSTRUALCYCLE";
export const DELETEDENTALOPDOUTMENSTRUALCYCLE = "DELETEDENTALOPDOUTMENSTRUALCYCLE";

export const GETDENTALOPDOUTOBSTETRICALHIST = "GETDENTALOPDOUTOBSTETRICALHIST";
export const CREATEDENTALOPDOUTOBSTETRICALHIST = "CREATEDENTALOPDOUTOBSTETRICALHIST";
export const UPDATEDENTALOPDOUTOBSTETRICALHIST = "UPDATEDENTALOPDOUTOBSTETRICALHIST";
export const DELETEDENTALOPDOUTOBSTETRICALHIST = "DELETEDENTALOPDOUTOBSTETRICALHIST";

export const GETDENTALOPDOUTNATUREOFDELIVERY = "GETDENTALOPDOUTNATUREOFDELIVERY";
export const CREATEDENTALOPDOUTNATUREOFDELIVERY = "CREATEDENTALOPDOUTNATUREOFDELIVERY";
export const UPDATEDENTALOPDOUTNATUREOFDELIVERY = "UPDATEDENTALOPDOUTNATUREOFDELIVERY";
export const DELETEDENTALOPDOUTNATUREOFDELIVERY = "DELETEDENTALOPDOUTNATUREOFDELIVERY";
export const GETDENTALOPDOUTDENTALCHART = "GETDENTALOPDOUTDENTALCHART";
export const CREATEDENTALOPDOUTDENTALCHART = "CREATEDENTALOPDOUTDENTALCHART";
export const UPDATEDENTALOPDOUTDENTALCHART = "UPDATEDENTALOPDOUTDENTALCHART";
export const DELETEDENTALOPDOUTDENTALCHART = "DELETEDENTALOPDOUTDENTALCHART";

export const CLEAR_OPD_CHIEF_COMPLAINT_LIST = "CLEAR_OPD_CHIEF_COMPLAINT_LIST";
export const CLEARGENERALMEDIASSOCIATEDCOMPLAINT = "CLEARGENERALMEDIASSOCIATEDCOMPLAINT";
export const CLEARGENERALMEDIPRESENTILLNESSHIST = "CLEARGENERALMEDIPRESENTILLNESSHIST";
export const CLEARGENERALMEDICHILDHOODILLNESS = "CLEARGENERALMEDICHILDHOODILLNESS";
export const CLEARGENERALMEDIADULTILLNESS = "CLEARGENERALMEDIADULTILLNESS";
export const CLEARGENERALMEDIHEALTHMAIN = "CLEARGENERALMEDIHEALTHMAIN";
export const CLEARGENERALMEDIPASTILLNESSNOTE = "CLEARGENERALMEDIPASTNOTE";
export const CLEARGENERALMEDIRELATIONHIST = "CLEARGENERALMEDIRELATIONHIST";
export const CLEARGENERALMEDIFAMILYSYMPTOMS = "CLEARGENERALMEDIFAMILYSYMPTOMS";
export const CLEARGENERALMEDIFAMILYCOMORBIDITY = "CLEARGENERALMEDIFAMILYCOMORBIDITY";
export const CLEARGENERALMEDIPERSONALDIET = "CLEARGENERALMEDIPERSONALDIET";
export const CLEARGENERALMEDIAPPETITE = "CLEARGENERALMEDIAPPETITE";
export const CLEARGENERALMEDIDIGESTIVETRACT = "CLEARGENERALMEDIDIGESTIVETRACT";
export const CLEARGENERALMEDIBOWEL = "CLEARGENERALMEDIBOWEL";
export const CLEARGENERALMEDISLEEP = "CLEARGENERALMEDISLEEP";
export const CLEARGENERALMEDIADDICTIONS = "CLEARGENERALMEDIADDICTIONS";
export const CLEARGENERALMEDIHIGHRISK = "CLEARGENERALMEDIHIGHRISK";
export const CLEARGENERALMEDIPOSITIONOFWORK = "CLEARGENERALMEDIPOSITIONOFWORK";
export const CLEARGENERALMEDINATUREOFWORK = "CLEARGENERALMEDINATUREOFWORK";
export const CLEARGENERALMEDIOCCUPATIONALHIST = "CLEARGENERALMEDIOCCUPATIONALHIST";
export const CLEARGENERALMEDIALLOPATHICMEDI = "CLEARGENERALMEDIALLOPATHICMEDI";
export const CLEARGENERALMEDIAYURVEDAMEDI = "CLEARGENERALMEDIAYURVEDAMEDI";
export const CLEARGENERALMEDIHOMEOPATHYMEDI = "CLEARGENERALMEDIANXIETY";
export const CLEARGENERALMEDIOTHERMEDI = "CLEARGENERALMEDIOTHERMEDI";
export const CLEARGENERALMEDIANXIETY = "CLEARGENERALMEDIANXIETY";
export const CLEARGENERALMEDDEPRESSION = "CLEARGENERALMEDDEPRESSION";
export const CLEARGENERALMEDIIRRITABILITY = "CLEARGENERALMEDIIRRITABILITY";
export const CLEARGENERALMEDIEUPHORIA = "CLEARGENERALMEDIEUPHORIA";
export const CLEARGENERALMEDIOBSESSION = "CLEARGENERALMEDIOBSESSION";
export const CLEARGENERALMEDINEUROSIS = "CLEARGENERALMEDINEUROSIS";
export const CLEARGENERALMEDIDEPERSONLIZATION = "CLEARGENERALMEDIDEPERSONLIZATION";
export const CLEARGENERALMEDIMENSTRUALCYCLE = "CLEARGENERALMEDIMENSTRUALCYCLE";
export const CLEARGENERALMEDIGYNECOLOGICHIST = "CLEARGENERALMEDIGYNECOLOGICHIST";
export const CLEARGENERALMEDINATUEOFDELIVERY = "CLEARGENERALMEDINATUEOFDELIVERY";
export const CLEARGENERALMEDIOBSTETRICAL = "CLEARGENERALMEDIOBSTETRICAL";
export const CLEARGENERALMEDIGENERALLOOK = "CLEARGENERALMEDIGENERALLOOK";
export const CLEARGENERALMEDINUTRITION = "CLEARGENERALMEDINUTRITION";
export const CLEARGENERALMEDIANAEMIA = "CLEARGENERALMEDIANAEMIA";
export const CLEARGENERALMEDINECKVEIN = "CLEARGENERALMEDINECKVEIN";
export const CLEARGENERALMEDILYMPHNODE = "CLEARGENERALMEDILYMPHNODE";
export const CLEARGENERALMEDIGENERALEXAMINATION = "CLEARGENERALMEDIGENERALEXAMINATION";
export const CLEARGENERALMEDIVITALS = "CLEARGENERALMEDIVITALS";
export const CLEARGENERALMEDIEXAMGENERALAPPEARANCE = "CLEARGENERALMEDIEXAMGENERALAPPEARANCE";
export const CLEARGENERALMEDIGENDER = "CLEARGENERALMEDIGENDER";
export const CLEARGENERALMEDISIGNOFDISTRESS = "CLEARGENERALMEDISIGNOFDISTRESS";
export const CLEARGENERALMEDIBODYTYPE = "CLEARGENERALMEDIBODYTYPE";
export const CLEARGENERALMEDIPOSTURE = "CLEARGENERALMEDIPOSTURE";
export const CLEARGENERALMEDIGAIT = "CLEARGENERALMEDIGAIT";
export const CLEARGENERALMEDIBODYMOVEMENT = "CLEARGENERALMEDIBODYMOVEMENT";
export const CLEARGENERALMEDIBODY = "CLEARGENERALMEDIBODY";
export const CLEARGENERALMEDIAFFECTANDMOOD = "CLEARGENERALMEDIAFFECTANDMOOD";
export const CLEARGENERALMEDISPEECH = "CLEARGENERALMEDISPEECH";
export const CLEARGENERALMEDISUBSTANCEABUSE = "CLEARGENERALMEDISUBSTANCEABUSE";
export const CLEARGENERALMEDIHAIRANDSCALP = "CLEARGENERALMEDIHAIRANDSCALP";
export const CLEARGENERALMEDIHAIRCOLOR = "CLEARGENERALMEDIHAIRCOLOR";
export const CLEARGENERALMEDIHAIRDISTRIBUTION = "CLEARGENERALMEDIHAIRDISTRIBUTION";
export const CLEARGENERALMEDIHAIRTEXTURE = "CLEARGENERALMEDIHAIRTEXTURE";
export const CLEARGENERALMEDIHAIRLUBRICATION = "CLEARGENERALMEDIHAIRLUBRICATION";
export const CLEARGENERALMEDISCALP = "CLEARGENERALMEDISCALP";
export const CLEARGENERALMEDIHEADEYENECK = "CLEARGENERALMEDIHEADEYENECK";
export const CLEARGENERALMEDIHEADPOSITION = "CLEARGENERALMEDIHEADPOSITION";
export const CLEARGENERALMEDIHEADSHAPE = "CLEARGENERALMEDIHEADSHAPE";
export const CLEARGENERALMEDIFACIALFEATURES = "CLEARGENERALMEDIFACIALFEATURES";
export const CLEARGENERALMEDIEYEPOSITION = "CLEARGENERALMEDIEYEPOSITION";
export const CLEARGENERALMEDILACRIMALAPPARATUS = "CLEARGENERALMEDILACRIMALAPPARATUS";
export const CLEARGENERALMEDICONJUCTIVASCLERA = "CLEARGENERALMEDICONJUCTIVASCLERA";
export const CLEARGENERALMEDIOCULARMOVEMENT = "CLEARGENERALMEDIOCULARMOVEMENT";
export const CLEARGENERALMEDINECKLYMPHNODE = "CLEARGENERALMEDINECKLYMPHNODE";
export const CLEARGENERALMEDIEARNOSEMOUTHPHARYNX = "CLEARGENERALMEDIEARNOSEMOUTHPHARYNX";
export const CLEARGENERALMEDICHESTAXILLATHORAX = "CLEARGENERALMEDICHESTAXILLATHORAX";
export const CLEARGENERALMEDIABDOMEN = "CLEARGENERALMEDIABDOMEN";
export const CLEARGENERALMEDIGENITALORGANS = "CLEARGENERALMEDIGENITALORGANS";
export const CLEARGENERALMEDIMUSCULOSKELETAL = "CLEARGENERALMEDIMUSCULOSKELETAL";
export const CLEARGENERALMEDINEURO = "CLEARGENERALMEDINEURO";

export const GETSETUPOPTICSHOPUNIT = "GETSETUPOPTICSHOPUNIT";
export const CREATESETUPOPTICSHOPUNIT = "CREATESETUPOPTICSHOPUNIT";
export const UPDATESETUPOPTICSHOPUNIT = "UPDATESETUPOPTICSHOPUNIT";
export const DELETESETUPOPTICSHOPUNIT = "DELETESETUPOPTICSHOPUNIT";
export const GETSETUPOPTICSHOPSUPPLIER = "GETSETUPOPTICSHOPSUPPLIER";
export const CREATESETUPOPTICSHOPSUPPLIER = "CREATESETUPOPTICSHOPSUPPLIER";
export const UPDATESETUPOPTICSHOPSUPPLIER = "UPDATESETUPOPTICSHOPSUPPLIER";
export const DELETESETUPOPTICSHOPSUPPLIER = "DELETESETUPOPTICSHOPSUPPLIER";
export const GETSETUPOPTICSHOPITEMCATEGORY = "GETSETUPOPTICSHOPITEMCATEGORY";
export const CREATESETUPOPTICSHOPITEMCATEGORY = "CREATESETUPOPTICSHOPITEMCATEGORY";
export const UPDATESETUPOPTICSHOPITEMCATEGORY = "UPDATESETUPOPTICSHOPITEMCATEGORY";
export const DELETESETUPOPTICSHOPITEMCATEGORY = "DELETESETUPOPTICSHOPITEMCATEGORY";
export const GETSETUPOPTICSHOPITEMS = "GETSETUPOPTICSHOPITEMS";
export const CREATESETUPOPTICSHOPITEMS = "CREATESETUPOPTICSHOPITEMS";
export const UPDATESETUPOPTICSHOPITEMS = "UPDATESETUPOPTICSHOPITEMS";
export const DELETESETUPOPTICSHOPITEMS = "DELETESETUPOPTICSHOPITEMS";

export const GETOPTICSHOPOPDPURCHASEITEM = "GETOPTICSHOPOPDPURCHASEITEM";
export const CREATEOPTICSHOPOPDPURCHASEITEM = "CREATEOPTICSHOPOPDPURCHASEITEM";
export const UPDATEOPTICSHOPOPDPURCHASEITEM = "UPDATEOPTICSHOPOPDPURCHASEITEM";
export const DELETEOPTICSHOPOPDPURCHASEITEM = "DELETEOPTICSHOPOPDPURCHASEITEM";
export const GETOPTICSHOPOPDGENERATEBILL = "GETOPTICSHOPOPDGENERATEBILL";
export const CREATEOPTICSHOPOPDGENERATEBILL = "CREATEOPTICSHOPOPDGENERATEBILL";
export const UPDATEOPTICSHOPOPDGENERATEBILL = "UPDATEOPTICSHOPOPDGENERATEBILL";
export const DELETEOPTICSHOPOPDGENERATEBILL = "DELETEOPTICSHOPOPDGENERATEBILL";
export const GETOPTICSHOPOPDBILLITEM = "GETOPTICSHOPOPDBILLITEM";
export const CREATEOPTICSHOPOPDBILLITEM = "CREATEOPTICSHOPOPDBILLITEM";
export const UPDATEOPTICSHOPOPDBILLITEM = "UPDATEOPTICSHOPOPDBILLITEM";
export const DELETEOPTICSHOPOPDBILLITEM = "DELETEOPTICSHOPOPDBILLITEM";
export const GETOPTICSHOPOPDBILLTRANSACTION = "GETOPTICSHOPOPDBILLTRANSACTION";
export const CREATEOPTICSHOPOPDBILLTRANSACTION = "CREATEOPTICSHOPOPDBILLTRANSACTION";
export const UPDATEOPTICSHOPOPDBILLTRANSACTION = "UPDATEOPTICSHOPOPDBILLTRANSACTION";
export const DELETEOPTICSHOPOPDBILLTRANSACTION = "DELETEOPTICSHOPOPDBILLTRANSACTION";

export const GETOPTICSHOPOPDPURCHASEITEMBILL = "GETOPTICSHOPOPDPURCHASEITEMBILL";
export const GETALLOPTICOPDITEMQTY = "GETALLOPTICOPDITEMQTY";
export const GETALLOPTICOPDPURCHASEITEMQTY = "GETALLOPTICOPDPURCHASEITEMQTY";
export const CREATEOPTICSHOPOPDPURCHASEITEMBILL = "CREATEOPTICSHOPOPDPURCHASEITEMBILL";
export const UPDATEOPTICSHOPOPDPURCHASEITEMBILL = "UPDATEOPTICSHOPOPDPURCHASEITEMBILL";
export const DELETEOPTICSHOPOPDPURCHASEITEMBILL = "DELETEOPTICSHOPOPDPURCHASEITEMBILL";
export const GETOPTICSHOPOPDPURCHASEITEMSHOW = "GETOPTICSHOPOPDPURCHASEITEMSHOW";
export const CREATEOPTICSHOPOPDPURCHASEITEMSHOW = "CREATEOPTICSHOPOPDPURCHASEITEMSHOW";
export const UPDATEOPTICSHOPOPDPURCHASEITEMSHOW = "UPDATEOPTICSHOPOPDPURCHASEITEMSHOW";
export const DELETEOPTICSHOPOPDPURCHASEITEMSHOW = "DELETEOPTICSHOPOPDPURCHASEITEMSHOW";
export const GETOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION = "GETOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION";
export const CREATEOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION = "CREATEOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION";
export const UPDATEOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION = "UPDATEOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION";
export const DELETEOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION = "DELETEOPTICSHOPOPDPURCHASEITEMBILLTRANSACTION";
export const GETOPTICSHOPOPDBADSTOCK = "GETOPTICSHOPOPDBADSTOCK";
export const CREATEOPTICSHOPOPDBADSTOCK = "CREATEOPTICSHOPOPDBADSTOCK";
export const UPDATEOPTICSHOPOPDBADSTOCK = "UPDATEOPTICSHOPOPDBADSTOCK";
export const DELETEOPTICSHOPOPDBADSTOCK = "DELETEOPTICSHOPOPDBADSTOCK";

export const GETOPTICSHOPOPDBILL = "GETOPTICSHOPOPDBILL";
export const CREATEOPTICSHOPOPDBILL = "CREATEOPTICSHOPOPDBILL";
export const UPDATEOPTICSHOPOPDBILL = "UPDATEOPTICSHOPOPDBILL";
export const DELETEOPTICSHOPOPDBILL = "DELETEOPTICSHOPOPDBILL";
export const GETOPTICSHOPOPDPAYMENTRECEIPT = "GETOPTICSHOPOPDPAYMENTRECEIPT";
export const CREATEOPTICSHOPOPDPAYMENTRECEIPT = "CREATEOPTICSHOPOPDPAYMENTRECEIPT";
export const UPDATEOPTICSHOPOPDPAYMENTRECEIPT = "UPDATEOPTICSHOPOPDPAYMENTRECEIPT";
export const DELETEOPTICSHOPOPDPAYMENTRECEIPT = "DELETEOPTICSHOPOPDPAYMENTRECEIPT";
export const CREATEOPDOUTDENTALCHARTPRINT = "CREATEOPDOUTDENTALCHARTPRINT";
export const GETOPDOUTDENTALCHARTPRINT = "GETOPDOUTDENTALCHARTPRINT";
export const UPDATEOPDOUTDENTALCHARTPRINT = "UPDATEOPDOUTDENTALCHARTPRINT";
export const DELETEOPDOUTDENTALCHARTPRINT = "DELETEOPDOUTDENTALCHARTPRINT";
export const CREATESETUPDIAGNOSIS = "CREATESETUPDIAGNOSIS";
export const GETSETUPDIAGNOSIS = "GETSETUPDIAGNOSIS";
export const UPDATESETUPDIAGNOSIS = "UPDATESETUPDIAGNOSIS";
export const DELETESETUPDIAGNOSIS = "DELETESETUPDIAGNOSIS";

export const GETOPTICOPDVISIONCHART = "GETOPTICOPDVISIONCHART";
export const CREATEOPTICOPDVISIONCHART = "CREATEOPTICOPDVISIONCHART";
export const UPDATEOPTICOPDVISIONCHART = "UPDATEOPTICOPDVISIONCHART";
export const DELETEOPTICOPDVISIONCHART = "DELETEOPTICOPDVISIONCHART";
export const GETOPDOUTENDODONTIC = "GETOPDOUTENDODONTIC";
export const CREATEOPDOUTENDODONTIC = "CREATEOPDOUTENDODONTIC";
export const UPDATEOPDOUTENDODONTIC = "UPDATEOPDOUTENDODONTIC";
export const DELETEOPDOUTENDODONTIC = "DELETEOPDOUTENDODONTIC";

export const GETOPHTHALMOLOGYOPDPASTOCCULARHIST = "GETOPHTHALMOLOGYOPDPASTOCCULARHIST";
export const CREATEOPHTHALMOLOGYOPDPASTOCCULARHIST = "CREATEOPHTHALMOLOGYOPDPASTOCCULARHIST";
export const UPDATEOPHTHALMOLOGYOPDPASTOCCULARHIST = "UPDATEOPHTHALMOLOGYOPDPASTOCCULARHIST";
export const DELETEOPHTHALMOLOGYOPDPASTOCCULARHIST = "DELETEOPHTHALMOLOGYOPDPASTOCCULARHIST";

export const GETOPHTHALMOLOGYOPDSYSTEMICILLNESS = "GETOPHTHALMOLOGYOPDSYSTEMICILLNESS";
export const CREATEOPHTHALMOLOGYOPDSYSTEMICILLNESS = "CREATEOPHTHALMOLOGYOPDSYSTEMICILLNESS";
export const UPDATEOPHTHALMOLOGYOPDSYSTEMICILLNESS = "UPDATEOPHTHALMOLOGYOPDSYSTEMICILLNESS";
export const DELETEOPHTHALMOLOGYOPDSYSTEMICILLNESS = "DELETEOPHTHALMOLOGYOPDSYSTEMICILLNESS";

export const GETOPHTHALMOLOGYOPDFAMILYHIST = "GETOPHTHALMOLOGYOPDFAMILYHIST";
export const CREATEOPHTHALMOLOGYOPDFAMILYHIST = "CREATEOPHTHALMOLOGYOPDFAMILYHIST";
export const UPDATEOPHTHALMOLOGYOPDFAMILYHIST = "UPDATEOPHTHALMOLOGYOPDFAMILYHIST";
export const DELETEOPHTHALMOLOGYOPDFAMILYHIST = "DELETEOPHTHALMOLOGYOPDFAMILYHIST";

export const GETOPHTHALMOLOGYOPDALLERGYHIST = "GETOPHTHALMOLOGYOPDALLERGYHIST";
export const CREATEOPHTHALMOLOGYOPDALLERGYHIST = "CREATEOPHTHALMOLOGYOPDALLERGYHIST";
export const UPDATEOPHTHALMOLOGYOPDALLERGYHIST = "UPDATEOPHTHALMOLOGYOPDALLERGYHIST";
export const DELETEOPHTHALMOLOGYOPDALLERGYHIST = "DELETEOPHTHALMOLOGYOPDALLERGYHIST";

export const GETOPHTHALMOLOGYOPDGLASSTYPE = "GETOPHTHALMOLOGYOPDGLASSTYPE";
export const CREATEOPHTHALMOLOGYOPDGLASSTYPE = "CREATEOPHTHALMOLOGYOPDGLASSTYPE";
export const UPDATEOPHTHALMOLOGYOPDGLASSTYPE = "UPDATEOPHTHALMOLOGYOPDGLASSTYPE";
export const DELETEOPHTHALMOLOGYOPDGLASSTYPE = "DELETEOPHTHALMOLOGYOPDGLASSTYPE";
export const GETOPHTHALMOLOGYOPDLENSETYPE = "GETOPHTHALMOLOGYOPDLENSETYPE";
export const CREATEOPHTHALMOLOGYOPDLENSETYPE = "CREATEOPHTHALMOLOGYOPDLENSETYPE";
export const UPDATEOPHTHALMOLOGYOPDLENSETYPE = "UPDATEOPHTHALMOLOGYOPDLENSETYPE";
export const DELETEOPHTHALMOLOGYOPDLENSETYPE = "DELETEOPHTHALMOLOGYOPDLENSETYPE";
export const GETOPHTHALMOLOGYOPDCOVERDISTEYE = "GETOPHTHALMOLOGYOPDCOVERDISTEYE";
export const CREATEOPHTHALMOLOGYOPDCOVERDISTEYE = "CREATEOPHTHALMOLOGYOPDCOVERDISTEYE";
export const UPDATEOPHTHALMOLOGYOPDCOVERDISTEYE = "UPDATEOPHTHALMOLOGYOPDCOVERDISTEYE";
export const DELETEOPHTHALMOLOGYOPDCOVERDISTEYE = "DELETEOPHTHALMOLOGYOPDCOVERDISTEYE";
export const GETOPHTHALMOLOGYOPDCOVERDISTOPTION = "GETOPHTHALMOLOGYOPDCOVERDISTOPTION";
export const CREATEOPHTHALMOLOGYOPDCOVERDISTOPTION = "CREATEOPHTHALMOLOGYOPDCOVERDISTOPTION";
export const UPDATEOPHTHALMOLOGYOPDCOVERDISTOPTION = "UPDATEOPHTHALMOLOGYOPDCOVERDISTOPTION";
export const DELETEOPHTHALMOLOGYOPDCOVERDISTOPTION = "DELETEOPHTHALMOLOGYOPDCOVERDISTOPTION";
export const GETOPHTHALMOLOGYOPDCOVERNNEAREYE = "GETOPHTHALMOLOGYOPDCOVERNNEAREYE";
export const CREATEOPHTHALMOLOGYOPDCOVERNNEAREYE = "CREATEOPHTHALMOLOGYOPDCOVERNNEAREYE";
export const UPDATEOPHTHALMOLOGYOPDCOVERNNEAREYE = "UPDATEOPHTHALMOLOGYOPDCOVERNNEAREYE";
export const DELETEOPHTHALMOLOGYOPDCOVERNNEAREYE = "DELETEOPHTHALMOLOGYOPDCOVERNNEAREYE";
export const GETOPHTHALMOLOGYOPDCOVERNEAROPTION = "GETOPHTHALMOLOGYOPDCOVERNEAROPTION";
export const CREATEOPHTHALMOLOGYOPDCOVERNEAROPTION = "CREATEOPHTHALMOLOGYOPDCOVERNEAROPTION";
export const UPDATEOPHTHALMOLOGYOPDCOVERNEAROPTION = "UPDATEOPHTHALMOLOGYOPDCOVERNEAROPTION";
export const DELETEOPHTHALMOLOGYOPDCOVERNEAROPTION = "DELETEOPHTHALMOLOGYOPDCOVERNEAROPTION";
export const GETOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE = "GETOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE";
export const CREATEOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE = "CREATEOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE";
export const UPDATEOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE = "UPDATEOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE";
export const DELETEOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE = "DELETEOPHTHALMOLOGYOPDOCULARMOVEMENTODRIGHEYE";
export const GETOPHTHALMOLOGYOPDFUNDUSDISCODRE = "GETOPHTHALMOLOGYOPDFUNDUSDISCODRE";
export const CREATEOPHTHALMOLOGYOPDFUNDUSDISCODRE = "CREATEOPHTHALMOLOGYOPDFUNDUSDISCODRE";
export const UPDATEOPHTHALMOLOGYOPDFUNDUSDISCODRE = "UPDATEOPHTHALMOLOGYOPDFUNDUSDISCODRE";
export const DELETEOPHTHALMOLOGYOPDFUNDUSDISCODRE = "DELETEOPHTHALMOLOGYOPDFUNDUSDISCODRE";
export const GETOPHTHALMOLOGYOPDFUNDUSMACULAODRE = "GETOPHTHALMOLOGYOPDFUNDUSMACULAODRE";
export const CREATEOPHTHALMOLOGYOPDFUNDUSMACULAODRE = "CREATEOPHTHALMOLOGYOPDFUNDUSMACULAODRE";
export const UPDATEOPHTHALMOLOGYOPDFUNDUSMACULAODRE = "UPDATEOPHTHALMOLOGYOPDFUNDUSMACULAODRE";
export const DELETEOPHTHALMOLOGYOPDFUNDUSMACULAODRE = "DELETEOPHTHALMOLOGYOPDFUNDUSMACULAODRE";
export const GETOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE = "GETOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE";
export const CREATEOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE = "CREATEOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE";
export const UPDATEOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE = "UPDATEOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE";
export const DELETEOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE = "DELETEOPHTHALMOLOGYOPDFUNDUSPERIPHERALODRE";
export const GETOPHTHALMOLOGYOPDFUNDUSCDODRE = "GETOPHTHALMOLOGYOPDFUNDUSCDODRE";
export const CREATEOPHTHALMOLOGYOPDFUNDUSCDODRE = "CREATEOPHTHALMOLOGYOPDFUNDUSCDODRE";
export const UPDATEOPHTHALMOLOGYOPDFUNDUSCDODRE = "UPDATEOPHTHALMOLOGYOPDFUNDUSCDODRE";
export const DELETEOPHTHALMOLOGYOPDFUNDUSCDODRE = "DELETEOPHTHALMOLOGYOPDFUNDUSCDODRE";
export const GETOPHTHALMOLOGYOPDGLAUCOMAIOPODRE = "GETOPHTHALMOLOGYOPDGLAUCOMAIOPODRE";
export const CREATEOPHTHALMOLOGYOPDGLAUCOMAIOPODRE = "CREATEOPHTHALMOLOGYOPDGLAUCOMAIOPODRE";
export const UPDATEOPHTHALMOLOGYOPDGLAUCOMAIOPODRE = "UPDATEOPHTHALMOLOGYOPDGLAUCOMAIOPODRE";
export const DELETEOPHTHALMOLOGYOPDGLAUCOMAIOPODRE = "DELETEOPHTHALMOLOGYOPDGLAUCOMAIOPODRE";

export const GETOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE = "GETOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE";
export const CREATEOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE = "CREATEOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE";
export const UPDATEOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE = "UPDATEOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE";
export const DELETEOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE = "DELETEOPHTHALMOLOGYOPDGLAUCOMADISCRATIOODRE";

export const GETOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION = "GETOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION";
export const CREATEOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION = "CREATEOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION";
export const UPDATEOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION = "UPDATEOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION";
export const DELETEOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION = "DELETEOPHTHALMOLOGYOPTICSHOPITEMPRESCRIPTION";
export const GETOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION = "GETOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION";
export const CREATEOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION = "CREATEOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION";
export const UPDATEOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION = "UPDATEOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION";
export const DELETEOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION = "DELETEOPHTHALMOLOGYOPTICSHOPITEMSPECIFICATION";

export const GETOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT = "GETOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT";
export const CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT = "CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT";
export const UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT = "UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT";
export const DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT = "DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTCHIEFCOMPLAINT";
export const GETOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST = "GETOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST";
export const CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST = "CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST";
export const UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST = "UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST";
export const DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST = "DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTPASTOCCULARHIST";
export const GETOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS = "GETOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS";
export const CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS = "CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS";
export const UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS = "UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS";
export const DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS = "DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTSYSTEMICILLNESS";
export const GETOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST = "GETOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST";
export const CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST = "CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST";
export const UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST = "UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST";
export const DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST = "DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTFAMILYHIST";
export const GETOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST = "GETOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST";
export const CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST = "CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST";
export const UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST = "UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST";
export const DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST = "DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTALLERGYHIST";
export const GETOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC = "GETOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC";
export const CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC = "CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC";
export const UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC = "UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC";
export const DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC = "DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTDIABETIC";
export const GETOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX = "GETOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX";
export const CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX = "CREATEOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX";
export const UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX = "UPDATEOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX";
export const DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX = "DELETEOPHTHALMOLOGYOPDCOMPLAINTHISTTEXTBOX";
export const GETOPHTHALMOLOGYOPDOUTVISIONCHART2 = "GETOPHTHALMOLOGYOPDOUTVISIONCHART2";
export const CREATEOPHTHALMOLOGYOPDOUTVISIONCHART2 = "CREATEOPHTHALMOLOGYOPDOUTVISIONCHART2";
export const UPDATEOPHTHALMOLOGYOPDOUTVISIONCHART2 = "UPDATEOPHTHALMOLOGYOPDOUTVISIONCHART2";
export const DELETEOPHTHALMOLOGYOPDOUTVISIONCHART2 = "DELETEOPHTHALMOLOGYOPDOUTVISIONCHART2";
export const GETOPHTHALMOLOGYOPDOUTREFRACTIONS = "GETOPHTHALMOLOGYOPDOUTREFRACTIONS";
export const CREATEOPHTHALMOLOGYOPDOUTREFRACTIONS = "CREATEOPHTHALMOLOGYOPDOUTREFRACTIONS";
export const UPDATEOPHTHALMOLOGYOPDOUTREFRACTIONS = "UPDATEOPHTHALMOLOGYOPDOUTREFRACTIONS";
export const DELETEOPHTHALMOLOGYOPDOUTREFRACTIONS = "DELETEOPHTHALMOLOGYOPDOUTREFRACTIONS";
export const GETOPHTHALMOLOGYOPDOUTASCAN = "GETOPHTHALMOLOGYOPDOUTASCAN";
export const CREATEOPHTHALMOLOGYOPDOUTASCAN = "CREATEOPHTHALMOLOGYOPDOUTASCAN";
export const UPDATEOPHTHALMOLOGYOPDOUTASCAN = "UPDATEOPHTHALMOLOGYOPDOUTASCAN";
export const DELETEOPHTHALMOLOGYOPDOUTASCAN = "DELETEOPHTHALMOLOGYOPDOUTASCAN";
export const GETOPHTHALMOLOGYOPDOUTCOVERTESTEOM = "GETOPHTHALMOLOGYOPDOUTCOVERTESTEOM";
export const CREATEOPHTHALMOLOGYOPDOUTCOVERTESTEOM = "CREATEOPHTHALMOLOGYOPDOUTCOVERTESTEOM";
export const UPDATEOPHTHALMOLOGYOPDOUTCOVERTESTEOM = "UPDATEOPHTHALMOLOGYOPDOUTCOVERTESTEOM";
export const DELETEOPHTHALMOLOGYOPDOUTCOVERTESTEOM = "DELETEOPHTHALMOLOGYOPDOUTCOVERTESTEOM";
export const GETOPHTHALMOLOGYOPDOUTKERATOMETRY = "GETOPHTHALMOLOGYOPDOUTKERATOMETRY";
export const CREATEOPHTHALMOLOGYOPDOUTKERATOMETRY = "CREATEOPHTHALMOLOGYOPDOUTKERATOMETRY";
export const UPDATEOPHTHALMOLOGYOPDOUTKERATOMETRY = "UPDATEOPHTHALMOLOGYOPDOUTKERATOMETRY";
export const DELETEOPHTHALMOLOGYOPDOUTKERATOMETRY = "DELETEOPHTHALMOLOGYOPDOUTKERATOMETRY";
export const GETOPHTHALMOLOGYOPDOUTPACHYMETRY = "GETOPHTHALMOLOGYOPDOUTPACHYMETRY";
export const CREATEOPHTHALMOLOGYOPDOUTPACHYMETRY = "CREATEOPHTHALMOLOGYOPDOUTPACHYMETRY";
export const UPDATEOPHTHALMOLOGYOPDOUTPACHYMETRY = "UPDATEOPHTHALMOLOGYOPDOUTPACHYMETRY";
export const DELETEOPHTHALMOLOGYOPDOUTPACHYMETRY = "DELETEOPHTHALMOLOGYOPDOUTPACHYMETRY";
export const GETOPHTHALMOLOGYOPDOUTSYRINGING = "GETOPHTHALMOLOGYOPDOUTSYRINGING";
export const CREATEOPHTHALMOLOGYOPDOUTSYRINGING = "CREATEOPHTHALMOLOGYOPDOUTSYRINGING";
export const UPDATEOPHTHALMOLOGYOPDOUTSYRINGING = "UPDATEOPHTHALMOLOGYOPDOUTSYRINGING";
export const DELETEOPHTHALMOLOGYOPDOUTSYRINGING = "DELETEOPHTHALMOLOGYOPDOUTSYRINGING";
export const GETOPHTHALMOLOGYOPDOUTIOP = "GETOPHTHALMOLOGYOPDOUTIOP";
export const CREATEOPHTHALMOLOGYOPDOUTIOP = "CREATEOPHTHALMOLOGYOPDOUTIOP";
export const UPDATEOPHTHALMOLOGYOPDOUTIOP = "UPDATEOPHTHALMOLOGYOPDOUTIOP";
export const DELETEOPHTHALMOLOGYOPDOUTIOP = "DELETEOPHTHALMOLOGYOPDOUTIOP";
export const GETOPHTHALMOLOGYOPDOUTCOLORVISION = "GETOPHTHALMOLOGYOPDOUTCOLORVISION";
export const CREATEOPHTHALMOLOGYOPDOUTCOLORVISION = "CREATEOPHTHALMOLOGYOPDOUTCOLORVISION";
export const UPDATEOPHTHALMOLOGYOPDOUTCOLORVISION = "UPDATEOPHTHALMOLOGYOPDOUTCOLORVISION";
export const DELETEOPHTHALMOLOGYOPDOUTCOLORVISION = "DELETEOPHTHALMOLOGYOPDOUTCOLORVISION";
export const GETOPHTHALMOLOGYOPDOUTFUNDUS = "GETOPHTHALMOLOGYOPDOUTFUNDUS";
export const CREATEOPHTHALMOLOGYOPDOUTFUNDUS = "CREATEOPHTHALMOLOGYOPDOUTFUNDUS";
export const UPDATEOPHTHALMOLOGYOPDOUTFUNDUS = "UPDATEOPHTHALMOLOGYOPDOUTFUNDUS";
export const DELETEOPHTHALMOLOGYOPDOUTFUNDUS = "DELETEOPHTHALMOLOGYOPDOUTFUNDUS";
export const GETOPHTHALMOLOGYOPDOUTGLAUCOMA = "GETOPHTHALMOLOGYOPDOUTGLAUCOMA";
export const CREATEOPHTHALMOLOGYOPDOUTGLAUCOMA = "CREATEOPHTHALMOLOGYOPDOUTGLAUCOMA";
export const UPDATEOPHTHALMOLOGYOPDOUTGLAUCOMA = "UPDATEOPHTHALMOLOGYOPDOUTGLAUCOMA";
export const DELETEOPHTHALMOLOGYOPDOUTGLAUCOMA = "DELETEOPHTHALMOLOGYOPDOUTGLAUCOMA";

export const GETOPHTHALMOLOGYOPDOUTDRLASH = "GETOPHTHALMOLOGYOPDOUTDRLASH";
export const CREATEOPHTHALMOLOGYOPDOUTDRLASH = "CREATEOPHTHALMOLOGYOPDOUTDRLASH";
export const UPDATEOPHTHALMOLOGYOPDOUTDRLASH = "UPDATEOPHTHALMOLOGYOPDOUTDRLASH";
export const DELETEOPHTHALMOLOGYOPDOUTDRLASH = "DELETEOPHTHALMOLOGYOPDOUTDRLASH";
export const GETOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA = "GETOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA";
export const CREATEOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA = "CREATEOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA";
export const UPDATEOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA = "UPDATEOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA";
export const DELETEOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA = "DELETEOPHTHALMOLOGYOPDOUTDRCONJUNCTIVA";
export const GETOPHTHALMOLOGYOPDOUTDRCORNEA = "GETOPHTHALMOLOGYOPDOUTDRCORNEA";
export const CREATEOPHTHALMOLOGYOPDOUTDRCORNEA = "CREATEOPHTHALMOLOGYOPDOUTDRCORNEA";
export const UPDATEOPHTHALMOLOGYOPDOUTDRCORNEA = "UPDATEOPHTHALMOLOGYOPDOUTDRCORNEA";
export const DELETEOPHTHALMOLOGYOPDOUTDRCORNEA = "DELETEOPHTHALMOLOGYOPDOUTDRCORNEA";
export const GETOPHTHALMOLOGYOPDOUTDRIRIS = "GETOPHTHALMOLOGYOPDOUTDRIRIS";
export const CREATEOPHTHALMOLOGYOPDOUTDRIRIS = "CREATEOPHTHALMOLOGYOPDOUTDRIRIS";
export const UPDATEOPHTHALMOLOGYOPDOUTDRIRIS = "UPDATEOPHTHALMOLOGYOPDOUTDRIRIS";
export const DELETEOPHTHALMOLOGYOPDOUTDRIRIS = "DELETEOPHTHALMOLOGYOPDOUTDRIRIS";
export const GETOPHTHALMOLOGYOPDOUTDRPUPIL = "GETOPHTHALMOLOGYOPDOUTDRPUPIL";
export const CREATEOPHTHALMOLOGYOPDOUTDRPUPIL = "CREATEOPHTHALMOLOGYOPDOUTDRPUPIL";
export const UPDATEOPHTHALMOLOGYOPDOUTDRPUPIL = "UPDATEOPHTHALMOLOGYOPDOUTDRPUPIL";
export const DELETEOPHTHALMOLOGYOPDOUTDRPUPIL = "DELETEOPHTHALMOLOGYOPDOUTDRPUPIL";
export const GETOPHTHALMOLOGYOPDOUTDRLENSE = "GETOPHTHALMOLOGYOPDOUTDRLENSE";
export const CREATEOPHTHALMOLOGYOPDOUTDRLENSE = "CREATEOPHTHALMOLOGYOPDOUTDRLENSE";
export const UPDATEOPHTHALMOLOGYOPDOUTDRLENSE = "UPDATEOPHTHALMOLOGYOPDOUTDRLENSE";
export const DELETEOPHTHALMOLOGYOPDOUTDRLENSE = "DELETEOPHTHALMOLOGYOPDOUTDRLENSE";
export const GETOPHTHALMOLOGYOPDOUTDRGLASSPRESCRIPTION = "GETOPHTHALMOLOGYOPDOUTDRDLASSPRESCRIPTION";
export const CREATEOPHTHALMOLOGYOPDOUTDRGLASSPRESCRIPTION = "CREATEOPHTHALMOLOGYOPDOUTDRGLASSPRESCRIPTION";
export const UPDATEOPHTHALMOLOGYOPDOUTDRGLASSPRESCRIPTION = "UPDATEOPHTHALMOLOGYOPDOUTDRGLASSPRESCRIPTION";
export const DELETEOPHTHALMOLOGYOPDOUTDRGLASSPRESCRIPTION = "DELETEOPHTHALMOLOGYOPDOUTDRGLASSPRESCRIPTION";
export const GETOPHTHALMOLOGYOPDOUTDRPACHYMETRY = "GETOPHTHALMOLOGYOPDOUTDRPACHYMETRY";
export const CREATEOPHTHALMOLOGYOPDOUTDRPACHYMETRY = "CREATEOPHTHALMOLOGYOPDOUTDRPACHYMETRY";
export const UPDATEOPHTHALMOLOGYOPDOUTDRPACHYMETRY = "UPDATEOPHTHALMOLOGYOPDOUTDRPACHYMETRY";
export const DELETEOPHTHALMOLOGYOPDOUTDRPACHYMETRY = "DELETEOPHTHALMOLOGYOPDOUTDRPACHYMETRY";
export const GETOPHTHALMOLOGYOPDOUTDRIOP = "GETOPHTHALMOLOGYOPDOUTDRIOP";
export const CREATEOPHTHALMOLOGYOPDOUTDRIOP = "CREATEOPHTHALMOLOGYOPDOUTDRIOP";
export const UPDATEOPHTHALMOLOGYOPDOUTDRIOP = "UPDATEOPHTHALMOLOGYOPDOUTDRIOP";
export const DELETEOPHTHALMOLOGYOPDOUTDRIOP = "DELETEOPHTHALMOLOGYOPDOUTDRIOP";
export const GETOPHTHALMOLOGYOPDOUTDRDRAWING = "GETOPHTHALMOLOGYOPDOUTDRDRAWING";
export const CREATEOPHTHALMOLOGYOPDOUTDRDRAWING = "CREATEOPHTHALMOLOGYOPDOUTDRDRAWING";
export const UPDATEOPHTHALMOLOGYOPDOUTDRDRAWING = "UPDATEOPHTHALMOLOGYOPDOUTDRDRAWING";
export const DELETEOPHTHALMOLOGYOPDOUTDRDRAWING = "DELETEOPHTHALMOLOGYOPDOUTDRDRAWING";
export const GETOPHTHALMOLOGYOPDOUTDRGONIOSCOPY = "GETOPHTHALMOLOGYOPDOUTDRGONIOSCOPY";
export const CREATEOPHTHALMOLOGYOPDOUTDRGONIOSCOPY = "CREATEOPHTHALMOLOGYOPDOUTDRGONIOSCOPY";
export const UPDATEOPHTHALMOLOGYOPDOUTDRGONIOSCOPY = "UPDATEOPHTHALMOLOGYOPDOUTDRGONIOSCOPY";
export const DELETEOPHTHALMOLOGYOPDOUTDRGONIOSCOPY = "DELETEOPHTHALMOLOGYOPDOUTDRGONIOSCOPY";
export const GETOPHTHALMOLOGYOPDOUTDRDOCTOR = "GETOPHTHALMOLOGYOPDOUTDRDOCTOR";
export const CREATEOPHTHALMOLOGYOPDOUTDRDOCTOR = "CREATEOPHTHALMOLOGYOPDOUTDRDOCTOR";
export const UPDATEOPHTHALMOLOGYOPDOUTDRDOCTOR = "UPDATEOPHTHALMOLOGYOPDOUTDRDOCTOR";
export const DELETEOPHTHALMOLOGYOPDOUTDRDOCTOR = "DELETEOPHTHALMOLOGYOPDOUTDRDOCTOR";
export const GETOPHTHALMOLOGYOPDOUTDRDIAGNOSIS = "GETOPHTHALMOLOGYOPDOUTDRDIAGNOSIS";
export const CREATEOPHTHALMOLOGYOPDOUTDRDIAGNOSIS = "CREATEOPHTHALMOLOGYOPDOUTDRDIAGNOSIS";
export const UPDATEOPHTHALMOLOGYOPDOUTDRDIAGNOSIS = "UPDATEOPHTHALMOLOGYOPDOUTDRDIAGNOSIS";
export const DELETEOPHTHALMOLOGYOPDOUTDRDIAGNOSIS = "DELETEOPHTHALMOLOGYOPDOUTDRDIAGNOSIS";
export const GETOPHTHALMOLOGYOPDOUTDRSURGERYADVICE = "GETOPHTHALMOLOGYOPDOUTDRSURGERYADVICE";
export const CREATEOPHTHALMOLOGYOPDOUTDRSURGERYADVICE = "CREATEOPHTHALMOLOGYOPDOUTDRSURGERYADVICE";
export const UPDATEOPHTHALMOLOGYOPDOUTDRSURGERYADVICE = "UPDATEOPHTHALMOLOGYOPDOUTDRSURGERYADVICE";
export const DELETEOPHTHALMOLOGYOPDOUTDRSURGERYADVICE = "DELETEOPHTHALMOLOGYOPDOUTDRSURGERYADVICE";

export const GETOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS = "GETOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS";
export const CREATEOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS = "CREATEOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS";
export const UPDATEOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS = "UPDATEOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS";
export const DELETEOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS = "DELETEOPHTHALMOLOGYOPDOUTCOUNSSURGERYDETAILS";
export const GETOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM = "GETOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM";
export const CREATEOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM = "CREATEOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM";
export const UPDATEOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM = "UPDATEOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM";
export const DELETEOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM = "DELETEOPHTHALMOLOGYOPDOUTCOUNSCOUNSELLORFORM";
export const GETOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE = "GETOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE";
export const CREATEOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE = "CREATEOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE";
export const UPDATEOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE = "UPDATEOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE";
export const DELETEOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE = "DELETEOPHTHALMOLOGYOPDOUTCOUNSEASTIMATE";
export const GETOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE = "GETOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE";
export const CREATEOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE = "CREATEOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE";
export const UPDATEOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE = "UPDATEOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE";
export const DELETEOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE = "DELETEOPHTHALMOLOGYOPDOUTCOUNSSCHEDULE";
export const GETOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION = "GETOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION";
export const CREATEOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION = "CREATEOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION";
export const UPDATEOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION = "UPDATEOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION";
export const DELETEOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION = "DELETEOPHTHALMOLOGYOPDOUTCOUNSINSTRUCTION";

export const GETOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS = "GETOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS";
export const CREATEOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS = "CREATEOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS";
export const UPDATEOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS = "UPDATEOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS";
export const DELETEOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS = "DELETEOPHTHALMOLOGYOPDOUTPROCEDURENEWGLASS";
export const GETOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE = "GETOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE";
export const CREATEOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE = "CREATEOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE";
export const UPDATEOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE = "UPDATEOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE";
export const DELETEOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE = "DELETEOPHTHALMOLOGYOPDOUTPROCEDURECONTACTLENSE";
export const GETOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY = "GETOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY";
export const CREATEOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY = "CREATEOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY";
export const UPDATEOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY = "UPDATEOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY";
export const DELETEOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY = "DELETEOPHTHALMOLOGYOPDOUTPROCEDUREREFRACTIVESURGERY";
export const GETOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY = "GETOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY";
export const CREATEOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY = "CREATEOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY";
export const UPDATEOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY = "UPDATEOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY";
export const DELETEOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY = "DELETEOPHTHALMOLOGYOPDOUTPROCEDURECONTRACTSURGERY";
export const GETOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY = "GETOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY";
export const CREATEOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY = "CREATEOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY";
export const UPDATEOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY = "UPDATEOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY";
export const DELETEOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY = "DELETEOPHTHALMOLOGYOPDOUTPROCEDURECORNEALSURGERY";
export const GETOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE = "GETOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE";
export const CREATEOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE = "CREATEOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE";
export const UPDATEOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE = "UPDATEOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE";
export const DELETEOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE = "DELETEOPHTHALMOLOGYOPDOUTPROCEDURELASIKPROCEDURE";
export const CLEAROPTHALMOLOGYOPDPROCEDURENEWGLASS = "CLEAROPTHALMOLOGYOPDPROCEDURENEWGLASS";
export const CLEAROPTHALMOLOGYOPDPROCEDURECONTACTLENSE = "CLEAROPTHALMOLOGYOPDPROCEDURECONTACTLENSE";
export const CLEAROPTHALMOLOGYOPDPROCEDUREREFRACTIVESURGERY = "CLEAROPTHALMOLOGYOPDPROCEDUREREFRACTIVESURGERY";
export const CLEAROPTHALMOLOGYOPDPROCEDURECONTRACTSURGERY = "CLEAROPTHALMOLOGYOPDPROCEDURECONTRACTSURGERY";
export const CLEAROPTHALMOLOGYOPDPROCEDURECORNEALSURGERY = "CLEAROPTHALMOLOGYOPDPROCEDURECORNEALSURGERY";
export const CLEAROPTHALMOLOGYOPDPROCEDURELASIKPROCEDURE = "CLEAROPTHALMOLOGYOPDPROCEDURELASIKPROCEDURE";

export const CLEAROPTHALMOLOGYOPDCOUNSSURGERYDETAILS = "CLEAROPTHALMOLOGYOPDCOUNSSURGERYDETAILS";
export const CLEAROPTHALMOLOGYOPDCOUNSCOUNSELLORFORM = "CLEAROPTHALMOLOGYOPDCOUNSCOUNSELLORFORM";
export const CLEAROPTHALMOLOGYOPDCOUNSEASTIMATE = "CLEAROPTHALMOLOGYOPDCOUNSEASTIMATE";
export const CLEAROPTHALMOLOGYOPDCOUNSSCHEDULE = "CLEAROPTHALMOLOGYOPDCOUNSSCHEDULE";
export const CLEAROPTHALMOLOGYOPDCOUNSINSTRUCTION = "CLEAROPTHALMOLOGYOPDCOUNSINSTRUCTION";

export const CLEAROPTHALMOLOGYOPDCHIEFCOMPLAINT = "CLEAROPTHALMOLOGYOPDCHIEFCOMPLAINT";
export const CLEAROPTHALMOLOGYOPDPASTOCCULARHIST = "CLEAROPTHALMOLOGYOPDPASTOCCULARHIST";
export const CLEAROPTHALMOLOGYOPDSYSTEMICILLNESS = "CLEAROPTHALMOLOGYOPDSYSTEMICILLNESS";
export const CLEAROPTHALMOLOGYOPDFAMILYHIST = "CLEAROPTHALMOLOGYOPDFAMILYHIST";
export const CLEAROPTHALMOLOGYOPDALLERGYHIST = "CLEAROPTHALMOLOGYOPDALLERGYHIST";
export const CLEAROPTHALMOLOGYOPDDIABETIC = "CLEAROPTHALMOLOGYOPDDIABETIC";
export const CLEAROPTHALMOLOGYOPDVISION = "CLEAROPTHALMOLOGYOPDVISION";
export const CLEAROPTHALMOLOGYOPDREFRACTION = "CLEAROPTHALMOLOGYOPDREFRACTION";
export const CLEAROPTHALMOLOGYOPDPRESCRIPTION = "CLEAROPTHALMOLOGYOPDPRESCRIPTION";
export const CLEAROPTHALMOLOGYOPDASCAN = "CLEAROPTHALMOLOGYOPDASCAN";
export const CLEAROPTHALMOLOGYOPDCOVERTESTEOM = "CLEAROPTHALMOLOGYOPDCOVERTESTEOM";
export const CLEAROPTHALMOLOGYOPDKERATOMETRY = "CLEAROPTHALMOLOGYOPDKERATOMETRY";
export const CLEAROPTHALMOLOGYOPDPACHYMETRY = "CLEAROPTHALMOLOGYOPDPACHYMETRY";
export const CLEAROPTHALMOLOGYOPDSYRINGING = "CLEAROPTHALMOLOGYOPDSYRINGING";
export const CLEAROPTHALMOLOGYOPDOUTIOP = "CLEAROPTHALMOLOGYOPDOUTIOP";
export const CLEAROPTHALMOLOGYOPDCOLORVISION = "CLEAROPTHALMOLOGYOPDCOLORVISION";
export const CLEAROPTHALMOLOGYOPDFUNDUS = "CLEAROPTHALMOLOGYOPDFUNDUS";
export const CLEAROPTHALMOLOGYOPDGLAUCOMA = "CLEAROPTHALMOLOGYOPDGLAUCOMA";
export const CLEAROPTHALMOLOGYOPDCOMPLAINTTEXTBOX = "CLEAROPTHALMOLOGYOPDCOMPLAINTTEXTBOX";

export const CLEAROPTHALMOLOGYOPDDRLASH = "CLEAROPTHALMOLOGYOPDDRLASH";
export const CLEAROPTHALMOLOGYOPDDRCONJUNCTIVA = "CLEAROPTHALMOLOGYOPDDRCONJUNCTIVA";
export const CLEAROPTHALMOLOGYOPDDRCORNEA = "CLEAROPTHALMOLOGYOPDDRCORNEA";
export const CLEAROPTHALMOLOGYOPDDRIRIS = "CLEAROPTHALMOLOGYOPDDRIRIS";
export const CLEAROPTHALMOLOGYOPDDRPUPIL = "CLEAROPTHALMOLOGYOPDDRPUPIL";
export const CLEAROPTHALMOLOGYOPDDRLENSE = "CLEAROPTHALMOLOGYOPDDRLENSE";
export const CLEAROPTHALMOLOGYOPDDRGLASSPRESCRIPTION = "CLEAROPTHALMOLOGYOPDDRGLASSPRESCRIPTION";
export const CLEAROPTHALMOLOGYOPDDRPACHYMETRY = "CLEAROPTHALMOLOGYOPDDRPACHYMETRY";
export const CLEAROPTHALMOLOGYOPDDRIOP = "CLEAROPTHALMOLOGYOPDDRIOP";
export const CLEAROPTHALMOLOGYOPDDRDRAWING = "CLEAROPTHALMOLOGYOPDDRDRAWING";
export const CLEAROPTHALMOLOGYOPDDRGONIOSCOPY = "CLEAROPTHALMOLOGYOPDDRGONIOSCOPY";
export const CLEAROPTHALMOLOGYOPDDRDOCTOR = "CLEAROPTHALMOLOGYOPDDRDOCTOR";
export const CLEAROPTHALMOLOGYOPDDRDIAGNOSIS = "CLEAROPTHALMOLOGYOPDDRDIAGNOSIS";
export const CLEAROPTHALMOLOGYOPDDRSURGERYADVICE = "CLEAROPTHALMOLOGYOPDDRSURGERYADVICE";

export const GETOPHTHALMOLOGYOPDVISIONCHART = "GETOPHTHALMOLOGYOPDVISIONCHART";
export const CREATEOPHTHALMOLOGYOPDVISIONCHART = "CREATEOPHTHALMOLOGYOPDVISIONCHART";
export const UPDATEOPHTHALMOLOGYOPDVISIONCHART = "UPDATEOPHTHALMOLOGYOPDVISIONCHART";
export const DELETEOPHTHALMOLOGYOPDVISIONCHART = "DELETEOPHTHALMOLOGYOPDVISIONCHART";
export const GETOPHTHALMOLOGYOPDREFRACTION = "GETOPHTHALMOLOGYOPDREFRACTION";
export const CREATEOPHTHALMOLOGYOPDREFRACTION = "CREATEOPHTHALMOLOGYOPDREFRACTION";
export const UPDATEOPHTHALMOLOGYOPDREFRACTION = "UPDATEOPHTHALMOLOGYOPDREFRACTION";
export const DELETEOPHTHALMOLOGYOPDREFRACTION = "DELETEOPHTHALMOLOGYOPDREFRACTION";
export const GETOPHTHALMOLOGYOPDGLASSLENSEPRESCRIPTION = "GETOPHTHALMOLOGYOPDGLASSLENSEPRESCRIPTION";
export const CREATEOPHTHALMOLOGYOPDGLASSLENSEPRESCRIPTION = "CREATEOPHTHALMOLOGYOPDGLASSLENSEPRESCRIPTION";
export const UPDATEOPHTHALMOLOGYOPDGLASSLENSEPRESCRIPTION = "UPDATEOPHTHALMOLOGYOPDGLASSLENSEPRESCRIPTION";
export const DELETEOPHTHALMOLOGYOPDGLASSLENSEPRESCRIPTION = "DELETEOPHTHALMOLOGYOPDGLASSLENSEPRESCRIPTION";
export const GETOPHTHALMOLOGYOPDASCAN = "GETOPHTHALMOLOGYOPDASCAN";
export const CREATEOPHTHALMOLOGYOPDASCAN = "CREATEOPHTHALMOLOGYOPDASCAN";
export const UPDATEOPHTHALMOLOGYOPDASCAN = "UPDATEOPHTHALMOLOGYOPDASCAN";
export const DELETEOPHTHALMOLOGYOPDASCAN = "DELETEOPHTHALMOLOGYOPDASCAN";
export const GETOPHTHALMOLOGYOPDCOVERTESTEOM = "GETOPHTHALMOLOGYOPDCOVERTESTEOM";
export const CREATEOPHTHALMOLOGYOPDCOVERTESTEOM = "CREATEOPHTHALMOLOGYOPDCOVERTESTEOM";
export const UPDATEOPHTHALMOLOGYOPDCOVERTESTEOM = "UPDATEOPHTHALMOLOGYOPDCOVERTESTEOM";
export const DELETEOPHTHALMOLOGYOPDCOVERTESTEOM = "DELETEOPHTHALMOLOGYOPDCOVERTESTEOM";
export const GETOPHTHALMOLOGYOPDKERATOMETRY = "GETOPHTHALMOLOGYOPDKERATOMETRY";
export const CREATEOPHTHALMOLOGYOPDKERATOMETRY = "CREATEOPHTHALMOLOGYOPDKERATOMETRY";
export const UPDATEOPHTHALMOLOGYOPDKERATOMETRY = "UPDATEOPHTHALMOLOGYOPDKERATOMETRY";
export const DELETEOPHTHALMOLOGYOPDKERATOMETRY = "DELETEOPHTHALMOLOGYOPDKERATOMETRY";
export const GETOPHTHALMOLOGYOPDPACHYMETRY = "GETOPHTHALMOLOGYOPDPACHYMETRY";
export const CREATEOPHTHALMOLOGYOPDPACHYMETRY = "CREATEOPHTHALMOLOGYOPDPACHYMETRY";
export const UPDATEOPHTHALMOLOGYOPDPACHYMETRY = "UPDATEOPHTHALMOLOGYOPDPACHYMETRY";
export const DELETEOPHTHALMOLOGYOPDPACHYMETRY = "DELETEOPHTHALMOLOGYOPDPACHYMETRY";
export const GETOPHTHALMOLOGYOPDSYRINGING = "GETOPHTHALMOLOGYOPDSYRINGING";
export const CREATEOPHTHALMOLOGYOPDSYRINGING = "CREATEOPHTHALMOLOGYOPDSYRINGING";
export const UPDATEOPHTHALMOLOGYOPDSYRINGING = "UPDATEOPHTHALMOLOGYOPDSYRINGING";
export const DELETEOPHTHALMOLOGYOPDSYRINGING = "DELETEOPHTHALMOLOGYOPDSYRINGING";
export const GETOPHTHALMOLOGYOPDIOP = "GETOPHTHALMOLOGYOPDIOP";
export const CREATEOPHTHALMOLOGYOPDIOP = "CREATEOPHTHALMOLOGYOPDIOP";
export const UPDATEOPHTHALMOLOGYOPDIOP = "UPDATEOPHTHALMOLOGYOPDIOP";
export const DELETEOPHTHALMOLOGYOPDIOP = "DELETEOPHTHALMOLOGYOPDIOP";
export const GETOPHTHALMOLOGYOPDCOLORVISION = "GETOPHTHALMOLOGYOPDCOLORVISION";
export const CREATEOPHTHALMOLOGYOPDCOLORVISION = "CREATEOPHTHALMOLOGYOPDCOLORVISION";
export const UPDATEOPHTHALMOLOGYOPDCOLORVISION = "UPDATEOPHTHALMOLOGYOPDCOLORVISION";
export const DELETEOPHTHALMOLOGYOPDCOLORVISION = "DELETEOPHTHALMOLOGYOPDCOLORVISION";
export const GETOPHTHALMOLOGYOPDFUNDUS = "GETOPHTHALMOLOGYOPDFUNDUS";
export const CREATEOPHTHALMOLOGYOPDFUNDUS = "CREATEOPHTHALMOLOGYOPDFUNDUS";
export const UPDATEOPHTHALMOLOGYOPDFUNDUS = "UPDATEOPHTHALMOLOGYOPDFUNDUS";
export const DELETEOPHTHALMOLOGYOPDFUNDUS = "DELETEOPHTHALMOLOGYOPDFUNDUS";
export const GETOPHTHALMOLOGYOPDGLAUCOMA = "GETOPHTHALMOLOGYOPDGLAUCOMA";
export const CREATEOPHTHALMOLOGYOPDGLAUCOMA = "CREATEOPHTHALMOLOGYOPDGLAUCOMA";
export const UPDATEOPHTHALMOLOGYOPDGLAUCOMA = "UPDATEOPHTHALMOLOGYOPDGLAUCOMA";
export const DELETEOPHTHALMOLOGYOPDGLAUCOMA = "DELETEOPHTHALMOLOGYOPDGLAUCOMA";

export const GETSETUPOPTICDOCWORKPUPILSIZEODRE = "GETSETUPOPTICDOCWORKPUPILSIZEODRE";
export const CREATESETUPOPTICDOCWORKPUPILSIZEODRE = "CREATESETUPOPTICDOCWORKPUPILSIZEODRE";
export const UPDATESETUPOPTICDOCWORKPUPILSIZEODRE = "UPDATESETUPOPTICDOCWORKPUPILSIZEODRE";
export const DELETESETUPOPTICDOCWORKPUPILSIZEODRE = "DELETESETUPOPTICDOCWORKPUPILSIZEODRE";

export const GETSETUPOPTICDOCWORKPUPILSHAPEODRE = "GETSETUPOPTICDOCWORKPUPILSHAPEODRE";
export const CREATESETUPOPTICDOCWORKPUPILSHAPEODRE = "CREATESETUPOPTICDOCWORKPUPILSHAPEODRE";
export const UPDATESETUPOPTICDOCWORKPUPILSHAPEODRE = "UPDATESETUPOPTICDOCWORKPUPILSHAPEODRE";
export const DELETESETUPOPTICDOCWORKPUPILSHAPEODRE = "DELETESETUPOPTICDOCWORKPUPILSHAPEODRE";

export const GETSETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE = "GETSETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE";
export const CREATESETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE = "CREATESETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE";
export const UPDATESETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE = "UPDATESETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE";
export const DELETESETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE = "DELETESETUPOPTICDOCWORKPUPILREACTTOLIGHTODRE";

export const GETSETUPOPTICDOCWORKPUPILREACTTONEARODRE = "GETSETUPOPTICDOCWORKPUPILREACTTONEARODRE";
export const CREATESETUPOPTICDOCWORKPUPILREACTTONEARODRE = "CREATESETUPOPTICDOCWORKPUPILREACTTONEARODRE";
export const UPDATESETUPOPTICDOCWORKPUPILREACTTONEARODRE = "UPDATESETUPOPTICDOCWORKPUPILREACTTONEARODRE";
export const DELETESETUPOPTICDOCWORKPUPILREACTTONEARODRE = "DELETESETUPOPTICDOCWORKPUPILREACTTONEARODRE";

export const GETSETUPOPTICDOCWORKLENSEABNORMALODRE = "GETSETUPOPTICDOCWORKLENSEABNORMALODRE";
export const CREATESETUPOPTICDOCWORKLENSEABNORMALODRE = "CREATESETUPOPTICDOCWORKLENSEABNORMALODRE";
export const UPDATESETUPOPTICDOCWORKLENSEABNORMALODRE = "UPDATESETUPOPTICDOCWORKLENSEABNORMALODRE";
export const DELETESETUPOPTICDOCWORKLENSEABNORMALODRE = "DELETESETUPOPTICDOCWORKLENSEABNORMALODRE";

export const GETSETUPOPTICDOCWORKDRAWGONISCOPYODRE = "GETSETUPOPTICDOCWORKDRAWGONISCOPYODRE";
export const CREATESETUPOPTICDOCWORKDRAWGONISCOPYODRE = "CREATESETUPOPTICDOCWORKDRAWGONISCOPYODRE";
export const UPDATESETUPOPTICDOCWORKDRAWGONISCOPYODRE = "UPDATESETUPOPTICDOCWORKDRAWGONISCOPYODRE";
export const DELETESETUPOPTICDOCWORKDRAWGONISCOPYODRE = "DELETESETUPOPTICDOCWORKDRAWGONISCOPYODRE";

export const GETSETUPOPTICCOUNSELLWORKSURGERYPROCEDUREOPRATETYPE = "GETSETUPOPTICCOUNSELLWORKSURGERYPROCEDUREOPRATETYPE";
export const CREATESETUPOPTICCOUNSELLWORKSURGERYPROCEDUREOPRATETYPE = "CREATESETUPOPTICCOUNSELLWORKSURGERYPROCEDUREOPRATETYPE";
export const UPDATESETUPOPTICCOUNSELLWORKSURGERYPROCEDUREOPRATETYPE = "UPDATESETUPOPTICCOUNSELLWORKSURGERYPROCEDUREOPRATETYPE";
export const DELETESETUPOPTICCOUNSELLWORKSURGERYPROCEDUREOPRATETYPE = "DELETESETUPOPTICCOUNSELLWORKSURGERYPROCEDUREOPRATETYPE";

export const GETSETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE = "GETSETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE";
export const CREATESETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE = "CREATESETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE";
export const UPDATESETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE = "UPDATESETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE";
export const DELETESETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE = "DELETESETUPOPTICCOUNSELLWORKCOUNSELLORSURGERYTYPE";
export const GETSETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE = "GETSETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE";
export const CREATESETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE = "CREATESETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE";
export const UPDATESETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE = "UPDATESETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE";
export const DELETESETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE = "DELETESETUPOPTICCOUNSELLWORKCOUNSELLORIOLIMPLANTTYPE";
export const GETSETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT = "GETSETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT";
export const CREATESETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT = "CREATESETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT";
export const UPDATESETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT = "UPDATESETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT";
export const DELETESETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT = "DELETESETUPOPTICCOUNSELLWORKESTIMATEDISCOUNT";
export const GETSETUPOPTICPROCEDURENEWGLASSLENSETYPEOD = "GETSETUPOPTICPROCEDURENEWGLASSLENSETYPEOD";
export const CREATESETUPOPTICPROCEDURENEWGLASSLENSETYPEOD = "CREATESETUPOPTICPROCEDURENEWGLASSLENSETYPEOD";
export const UPDATESETUPOPTICPROCEDURENEWGLASSLENSETYPEOD = "UPDATESETUPOPTICPROCEDURENEWGLASSLENSETYPEOD";
export const DELETESETUPOPTICPROCEDURENEWGLASSLENSETYPEOD = "DELETESETUPOPTICPROCEDURENEWGLASSLENSETYPEOD";

export const GETSETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD = "GETSETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD";
export const CREATESETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD = "CREATESETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD";
export const UPDATESETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD = "UPDATESETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD";
export const DELETESETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD = "DELETESETUPOPTICPROCEDURENEWGLASSLENSEMATERIALOD";

export const GETSETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD = "GETSETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD";
export const CREATESETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD = "CREATESETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD";
export const UPDATESETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD = "UPDATESETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD";
export const DELETESETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD = "DELETESETUPOPTICPROCEDURENEWGLASSLENSESTYLEOD";

export const GETSETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD = "GETSETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD";
export const CREATESETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD = "CREATESETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD";
export const UPDATESETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD = "UPDATESETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD";
export const DELETESETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD = "DELETESETUPOPTICPROCEDURENEWGLASSLENSETHICKNESSTYPEOD";

export const GETSETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE = "GETSETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE";
export const CREATESETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE = "CREATESETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE";
export const UPDATESETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE = "UPDATESETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE";
export const DELETESETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE = "DELETESETUPOPTICPROCEDURENEWGLASSLABCOATINGTYPE";

export const GETSETUPOPTICPROCEDURENEWGLASSFACTORYCOATING = "GETSETUPOPTICPROCEDURENEWGLASSFACTORYCOATING";
export const CREATESETUPOPTICPROCEDURENEWGLASSFACTORYCOATING = "CREATESETUPOPTICPROCEDURENEWGLASSFACTORYCOATING";
export const UPDATESETUPOPTICPROCEDURENEWGLASSFACTORYCOATING = "UPDATESETUPOPTICPROCEDURENEWGLASSFACTORYCOATING";
export const DELETESETUPOPTICPROCEDURENEWGLASSFACTORYCOATING = "DELETESETUPOPTICPROCEDURENEWGLASSFACTORYCOATING";
export const GETSETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL = "GETSETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL";
export const CREATESETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL = "CREATESETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL";
export const UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL = "UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL";
export const DELETESETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL = "DELETESETUPOPTICPROCEDURENEWGLASSFRAMEMATERIAL";
export const GETSETUPOPTICPROCEDURENEWGLASSBEVEL = "GETSETUPOPTICPROCEDURENEWGLASSBEVEL";
export const CREATESETUPOPTICPROCEDURENEWGLASSBEVEL = "CREATESETUPOPTICPROCEDURENEWGLASSBEVEL";
export const UPDATESETUPOPTICPROCEDURENEWGLASSBEVEL = "UPDATESETUPOPTICPROCEDURENEWGLASSBEVEL";
export const DELETESETUPOPTICPROCEDURENEWGLASSBEVEL = "DELETESETUPOPTICPROCEDURENEWGLASSBEVEL";
export const GETSETUPOPTICPROCEDURENEWGLASSEDGES = "GETSETUPOPTICPROCEDURENEWGLASSEDGES";
export const CREATESETUPOPTICPROCEDURENEWGLASSEDGES = "CREATESETUPOPTICPROCEDURENEWGLASSEDGES";
export const UPDATESETUPOPTICPROCEDURENEWGLASSEDGES = "UPDATESETUPOPTICPROCEDURENEWGLASSEDGES";
export const DELETESETUPOPTICPROCEDURENEWGLASSEDGES = "DELETESETUPOPTICPROCEDURENEWGLASSEDGES";
export const GETSETUPOPTICPROCEDURENEWGLASSTINTTYPE = "GETSETUPOPTICPROCEDURENEWGLASSTINTTYPE";
export const CREATESETUPOPTICPROCEDURENEWGLASSTINTTYPE = "CREATESETUPOPTICPROCEDURENEWGLASSTINTTYPE";
export const UPDATESETUPOPTICPROCEDURENEWGLASSTINTTYPE = "UPDATESETUPOPTICPROCEDURENEWGLASSTINTTYPE";
export const DELETESETUPOPTICPROCEDURENEWGLASSTINTTYPE = "DELETESETUPOPTICPROCEDURENEWGLASSTINTTYPE";
export const GETSETUPOPTICPROCEDURENEWGLASSFRAMEID = "GETSETUPOPTICPROCEDURENEWGLASSFRAMEID";
export const CREATESETUPOPTICPROCEDURENEWGLASSFRAMEID = "CREATESETUPOPTICPROCEDURENEWGLASSFRAMEID";
export const UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEID = "UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEID";
export const DELETESETUPOPTICPROCEDURENEWGLASSFRAMEID = "DELETESETUPOPTICPROCEDURENEWGLASSFRAMEID";
export const GETSETUPOPTICPROCEDURENEWGLASSEYESIZE = "GETSETUPOPTICPROCEDURENEWGLASSEYESIZE";
export const CREATESETUPOPTICPROCEDURENEWGLASSEYESIZE = "CREATESETUPOPTICPROCEDURENEWGLASSEYESIZE";
export const UPDATESETUPOPTICPROCEDURENEWGLASSEYESIZE = "UPDATESETUPOPTICPROCEDURENEWGLASSEYESIZE";
export const DELETESETUPOPTICPROCEDURENEWGLASSEYESIZE = "DELETESETUPOPTICPROCEDURENEWGLASSEYESIZE";
export const GETSETUPOPTICPROCEDURENEWGLASSEYERATIO = "GETSETUPOPTICPROCEDURENEWGLASSEYERATIO";
export const CREATESETUPOPTICPROCEDURENEWGLASSEYERATIO = "CREATESETUPOPTICPROCEDURENEWGLASSEYERATIO";
export const UPDATESETUPOPTICPROCEDURENEWGLASSEYERATIO = "UPDATESETUPOPTICPROCEDURENEWGLASSEYERATIO";
export const DELETESETUPOPTICPROCEDURENEWGLASSEYERATIO = "DELETESETUPOPTICPROCEDURENEWGLASSEYERATIO";
export const GETSETUPOPTICPROCEDURENEWGLASSFRAMEBC = "GETSETUPOPTICPROCEDURENEWGLASSFRAMEBC";
export const CREATESETUPOPTICPROCEDURENEWGLASSFRAMEBC = "CREATESETUPOPTICPROCEDURENEWGLASSFRAMEBC";
export const UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEBC = "UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEBC";
export const DELETESETUPOPTICPROCEDURENEWGLASSFRAMEBC = "DELETESETUPOPTICPROCEDURENEWGLASSFRAMEBC";
export const GETSETUPOPTICPROCEDURENEWGLASSFRAMEMODEL = "GETSETUPOPTICPROCEDURENEWGLASSFRAMEMODEL";
export const CREATESETUPOPTICPROCEDURENEWGLASSFRAMEMODEL = "CREATESETUPOPTICPROCEDURENEWGLASSFRAMEMODEL";
export const UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEMODEL = "UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEMODEL";
export const DELETESETUPOPTICPROCEDURENEWGLASSFRAMEMODEL = "DELETESETUPOPTICPROCEDURENEWGLASSFRAMEMODEL";
export const GETSETUPOPTICPROCEDURENEWGLASSFRAMEDBL = "GETSETUPOPTICPROCEDURENEWGLASSFRAMEDBL";
export const CREATESETUPOPTICPROCEDURENEWGLASSFRAMEDBL = "CREATESETUPOPTICPROCEDURENEWGLASSFRAMEDBL";
export const UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEDBL = "UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEDBL";
export const DELETESETUPOPTICPROCEDURENEWGLASSFRAMEDBL = "DELETESETUPOPTICPROCEDURENEWGLASSFRAMEDBL";
export const GETSETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF = "GETSETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF";
export const CREATESETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF = "CREATESETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF";
export const UPDATESETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF = "UPDATESETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF";
export const DELETESETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF = "DELETESETUPOPTICPROCEDURENEWGLASSSTABILITYCOEFF";
export const GETSETUPOPTICPROCEDURENEWGLASSFRAMESHAPE = "GETSETUPOPTICPROCEDURENEWGLASSFRAMESHAPE";
export const CREATESETUPOPTICPROCEDURENEWGLASSFRAMESHAPE = "CREATESETUPOPTICPROCEDURENEWGLASSFRAMESHAPE";
export const UPDATESETUPOPTICPROCEDURENEWGLASSFRAMESHAPE = "UPDATESETUPOPTICPROCEDURENEWGLASSFRAMESHAPE";
export const DELETESETUPOPTICPROCEDURENEWGLASSFRAMESHAPE = "DELETESETUPOPTICPROCEDURENEWGLASSFRAMESHAPE";
export const GETSETUPOPTICPROCEDURENEWGLASSVENDOR = "GETSETUPOPTICPROCEDURENEWGLASSVENDOR";
export const CREATESETUPOPTICPROCEDURENEWGLASSVENDOR = "CREATESETUPOPTICPROCEDURENEWGLASSVENDOR";
export const UPDATESETUPOPTICPROCEDURENEWGLASSVENDOR = "UPDATESETUPOPTICPROCEDURENEWGLASSVENDOR";
export const DELETESETUPOPTICPROCEDURENEWGLASSVENDOR = "DELETESETUPOPTICPROCEDURENEWGLASSVENDOR";
export const GETSETUPOPTICPROCEDURENEWGLASSFRAMETMPL = "GETSETUPOPTICPROCEDURENEWGLASSFRAMETMPL";
export const CREATESETUPOPTICPROCEDURENEWGLASSFRAMETMPL = "CREATESETUPOPTICPROCEDURENEWGLASSFRAMETMPL";
export const UPDATESETUPOPTICPROCEDURENEWGLASSFRAMETMPL = "UPDATESETUPOPTICPROCEDURENEWGLASSFRAMETMPL";
export const DELETESETUPOPTICPROCEDURENEWGLASSFRAMETMPL = "DELETESETUPOPTICPROCEDURENEWGLASSFRAMETMPL";
export const GETSETUPOPTICPROCEDURENEWGLASSECXX = "GETSETUPOPTICPROCEDURENEWGLASSECXX";
export const CREATESETUPOPTICPROCEDURENEWGLASSECXX = "CREATESETUPOPTICPROCEDURENEWGLASSECXX";
export const UPDATESETUPOPTICPROCEDURENEWGLASSECXX = "UPDATESETUPOPTICPROCEDURENEWGLASSECXX";
export const DELETESETUPOPTICPROCEDURENEWGLASSECXX = "DELETESETUPOPTICPROCEDURENEWGLASSECXX";
export const GETSETUPOPTICPROCEDURENEWGLASSFRAMESOURCE = "GETSETUPOPTICPROCEDURENEWGLASSFRAMESOURCE";
export const CREATESETUPOPTICPROCEDURENEWGLASSFRAMESOURCE = "CREATESETUPOPTICPROCEDURENEWGLASSFRAMESOURCE";
export const UPDATESETUPOPTICPROCEDURENEWGLASSFRAMESOURCE = "UPDATESETUPOPTICPROCEDURENEWGLASSFRAMESOURCE";
export const DELETESETUPOPTICPROCEDURENEWGLASSFRAMESOURCE = "DELETESETUPOPTICPROCEDURENEWGLASSFRAMESOURCE";
export const GETSETUPOPTICPROCEDURENEWGLASSMANUFACTURE = "GETSETUPOPTICPROCEDURENEWGLASSMANUFACTURE";
export const CREATESETUPOPTICPROCEDURENEWGLASSMANUFACTURE = "CREATESETUPOPTICPROCEDURENEWGLASSMANUFACTURE";
export const UPDATESETUPOPTICPROCEDURENEWGLASSMANUFACTURE = "UPDATESETUPOPTICPROCEDURENEWGLASSMANUFACTURE";
export const DELETESETUPOPTICPROCEDURENEWGLASSMANUFACTURE = "DELETESETUPOPTICPROCEDURENEWGLASSMANUFACTURE";
export const GETSETUPOPTICPROCEDURENEWGLASSBDIM = "GETSETUPOPTICPROCEDURENEWGLASSBDIM";
export const CREATESETUPOPTICPROCEDURENEWGLASSBDIM = "CREATESETUPOPTICPROCEDURENEWGLASSBDIM";
export const UPDATESETUPOPTICPROCEDURENEWGLASSBDIM = "UPDATESETUPOPTICPROCEDURENEWGLASSBDIM";
export const DELETESETUPOPTICPROCEDURENEWGLASSBDIM = "DELETESETUPOPTICPROCEDURENEWGLASSBDIM";
export const GETSETUPOPTICPROCEDURENEWGLASSECXY = "GETSETUPOPTICPROCEDURENEWGLASSECXY";
export const CREATESETUPOPTICPROCEDURENEWGLASSECXY = "CREATESETUPOPTICPROCEDURENEWGLASSECXY";
export const UPDATESETUPOPTICPROCEDURENEWGLASSECXY = "UPDATESETUPOPTICPROCEDURENEWGLASSECXY";
export const DELETESETUPOPTICPROCEDURENEWGLASSECXY = "DELETESETUPOPTICPROCEDURENEWGLASSECXY";
export const GETSETUPOPTICPROCEDURENEWGLASSFRAMETYPE = "GETSETUPOPTICPROCEDURENEWGLASSFRAMETYPE";
export const CREATESETUPOPTICPROCEDURENEWGLASSFRAMETYPE = "CREATESETUPOPTICPROCEDURENEWGLASSFRAMETYPE";
export const UPDATESETUPOPTICPROCEDURENEWGLASSFRAMETYPE = "UPDATESETUPOPTICPROCEDURENEWGLASSFRAMETYPE";
export const DELETESETUPOPTICPROCEDURENEWGLASSFRAMETYPE = "DELETESETUPOPTICPROCEDURENEWGLASSFRAMETYPE";
export const GETSETUPOPTICPROCEDURENEWGLASSBRAND = "GETSETUPOPTICPROCEDURENEWGLASSBRAND";
export const CREATESETUPOPTICPROCEDURENEWGLASSBRAND = "CREATESETUPOPTICPROCEDURENEWGLASSBRAND";
export const UPDATESETUPOPTICPROCEDURENEWGLASSBRAND = "UPDATESETUPOPTICPROCEDURENEWGLASSBRAND";
export const DELETESETUPOPTICPROCEDURENEWGLASSBRAND = "DELETESETUPOPTICPROCEDURENEWGLASSBRAND";
export const GETSETUPOPTICPROCEDURENEWGLASSCIRCUM = "GETSETUPOPTICPROCEDURENEWGLASSCIRCUM";
export const CREATESETUPOPTICPROCEDURENEWGLASSCIRCUM = "CREATESETUPOPTICPROCEDURENEWGLASSCIRCUM";
export const UPDATESETUPOPTICPROCEDURENEWGLASSCIRCUM = "UPDATESETUPOPTICPROCEDURENEWGLASSCIRCUM";
export const DELETESETUPOPTICPROCEDURENEWGLASSCIRCUM = "DELETESETUPOPTICPROCEDURENEWGLASSCIRCUM";
export const GETSETUPOPTICPROCEDURENEWGLASSECXZ = "GETSETUPOPTICPROCEDURENEWGLASSECXZ";
export const CREATESETUPOPTICPROCEDURENEWGLASSECXZ = "CREATESETUPOPTICPROCEDURENEWGLASSECXZ";
export const UPDATESETUPOPTICPROCEDURENEWGLASSECXZ = "UPDATESETUPOPTICPROCEDURENEWGLASSECXZ";
export const DELETESETUPOPTICPROCEDURENEWGLASSECXZ = "DELETESETUPOPTICPROCEDURENEWGLASSECXZ";
export const GETSETUPOPTICPROCEDURENEWGLASSCOLLECTION = "GETSETUPOPTICPROCEDURENEWGLASSCOLLECTION";
export const CREATESETUPOPTICPROCEDURENEWGLASSCOLLECTION = "CREATESETUPOPTICPROCEDURENEWGLASSCOLLECTION";
export const UPDATESETUPOPTICPROCEDURENEWGLASSCOLLECTION = "UPDATESETUPOPTICPROCEDURENEWGLASSCOLLECTION";
export const DELETESETUPOPTICPROCEDURENEWGLASSCOLLECTION = "DELETESETUPOPTICPROCEDURENEWGLASSCOLLECTION";
export const GETSETUPOPTICPROCEDURENEWGLASSFRAMEED = "GETSETUPOPTICPROCEDURENEWGLASSFRAMEED";
export const CREATESETUPOPTICPROCEDURENEWGLASSFRAMEED = "CREATESETUPOPTICPROCEDURENEWGLASSFRAMEED";
export const UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEED = "UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEED";
export const DELETESETUPOPTICPROCEDURENEWGLASSFRAMEED = "DELETESETUPOPTICPROCEDURENEWGLASSFRAMEED";
export const GETSETUPOPTICPROCEDURENEWGLASSREAD = "GETSETUPOPTICPROCEDURENEWGLASSREAD";
export const CREATESETUPOPTICPROCEDURENEWGLASSREAD = "CREATESETUPOPTICPROCEDURENEWGLASSREAD";
export const UPDATESETUPOPTICPROCEDURENEWGLASSREAD = "UPDATESETUPOPTICPROCEDURENEWGLASSREAD";
export const DELETESETUPOPTICPROCEDURENEWGLASSREAD = "DELETESETUPOPTICPROCEDURENEWGLASSREAD";
export const GETSETUPOPTICPROCEDURENEWGLASSFRAMECOLOR = "GETSETUPOPTICPROCEDURENEWGLASSFRAMECOLOR";
export const CREATESETUPOPTICPROCEDURENEWGLASSFRAMECOLOR = "CREATESETUPOPTICPROCEDURENEWGLASSFRAMECOLOR";
export const UPDATESETUPOPTICPROCEDURENEWGLASSFRAMECOLOR = "UPDATESETUPOPTICPROCEDURENEWGLASSFRAMECOLOR";
export const DELETESETUPOPTICPROCEDURENEWGLASSFRAMECOLOR = "DELETESETUPOPTICPROCEDURENEWGLASSFRAMECOLOR";
export const GETSETUPOPTICPROCEDURENEWGLASSPANTO = "GETSETUPOPTICPROCEDURENEWGLASSPANTO";
export const CREATESETUPOPTICPROCEDURENEWGLASSPANTO = "CREATESETUPOPTICPROCEDURENEWGLASSPANTO";
export const UPDATESETUPOPTICPROCEDURENEWGLASSPANTO = "UPDATESETUPOPTICPROCEDURENEWGLASSPANTO";
export const DELETESETUPOPTICPROCEDURENEWGLASSPANTO = "DELETESETUPOPTICPROCEDURENEWGLASSPANTO";
export const GETSETUPOPTICPROCEDURENEWGLASSHEADCAPE = "GETSETUPOPTICPROCEDURENEWGLASSHEADCAPE";
export const CREATESETUPOPTICPROCEDURENEWGLASSHEADCAPE = "CREATESETUPOPTICPROCEDURENEWGLASSHEADCAPE";
export const UPDATESETUPOPTICPROCEDURENEWGLASSHEADCAPE = "UPDATESETUPOPTICPROCEDURENEWGLASSHEADCAPE";
export const DELETESETUPOPTICPROCEDURENEWGLASSHEADCAPE = "DELETESETUPOPTICPROCEDURENEWGLASSHEADCAPE";
export const GETSETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL = "GETSETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL";
export const CREATESETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL = "CREATESETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL";
export const UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL = "UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL";
export const DELETESETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL = "DELETESETUPOPTICPROCEDURENEWGLASSFRAMEDETAILMATERIAL";
export const GETSETUPOPTICPROCEDURENEWGLASSFRAMEFIT = "GETSETUPOPTICPROCEDURENEWGLASSFRAMEFIT";
export const CREATESETUPOPTICPROCEDURENEWGLASSFRAMEFIT = "CREATESETUPOPTICPROCEDURENEWGLASSFRAMEFIT";
export const UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEFIT = "UPDATESETUPOPTICPROCEDURENEWGLASSFRAMEFIT";
export const DELETESETUPOPTICPROCEDURENEWGLASSFRAMEFIT = "DELETESETUPOPTICPROCEDURENEWGLASSFRAMEFIT";
export const GETSETUPOPTICPROCEDURENEWGLASSCORRIDORR = "GETSETUPOPTICPROCEDURENEWGLASSCORRIDORR";
export const CREATESETUPOPTICPROCEDURENEWGLASSCORRIDORR = "CREATESETUPOPTICPROCEDURENEWGLASSCORRIDORR";
export const UPDATESETUPOPTICPROCEDURENEWGLASSCORRIDORR = "UPDATESETUPOPTICPROCEDURENEWGLASSCORRIDORR";
export const DELETESETUPOPTICPROCEDURENEWGLASSCORRIDORR = "DELETESETUPOPTICPROCEDURENEWGLASSCORRIDORR";
export const GETSETUPOPTICPROCEDURENEWGLASSWRAPANGLE = "GETSETUPOPTICPROCEDURENEWGLASSWRAPANGLE";
export const CREATESETUPOPTICPROCEDURENEWGLASSWRAPANGLE = "CREATESETUPOPTICPROCEDURENEWGLASSWRAPANGLE";
export const UPDATESETUPOPTICPROCEDURENEWGLASSWRAPANGLE = "UPDATESETUPOPTICPROCEDURENEWGLASSWRAPANGLE";
export const DELETESETUPOPTICPROCEDURENEWGLASSWRAPANGLE = "DELETESETUPOPTICPROCEDURENEWGLASSWRAPANGLE";
export const GETSETUPOPTICPROCEDURENEWGLASSCORRIDORL = "GETSETUPOPTICPROCEDURENEWGLASSCORRIDORL";
export const CREATESETUPOPTICPROCEDURENEWGLASSCORRIDORL = "CREATESETUPOPTICPROCEDURENEWGLASSCORRIDORL";
export const UPDATESETUPOPTICPROCEDURENEWGLASSCORRIDORL = "UPDATESETUPOPTICPROCEDURENEWGLASSCORRIDORL";
export const DELETESETUPOPTICPROCEDURENEWGLASSCORRIDORL = "DELETESETUPOPTICPROCEDURENEWGLASSCORRIDORL";
export const GETSETUPOPTICPROCEDURENEWGLASSFRAMESTATUS = "GETSETUPOPTICPROCEDURENEWGLASSFRAMESTATUS";
export const CREATESETUPOPTICPROCEDURENEWGLASSFRAMESTATUS = "CREATESETUPOPTICPROCEDURENEWGLASSFRAMESTATUS";
export const UPDATESETUPOPTICPROCEDURENEWGLASSFRAMESTATUS = "UPDATESETUPOPTICPROCEDURENEWGLASSFRAMESTATUS";
export const DELETESETUPOPTICPROCEDURENEWGLASSFRAMESTATUS = "DELETESETUPOPTICPROCEDURENEWGLASSFRAMESTATUS";
export const GETSETUPOPTICPROCEDURESURGERYPROCUDEURETYPE = "GETSETUPOPTICPROCEDURESURGERYPROCUDEURETYPE";
export const CREATESETUPOPTICPROCEDURESURGERYPROCUDEURETYPE = "CREATESETUPOPTICPROCEDURESURGERYPROCUDEURETYPE";
export const UPDATESETUPOPTICPROCEDURESURGERYPROCUDEURETYPE = "UPDATESETUPOPTICPROCEDURESURGERYPROCUDEURETYPE";
export const DELETESETUPOPTICPROCEDURESURGERYPROCUDEURETYPE = "DELETESETUPOPTICPROCEDURESURGERYPROCUDEURETYPE";
export const GETSETUPOPTICPROCEDURESURGERYPROCUDEURENAME = "GETSETUPOPTICPROCEDURESURGERYPROCUDEURENAME";
export const CREATESETUPOPTICPROCEDURESURGERYPROCUDEURENAME = "CREATESETUPOPTICPROCEDURESURGERYPROCUDEURENAME";
export const UPDATESETUPOPTICPROCEDURESURGERYPROCUDEURENAME = "UPDATESETUPOPTICPROCEDURESURGERYPROCUDEURENAME";
export const DELETESETUPOPTICPROCEDURESURGERYPROCUDEURENAME = "DELETESETUPOPTICPROCEDURESURGERYPROCUDEURENAME";
export const GETSETUPOPTICPROCEDURELASIKSURGERYPOWERUSED = "GETSETUPOPTICPROCEDURELASIKSURGERYPOWERUSED";
export const CREATESETUPOPTICPROCEDURELASIKSURGERYPOWERUSED = "CREATESETUPOPTICPROCEDURELASIKSURGERYPOWERUSED";
export const UPDATESETUPOPTICPROCEDURELASIKSURGERYPOWERUSED = "UPDATESETUPOPTICPROCEDURELASIKSURGERYPOWERUSED";
export const DELETESETUPOPTICPROCEDURELASIKSURGERYPOWERUSED = "DELETESETUPOPTICPROCEDURELASIKSURGERYPOWERUSED";

export const GETSETUPOPTICVISIONEYECHARTDISTANCE = "GETSETUPOPTICVISIONEYECHARTDISTANCE";
export const CREATESETUPOPTICVISIONEYECHARTDISTANCE = "CREATESETUPOPTICVISIONEYECHARTDISTANCE";
export const UPDATESETUPOPTICVISIONEYECHARTDISTANCE = "UPDATESETUPOPTICVISIONEYECHARTDISTANCE";
export const DELETESETUPOPTICVISIONEYECHARTDISTANCE = "DELETESETUPOPTICVISIONEYECHARTDISTANCE";
export const GETSETUPOPTICVISIONEYECHARTNEAR = "GETSETUPOPTICVISIONEYECHARTNEAR";
export const CREATESETUPOPTICVISIONEYECHARTNEAR = "CREATESETUPOPTICVISIONEYECHARTNEAR";
export const UPDATESETUPOPTICVISIONEYECHARTNEAR = "UPDATESETUPOPTICVISIONEYECHARTNEAR";
export const DELETESETUPOPTICVISIONEYECHARTNEAR = "DELETESETUPOPTICVISIONEYECHARTNEAR";
export const GETSETUPOPTICVISIONEYECHARTSPHERICAL = "GETSETUPOPTICVISIONEYECHARTSPHERICAL";
export const CREATESETUPOPTICVISIONEYECHARTSPHERICAL = "CREATESETUPOPTICVISIONEYECHARTSPHERICAL";
export const UPDATESETUPOPTICVISIONEYECHARTSPHERICAL = "UPDATESETUPOPTICVISIONEYECHARTSPHERICAL";
export const DELETESETUPOPTICVISIONEYECHARTSPHERICAL = "DELETESETUPOPTICVISIONEYECHARTSPHERICAL";
export const GETSETUPOPTICVISIONEYECHARTCYLINDERICAL = "GETSETUPOPTICVISIONEYECHARTCYLINDERICAL";
export const CREATESETUPOPTICVISIONEYECHARTCYLINDERICAL = "CREATESETUPOPTICVISIONEYECHARTCYLINDERICAL";
export const UPDATESETUPOPTICVISIONEYECHARTCYLINDERICAL = "UPDATESETUPOPTICVISIONEYECHARTCYLINDERICAL";
export const DELETESETUPOPTICVISIONEYECHARTCYLINDERICAL = "DELETESETUPOPTICVISIONEYECHARTCYLINDERICAL";
export const GETSETUPOPTICVISIONEYECHARTAXIS = "GETSETUPOPTICVISIONEYECHARTAXIS";
export const CREATESETUPOPTICVISIONEYECHARTAXIS = "CREATESETUPOPTICVISIONEYECHARTAXIS";
export const UPDATESETUPOPTICVISIONEYECHARTAXIS = "UPDATESETUPOPTICVISIONEYECHARTAXIS";
export const DELETESETUPOPTICVISIONEYECHARTAXIS = "DELETESETUPOPTICVISIONEYECHARTAXIS";
export const GETSETUPOPTICVISIONEYECHARTDIAMETER = "GETSETUPOPTICVISIONEYECHARTDIAMETER";
export const CREATESETUPOPTICVISIONEYECHARTDIAMETER = "CREATESETUPOPTICVISIONEYECHARTDIAMETER";
export const UPDATESETUPOPTICVISIONEYECHARTDIAMETER = "UPDATESETUPOPTICVISIONEYECHARTDIAMETER";
export const DELETESETUPOPTICVISIONEYECHARTDIAMETER = "DELETESETUPOPTICVISIONEYECHARTDIAMETER";

export const CREATEOPDOUTENDODONTICCHARTPRINT = "CREATEOPDOUTENDODONTICCHARTPRINT";
export const GETOPDOUTENDODONTICCHARTPRINT = "GETOPDOUTENDODONTICCHARTPRINT";
export const UPDATEOPDOUTENDODONTICCHARTPRINT = "UPDATEOPDOUTENDODONTICCHARTPRINT";
export const DELETEOPDOUTENDODONTICCHARTPRINT = "DELETEOPDOUTENDODONTICCHARTPRINT";
export const GETOPDOUTLABWORK = "GETOPDOUTLABWORK";
export const CREATEOPDOUTLABWORK = "CREATEOPDOUTLABWORK";
export const UPDATEOPDOUTLABWORK = "UPDATEOPDOUTLABWORK";
export const DELETEOPDOUTLABWORK = "DELETEOPDOUTLABWORK";

export const GETSETUPLABWORKMATERIALUSED = "GETSETUPLABWORKMATERIALUSED";
export const CREATESETUPLABWORKMATERIALUSED = "CREATESETUPLABWORKMATERIALUSED";
export const UPDATESETUPLABWORKMATERIALUSED = "UPDATESETUPLABWORKMATERIALUSED";
export const DELETESETUPLABWORKMATERIALUSED = "DELETESETUPLABWORKMATERIALUSED";
export const GETSETUPLABWORKUNIT = "GETSETUPLABWORKUNIT";
export const CREATESETUPLABWORKUNIT = "CREATESETUPLABWORKUNIT";
export const UPDATESETUPLABWORKUNIT = "UPDATESETUPLABWORKUNIT";
export const DELETESETUPLABWORKUNIT = "DELETESETUPLABWORKUNIT";
export const GETSETUPLABWORKSHADE = "GETSETUPLABWORKSHADE";
export const CREATESETUPLABWORKSHADE = "CREATESETUPLABWORKSHADE";
export const UPDATESETUPLABWORKSHADE = "UPDATESETUPLABWORKSHADE";
export const DELETESETUPLABWORKSHADE = "DELETESETUPLABWORKSHADE";
export const GETSETUPLABWORKSTATUS = "GETSETUPLABWORKSTATUS";
export const CREATESETUPLABWORKSTATUS = "CREATESETUPLABWORKSTATUS";
export const UPDATESETUPLABWORKSTATUS = "UPDATESETUPLABWORKSTATUS";
export const DELETESETUPLABWORKSTATUS = "DELETESETUPLABWORKSTATUS";
export const GETSETUPLABWORKLABNAME = "GETSETUPLABWORKLABNAME";
export const CREATESETUPLABWORKLABNAME = "CREATESETUPLABWORKLABNAME";
export const UPDATESETUPLABWORKLABNAME = "UPDATESETUPLABWORKLABNAME";
export const DELETESETUPLABWORKLABNAME = "DELETESETUPLABWORKLABNAME";

export const CREATEOPDOUTLABWORKPRINT = "CREATEOPDOUTLABWORKPRINT";
export const GETOPDOUTLABWORKPRINT = "GETOPDOUTLABWORKPRINT";
export const UPDATEOPDOUTLABWORKPRINT = "UPDATEOPDOUTLABWORKPRINT";
export const DELETEOPDOUTLABWORKPRINT = "DELETEOPDOUTLABWORKPRINT";
export const GETSETUPLABWORKRESTORATION = "GETSETUPLABWORKRESTORATION";
export const CREATESETUPLABWORKRESTORATION = "CREATESETUPLABWORKRESTORATION";
export const UPDATESETUPLABWORKRESTORATION = "UPDATESETUPLABWORKRESTORATION";
export const DELETESETUPLABWORKRESTORATION = "DELETESETUPLABWORKRESTORATION";

export const CREATEDENTALLABRECORDALLOY = "CREATEDENTALLABRECORDALLOY";
export const GETDENTALLABRECORDALLOY = "GETDENTALLABRECORDALLOY";
export const UPDATEDENTALLABRECORDALLOY = "UPDATEDENTALLABRECORDALLOY";
export const DELETEDENTALLABRECORDALLOY = "DELETEDENTALLABRECORDALLOY";
export const CREATEDENTALLABRECORDUNIT = "CREATEDENTALLABRECORDUNIT";
export const GETDENTALLABRECORDUNIT = "GETDENTALLABRECORDUNIT";
export const UPDATEDENTALLABRECORDUNIT = "UPDATEDENTALLABRECORDUNIT";
export const DELETEDENTALLABRECORDUNIT = "DELETEDENTALLABRECORDUNIT";
export const CREATEDENTALLABRECORDSHADE = "CREATEDENTALLABRECORDSHADE";
export const GETDENTALLABRECORDSHADE = "GETDENTALLABRECORDSHADE";
export const UPDATEDENTALLABRECORDSHADE = "UPDATEDENTALLABRECORDSHADE";
export const DELETEDENTALLABRECORDSHADE = "DELETEDENTALLABRECORDSHADE";
export const CREATEDENTALLABRECORDSTATUS = "CREATEDENTALLABRECORDSTATUS";
export const GETDENTALLABRECORDSTATUS = "GETDENTALLABRECORDSTATUS";
export const UPDATEDENTALLABRECORDSTATUS = "UPDATEDENTALLABRECORDSTATUS";
export const DELETEDENTALLABRECORDSTATUS = "DELETEDENTALLABRECORDSTATUS";
export const CREATEDENTALLABRECORDLABNAME = "CREATEDENTALLABRECORDLABNAME";
export const GETDENTALLABRECORDLABNAME = "GETDENTALLABRECORDLABNAME";
export const UPDATEDENTALLABRECORDLABNAME = "UPDATEDENTALLABRECORDLABNAME";
export const DELETEDENTALLABRECORDLABNAME = "DELETEDENTALLABRECORDLABNAME";

export const CREATEDENTALLABRECORDBILL = "CREATEDENTALLABRECORDBILL";
export const GETDENTALLABRECORDBILL = "GETDENTALLABRECORDBILL";
export const UPDATEDENTALLABRECORDBILL = "UPDATEDENTALLABRECORDBILL";
export const DELETEDENTALLABRECORDBILL = "DELETEDENTALLABRECORDBILL";
export const CREATEDENTALLABRECORDTRANSACTION = "CREATEDENTALLABRECORDTRANSACTION";
export const GETDENTALLABRECORDTRANSACTION = "GETDENTALLABRECORDTRANSACTION";
export const UPDATEDENTALLABRECORDTRANSACTION = "UPDATEDENTALLABRECORDTRANSACTION";
export const DELETEDENTALLABRECORDTRANSACTION = "DELETEDENTALLABRECORDTRANSACTION";
export const CREATEDENTALLABRECORDTEST = "CREATEDENTALLABRECORDTEST";
export const GETDENTALLABRECORDTEST = "GETDENTALLABRECORDTEST";
export const UPDATEDENTALLABRECORDTEST = "UPDATEDENTALLABRECORDTEST";
export const DELETEDENTALLABRECORDTEST = "DELETEDENTALLABRECORDTEST";


export const CREATEDENTALOPDOUTPERIOCHART = "CREATEDENTALOPDOUTPERIOCHART";
export const GETDENTALOPDOUTPERIOCHART = "GETDENTALOPDOUTPERIOCHART";
export const UPDATEDENTALOPDOUTPERIOCHART = "UPDATEDENTALOPDOUTPERIOCHART";
export const DELETEDENTALOPDOUTPERIOCHART = "DELETEDENTALOPDOUTPERIOCHART";

export const GETINVENTORYPURCHASEBILL = "GETINVENTORYPURCHASEBILL";
export const CREATEINVENTORYPURCHASEBILL = "CREATEINVENTORYPURCHASEBILL";
export const UPDATEINVENTORYPURCHASEBILL = "UPDATEINVENTORYPURCHASEBILL";
export const DELETEINVENTORYPURCHASEBILL = "DELETEINVENTORYPURCHASEBILL";
export const GETINVENTORYPURCHASEBILLTRANSACTION = "GETINVENTORYPURCHASEBILLTRANSACTION";
export const CREATEINVENTORYPURCHASEBILLTRANSACTION = "CREATEINVENTORYPURCHASEBILLTRANSACTION";
export const UPDATEINVENTORYPURCHASEBILLTRANSACTION = "UPDATEINVENTORYPURCHASEBILLTRANSACTION";
export const DELETEINVENTORYPURCHASEBILLTRANSACTION = "DELETEINVENTORYPURCHASEBILLTRANSACTION";

export const GETINVENTORYITEM = "GETINVENTORYITEM";
export const GETINVENTORYITEMQTY = "GETINVENTORYITEMQTY";
export const CREATEINVENTORYITEM = "CREATEINVENTORYITEM";
export const UPDATEINVENTORYITEM = "UPDATEINVENTORYITEM";
export const DELETEINVENTORYITEM = "DELETEINVENTORYITEM";
export const GETINVENTORYITEMBILL = "GETINVENTORYITEMBILL";
export const CREATEINVENTORYITEMBILL = "CREATEINVENTORYITEMBILL";
export const UPDATEINVENTORYITEMBILL = "UPDATEINVENTORYITEMBILL";
export const DELETEINVENTORYITEMBILL = "DELETEINVENTORYITEMBILL";
export const GETINVENTORYITEMBADSTOCK = "GETINVENTORYITEMBADSTOCK";
export const CREATEINVENTORYITEMBADSTOCK = "CREATEINVENTORYITEMBADSTOCK";
export const UPDATEINVENTORYITEMBADSTOCK = "UPDATEINVENTORYITEMBADSTOCK";
export const DELETEINVENTORYITEMBADSTOCK = "DELETEINVENTORYITEMBADSTOCK";
export const GETINVENTORYGENERATEBILL = "GETINVENTORYGENERATEBILL";
export const GETINVENTORYGENERATEBILLQTY = "GETINVENTORYGENERATEBILLQTY";
export const CREATEINVENTORYGENERATEBILL = "CREATEINVENTORYGENERATEBILL";
export const UPDATEINVENTORYGENERATEBILL = "UPDATEINVENTORYGENERATEBILL";
export const DELETEINVENTORYGENERATEBILL = "DELETEINVENTORYGENERATEBILL";
export const GETINVENTORYGENERATEBILLTRANSACTION = "GETINVENTORYGENERATEBILLTRANSACTION";
export const CREATEINVENTORYGENERATEBILLTRANSACTION = "CREATEINVENTORYGENERATEBILLTRANSACTION";
export const UPDATEINVENTORYGENERATEBILLTRANSACTION = "UPDATEINVENTORYGENERATEBILLTRANSACTION";
export const DELETEINVENTORYGENERATEBILLTRANSACTION = "DELETEINVENTORYGENERATEBILLTRANSACTION";
export const GETINVENTORYPURCHASESHOW = "GETINVENTORYPURCHASESHOW";
export const CREATEINVENTORYPURCHASESHOW = "CREATEINVENTORYPURCHASESHOW";
export const UPDATEINVENTORYPURCHASESHOW = "UPDATEINVENTORYPURCHASESHOW";
export const DELETEINVENTORYPURCHASESHOW = "DELETEINVENTORYPURCHASESHOW";
export const GETINVENTORYPURCHASEORDER = "GETINVENTORYPURCHASEORDER";
export const CREATEINVENTORYPURCHASEORDER = "CREATEINVENTORYPURCHASEORDER";
export const UPDATEINVENTORYPURCHASEORDER = "UPDATEINVENTORYPURCHASEORDER";
export const DELETEINVENTORYPURCHASEORDER = "DELETEINVENTORYPURCHASEORDER";
export const GETINVENTORYPURCHASEORDERSHOW = "GETINVENTORYPURCHASEORDERSHOW";
export const CREATEINVENTORYPURCHASEORDERSHOW = "CREATEINVENTORYPURCHASEORDERSHOW";
export const UPDATEINVENTORYPURCHASEORDERSHOW = "UPDATEINVENTORYPURCHASEORDERSHOW";
export const DELETEINVENTORYPURCHASEORDERSHOW = "DELETEINVENTORYPURCHASEORDERSHOW";
export const GETSETUPHRATTENDANCETYPE = "GETSETUPHRATTENDANCETYPE";
export const CREATESETUPHRATTENDANCETYPE = "CREATESETUPHRATTENDANCETYPE";
export const UPDATESETUPHRATTENDANCETYPE = "UPDATESETUPHRATTENDANCETYPE";
export const DELETESETUPHRATTENDANCETYPE = "DELETESETUPHRATTENDANCETYPE";
export const GETSETUPHRPROFESSIONALTAX = "GETSETUPHRPROFESSIONALTAX";
export const CREATESETUPHRPROFESSIONALTAX = "CREATESETUPHRPROFESSIONALTAX";
export const UPDATESETUPHRPROFESSIONALTAX = "UPDATESETUPHRPROFESSIONALTAX";
export const DELETESETUPHRPROFESSIONALTAX = "DELETESETUPHRPROFESSIONALTAX";
export const GETSETUPHRINCOMETAX = "GETSETUPHRINCOMETAX";
export const CREATESETUPHRINCOMETAX = "CREATESETUPHRINCOMETAX";
export const UPDATESETUPHRINCOMETAX = "UPDATESETUPHRINCOMETAX";
export const DELETESETUPHRINCOMETAX = "DELETESETUPHRINCOMETAX";
export const GETSETUPHRSURCHARGETAX = "GETSETUPHRSURCHARGETAX";
export const CREATESETUPHRSURCHARGETAX = "CREATESETUPHRSURCHARGETAX";
export const UPDATESETUPHRSURCHARGETAX = "UPDATESETUPHRSURCHARGETAX";
export const DELETESETUPHRSURCHARGETAX = "DELETESETUPHRSURCHARGETAX";
export const GETHRPAYROLLEARNINGDEDUCTION = "GETHRPAYROLLEARNINGDEDUCTION";
export const CREATEHRPAYROLLEARNINGDEDUCTION = "CREATEHRPAYROLLEARNINGDEDUCTION";
export const UPDATEHRPAYROLLEARNINGDEDUCTION = "UPDATEHRPAYROLLEARNINGDEDUCTION";
export const DELETEHRPAYROLLEARNINGDEDUCTION = "DELETEHRPAYROLLEARNINGDEDUCTION";
export const GETSETUPHRCESSTAX = "GETSETUPHRCESSTAX";
export const CREATESETUPHRCESSTAX = "CREATESETUPHRCESSTAX";
export const UPDATESETUPHRCESSTAX = "UPDATESETUPHRCESSTAX";
export const DELETESETUPHRCESSTAX = "DELETESETUPHRCESSTAX";
export const GETSETUPHRTEMPLATE = "GETSETUPHRTEMPLATE";
export const CREATESETUPHRTEMPLATE = "CREATESETUPHRTEMPLATE";
export const UPDATESETUPHRTEMPLATE = "UPDATESETUPHRTEMPLATE";
export const DELETESETUPHRTEMPLATE = "DELETESETUPHRTEMPLATE";
export const GETSETUPHRSURVEYTEMPLATE = "GETSETUPHRSURVEYTEMPLATE";
export const CREATESETUPHRSURVEYTEMPLATE = "CREATESETUPHRSURVEYTEMPLATE";
export const UPDATESETUPHRSURVEYTEMPLATE = "UPDATESETUPHRSURVEYTEMPLATE";
export const DELETESETUPHRSURVEYTEMPLATE = "DELETESETUPHRSURVEYTEMPLATE";

export const GETHRRECRUITMENTSKILLZONE = "GETHRRECRUITMENTSKILLZONE";
export const CREATEHRRECRUITMENTSKILLZONE = "CREATEHRRECRUITMENTSKILLZONE";
export const UPDATEHRRECRUITMENTSKILLZONE = "UPDATEHRRECRUITMENTSKILLZONE";
export const DELETEHRRECRUITMENTSKILLZONE = "DELETEHRRECRUITMENTSKILLZONE";
export const GETHRRECRUITMENTSTAGES = "GETHRRECRUITMENTSTAGES";
export const GETHRRECRUITMENTSTAGESBYID = "GETHRRECRUITMENTSTAGESBYID";
export const GETHRRECRUITMENTSTAGESALLDETAILS = "GETHRRECRUITMENTSTAGESALLDETAILS";
export const CREATEHRRECRUITMENTSTAGES = "CREATEHRRECRUITMENTSTAGES";
export const UPDATEHRRECRUITMENTSTAGES = "UPDATEHRRECRUITMENTSTAGES";
export const DELETEHRRECRUITMENTSTAGES = "DELETEHRRECRUITMENTSTAGES";
export const GETHRRECRUITMENTMAIN = "GETHRRECRUITMENTMAIN";
export const CREATEHRRECRUITMENTMAIN = "CREATEHRRECRUITMENTMAIN";
export const UPDATEHRRECRUITMENTMAIN = "UPDATEHRRECRUITMENTMAIN";
export const DELETEHRRECRUITMENTMAIN = "DELETEHRRECRUITMENTMAIN";
export const GETHRRECRUITMENTCANDIDATE = "GETHRRECRUITMENTCANDIDATE";
export const CREATEHRRECRUITMENTCANDIDATE = "CREATEHRRECRUITMENTCANDIDATE";
export const UPDATEHRRECRUITMENTCANDIDATE = "UPDATEHRRECRUITMENTCANDIDATE";
export const DELETEHRRECRUITMENTCANDIDATE = "DELETEHRRECRUITMENTCANDIDATE";
export const GETHRRECRUITMENTCANDIDATERESUME = "GETHRRECRUITMENTCANDIDATERESUME";
export const CREATEHRRECRUITMENTCANDIDATERESUME = "CREATEHRRECRUITMENTCANDIDATERESUME";
export const UPDATEHRRECRUITMENTCANDIDATERESUME = "UPDATEHRRECRUITMENTCANDIDATERESUME";
export const DELETEHRRECRUITMENTCANDIDATERESUME = "DELETEHRRECRUITMENTCANDIDATERESUME";
export const GETHRRECRUITMENTINFO = "GETHRRECRUITMENTINFO";
export const GETHRRECRUITMENTINFOBYID = "GETHRRECRUITMENTINFOBYID";
export const CREATEHRRECRUITMENTINFO = "CREATEHRRECRUITMENTINFO";
export const UPDATEHRRECRUITMENTINFO = "UPDATEHRRECRUITMENTINFO";
export const DELETEHRRECRUITMENTINFO = "DELETEHRRECRUITMENTINFO";
export const GETHRRECRUITMENTINFOHISTORY = "GETHRRECRUITMENTINFOHISTORY";
export const GETHRRECRUITMENTINFOHISTORYBYID = "GETHRRECRUITMENTINFOHISTORYBYID";
export const GETHRRECRUITMENTINFOHISTORYALLDETAILS = "GETHRRECRUITMENTINFOHISTORYALLDETAILS";
export const CREATEHRRECRUITMENTINFOHISTORY = "CREATEHRRECRUITMENTINFOHISTORY";
export const UPDATEHRRECRUITMENTINFOHISTORY = "UPDATEHRRECRUITMENTINFOHISTORY";
export const DELETEHRRECRUITMENTINFOHISTORY = "DELETEHRRECRUITMENTINFOHISTORY";
export const GETHRRECRUITMENTCANDIDATENOTE = "GETHRRECRUITMENTCANDIDATENOTE";
export const CREATEHRRECRUITMENTCANDIDATENOTE = "CREATEHRRECRUITMENTCANDIDATENOTE";
export const UPDATEHRRECRUITMENTCANDIDATENOTE = "UPDATEHRRECRUITMENTCANDIDATENOTE";
export const DELETEHRRECRUITMENTCANDIDATENOTE = "DELETEHRRECRUITMENTCANDIDATENOTE";
export const GETHRRECRUITMENTCANDIDATEEMAIL = "GETHRRECRUITMENTCANDIDATEEMAIL";
export const CREATEHRRECRUITMENTCANDIDATEEMAIL = "CREATEHRRECRUITMENTCANDIDATEEMAIL";
export const UPDATEHRRECRUITMENTCANDIDATEEMAIL = "UPDATEHRRECRUITMENTCANDIDATEEMAIL";
export const DELETEHRRECRUITMENTCANDIDATEEMAIL = "DELETEHRRECRUITMENTCANDIDATEEMAIL";
export const GETHRRECRUITMENTPIPELINE = "GETHRRECRUITMENTPIPELINE";
export const CREATEHRRECRUITMENTPIPELINE = "CREATEHRRECRUITMENTPIPELINE";
export const UPDATEHRRECRUITMENTPIPELINE = "UPDATEHRRECRUITMENTPIPELINE";
export const DELETEHRRECRUITMENTPIPELINE = "DELETEHRRECRUITMENTPIPELINE";
export const GETHRRECRUITMENTPIPELINESKILLZONE = "GETHRRECRUITMENTPIPELINESKILLZONE";
export const CREATEHRRECRUITMENTPIPELINESKILLZONE = "CREATEHRRECRUITMENTPIPELINESKILLZONE";
export const UPDATEHRRECRUITMENTPIPELINESKILLZONE = "UPDATEHRRECRUITMENTPIPELINESKILLZONE";
export const DELETEHRRECRUITMENTPIPELINESKILLZONE = "DELETEHRRECRUITMENTPIPELINESKILLZONE";
export const GETHRRECRUITMENTSURVEYRESPONSE = "GETHRRECRUITMENTSURVEYRESPONSE";
export const CREATEHRRECRUITMENTSURVEYRESPONSE = "CREATEHRRECRUITMENTSURVEYRESPONSE";
export const UPDATEHRRECRUITMENTSURVEYRESPONSE = "UPDATEHRRECRUITMENTSURVEYRESPONSE";
export const DELETEHRRECRUITMENTSURVEYRESPONSE = "DELETEHRRECRUITMENTSURVEYRESPONSE";
export const GETHRRECRUITMENTMASTERTASK = "GETHRRECRUITMENTMASTERTASK";
export const CREATEHRRECRUITMENTMASTERTASK = "CREATEHRRECRUITMENTMASTERTASK";
export const UPDATEHRRECRUITMENTMASTERTASK = "UPDATEHRRECRUITMENTMASTERTASK";
export const DELETEHRRECRUITMENTMASTERTASK = "DELETEHRRECRUITMENTMASTERTASK";
export const GETHRRECRUITMENTPOLICIES = "GETHRRECRUITMENTPOLICIES";
export const CREATEHRRECRUITMENTPOLICIES = "CREATEHRRECRUITMENTPOLICIES";
export const UPDATEHRRECRUITMENTPOLICIES = "UPDATEHRRECRUITMENTPOLICIES";
export const DELETEHRRECRUITMENTPOLICIES = "DELETEHRRECRUITMENTPOLICIES";
export const GETHREMAIL = "GETHREMAIL";
export const CREATEHREMAIL = "CREATEHREMAIL";
export const SENDHRSMS = "SENDHRSMS";
export const UPDATEHREMAIL = "UPDATEHREMAIL";
export const DELETEHREMAIL = "DELETEHREMAIL";

export const GETHRRECRUITMENTPERFORMANCEOBJECTIVE = "GETHRRECRUITMENTPERFORMANCEOBJECTIVE";
export const CREATEHRRECRUITMENTPERFORMANCEOBJECTIVE = "CREATEHRRECRUITMENTPERFORMANCEOBJECTIVE";
export const UPDATEHRRECRUITMENTPERFORMANCEOBJECTIVE = "UPDATEHRRECRUITMENTPERFORMANCEOBJECTIVE";
export const DELETEHRRECRUITMENTPERFORMANCEOBJECTIVE = "DELETEHRRECRUITMENTPERFORMANCEOBJECTIVE";
export const GETHRRECRUITMENTPERFORMANCEMEETINGS = "GETHRRECRUITMENTPERFORMANCEMEETINGS";
export const CREATEHRRECRUITMENTPERFORMANCEMEETINGS = "CREATEHRRECRUITMENTPERFORMANCEMEETINGS";
export const UPDATEHRRECRUITMENTPERFORMANCEMEETINGS = "UPDATEHRRECRUITMENTPERFORMANCEMEETINGS";
export const DELETEHRRECRUITMENTPERFORMANCEMEETINGS = "DELETEHRRECRUITMENTPERFORMANCEMEETINGS";
export const GETHRRECRUITMENTPERFORMANCEKRA = "GETHRRECRUITMENTPERFORMANCEKRA";
export const CREATEHRRECRUITMENTPERFORMANCEKRA = "CREATEHRRECRUITMENTPERFORMANCEKRA";
export const UPDATEHRRECRUITMENTPERFORMANCEKRA = "UPDATEHRRECRUITMENTPERFORMANCEKRA";
export const DELETEHRRECRUITMENTPERFORMANCEKRA = "DELETEHRRECRUITMENTPERFORMANCEKRA";
export const GETHRRECRUITMENTPERFORMANCEQA = "GETHRRECRUITMENTPERFORMANCEQA";
export const CREATEHRRECRUITMENTPERFORMANCEQA = "CREATEHRRECRUITMENTPERFORMANCEQA";
export const UPDATEHRRECRUITMENTPERFORMANCEQA = "UPDATEHRRECRUITMENTPERFORMANCEQA";
export const DELETEHRRECRUITMENTPERFORMANCEQA = "DELETEHRRECRUITMENTPERFORMANCEQA";
export const GETHRRECRUITMENTSHIFTREQUESTS = "GETHRRECRUITMENTSHIFTREQUESTS";
export const CREATEHRRECRUITMENTSHIFTREQUESTS = "CREATEHRRECRUITMENTSHIFTREQUESTS";
export const UPDATEHRRECRUITMENTSHIFTREQUESTS = "UPDATEHRRECRUITMENTSHIFTREQUESTS";
export const DELETEHRRECRUITMENTSHIFTREQUESTS = "DELETEHRRECRUITMENTSHIFTREQUESTS";
export const GETHROFFBOARDRESIGNATION = "GETHROFFBOARDRESIGNATION";
export const CREATEHROFFBOARDRESIGNATION = "CREATEHROFFBOARDRESIGNATION";
export const UPDATEHROFFBOARDRESIGNATION = "UPDATEHROFFBOARDRESIGNATION";
export const DELETEHROFFBOARDRESIGNATION = "DELETEHROFFBOARDRESIGNATION";
export const GETHRASSETSALL = "GETHRASSETSALL";
export const CREATEHRASSETSALL = "CREATEHRASSETSALL";
export const UPDATEHRASSETSALL = "UPDATEHRASSETSALL";
export const DELETEHRASSETSALL = "DELETEHRASSETSALL";
export const GETHRASSETSLIST = "GETHRASSETSLIST";
export const CREATEHRASSETSLIST = "CREATEHRASSETSLIST";
export const UPDATEHRASSETSLIST = "UPDATEHRASSETSLIST";
export const DELETEHRASSETSLIST = "DELETEHRASSETSLIST";


export const GETALLHOSPITALANDUSERINFO = "GETALLHOSPITALANDUSERINFO";
export const GETEMAILVERIFICATION = "GETEMAILVERIFICATION";
export const CREATE_EMAIL_OTP_RECORD = "CREATE_EMAIL_OTP_RECORD";

export const CREATE_CHECK_RECORD = "CREATE_CHECK_RECORD";

export const GETSPECIFICATION = "GETSPECIFICATION";
export const CREATESPECIFICATION = "CREATESPECIFICATION";
export const UPDATESPECIFICATION = "UPDATESPECIFICATION";
export const DELETESPECIFICATION = "DELETESPECIFICATION";
export const GETPROMOCODE = "GETPROMOCODE";
export const CREATEPROMOCODE = "CREATEPROMOCODE";
export const UPDATEPROMOCODE = "UPDATEPROMOCODE";
export const DELETEPROMOCODE = "DELETEPROMOCODE";

export const GETPPRODUCTPACKAGE = "GETPPRODUCTPACKAGE";
export const CREATEPPRODUCTPACKAGE = "CREATEPPRODUCTPACKAGE";
export const UPDATEPPRODUCTPACKAGE = "UPDATEPPRODUCTPACKAGE";
export const DELETEPPRODUCTPACKAGE = "DELETEPPRODUCTPACKAGE";

export const GETPPRODUCTTAX = "GETPPRODUCTTAX";
export const CREATEPPRODUCTTAX = "CREATEPPRODUCTTAX";
export const UPDATEPPRODUCTTAX = "UPDATEPPRODUCTTAX";
export const DELETEPPRODUCTTAX = "DELETEPPRODUCTTAX";

export const GETPPRODUCTTAXTYPE = "GETPPRODUCTTAXTYPE";
export const CREATEPPRODUCTTAXTYPE = "CREATEPPRODUCTTAXTYPE";
export const UPDATEPPRODUCTTAXTYPE = "UPDATEPPRODUCTTAXTYPE";
export const DELETEPPRODUCTTAXTYPE = "DELETEPPRODUCTTAXTYPE";

export const GETTAXRETURNTYPEMASTER = "GETTAXRETURNTYPEMASTER";
export const CREATETAXRETURNTYPEMASTER = "CREATETAXRETURNTYPEMASTER";
export const UPDATETAXRETURNTYPEMASTER = "UPDATETAXRETURNTYPEMASTER";
export const DELETETAXRETURNTYPEMASTER = "DELETETAXRETURNTYPEMASTER";

export const GETTAXTDSSECTIONMASTER = "GETTAXTDSSECTIONMASTER";
export const CREATETAXTDSSECTIONMASTER = "CREATETAXTDSSECTIONMASTER";
export const UPDATETAXTDSSECTIONMASTER = "UPDATETAXTDSSECTIONMASTER";
export const DELETETAXTDSSECTIONMASTER = "DELETETAXTDSSECTIONMASTER";

export const GETTAXTCSSECTIONMASTER = "GETTAXTCSSECTIONMASTER";
export const CREATETAXTCSSECTIONMASTER = "CREATETAXTCSSECTIONMASTER";
export const UPDATETAXTCSSECTIONMASTER = "UPDATETAXTCSSECTIONMASTER";
export const DELETETAXTCSSECTIONMASTER = "DELETETAXTCSSECTIONMASTER";

export const GETTAXMASTER = "GETTAXMASTER";
export const CREATETAXMASTER = "CREATETAXMASTER";
export const UPDATETAXMASTER = "UPDATETAXMASTER";
export const DELETETAXMASTER = "DELETETAXMASTER";

export const VERIFY_AND_SAVE_PAYMENT = "VERIFY_AND_SAVE_PAYMENT";
export const CREATE_RAZORPAY_ORDER = "CREATE_RAZORPAY_ORDER";
export const GETSPECIFICATIONTYPE = "GETSPECIFICATIONTYPE";
export const CREATESPECIFICATIONTYPE = "CREATESPECIFICATIONTYPE";
export const UPDATESPECIFICATIONTYPE = "UPDATESPECIFICATIONTYPE";
export const DELETESPECIFICATIONTYPE = "DELETESPECIFICATIONTYPE";

export const REQUESTPASSWORDTORESET = "REQUESTPASSWORDTORESET";
export const RESETPASSWORD = "RESETPASSWORD";

export const GETTRANSACTIONINFORMATION = "GETTRANSACTIONINFORMATION";
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const CLEAR_CART = 'CLEAR_CART';
export const SET_SALES_MODULE_STATUS = "SET_SALES_MODULE_STATUS";

export const GETALLTRANSACTION = "GETALLTRANSACTION";
export const CREATETRANSACTION = "CREATETRANSACTION";
export const UPDATEALLTRANSACTION = "UPDATEALLTRANSACTION";
export const DELETEALLTRANSACTION = "GETALLTRANSACTION";

export const GETPAYMENT18 = "GETPAYMENT18";
export const CREATEPAYMENT18 = "CREATEPAYMENT18";
export const UPDATEPAYMENT18 = "UPDATEPAYMENT18";
export const DELETEPAYMENT18 = "DELETEPAYMENT18";
export const GETPAYMENTGETWAY = "GETPAYMENTGETWAY";
export const CREATELINK = "CREATELINK";
export const SENDMAIL = "SENDMAIL";
export const CREATECHEQUE = "CREATECHEQUE";
export const GETSPECIALIZATION = "GETSPECIALIZATION";
export const CREATESPECIALIZATION = "CREATESPECIALIZATION";
export const UPDATESPECIALIZATION = "UPDATESPECIALIZATION";
export const DELETESPECIALIZATION = "DELETESPECIALIZATION";

export const GETPRODUCTSETUPDEPARTMENT = "GETPRODUCTSETUPDEPARTMENT";
export const CREATEPRODUCTSETUPDEPARTMENT = "CREATEPRODUCTSETUPDEPARTMENT";
export const UPDATEPRODUCTSETUPDEPARTMENT = "UPDATEPRODUCTSETUPDEPARTMENT";
export const DELETEPRODUCTSETUPDEPARTMENT = "DELETEPRODUCTSETUPDEPARTMENT";
export const GETPRODUCTSETUPROLE = "GETPRODUCTSETUPROLE";
export const CREATEPRODUCTSETUPROLE = "CREATEPRODUCTSETUPROLE";
export const UPDATEPRODUCTSETUPROLE = "UPDATEPRODUCTSETUPROLE";
export const DELETEPRODUCTSETUPROLE = "DELETEPRODUCTSETUPROLE";
export const SET_CASHFREE_ORDER_ID = 'SET_CASHFREE_ORDER_ID';
export const SET_RAZORPAY_ORDER_ID = "SET_RAZORPAY_ORDER_ID";
export const GETPRODUCTSETUPROLETYPE = "GETPRODUCTSETUPROLETYPE";
export const CREATEPRODUCTSETUPROLETYPE = "CREATEPRODUCTSETUPROLETYPE";
export const UPDATEPRODUCTSETUPROLETYPE = "UPDATEPRODUCTSETUPROLETYPE";
export const DELETEPRODUCTSETUPROLETYPE = "DELETEPRODUCTSETUPROLETYPE";
export const CREATEPRODUCTSPECIALITY = "CREATEPRODUCTSPECIALITY";
export const GETPRODUCTSPECIALITY = "GETPRODUCTSPECIALITY";
export const GETAllPRODUCTSPECIALITY = "GETAllPRODUCTSPECIALITY";
export const UPDATEPRODUCTSPECIALITY = "UPDATEPRODUCTSPECIALITY";
export const DELETEPRODUCTSPECIALITY = "DELETEPRODUCTSPECIALITY";
export const CREATEBRANCH = "CREATEBRANCH";
export const GETBRANCH = "GETBRANCH";
export const UPDATEBRANCH = "UPDATEBRANCH";
export const DELETEBRANCH = "DELETEBRANCH";
export const SET_SELECTED_BRANCH = 'SET_SELECTED_BRANCH';
export const CLEAR_HR_STAFF = 'CLEAR_HR_STAFF';
export const SET_HOSPITAL_CODE = 'SET_HOSPITAL_CODE';
export const GETSETUPACCOUNT = 'GETSETUPACCOUNT';
export const CREATESETUPACCOUNT = 'CREATESETUPACCOUNT';
export const UPDATESETUPACCOUNT = 'UPDATESETUPACCOUNT';
export const DELETESETUPACCOUNT = 'DELETESETUPACCOUNT';

export const GETSETUPACCOUNTHEAD = 'GETSETUPACCOUNTHEAD';
export const GETSETUPACCOUNTHEADBYHID = 'GETSETUPACCOUNTHEADBYHID';
export const CREATESETUPACCOUNTHEAD = 'CREATESETUPACCOUNTHEAD';
export const UPDATESETUPACCOUNTHEAD = 'UPDATESETUPACCOUNTHEAD';
export const DELETESETUPACCOUNTHEAD = 'DELETESETUPACCOUNTHEAD';
export const GETALLACCOUNTHEAD = 'GETALLACCOUNTHEAD';
export const CREATALLACCOUNTS = 'CREATALLACCOUNTS';

export const GETSETUPACCOUNTTYPE = 'GETSETUPACCOUNTTYPE';
export const CREATESETUPACCOUNTTYPE = 'CREATESETUPACCOUNTTYPE';
export const UPDATESETUPACCOUNTTYPE = 'UPDATESETUPACCOUNTTYPE';
export const DELETESETUPACCOUNTTYPE = 'DELETESETUPACCOUNTTYPE';

export const GETSETUPACCOUNTSUBTYPE = 'GETSETUPACCOUNTSUBTYPE';
export const CREATESETUPACCOUNTSUBTYPE = 'CREATESETUPACCOUNTSUBTYPE';
export const UPDATESETUPACCOUNTSUBTYPE = 'UPDATESETUPACCOUNTSUBTYPE';
export const DELETESETUPACCOUNTSUBTYPE = 'DELETESETUPACCOUNTSUBTYPE';
export const CREATE_COST_CENTER = "CREATE_COST_CENTER";
export const GET_COST_CENTER = "GET_COST_CENTER";
export const UPDATE_COST_CENTER = "UPDATE_COST_CENTER";
export const DELETE_COST_CENTER = "DELETE_COST_CENTER";

export const CREATEDURATION = 'CREATEDURATION';
export const GETDURATION = 'GETDURATION';
export const UPDATEDURATION = 'UPDATEDURATION';
export const DELETEDURATION = 'DELETEDURATION';

export const GETSETUPACCOUNTCURRENCY = 'GETSETUPACCOUNTCURRENCY';
export const CREATESETUPACCOUNTCURRENCY = 'CREATESETUPACCOUNTCURRENCY';
export const UPDATESETUPACCOUNTCURRENCY = 'UPDATESETUPACCOUNTCURRENCY';
export const DELETESETUPACCOUNTCURRENCY = 'DELETESETUPACCOUNTCURRENCY';

export const CREATEACCOUNTBANKMASTER = 'CREATEACCOUNTBANKMASTER';
export const GETACCOUNTBANKMASTER = 'GETACCOUNTBANKMASTER';
export const UPDATEACCOUNTBANKMASTER = 'UPDATEACCOUNTBANKMASTER';
export const DELETEACCOUNTBANKMASTER = 'DELETEACCOUNTBANKMASTER';

export const CREATEACCOUNTLEDGERMASTER = 'CREATEACCOUNTLEDGERMASTER';
export const GETACCOUNTLEDGERMASTER = 'GETACCOUNTLEDGERMASTER';
export const UPDATEACCOUNTLEDGERMASTER = 'UPDATEACCOUNTLEDGERMASTER';
export const DELETEACCOUNTLEDGERMASTER = 'DELETEACCOUNTLEDGERMASTER';
export const GETSETUPPARTYTYPES = 'GETSETUPPARTYTYPES';
export const CREATESETUPPARTYTYPES = 'CREATESETUPPARTYTYPES';
export const UPDATESETUPPARTYTYPES = 'UPDATESETUPPARTYTYPES';
export const DELETESETUPPARTYTYPES = 'DELETESETUPPARTYTYPES';

export const SET_SELECTED_CURRENCY = 'SET_SELECTED_CURRENCY';
export const GETPRODUCTACCOUNT = 'GETPRODUCTACCOUNT';
export const CREATEPRODUCTACCOUNT = 'CREATEPRODUCTACCOUNT';
export const UPDATEPRODUCTACCOUNT = 'UPDATEPRODUCTACCOUNT';
export const DELETEPRODUCTACCOUNT = 'DELETEPRODUCTACCOUNT';

export const GETPRODUCTACCOUNTHEAD = 'GETPRODUCTACCOUNTHEAD';
export const CREATEPRODUCTACCOUNTHEAD = 'CREATEPRODUCTACCOUNTHEAD';
export const UPDATEPRODUCTACCOUNTHEAD = 'UPDATEPRODUCTACCOUNTHEAD';
export const DELETEPRODUCTACCOUNTHEAD = 'DELETEPRODUCTACCOUNTHEAD';

export const GETPRODUCTACCOUNTTYPE = 'GETPRODUCTACCOUNTTYPE';
export const CREATEPRODUCTACCOUNTTYPE = 'CREATEPRODUCTACCOUNTTYPE';
export const UPDATEPRODUCTACCOUNTTYPE = 'UPDATEPRODUCTACCOUNTTYPE';
export const DELETEPRODUCTACCOUNTTYPE = 'DELETEPRODUCTACCOUNTTYPE';

export const GETPRODUCTACCOUNTSUBTYPE = 'GETPRODUCTACCOUNTSUBTYPE';
export const CREATEPRODUCTACCOUNTSUBTYPE = 'CREATEPRODUCTACCOUNTSUBTYPE';
export const UPDATEPRODUCTACCOUNTSUBTYPE = 'UPDATEPRODUCTACCOUNTSUBTYPE';
export const DELETEPRODUCTACCOUNTSUBTYPE = 'DELETEPRODUCTACCOUNTSUBTYPE';
export const GETALLPRODUCTACCOUNTHEAD = 'GETALLPRODUCTACCOUNTHEAD';
export const GETALLPRODUCTACCOUNT = 'GETALLPRODUCTACCOUNT';

export const GETPAYMENTMODE = 'GETPAYMENTMODE';
export const CREATEPAYMENTMODE = 'CREATEPAYMENTMODE';
export const UPDATEPAYMENTMODE = 'UPDATEPAYMENTMODE';
export const DELETEPAYMENTMODE = 'DELETEPAYMENTMODE';

export const CREATEHRPAYYROLLACCURE = 'CREATEHRPAYYROLLACCURE';
export const REVERTHRPAYYROLLACCURE = 'REVERTHRPAYYROLLACCURE';
export const CREATEHRPAYYROLLPAYOUT = 'CREATEHRPAYYROLLPAYOUT';
export const INITIATELOANHRPAYOUT = 'INITIATELOANHRPAYOUT';

export const UPDATEHRPAYYROLLACCURE = 'UPDATEHRPAYYROLLACCURE';

export const GET_LEDGER_REPORT = 'GET_LEDGER_REPORT';


export const CREATEHRSALARYADVANCEISSUE = 'CREATEHRSALARYADVANCEISSUE';
export const CREATEHRSALARYADVANCESETTLEMENTISSUE = 'CREATEHRSALARYADVANCESETTLEMENTISSUE';

export const SET_SELECTED_ACCOUNT_ID = 'SET_SELECTED_ACCOUNT_ID';

export const CREATECUSTOMPRODUCTSPECIALITY = 'CREATECUSTOMPRODUCTSPECIALITY';
export const GETCUSTOMPRODUCTSPECIALITY = 'GETCUSTOMPRODUCTSPECIALITY';
export const UPDATECUSTOMPRODUCTSPECIALITY = 'UPDATECUSTOMPRODUCTSPECIALITY';
export const DELETECUSTOMPRODUCTSPECIALITY = 'DELETECUSTOMPRODUCTSPECIALITY';
export const CREATECUSTOMPRODUCTROLE = 'CREATECUSTOMPRODUCTROLE';
export const GETCUSTOMPRODUCTROLE = 'GETCUSTOMPRODUCTROLE';
export const UPDATECUSTOMPRODUCTROLE = 'UPDATECUSTOMPRODUCTROLE';
export const DELETECUSTOMPRODUCTROLE = 'DELETECUSTOMPRODUCTROLE';
export const CREATECUSTOMPRODUCTDEPARTMENT = 'CREATECUSTOMPRODUCTDEPARTMENT';
export const GETCUSTOMPRODUCTDEPARTMENT = 'GETCUSTOMPRODUCTDEPARTMENT';
export const UPDATECUSTOMPRODUCTDEPARTMENT = 'UPDATECUSTOMPRODUCTDEPARTMENT';
export const DELETECUSTOMPRODUCTDEPARTMENT = 'DELETECUSTOMPRODUCTDEPARTMENT';

export const GETACCOUNTSTRANSACTIONHEADER = 'GETACCOUNTSTRANSACTIONHEADER';

export const SENDHRCUSTOMTEMPEMAIL = 'SENDHRCUSTOMTEMPEMAIL';
export const GETHRPAYROLLLOANISSUE = 'GETHRPAYROLLLOANISSUE';
export const CREATEHRPAYROLLLOANISSUE = 'CREATEHRPAYROLLLOANISSUE';
export const ISSUEHRPAYROLLLOANISSUE = 'ISSUEHRPAYROLLLOANISSUE';
export const UPDATEHRPAYROLLLOANISSUE = 'UPDATEHRPAYROLLLOANISSUE';
export const DELETEHRPAYROLLLOANISSUE = 'DELETEHRPAYROLLLOANISSUE';

export const GET_HR_STAFF_LOAN_REQUESTS = "GET_HR_STAFF_LOAN_REQUESTS";
export const GET_HR_STAFF_LOAN_REQUEST_DETAILS = "GET_HR_STAFF_LOAN_REQUEST_DETAILS";
export const RAISE_HR_STAFF_LOAN_REQUEST = "RAISE_HR_STAFF_LOAN_REQUEST";
export const APPROVE_HR_STAFF_LOAN_REQUEST = "APPROVE_HR_STAFF_LOAN_REQUEST";
export const REJECT_HR_STAFF_LOAN_REQUEST = "REJECT_HR_STAFF_LOAN_REQUEST";
export const CANCEL_HR_STAFF_LOAN_REQUEST = "CANCEL_HR_STAFF_LOAN_REQUEST";
export const HRLOANGENERATEMANDATE = "HRLOANGENERATEMANDATE";

export const CREATEHRPAYROLLLOANREPAYMANUAL = 'CREATEHRPAYROLLLOANREPAYMANUAL';
export const CREATEHRPAYROLLLOANREPAYPAYROLL = 'CREATEHRPAYROLLLOANREPAYPAYROLL';
export const CREATEHRPAYROLLLOANPREPAYFULL = 'CREATEHRPAYROLLLOANREPAYFULL';
export const CREATEHRPAYROLLLOANPREPAYPPARTIAL = 'CREATEHRPAYROLLLOANREPAYPPARTIAL';
export const CREATEHRPAYROLLLOANADDONINTERESTLOAN = 'CREATEHRPAYROLLLOANADDONINTERESTLOAN';
export const GETHRPAYROLLLOANSCHEDULEINFO = 'GETHRPAYROLLLOANSCHEDULEINFO';

export const GETHRLOANDOCUMENTS = "GETHRLOANDOCUMENTS";
export const CREATEHRLOANDOCUMENTS = "CREATEHRLOANDOCUMENTS";
export const UPDATEHRLOANDOCUMENTS = "UPDATEHRLOANDOCUMENTS";
export const DELETEHRLOANDOCUMENTS = "DELETEHRLOANDOCUMENTS";

export const GETHRLOANPOLICYINFOHISTORY = "GETHRLOANPOLICYINFOHISTORY";
export const CREATEHRLOANPOLICYINFOHISTORY = "CREATEHRLOANPOLICYINFOHISTORY";
export const UPDATEHRLOANPOLICYINFOHISTORY = "UPDATEHRLOANPOLICYINFOHISTORY";
export const DELETEHRLOANPOLICYINFOHISTORY = "DELETEHRLOANPOLICYINFOHISTORY";

export const GETHRSETUPACLLIST = "GETHRSETUPACLLIST";
export const CREATEHRSETUPACLLIST = "CREATEHRSETUPACLLIST";
export const UPDATEHRSETUPACLLIST = "UPDATEHRSETUPACLLIST";
export const DELETEHRSETUPACLLIST = "DELETEHRSETUPACLLIST";
export const CLEAR_HR_SETUPACL = "CLEAR_HR_SETUPACL";
export const CLEAR_HRINFOHISTORY = "CLEAR_HRINFOHISTORY";
export const CLEAR_HRINFO = "CLEAR_HRINFO";
export const CLEAR_HR_RECPIPELINE = "CLEAR_HR_RECPIPELINE";
export const CLEAR_HR_REWARDMASTER = "CLEAR_HR_REWARDMASTER";

export const CLEAR_BED_WING = "CLEAR_BED_WING";
export const CLEAR_BED_ROOM = "CLEAR_BED_ROOM";
export const CLEAR_BED_FLOOR = "CLEAR_BED_FLOOR";
export const CLEAR_BED_TYPES = "CLEAR_BED_TYPES";
export const CLEAR_BED = "CLEAR_BED";




export const GETNEWENQUIRES = "GETNEWENQUIRES";
export const CREATENEWENQUIRES = "CREATENEWENQUIRES";
export const UPDATENEWENQUIRES = "UPDATENEWENQUIRES";
export const DELETENEWENQUIRES = "DELETENEWENQUIRES";
export const CREATESALESPARTYTYPE = "CREATESALESPARTYTYPE";
export const GETSALESPARTYTYPE = "GETSALESPARTYTYPE";
export const UPDATESALESPARTYTYPE = "UPDATESALESPARTYTYPE";
export const DELETESALESPARTYTYPE = "DELETESALESPARTYTYPE";
export const CREATESALESCHANNEL = "CREATESALESCHANNEL";
export const GETSALESCHANNEL = "GETSALESCHANNEL";
export const UPDATESALESCHANNEL = "UPDATESALESCHANNEL";
export const DELETESALESCHANNEL = "DELETESALESCHANNEL";
export const GETPRODUCTDESIGNATION = "GETPRODUCTDESIGNATION";
export const CREATEPRODUCTDESIGNATION = "CREATEPRODUCTDESIGNATION";
export const UPDATEPRODUCTDESIGNATION = "UPDATEPRODUCTDESIGNATION";
export const DELETEPRODUCTDESIGNATION = "DELETEPRODUCTDESIGNATION";
export const CREATEADMINEMODULE = "CREATEADMINEMODULE";
export const CREATEADMINCHILDRENMODULE = "CREATEADMINCHILDRENMODULE";
export const BULK_CREATE_MASTER_DATA = "BULK_CREATE_MASTER_DATA";
export const SYNC_BULK_MODULES = "SYNC_BULK_MODULES";
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';
export const SEND_MOBILE_OTP = "SEND_MOBILE_OTP";
export const VERIFY_MOBILE_OTP = "VERIFY_MOBILE_OTP";
export const MOBILE_OTP_ERROR = "MOBILE_OTP_ERROR";
export const SEND_REGISTRATION_SMS = "SEND_REGISTRATION_SMS";
export const CREATEPRODUCTLANGUAGE = "CREATEPRODUCTLANGUAGE";
export const GETPRODUCTLANGUAGE = "GETPRODUCTLANGUAGE";
export const UPDATEPRODUCTLANGUAGE = "UPDATEPRODUCTLANGUAGE";
export const DELETEPRODUCTLANGUAGE = "DELETEPRODUCTLANGUAGE";
export const CREATEPRODUCTCURRENCY = "CREATEPRODUCTCURRENCY";
export const GETPRODUCTCURRENCY = "GETPRODUCTCURRENCY";
export const UPDATEPRODUCTCURRENCY = "UPDATEPRODUCTCURRENCY";
export const DELETEPRODUCTCURRENCY = "DELETEPRODUCTCURRENCY";
export const SEND_MOBILE_AND_EMAIL_OTP = "SEND_MOBILE_AND_EMAIL_OTP";
export const VERIFY_MOBILE_AND_EMAIL_OTP = "VERIFY_MOBILE_AND_EMAIL_OTP";
export const VERIFY_MOBILE_AND_EMAIL_OTP_ERROR = " VERIFY_MOBILE_AND_EMAIL_OTP_ERROR";
export const CREATE_TWOSTEP_VERIFICATION = "CREATE_TWOSTEP_VERIFICATION";
export const GET_TWOSTEP_VERIFICATION = "GET_TWOSTEP_VERIFICATION";
export const UPDATE_TWOSTEP_VERIFICATION = "UPDATE_TWOSTEP_VERIFICATION";
export const DELETE_TWOSTEP_VERIFICATION = "DELETE_TWOSTEP_VERIFICATION";
export const CREATECHANNELPARTNERSETUP = "CREATECHANNELPARTNERSETUP";
export const GETCHANNELPARTNERSETUP = "GETCHANNELPARTNERSETUP";
export const GETCHANNELPARTNERSETUPWITHNULL = "GETCHANNELPARTNERSETUPWITHNULL";
export const GETCHANNELPARTNERSETUPWITHOUTNULL = "GETCHANNELPARTNERSETUPWITHOUTNULL";
export const UPDATECHANNELPARTNERSETUP = "UPDATECHANNELPARTNERSETUP";
export const DELETECHANNELPARTNERSETUP = "DELETECHANNELPARTNERSETUP";

export const GETCHANELPARTNERMAPPING = "GETCHANELPARTNERMAPPING";
export const CREATECHANELPARTNERMAPPING = "CREATECHANELPARTNERMAPPING";
export const UPDATECHANELPARTNERMAPPING = "UPDATECHANELPARTNERMAPPING";
export const DELETECHANELPARTNERMAPPING = "DELETECHANELPARTNERMAPPING";
export const UPDATEALLMODULEANDCHILD = "UPDATEALLMODULEANDCHILD";
export const GETACCOUNTLEDGERBYID = "GETACCOUNTLEDGERBYID";
export const CREATECHANNELPARTNERPAYOUT = "CREATECHANNELPARTNERPAYOUT";
export const GETCHANNELPARTNERPAYOUT = "GETCHANNELPARTNERPAYOUT";
export const UPDATECHANNELPARTNERPAYOUT = "UPDATECHANNELPARTNERPAYOUT";
export const DELETECHANNELPARTNERPAYOUT = "DELETECHANNELPARTNERPAYOUT";
export const CREATE_CHANNEL_PARTNER_DOC = "CREATE_CHANNEL_PARTNER_DOC";
export const UPDATE_CHANNEL_PARTNER_DOC = "UPDATE_CHANNEL_PARTNER_DOC";
export const DELETE_CHANNEL_PARTNER_DOC = "DELETE_CHANNEL_PARTNER_DOC";
export const GET_CHANNEL_PARTNER_DOC = "GET_CHANNEL_PARTNER_DOC";


export const GETHRREWARDWALLETPASSBOOK = "GETHRREWARDWALLETPASSBOOK";
export const GETHRREWARDWALLETWALLET = "GETHRREWARDWALLETWALLET";
export const CREATEHRREWARDWALLETPASSBOOK = "CREATEHRREWARDWALLETPASSBOOK";
export const UPDATEHRREWARDWALLETPASSBOOK = "UPDATEHRREWARDWALLETPASSBOOK";
export const DELETEHRREWARDWALLETPASSBOOK = "DELETEHRREWARDWALLETPASSBOOK";
export const DEDUCTWALLET = "DEDUCTWALLET";

export const GETHRREWARDMASTER = "GETHRREWARDMASTER";
export const CREATEHRREWARDMASTER = "CREATEHRREWARDMASTER";
export const UPDATEHRREWARDMASTER = "UPDATEHRREWARDMASTER";
export const DELETEHRREWARDMASTER = "DELETEHRREWARDMASTER";
export const CREATEPRODUCTNOTIFICATION = "CREATEPRODUCTNOTIFICATION";
export const GETPRODUCTNOTIFICATION = "GETPRODUCTNOTIFICATION";
export const UPDATEPRODUCTNOTIFICATION = "UPDATEPRODUCTNOTIFICATION";
export const DELETEPRODUCTNOTIFICATION = "DELETEPRODUCTNOTIFICATION";
export const GET_CHANNEL_PARTNER_PAYOUT_ALL = "GET_CHANNEL_PARTNER_PAYOUT_ALL";
export const GET_CHANNEL_PARTNER_PAYOUT_BALANCE = "GET_CHANNEL_PARTNER_PAYOUT_BALANCE";


export const GETSETUPWINGLOCATION = "GETSETUPWINGLOCATION";
export const CREATESETUPWINGLOCATION = "CREATESETUPWINGLOCATION";
export const UPDATESETUPWINGLOCATION = "UPDATESETUPWINGLOCATION";
export const DELETESETUPWINGLOCATION = "DELETESETUPWINGLOCATION";
export const GETSETUPROOMOCATION = "GETSETUPROOMOCATION";
export const CREATESETUPROOMOCATION = "CREATESETUPROOMOCATION";
export const UPDATESETUPROOMOCATION = "UPDATESETUPROOMOCATION";
export const DELETESETUPROOMOCATION = "DELETESETUPROOMOCATION";
export const SEND_SMS = "SEND_SMS";
export const SEND_EMAIL = "SEND_EMAIL";
export const GET_COMMUNICATION_LOGS = "GET_COMMUNICATION_LOGS";


// ticket agent
export const GET_ALL_HOSPITAL_AGENTS = "GET_ALL_HOSPITAL_AGENTS";
export const GET_HOSPITAL_AGENT_BY_ID = "GET_HOSPITAL_AGENT_BY_ID";
export const GET_AGENT_STAFF_COMBINED = "GET_AGENT_STAFF_COMBINED";
export const GET_HELPDESK_DISTINCT_DEPTS = "GET_HELPDESK_DISTINCT_DEPTS";
export const CREATE_HOSPITAL_AGENT = "CREATE_HOSPITAL_AGENT";
export const UPDATE_HOSPITAL_AGENT = "UPDATE_HOSPITAL_AGENT";
export const DELETE_HOSPITAL_AGENT = "DELETE_HOSPITAL_AGENT";

export const CREATE_CALL = "CREATE_CALL";
export const GET_CALLS = "GET_CALLS";
export const UPDATE_CALL = "UPDATE_CALL";
export const DELETE_CALL = "DELETE_CALL";
export const CREATE_NOTE = "CREATE_NOTE";
export const GET_NOTES = "GET_NOTES";
export const UPDATE_NOTE = "UPDATE_NOTE";
export const DELETE_NOTE = "DELETE_NOTE";
export const CREATE_REMINDER = "CREATE_REMINDER";
export const GET_REMINDERS = "GET_REMINDERS";
export const UPDATE_REMINDER = "UPDATE_REMINDER";
export const DELETE_REMINDER = "DELETE_REMINDER";
export const CREATE_MANUAL_SMS = "CREATE_MANUAL_SMS";
export const GET_MANUAL_SMS = "GET_MANUAL_SMS";
export const UPDATE_MANUAL_SMS = "UPDATE_MANUAL_SMS";
export const DELETE_MANUAL_SMS = "DELETE_MANUAL_SMS";
export const SEND_MANUAL_EMAIL = "SEND_MANUAL_EMAIL";
export const GET_MANUAL_EMAIL = "GET_MANUAL_EMAIL";
export const UPDATE_MANUAL_EMAIL = "UPDATE_MANUAL_EMAIL";
export const DELETE_MANUAL_EMAIL = "DELETE_MANUAL_EMAIL";
export const CREATE_TICKET = "CREATE_TICKET";
export const GET_MY_TICKETS = "GET_MY_TICKETS";
export const GET_TICKET_DETAILS = "GET_TICKET_DETAILS";
export const ASSIGN_TICKET = "ASSIGN_TICKET";
export const AGENT_REPLY = "AGENT_REPLY";
export const CUSTOMER_REPLY = "CUSTOMER_REPLY";
export const UPDATE_TICKET_STATUS = "UPDATE_TICKET_STATUS";
export const REOPEN_TICKET = "REOPEN_TICKET";
export const GET_ALL_TICKETS = "GET_ALL_TICKETS";
export const UPDATE_TICKET_PROPERTIES = "UPDATE_TICKET_PROPERTIES";
export const DELETE_TICKET = "DELETE_TICKET";
export const MARK_TICKET_AS_READ = "MARK_TICKET_AS_READ";
export const RATE_TICKET = "RATE_TICKET";

export const GETKNOWLEDGETRANSFER = "GETKNOWLEDGETRANSFER";
export const CREATEKNOWLEDGETRANSFER = "CREATEKNOWLEDGETRANSFER";
export const UPDATEKNOWLEDGETRANSFER = "UPDATEKNOWLEDGETRANSFER";
export const DELETEKNOWLEDGETRANSFER = "DELETEKNOWLEDGETRANSFER";

export const GETKNOWLEDGETRANSFERMAINTITLE = "GETKNOWLEDGETRANSFERMAINTITLE";
export const CREATEKNOWLEDGETRANSFERMAINTITLE = "CREATEKNOWLEDGETRANSFERMAINTITLE";
export const UPDATEKNOWLEDGETRANSFERMAINTITLE = "UPDATEKNOWLEDGETRANSFERMAINTITLE";
export const DELETEKNOWLEDGETRANSFERMAINTITLE = "DELETEKNOWLEDGETRANSFERMAINTITLE";

export const UPLOADKTDOCUMENT = "UPLOADKTDOCUMENT";
export const DELETEKTDOCUMENT = "DELETEKTDOCUMENT";

// KNOWLEDGE BASE
export const GET_ALL_KNOWLEDGE_BASE = "GET_ALL_KNOWLEDGE_BASE";
export const GET_KNOWLEDGE_BASE_BY_ID = "GET_KNOWLEDGE_BASE_BY_ID";
export const CREATE_KNOWLEDGE_BASE = "CREATE_KNOWLEDGE_BASE";
export const UPDATE_KNOWLEDGE_BASE = "UPDATE_KNOWLEDGE_BASE";
export const DELETE_KNOWLEDGE_BASE = "DELETE_KNOWLEDGE_BASE";

// KNOWLEDGE BASE CATEGORY
export const GET_ALL_KB_CATEGORIES = "GET_ALL_KB_CATEGORIES";
export const GET_KB_CATEGORY_BY_ID = "GET_KB_CATEGORY_BY_ID";
export const CREATE_KB_CATEGORY = "CREATE_KB_CATEGORY";
export const UPDATE_KB_CATEGORY = "UPDATE_KB_CATEGORY";
export const DELETE_KB_CATEGORY = "DELETE_KB_CATEGORY";
// Knowledge Base Image
export const UPLOAD_KB_IMAGE = "UPLOAD_KB_IMAGE";
export const DELETE_KB_IMAGE = "DELETE_KB_IMAGE";

// Category Image
export const UPLOAD_KB_CATEGORY_IMAGE = "UPLOAD_KB_CATEGORY_IMAGE";
export const DELETE_KB_CATEGORY_IMAGE = "DELETE_KB_CATEGORY_IMAGE";
// KNOWLEDGE BASE ARTICLE
export const GET_ALL_KB_ARTICLES = "GET_ALL_KB_ARTICLES";
export const GET_KB_ARTICLE_BY_ID = "GET_KB_ARTICLE_BY_ID";
export const CREATE_KB_ARTICLE = "CREATE_KB_ARTICLE";
export const UPDATE_KB_ARTICLE = "UPDATE_KB_ARTICLE";
export const DELETE_KB_ARTICLE = "DELETE_KB_ARTICLE";
export const UPLOAD_KB_ARTICLE_IMAGE = "UPLOAD_KB_ARTICLE_IMAGE";
export const DELETE_KB_ARTICLE_IMAGE = "DELETE_KB_ARTICLE_IMAGE";

export const GETALLCONTACTCAMPAIGN = "GETALLCONTACTCAMPAIGN";
export const CREATE_CONTACT_CAMPAIGN = "CREATE_CONTACT_CAMPAIGN";
export const UPDATE_CONTACT_CAMPAIGN = "UPDATE_CONTACT_CAMPAIGN";
export const DELETE_CONTACT_CAMPAIGN = "DELETE_CONTACT_CAMPAIGN";

export const GET_ALL_ANNOUNCEMENTS = "GET_ALL_ANNOUNCEMENTS";
export const GET_ANNOUNCEMENT_BY_ID = "GET_ANNOUNCEMENT_BY_ID";
export const CREATE_ANNOUNCEMENT = "CREATE_ANNOUNCEMENT";
export const UPDATE_ANNOUNCEMENT = "UPDATE_ANNOUNCEMENT";
export const DELETE_ANNOUNCEMENT = "DELETE_ANNOUNCEMENT";
export const GET_ALL_SUPPORT = "GET_ALL_SUPPORT";
export const GET_SUPPORT_BY_ID = "GET_SUPPORT_BY_ID";
export const CREATE_SUPPORT = "CREATE_SUPPORT";
export const UPDATE_SUPPORT = "UPDATE_SUPPORT";
export const DELETE_SUPPORT = "DELETE_SUPPORT";
export const GETALLUSERSFILTER = 'GETALLUSERSFILTER';
export const GETUSERDATA = 'GETUSERDATA'
export const GET_CHANNEL_PARTNER_SOURCE = "GET_CHANNEL_PARTNER_SOURCE";
export const CREATE_CHANNEL_PARTNER_SOURCE = "CREATE_CHANNEL_PARTNER_SOURCE";
export const UPDATE_CHANNEL_PARTNER_SOURCE = "UPDATE_CHANNEL_PARTNER_SOURCE";
export const DELETE_CHANNEL_PARTNER_SOURCE = "DELETE_CHANNEL_PARTNER_SOURCE";
export const GET_CHANNEL_PARTNER_COMMISSION_LOG = "GET_CHANNEL_PARTNER_COMMISSION_LOG";
export const GET_CHANNEL_PARTNER_CONTACT_ALL = "GET_CHANNEL_PARTNER_CONTACT_ALL";

export const GETCHANNELPARTNERCUSTOMERLEAD = "GETCHANNELPARTNERCUSTOMERLEAD";
export const GETCHANNELPARTNERCUSTOMER = "GETCHANNELPARTNERCUSTOMER";
export const GET_COMMISSION_LOG = "GET_COMMISSION_LOG";
export const UPDATE_COMMISSION_LOG = "UPDATE_COMMISSION_LOG";

// New postal inward /outward api 
export const CREATEFRONTOFFICEPOSTALID = "CREATEFRONTOFFICEPOSTALID";
export const GETALLFRONTOFFICEPOSTALID = "GETALLFRONTOFFICEPOSTALID";
export const GETBYFRONTOFFICEPOSTALID = "GETBYFRONTOFFICEPOSTALID";
export const UPDATEFRONTOFFICEPOSTALID = "UPDATEFRONTOFFICEPOSTALID";
export const DELETEFRONTOFFICEPOSTALID = "DELETEFRONTOFFICEPOSTALID";

//Front office Lost and Found
export const CREATELOSTFOUND = "CREATELOSTFOUND";
export const GETLOSTFOUND = "GETLOSTFOUND";
export const GETLOSTFOUNDBYID = "GETLOSTFOUNDBYID";
export const UPDATELOSTFOUND = "UPDATELOSTFOUND";
export const DELETELOSTFOUND = "DELETELOSTFOUND";

//Front office Enquirey Management 

export const CREATEENQUIRY = "CREATEENQUIRY";
export const GETENQUIRY = "GETENQUIRY";
export const GETENQUIRYBYID = "GETENQUIRYBYID";
export const UPDATEENQUIRY = "UPDATEENQUIRY";
export const DELETEENQUIRY = "DELETEENQUIRY";
// Front office WHEELCHAIR
export const CREATEWHEELCHAIRREQUEST = "CREATEWHEELCHAIRREQUEST";
export const GETONEWHEELCHAIRREQUEST = "GETONEWHEELCHAIRREQUEST";
export const GETWHEELCHAIRREQUEST = "GETWHEELCHAIRREQUEST";
export const UPDATEWHEELCHAIRREQUEST = "UPDATEWHEELCHAIRREQUEST";
export const DELETEWHEELCHAIRREQUEST = "DELETEWHEELCHAIRREQUEST";

export const RAISE_CREDIT_NOTE = "RAISE_CREDIT_NOTE";
export const GET_CREDIT_NOTES = "GET_CREDIT_NOTES";
export const GET_CREDIT_NOTE_DETAILS = "GET_CREDIT_NOTE_DETAILS";
export const APPROVE_CREDIT_NOTE = "APPROVE_CREDIT_NOTE";
export const REJECT_CREDIT_NOTE = "REJECT_CREDIT_NOTE";
export const CANCEL_CREDIT_NOTE = "CANCEL_CREDIT_NOTE";
export const PROCESS_REFUND = "PROCESS_REFUND";
export const GET_PENDING_COUNT = "GET_PENDING_COUNT";

// Front Office Ambulance 
export const GET_AMBULANCE_REQUESTS = "GET_AMBULANCE_REQUESTS";
export const GET_AMBULANCE_BY_ID = "GET_AMBULANCE_BY_ID";
export const CREATE_AMBULANCE_REQUEST = "CREATE_AMBULANCE_REQUEST";
export const UPDATE_AMBULANCE_REQUEST = "UPDATE_AMBULANCE_REQUEST";
export const DELETE_AMBULANCE_REQUEST = "DELETE_AMBULANCE_REQUEST";

//Escort Management
export const CREATEFRONTOFFICEESCORT = "CREATEFRONTOFFICEESCORT";
export const GETALLFRONTOFFICEESCORT = "GETALLFRONTOFFICEESCORT";
export const GETBYIDFRONTOFFICEESCORT = "GETBYIDFRONTOFFICEESCORT";
export const UPDATEFRONTOFFICEESCORT = "UPDATEFRONTOFFICEESCORT";
export const DELETEFRONTOFFICEESCORT = "DELETEFRONTOFFICEESCORT";

// Token Generation
export const CREATEFRONTOFFICETOKENGENERATION = "CREATEFRONTOFFICETOKENGENERATION";
export const GETALLFRONTOFFICETOKENGENERATION = "GETALLFRONTOFFICETOKENGENERATION";
export const GETBYIDFRONTOFFICETOKENGENERATION = "GETBYIDFRONTOFFICETOKENGENERATION";
export const UPDATEFRONTOFFICETOKENGENERATION = "UPDATEFRONTOFFICETOKENGENERATION";
export const DELETEFRONTOFFICETOKENGENERATION = "DELETEFRONTOFFICETOKENGENERATION";

// Patient Check-in/Check-out
export const CREATEFRONTOFFICEPATIENTCHECKIN = "CREATEFRONTOFFICEPATIENTCHECKIN";
export const GETALLFRONTOFFICEPATIENTCHECKIN = "GETALLFRONTOFFICEPATIENTCHECKIN";
export const GETBYIDFRONTOFFICEPATIENTCHECKIN = "GETBYIDFRONTOFFICEPATIENTCHECKIN";
export const UPDATEFRONTOFFICEPATIENTCHECKIN = "UPDATEFRONTOFFICEPATIENTCHECKIN";
export const DELETEFRONTOFFICEPATIENTCHECKIN = "DELETEFRONTOFFICEPATIENTCHECKIN";
// counter setup
export const CREATECOUNTER = "CREATECOUNTER";
export const GETCOUNTER = "GETCOUNTER";
export const GETCOUNTERBYID = "GETCOUNTERBYID";
export const UPDATECOUNTER = "UPDATECOUNTER";
export const DELETECOUNTER = "DELETECOUNTER";
export const UPDATEBULKMODULECHILREN = "UPDATEBULKMODULECHILREN";

// training history mapping
export const GETHRTRAININGHISTORY = "GETHRTRAININGHISTORY";
export const GETHRTRAININGHISTORYBYID = "GETHRTRAININGHISTORYBYID";
export const GETHRTRAININGHISTORYALLDETAILS = "GETHRTRAININGHISTORYALLDETAILS";
export const CREATEHRTRAININGHISTORY = "CREATEHRTRAININGHISTORY";
export const UPDATEHRTRAININGHISTORY = "UPDATEHRTRAININGHISTORY";
export const DELETEHRTRAININGHISTORY = "DELETEHRTRAININGHISTORY";

// REGISTRATION - PATIENT
export const CREATEREGISTRATIONPATIENT = "CREATEREGISTRATIONPATIENT";
export const CREATEALLREGISTRATIONPATIENT = "CREATEALLREGISTRATIONPATIENT";
export const UPDATEALLREGISTRATIONPATIENT = "UPDATEALLREGISTRATIONPATIENT";
export const GETREGISTRATIONPATIENT = "GETREGISTRATIONPATIENT";
export const GETREGISTRATIONPATIENTBYID = "GETREGISTRATIONPATIENTBYID";
export const UPDATEREGISTRATIONPATIENT = "UPDATEREGISTRATIONPATIENT";
export const DELETEREGISTRATIONPATIENT = "DELETEREGISTRATIONPATIENT";

// REGISTRATION - APPOINTMENT
export const CREATEREGISTRATIONAPPOINTMENT = "CREATEREGISTRATIONAPPOINTMENT";
export const GETREGISTRATIONAPPOINTMENT = "GETREGISTRATIONAPPOINTMENT";
export const GETREGISTRATIONAPPOINTMENTBYID = "GETREGISTRATIONAPPOINTMENTBYID";
export const UPDATEREGISTRATIONAPPOINTMENT = "UPDATEREGISTRATIONAPPOINTMENT";
export const DELETEREGISTRATIONAPPOINTMENT = "DELETEREGISTRATIONAPPOINTMENT";

// REGISTRATION - IPD VISIT
export const CREATEREGISTRATIONIPDVISIT = "CREATEREGISTRATIONIPDVISIT";
export const GETREGISTRATIONIPDVISIT = "GETREGISTRATIONIPDVISIT";
export const GETREGISTRATIONIPDVISITBYID = "GETREGISTRATIONIPDVISITBYID";
export const UPDATEREGISTRATIONIPDVISIT = "UPDATEREGISTRATIONIPDVISIT";
export const DELETEREGISTRATIONIPDVISIT = "DELETEREGISTRATIONIPDVISIT";

// REGISTRATION - OPD VISIT
export const CREATEREGISTRATIONOPDVISIT = "CREATEREGISTRATIONOPDVISIT";
export const GETREGISTRATIONOPDVISIT = "GETREGISTRATIONOPDVISIT";
export const GETREGISTRATIONOPDVISITBYID = "GETREGISTRATIONOPDVISITBYID";
export const UPDATEREGISTRATIONOPDVISIT = "UPDATEREGISTRATIONOPDVISIT";
export const DELETEREGISTRATIONOPDVISIT = "DELETEREGISTRATIONOPDVISIT";

// REGISTRATION - EMERGENCY VISIT
export const CREATEREGISTRATIONEMERGENCYVISIT = "CREATEREGISTRATIONEMERGENCYVISIT";
export const GETREGISTRATIONEMERGENCYVISIT = "GETREGISTRATIONEMERGENCYVISIT";
export const GETREGISTRATIONEMERGENCYVISITBYID = "GETREGISTRATIONEMERGENCYVISITBYID";
export const UPDATEREGISTRATIONEMERGENCYVISIT = "UPDATEREGISTRATIONEMERGENCYVISIT";
export const DELETEREGISTRATIONEMERGENCYVISIT = "DELETEREGISTRATIONEMERGENCYVISIT";
/* PATIENT FAMILIES */
export const CREATEPATIENTFAMILY = "CREATEPATIENTFAMILY";
export const GETPATIENTFAMILY = "GETPATIENTFAMILY";
export const GETPATIENTFAMILYBYID = "GETPATIENTFAMILYBYID";
export const UPDATEPATIENTFAMILY = "UPDATEPATIENTFAMILY";
export const DELETEPATIENTFAMILY = "DELETEPATIENTFAMILY";

/* PATIENT CORPORATE RECORDS */
export const CREATEPATIENTCORPORATERECORD = "CREATEPATIENTCORPORATERECORD";
export const GETPATIENTCORPORATERECORD = "GETPATIENTCORPORATERECORD";
export const GETPATIENTCORPORATERECORDBYID = "GETPATIENTCORPORATERECORDBYID";
export const UPDATEPATIENTCORPORATERECORD = "UPDATEPATIENTCORPORATERECORD";
export const DELETEPATIENTCORPORATERECORD = "DELETEPATIENTCORPORATERECORD";

/* PATIENT INSURANCE RECORDS */
export const CREATEPATIENTINSURANCERECORD = "CREATEPATIENTINSURANCERECORD";
export const GETPATIENTINSURANCERECORD = "GETPATIENTINSURANCERECORD";
export const GETPATIENTINSURANCERECORDBYID = "GETPATIENTINSURANCERECORDBYID";
export const UPDATEPATIENTINSURANCERECORD = "UPDATEPATIENTINSURANCERECORD";
export const DELETEPATIENTINSURANCERECORD = "DELETEPATIENTINSURANCERECORD";

/* PATIENT CONSENT & DECLARATION */
export const CREATEPATIENTCONSENTDECLARATION = "CREATEPATIENTCONSENTDECLARATION";
export const GETPATIENTCONSENTDECLARATION = "GETPATIENTCONSENTDECLARATION";
export const GETPATIENTCONSENTDECLARATIONBYID = "GETPATIENTCONSENTDECLARATIONBYID";
export const UPDATEPATIENTCONSENTDECLARATION = "UPDATEPATIENTCONSENTDECLARATION";
export const DELETEPATIENTCONSENTDECLARATION = "DELETEPATIENTCONSENTDECLARATION";
/* PATIENT INTERNATIONAL RECORDS */
export const CREATEPATIENTINTERNATIONALRECORD = "CREATEPATIENTINTERNATIONALRECORD";
export const GETPATIENTINTERNATIONALRECORD = "GETPATIENTINTERNATIONALRECORD";
export const GETPATIENTINTERNATIONALRECORDBYID = "GETPATIENTINTERNATIONALRECORDBYID";
export const UPDATEPATIENTINTERNATIONALRECORD = "UPDATEPATIENTINTERNATIONALRECORD";
export const DELETEPATIENTINTERNATIONALRECORD = "DELETEPATIENTINTERNATIONALRECORD";
/* ============ PATIENT BLOOD GROUP ============ */
export const CREATEPATIENTBLOODGROUP = "CREATEPATIENTBLOODGROUP";
export const GETPATIENTBLOODGROUP = "GETPATIENTBLOODGROUP";
export const GETPATIENTBLOODGROUPBYID = "GETPATIENTBLOODGROUPBYID";
export const UPDATEPATIENTBLOODGROUP = "UPDATEPATIENTBLOODGROUP";
export const DELETEPATIENTBLOODGROUP = "DELETEPATIENTBLOODGROUP";

/* ============ PATIENT FAMILY RELATIONSHIP ============ */
export const CREATEPATIENTFAMILYRELATIONSHIP = "CREATEPATIENTFAMILYRELATIONSHIP";
export const GETPATIENTFAMILYRELATIONSHIP = "GETPATIENTFAMILYRELATIONSHIP";
export const GETPATIENTFAMILYRELATIONSHIPBYID = "GETPATIENTFAMILYRELATIONSHIPBYID";
export const UPDATEPATIENTFAMILYRELATIONSHIP = "UPDATEPATIENTFAMILYRELATIONSHIP";
export const DELETEPATIENTFAMILYRELATIONSHIP = "DELETEPATIENTFAMILYRELATIONSHIP";

/* ============ PATIENT REFERRAL TYPE ============ */
export const CREATEPATIENTREFERRALTYPE = "CREATEPATIENTREFERRALTYPE";
export const GETPATIENTREFERRALTYPE = "GETPATIENTREFERRALTYPE";
export const GETPATIENTREFERRALTYPEBYID = "GETPATIENTREFERRALTYPEBYID";
export const UPDATEPATIENTREFERRALTYPE = "UPDATEPATIENTREFERRALTYPE";
export const DELETEPATIENTREFERRALTYPE = "DELETEPATIENTREFERRALTYPE";

/* ============ PATIENT VISIT TYPE ============ */
export const CREATEPATIENTVISITTYPE = "CREATEPATIENTVISITTYPE";
export const GETPATIENTVISITTYPE = "GETPATIENTVISITTYPE";
export const GETPATIENTVISITTYPEBYID = "GETPATIENTVISITTYPEBYID";
export const UPDATEPATIENTVISITTYPE = "UPDATEPATIENTVISITTYPE";
export const DELETEPATIENTVISITTYPE = "DELETEPATIENTVISITTYPE";

/* ============ PATIENT QUEUE PRIORITY ============ */
export const CREATEPATIENTQUEUEPRIORITY = "CREATEPATIENTQUEUEPRIORITY";
export const GETPATIENTQUEUEPRIORITY = "GETPATIENTQUEUEPRIORITY";
export const GETPATIENTQUEUEPRIORITYBYID = "GETPATIENTQUEUEPRIORITYBYID";
export const UPDATEPATIENTQUEUEPRIORITY = "UPDATEPATIENTQUEUEPRIORITY";
export const DELETEPATIENTQUEUEPRIORITY = "DELETEPATIENTQUEUEPRIORITY";

/* ============ PATIENT  TYPE ============ */
export const CREATEPATIENTPATIENTTYPE = "CREATEPATIENTPATIENTTYPE";
export const GETPATIENTPATIENTTYPE = "GETPATIENTPATIENTTYPE";
export const GETPATIENTPATIENTTYPEBYID = "GETPATIENTPATIENTTYPEBYID";
export const UPDATEPATIENTPATIENTTYPE = "UPDATEPATIENTPATIENTTYPE";
export const DELETEPATIENTPATIENTTYPE = "DELETEPATIENTPATIENTTYPE";

/* ============ PATIENT ADMISSION TYPE ============ */
export const CREATEPATIENTADMISSIONTYPE = "CREATEPATIENTADMISSIONTYPE";
export const GETPATIENTADMISSIONTYPE = "GETPATIENTADMISSIONTYPE";
export const GETPATIENTADMISSIONTYPEBYID = "GETPATIENTADMISSIONTYPEBYID";
export const UPDATEPATIENTADMISSIONTYPE = "UPDATEPATIENTADMISSIONTYPE";
export const DELETEPATIENTADMISSIONTYPE = "DELETEPATIENTADMISSIONTYPE";

/* ============ PATIENT ARRIVAL MODE ============ */
export const CREATEPATIENTARRIVALMODE = "CREATEPATIENTARRIVALMODE";
export const GETPATIENTARRIVALMODE = "GETPATIENTARRIVALMODE";
export const GETPATIENTARRIVALMODEBYID = "GETPATIENTARRIVALMODEBYID";
export const UPDATEPATIENTARRIVALMODE = "UPDATEPATIENTARRIVALMODE";
export const DELETEPATIENTARRIVALMODE = "DELETEPATIENTARRIVALMODE";

/* ============ PATIENT TRIAGE CATEGORY ============ */
export const CREATEPATIENTTRIAGECATEGORY = "CREATEPATIENTTRIAGECATEGORY";
export const GETPATIENTTRIAGECATEGORY = "GETPATIENTTRIAGECATEGORY";
export const GETPATIENTTRIAGECATEGORYBYID = "GETPATIENTTRIAGECATEGORYBYID";
export const UPDATEPATIENTTRIAGECATEGORY = "UPDATEPATIENTTRIAGECATEGORY";
export const DELETEPATIENTTRIAGECATEGORY = "DELETEPATIENTTRIAGECATEGORY";

/* ============ PATIENT FAMILY CATEGORY ============ */
export const CREATEPATIENTFAMILYCATEGORY = "CREATEPATIENTFAMILYCATEGORY";
export const GETPATIENTFAMILYCATEGORY = "GETPATIENTFAMILYCATEGORY";
export const GETPATIENTFAMILYCATEGORYBYID = "GETPATIENTFAMILYCATEGORYBYID";
export const UPDATEPATIENTFAMILYCATEGORY = "UPDATEPATIENTFAMILYCATEGORY";
export const DELETEPATIENTFAMILYCATEGORY = "DELETEPATIENTFAMILYCATEGORY";

/* ============ PATIENT VISA TYPE ============ */
export const CREATEPATIENTVISATYPE = "CREATEPATIENTVISATYPE";
export const GETPATIENTVISATYPE = "GETPATIENTVISATYPE";
export const GETPATIENTVISATYPEBYID = "GETPATIENTVISATYPEBYID";
export const UPDATEPATIENTVISATYPE = "UPDATEPATIENTVISATYPE";
export const DELETEPATIENTVISATYPE = "DELETEPATIENTVISATYPE";
/* ============ PATIENT PACKAGE TYPE ============ */
export const CREATEPATIENTPACKAGETYPE = "CREATEPATIENTPACKAGETYPE";
export const GETPATIENTPACKAGETYPE = "GETPATIENTPACKAGETYPE";
export const GETPATIENTPACKAGETYPEBYID = "GETPATIENTPACKAGETYPEBYID";
export const UPDATEPATIENTPACKAGETYPE = "UPDATEPATIENTPACKAGETYPE";
export const DELETEPATIENTPACKAGETYPE = "DELETEPATIENTPACKAGETYPE";
/* ============ PATIENT UHID ============ */
export const CREATEPATIENTUHID = "CREATEPATIENTUHID";
export const GETPATIENTUHID = "GETPATIENTUHID";
export const GETPATIENTUHIDBYID = "GETPATIENTUHIDBYID";
export const UPDATEPATIENTUHID = "UPDATEPATIENTUHID";
export const DELETEPATIENTUHID = "DELETEPATIENTUHID";
/* ============ VISIT STATUS ============ */
export const CREATEVISITSTATUS = "CREATEVISITSTATUS";
export const GETVISITSTATUS = "GETVISITSTATUS";
export const GETVISITSTATUSBYID = "GETVISITSTATUSBYID";
export const UPDATEVISITSTATUS = "UPDATEVISITSTATUS";
export const DELETEVISITSTATUS = "DELETEVISITSTATUS";

export const GET_COMMISSION = "GET_COMMISSION";
export const CREATE_COMMISSION = "CREATE_COMMISSION";
export const UPDATE_COMMISSION = "UPDATE_COMMISSION";
export const DELETE_COMMISSION = "DELETE_COMMISSION";


export const GET_COMMISSION_TYPE = "GET_COMMISSION_TYPE";
export const CREATE_COMMISSION_TYPE = "CREATE_COMMISSION_TYPE";
export const UPDATE_COMMISSION_TYPE = "UPDATE_COMMISSION_TYPE";
export const DELETE_COMMISSION_TYPE = "DELETE_COMMISSION_TYPE";


export const GET_COMMISSION_CATEGORY = "GET_COMMISSION_CATEGORY";
export const CREATE_COMMISSION_CATEGORY = "CREATE_COMMISSION_CATEGORY";
export const UPDATE_COMMISSION_CATEGORY = "UPDATE_COMMISSION_CATEGORY";
export const DELETE_COMMISSION_CATEGORY = "DELETE_COMMISSION_CATEGORY";
export const CREATE_TAX_GROUP = "CREATE_TAX_GROUP";
export const GET_TAX_GROUP = "GET_TAX_GROUP";
export const UPDATE_TAX_GROUP = "UPDATE_TAX_GROUP";
export const DELETE_TAX_GROUP = "DELETE_TAX_GROUP";
export const CREATE_TAX_TYPE = "CREATE_TAX_TYPE";
export const GET_TAX_TYPE = "GET_TAX_TYPE";
export const UPDATE_TAX_TYPE = "UPDATE_TAX_TYPE";
export const DELETE_TAX_TYPE = "DELETE_TAX_TYPE";
export const CREATE_RETURN_TYPE = "CREATE_RETURN_TYPE";
export const GET_RETURN_TYPE = "GET_RETURN_TYPE";
export const UPDATE_RETURN_TYPE = "UPDATE_RETURN_TYPE";
export const DELETE_RETURN_TYPE = "DELETE_RETURN_TYPE";
export const CREATE_TDS_SECTION = "CREATE_TDS_SECTION";
export const GET_TDS_SECTION = "GET_TDS_SECTION";
export const UPDATE_TDS_SECTION = "UPDATE_TDS_SECTION";
export const DELETE_TDS_SECTION = "DELETE_TDS_SECTION";
export const CREATE_TCS_SECTION = "CREATE_TCS_SECTION";
export const GET_TCS_SECTION = "GET_TCS_SECTION";
export const UPDATE_TCS_SECTION = "UPDATE_TCS_SECTION";
export const DELETE_TCS_SECTION = "DELETE_TCS_SECTION";
export const CREATE_TAX_MASTER = "CREATE_TAX_MASTER";
export const GET_TAX_MASTER = "GET_TAX_MASTER";
export const GET_TAX_MASTER_BYID = "GET_TAX_MASTER_BYID";
export const UPDATE_TAX_MASTER = "UPDATE_TAX_MASTER";
export const DELETE_TAX_MASTER = "DELETE_TAX_MASTER";
export const CREATE_TAX_SLAB = "CREATE_TAX_SLAB";
export const GET_TAX_SLAB = "GET_TAX_SLAB";
export const UPDATE_TAX_SLAB = "UPDATE_TAX_SLAB";
export const DELETE_TAX_SLAB = "DELETE_TAX_SLAB";
export const CREATE_HSN_MASTER = "CREATE_HSN_MASTER";
export const GET_HSN_MASTER = "GET_HSN_MASTER";
export const UPDATE_HSN_MASTER = "UPDATE_HSN_MASTER";
export const DELETE_HSN_MASTER = "DELETE_HSN_MASTER";
export const CREATE_TAX_LEDGER = "CREATE_TAX_LEDGER";
export const GET_TAX_LEDGER = "GET_TAX_LEDGER";
export const UPDATE_TAX_LEDGER = "UPDATE_TAX_LEDGER";
export const DELETE_TAX_LEDGER = "DELETE_TAX_LEDGER";
export const CREATE_TAX_SETTINGS = "CREATE_TAX_SETTINGS";
export const GET_TAX_SETTINGS = "GET_TAX_SETTINGS";
export const UPDATE_TAX_SETTINGS = "UPDATE_TAX_SETTINGS";
export const DELETE_TAX_SETTINGS = "DELETE_TAX_SETTINGS";
export const CREATE_TAX_AUDIT = "CREATE_TAX_AUDIT";
export const GET_TAX_AUDIT = "GET_TAX_AUDIT";
export const UPDATE_TAX_AUDIT = "UPDATE_TAX_AUDIT";
export const DELETE_TAX_AUDIT = "DELETE_TAX_AUDIT";
export const CREATEFINANCIALYEAR = "CREATEFINANCIALYEAR";
export const GETFINANCIALYEAR = "GETFINANCIALYEAR";
export const UPDATEFINANCIALYEAR = "UPDATEFINANCIALYEAR";
export const DELETEFINANCIALYEAR = "DELETEFINANCIALYEAR";


// ─── 1. HR STAFF ADVANCE ───────────────────────────────────────────────────
export const GETHRSTAFFADVANCEDASHBOARDKPIS = "GETHRSTAFFADVANCEDASHBOARDKPIS";
export const CHECKHRSTAFFADVANCEELIGIBILITY = "CHECKHRSTAFFADVANCEELIGIBILITY";
export const PREVIEWHRSTAFFADVANCESCHEDULE = "PREVIEWHRSTAFFADVANCESCHEDULE";
export const GETHRSTAFFADVANCEACCOUNTINGPREVIEW = "GETHRSTAFFADVANCEACCOUNTINGPREVIEW";

export const RAISEHRSTAFFADVANCEREQUEST = "RAISEHRSTAFFADVANCEREQUEST";
export const GETHRSTAFFADVANCEREQUESTLIST = "GETHRSTAFFADVANCEREQUESTLIST";
export const GETHRSTAFFADVANCEREQUESTDETAILS = "GETHRSTAFFADVANCEREQUESTDETAILS";
export const APPROVEHRSTAFFADVANCEREQUEST = "APPROVEHRSTAFFADVANCEREQUEST";
export const REJECTHRSTAFFADVANCEREQUEST = "REJECTHRSTAFFADVANCEREQUEST";
export const CANCELHRSTAFFADVANCEREQUEST = "CANCELHRSTAFFADVANCEREQUEST";

export const ISSUEHRSTAFFADVANCE = "ISSUEHRSTAFFADVANCE";
export const GETHRSTAFFADVANCELIST = "GETHRSTAFFADVANCELIST";
export const GETHRSTAFFADVANCEDETAILS = "GETHRSTAFFADVANCEDETAILS";
export const RELEASEHRSTAFFADVANCE = "RELEASEHRSTAFFADVANCE";
export const CLOSEHRSTAFFADVANCE = "CLOSEHRSTAFFADVANCE";
export const REGENERATEHRSTAFFADVANCESCHEDULE = "REGENERATEHRSTAFFADVANCESCHEDULE";

export const SAVEHRSTAFFADVANCEEMERGENCYDETAILS = "SAVEHRSTAFFADVANCEEMERGENCYDETAILS";
export const GETHRSTAFFADVANCEEMERGENCYDETAILS = "GETHRSTAFFADVANCEEMERGENCYDETAILS";
export const DELETEHRSTAFFADVANCEEMERGENCYDETAILS = "DELETEHRSTAFFADVANCEEMERGENCYDETAILS";

export const UPLOADHRSTAFFADVANCEDOCUMENT = "UPLOADHRSTAFFADVANCEDOCUMENT";
export const UPDATEHRSTAFFADVANCEDOCUMENT = "UPDATEHRSTAFFADVANCEDOCUMENT";
export const DELETEHRSTAFFADVANCEDOCUMENT = "DELETEHRSTAFFADVANCEDOCUMENT";
export const GETHRSTAFFADVANCEDOCUMENTSLIST = "GETHRSTAFFADVANCEDOCUMENTSLIST";

// ─── 2. HR PAYROLL RECOVERY ────────────────────────────────────────────────
export const CREATEHRPAYROLLRECOVERY = "CREATEHRPAYROLLRECOVERY";
export const GETHRPAYROLLRECOVERY = "GETHRPAYROLLRECOVERY";
export const GETHRPAYROLLRECOVERYDETAILS = "GETHRPAYROLLRECOVERYDETAILS";
export const VERIFYHRPAYROLLRECOVERY = "VERIFYHRPAYROLLRECOVERY";
export const APPROVEHRPAYROLLRECOVERY = "APPROVEHRPAYROLLRECOVERY";
export const POSTHRPAYROLLRECOVERY = "POSTHRPAYROLLRECOVERY";
export const CANCELHRPAYROLLRECOVERY = "CANCELHRPAYROLLRECOVERY";

// ─── 3. HR FUND BUDGET ────────────────────────────────────────────────────
export const GET_HR_FUND_BUDGET = "GET_HR_FUND_BUDGET";
export const GET_HR_FUND_BUDGET_DETAILS = "GET_HR_FUND_BUDGET_DETAILS";
export const CREATE_HR_FUND_BUDGET = "CREATE_HR_FUND_BUDGET";
export const UPDATE_HR_FUND_BUDGET = "UPDATE_HR_FUND_BUDGET";
export const DELETE_HR_FUND_BUDGET = "DELETE_HR_FUND_BUDGET";

// ─── 4. HR APPROVAL WORKFLOW ────────────────────────────────────────────────
export const CREATEHRAPPROVALWORKFLOW = "CREATEHRAPPROVALWORKFLOW";
export const GETHRAPPROVALWORKFLOWHISTORY = "GETHRAPPROVALWORKFLOWHISTORY";
export const GETHRAPPROVALWORKFLOWPENDING = "GETHRAPPROVALWORKFLOWPENDING";
export const GETHRAPPROVALWORKFLOWDETAILS = "GETHRAPPROVALWORKFLOWDETAILS";
export const UPDATEHRAPPROVALWORKFLOW = "UPDATEHRAPPROVALWORKFLOW";
export const DELETEHRAPPROVALWORKFLOW = "DELETEHRAPPROVALWORKFLOW";

// ADVANCE TYPE MASTER
export const GET_HR_ADVANCE_TYPE_MASTER = "GET_HR_ADVANCE_TYPE_MASTER";
export const CREATE_HR_ADVANCE_TYPE_MASTER = "CREATE_HR_ADVANCE_TYPE_MASTER";
export const UPDATE_HR_ADVANCE_TYPE_MASTER = "UPDATE_HR_ADVANCE_TYPE_MASTER";
export const DELETE_HR_ADVANCE_TYPE_MASTER = "DELETE_HR_ADVANCE_TYPE_MASTER";

// RECOVERY TYPE MASTER
export const GET_HR_RECOVERY_TYPE_MASTER = "GET_HR_RECOVERY_TYPE_MASTER";
export const CREATE_HR_RECOVERY_TYPE_MASTER = "CREATE_HR_RECOVERY_TYPE_MASTER";
export const UPDATE_HR_RECOVERY_TYPE_MASTER = "UPDATE_HR_RECOVERY_TYPE_MASTER";
export const DELETE_HR_RECOVERY_TYPE_MASTER = "DELETE_HR_RECOVERY_TYPE_MASTER";

// ADVANCE MASTER / SCHEME
export const GET_HR_ADVANCE_MASTER = "GET_HR_ADVANCE_MASTER";
export const CREATE_HR_ADVANCE_MASTER = "CREATE_HR_ADVANCE_MASTER";
export const UPDATE_HR_ADVANCE_MASTER = "UPDATE_HR_ADVANCE_MASTER";
export const DELETE_HR_ADVANCE_MASTER = "DELETE_HR_ADVANCE_MASTER";

// ─── HR STAFF LOAN MASTER TYPES ───
export const GET_HR_LOAN_MASTER = "GET_HR_LOAN_MASTER";
export const CREATE_HR_LOAN_MASTER = "CREATE_HR_LOAN_MASTER";
export const UPDATE_HR_LOAN_MASTER = "UPDATE_HR_LOAN_MASTER";
export const DELETE_HR_LOAN_MASTER = "DELETE_HR_LOAN_MASTER";

export const GET_HR_LOAN_TYPE_MASTER = "GET_HR_LOAN_TYPE_MASTER";
export const CREATE_HR_LOAN_TYPE_MASTER = "CREATE_HR_LOAN_TYPE_MASTER";
export const UPDATE_HR_LOAN_TYPE_MASTER = "UPDATE_HR_LOAN_TYPE_MASTER";
export const DELETE_HR_LOAN_TYPE_MASTER = "DELETE_HR_LOAN_TYPE_MASTER";

export const GET_HR_COLLATERAL_TYPE_MASTER = "GET_HR_COLLATERAL_TYPE_MASTER";
export const CREATE_HR_COLLATERAL_TYPE_MASTER = "CREATE_HR_COLLATERAL_TYPE_MASTER";
export const UPDATE_HR_COLLATERAL_TYPE_MASTER = "UPDATE_HR_COLLATERAL_TYPE_MASTER";
export const DELETE_HR_COLLATERAL_TYPE_MASTER = "DELETE_HR_COLLATERAL_TYPE_MASTER";

export const CREATEFINANCESETUP = "CREATEFINANCESETUP";
export const GETFINANCESETUP = "GETFINANCESETUP";
export const UPDATEFINANCESETUP = "UPDATEFINANCESETUP";
export const DELETEFINANCESETUP = "DELETEFINANCESETUP";

export const FETCH_HR_STAFF_ADVANCE_ELIGIBILITY_BULK_SUCCESS = "FETCH_HR_STAFF_ADVANCE_ELIGIBILITY_BULK_SUCCESS";
export const UPDATE_HR_STAFF_ADVANCE_REQUEST = "UPDATE_HR_STAFF_ADVANCE_REQUEST";

// ─── SETUP REFERRAL TYPES ───
export const CREATEREFERRALTYPE = "CREATEREFERRALTYPE";
export const GETREFERRALTYPE = "GETREFERRALTYPE";
export const UPDATEREFERRALTYPE = "UPDATEREFERRALTYPE";
export const DELETEREFERRALTYPE = "DELETEREFERRALTYPE";

export const CREATEREFERALPERSONDOCUMENT = "CREATEREFERALPERSONDOCUMENT";
export const GETREFERALPERSONDOCUMENT = "GETREFERALPERSONDOCUMENT";
export const UPDATEREFERALPERSONDOCUMENT = "UPDATEREFERALPERSONDOCUMENT";
export const DELETEREFERALPERSONDOCUMENT = "DELETEREFERALPERSONDOCUMENT"; 

export const APPROVAL_WORKFLOW_CREATE = "APPROVAL_WORKFLOW_CREATE";
export const APPROVAL_WORKFLOW_GET_ALL = "APPROVAL_WORKFLOW_GET_ALL";
export const UPDATEREFERRALAPPROVALWORKFLOW = "UPDATEREFERRALAPPROVALWORKFLOW";
export const DELETEREFERRALAPPROVALWORKFLOW = "DELETEREFERRALAPPROVALWORKFLOW";

//End Refferal Source-------------

export const INITIATE_ADVANCE_PAYOUT = "INITIATE_ADVANCE_PAYOUT";
export const STAFF_DETAILS_FOR_ADVANCE = "STAFF_DETAILS_FOR_ADVANCE";



export const CREATESERVICECHARGE = "CREATESERVICECHARGE";
export const GETSERVICECHARGE = "GETSERVICECHARGE";
export const UPDATESERVICECHARGE = "UPDATESERVICECHARGE";
export const DELETESERVICECHARGE = "DELETESERVICECHARGE";

export const CREATESERVICEDEPTMAPPING = "CREATESERVICEDEPTMAPPING";
export const GETSERVICEDEPTMAPPING = "GETSERVICEDEPTMAPPING";
export const UPDATESERVICEDEPTMAPPING = "UPDATESERVICEDEPTMAPPING";
export const DELETESERVICEDEPTMAPPING = "DELETESERVICEDEPTMAPPING";
export const GET_MAPPING_DEPARTMENT = "GET_MAPPING_DEPARTMENT";
export const CREATE_MAPPING_DEPARTMENT = "CREATE_MAPPING_DEPARTMENT";
export const UPDATE_MAPPING_DEPARTMENT = "UPDATE_MAPPING_DEPARTMENT";
export const DELETE_MAPPING_DEPARTMENT = "DELETE_MAPPING_DEPARTMENT";
export const GET_MAPPING_DOCTOR = "GET_MAPPING_DOCTOR";
export const CREATE_MAPPING_DOCTOR = "CREATE_MAPPING_DOCTOR";
export const UPDATE_MAPPING_DOCTOR = "UPDATE_MAPPING_DOCTOR";
export const DELETE_MAPPING_DOCTOR = "DELETE_MAPPING_DOCTOR";
export const GET_MAPPING_CATEGORY = "GET_MAPPING_CATEGORY";
export const CREATE_MAPPING_CATEGORY = "CREATE_MAPPING_CATEGORY";
export const UPDATE_MAPPING_CATEGORY = "UPDATE_MAPPING_CATEGORY";
export const DELETE_MAPPING_CATEGORY = "DELETE_MAPPING_CATEGORY";
export const GET_MAPPING_COSTCENTER = "GET_MAPPING_COSTCENTER";
export const CREATE_MAPPING_COSTCENTER = "CREATE_MAPPING_COSTCENTER";
export const UPDATE_MAPPING_COSTCENTER = "UPDATE_MAPPING_COSTCENTER";
export const DELETE_MAPPING_COSTCENTER = "DELETE_MAPPING_COSTCENTER";

//patient visit master 
export const CREATEPATIENTVISIT = "CREATEPATIENTVISIT";
export const GETPATIENTVISIT = "GETPATIENTVISIT";
export const GETPATIENTVISITBYID = "GETPATIENTVISITBYID";
export const UPDATEPATIENTVISIT = "UPDATEPATIENTVISIT";
export const DELETEPATIENTVISIT = "DELETEPATIENTVISIT";

//Patient Primary Vitals
export const CREATEPATIENTPRIMARYVITAL = "CREATEPATIENTPRIMARYVITAL";
export const GETPATIENTPRIMARYVITAL = "GETPATIENTPRIMARYVITAL";
export const GETPATIENTPRIMARYVITALBYID = "GETPATIENTPRIMARYVITALBYID";
export const UPDATEPATIENTPRIMARYVITAL = "UPDATEPATIENTPRIMARYVITAL";
export const DELETEPATIENTPRIMARYVITAL = "DELETEPATIENTPRIMARYVITAL";
export const CREATEPACKAGECHARGE = "CREATEPACKAGECHARGE";
export const GETPACKAGECHARGE = "GETPACKAGECHARGE";
export const UPDATEPACKAGECHARGE = "UPDATEPACKAGECHARGE";
export const DELETEPACKAGECHARGE = "DELETEPACKAGECHARGE";
export const CREATEPACKAGESERVICEMAPPING = "CREATEPACKAGESERVICEMAPPING";
export const GETPACKAGESERVICEMAPPING = "GETPACKAGESERVICEMAPPING";
export const UPDATEPACKAGESERVICEMAPPING = "UPDATEPACKAGESERVICEMAPPING";
export const DELETEPACKAGESERVICEMAPPING = "DELETEPACKAGESERVICEMAPPING";
export const CREATEPACKAGECOMPONENTMAPPING = "CREATEPACKAGECOMPONENTMAPPING";
export const GETPACKAGECOMPONENTMAPPING = "GETPACKAGECOMPONENTMAPPING";
export const UPDATEPACKAGECOMPONENTMAPPING = "UPDATEPACKAGECOMPONENTMAPPING";
export const DELETEPACKAGECOMPONENTMAPPING = "DELETEPACKAGECOMPONENTMAPPING";
export const CREATEPACKAGECONSUMABLEMAPPING = "CREATEPACKAGECONSUMABLEMAPPING";
export const GETPACKAGECONSUMABLEMAPPING = "GETPACKAGECONSUMABLEMAPPING";
export const UPDATEPACKAGECONSUMABLEMAPPING = "UPDATEPACKAGECONSUMABLEMAPPING";
export const DELETEPACKAGECONSUMABLEMAPPING = "DELETEPACKAGECONSUMABLEMAPPING";
export const CREATEPACKAGEDOCTORSHAREMAPPING = "CREATEPACKAGEDOCTORSHAREMAPPING";
export const GETPACKAGEDOCTORSHAREMAPPING = "GETPACKAGEDOCTORSHAREMAPPING";
export const UPDATEPACKAGEDOCTORSHAREMAPPING = "UPDATEPACKAGEDOCTORSHAREMAPPING";
export const DELETEPACKAGEDOCTORSHAREMAPPING = "DELETEPACKAGEDOCTORSHAREMAPPING";